var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVermittlungHaus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 474.84 446.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .12;\n      }\n\n      .cls-2 {\n        opacity: .32;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69, .cls-70, .cls-71, .cls-72, .cls-73, .cls-74, .cls-75, .cls-76, .cls-77, .cls-78, .cls-79, .cls-80, .cls-81, .cls-82, .cls-83, .cls-84, .cls-85, .cls-86, .cls-87, .cls-88, .cls-89, .cls-90, .cls-91, .cls-92, .cls-93, .cls-94, .cls-95, .cls-96, .cls-97, .cls-98, .cls-99, .cls-100, .cls-101, .cls-102, .cls-103, .cls-104, .cls-105, .cls-106, .cls-107, .cls-108, .cls-109, .cls-110, .cls-111, .cls-112, .cls-113, .cls-114, .cls-115, .cls-116, .cls-117, .cls-118, .cls-119, .cls-120, .cls-121, .cls-122, .cls-123, .cls-124, .cls-125, .cls-126, .cls-127, .cls-128, .cls-129, .cls-130, .cls-131, .cls-132, .cls-133, .cls-134, .cls-135, .cls-136, .cls-137, .cls-138, .cls-139, .cls-140, .cls-141, .cls-142, .cls-143, .cls-144, .cls-145, .cls-146, .cls-147, .cls-148, .cls-149, .cls-150, .cls-151, .cls-152, .cls-153, .cls-154, .cls-155, .cls-156, .cls-157, .cls-158, .cls-159, .cls-160, .cls-161, .cls-162, .cls-163, .cls-164, .cls-165, .cls-166, .cls-167, .cls-168, .cls-169, .cls-170, .cls-171, .cls-172, .cls-173, .cls-174, .cls-175, .cls-176, .cls-177, .cls-178, .cls-179, .cls-180, .cls-181, .cls-182, .cls-183, .cls-184, .cls-185, .cls-186, .cls-187, .cls-188, .cls-189, .cls-190, .cls-191, .cls-192, .cls-193, .cls-194, .cls-195, .cls-196, .cls-197, .cls-198, .cls-199, .cls-200, .cls-201, .cls-202, .cls-203, .cls-204, .cls-205, .cls-206, .cls-207, .cls-208, .cls-209, .cls-210, .cls-211, .cls-212, .cls-213, .cls-214, .cls-215, .cls-216, .cls-217, .cls-218, .cls-219, .cls-220, .cls-221, .cls-222, .cls-223, .cls-224, .cls-225, .cls-226, .cls-227, .cls-228, .cls-229, .cls-230, .cls-231, .cls-232, .cls-233, .cls-234, .cls-235, .cls-236, .cls-237, .cls-238, .cls-239, .cls-240, .cls-241, .cls-242, .cls-243, .cls-244, .cls-245 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-101 {\n        fill: #231f20;\n      }\n\n      .cls-3 {\n        opacity: .15;\n      }\n\n      .cls-246 {\n        opacity: .22;\n      }\n\n      .cls-247, .cls-4 {\n        opacity: .2;\n      }\n\n      .cls-248 {\n        opacity: .29;\n      }\n\n      .cls-249 {\n        opacity: .25;\n      }\n\n      .cls-250 {\n        opacity: .39;\n      }\n\n      .cls-4 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-251 {\n        isolation: isolate;\n      }\n\n      .cls-6 {\n        fill: #4c4d61;\n      }\n\n      .cls-7 {\n        fill: #4ab3ec;\n      }\n\n      .cls-8 {\n        fill: #627b77;\n      }\n\n      .cls-9 {\n        fill: #617084;\n      }\n\n      .cls-10 {\n        fill: #6092c9;\n      }\n\n      .cls-11 {\n        fill: #4a2f2f;\n      }\n\n      .cls-12 {\n        fill: #4a3125;\n      }\n\n      .cls-13 {\n        fill: #5f2829;\n      }\n\n      .cls-14 {\n        fill: #5d94c7;\n      }\n\n      .cls-15 {\n        fill: #4a1414;\n      }\n\n      .cls-16 {\n        fill: #60524f;\n      }\n\n      .cls-17 {\n        fill: #61404b;\n      }\n\n      .cls-18 {\n        fill: #5ebbec;\n      }\n\n      .cls-19 {\n        fill: #7685a0;\n      }\n\n      .cls-20 {\n        fill: #614f6b;\n      }\n\n      .cls-21 {\n        fill: #748e8a;\n      }\n\n      .cls-22 {\n        fill: #524643;\n      }\n\n      .cls-23 {\n        fill: #784c4c;\n      }\n\n      .cls-24 {\n        fill: #617394;\n      }\n\n      .cls-25 {\n        fill: #4e2b24;\n      }\n\n      .cls-26 {\n        fill: #4f6460;\n      }\n\n      .cls-27 {\n        fill: #50527d;\n      }\n\n      .cls-28 {\n        fill: #50b7b2;\n      }\n\n      .cls-29 {\n        fill: #509fc9;\n      }\n\n      .cls-30 {\n        fill: #784d55;\n      }\n\n      .cls-31 {\n        fill: #4e565c;\n      }\n\n      .cls-32 {\n        fill: #4e6278;\n      }\n\n      .cls-33 {\n        fill: #4e637b;\n      }\n\n      .cls-34 {\n        fill: #4f3232;\n      }\n\n      .cls-35 {\n        fill: #2c3103;\n      }\n\n      .cls-36 {\n        fill: #483037;\n      }\n\n      .cls-37 {\n        fill: #485e73;\n      }\n\n      .cls-38 {\n        fill: #479cd3;\n      }\n\n      .cls-39 {\n        fill: #485c71;\n      }\n\n      .cls-40 {\n        fill: #6380d9;\n      }\n\n      .cls-41 {\n        fill: #2d2e40;\n      }\n\n      .cls-42 {\n        fill: #2d2f4f;\n      }\n\n      .cls-43 {\n        fill: #2c2d45;\n      }\n\n      .cls-44 {\n        fill: #2b3743;\n      }\n\n      .cls-45 {\n        fill: #292936;\n      }\n\n      .cls-46 {\n        fill: #5b748c;\n      }\n\n      .cls-47 {\n        fill: #2a222e;\n      }\n\n      .cls-48 {\n        fill: #628e4b;\n      }\n\n      .cls-49 {\n        fill: #548cc4;\n      }\n\n      .cls-50 {\n        fill: #99b6ed;\n      }\n\n      .cls-51 {\n        fill: #9aa0ad;\n      }\n\n      .cls-52 {\n        fill: #6d5f76;\n      }\n\n      .cls-53 {\n        fill: #54435c;\n      }\n\n      .cls-54 {\n        fill: #547d40;\n      }\n\n      .cls-55 {\n        fill: #964b63;\n      }\n\n      .cls-56 {\n        fill: #6f6f6f;\n      }\n\n      .cls-57 {\n        fill: #717c82;\n      }\n\n      .cls-58 {\n        fill: #a35a77;\n      }\n\n      .cls-59 {\n        fill: #a33745;\n      }\n\n      .cls-60 {\n        fill: #95a30b;\n      }\n\n      .cls-61 {\n        fill: #6cd0e8;\n      }\n\n      .cls-62 {\n        fill: #8a5959;\n      }\n\n      .cls-63 {\n        fill: #88dad6;\n      }\n\n      .cls-64 {\n        fill: #2e2f3b;\n      }\n\n      .cls-65 {\n        fill: #262731;\n      }\n\n      .cls-66 {\n        fill: #313d4d;\n      }\n\n      .cls-67 {\n        fill: #3b4d5f;\n      }\n\n      .cls-68 {\n        fill: #3b2525;\n      }\n\n      .cls-69 {\n        fill: #3a2b40;\n      }\n\n      .cls-70 {\n        fill: #3a252f;\n      }\n\n      .cls-71 {\n        fill: #39434f;\n      }\n\n      .cls-72 {\n        fill: #583c44;\n      }\n\n      .cls-73 {\n        fill: #5680ad;\n      }\n\n      .cls-74 {\n        fill: #574d5f;\n      }\n\n      .cls-75 {\n        fill: #2f2f3e;\n      }\n\n      .cls-76 {\n        fill: #1a1b22;\n      }\n\n      .cls-77 {\n        fill: #1a1a1a;\n      }\n\n      .cls-78 {\n        fill: #1b4c80;\n      }\n\n      .cls-79 {\n        fill: #1a1513;\n      }\n\n      .cls-80 {\n        fill: #3e3f4f;\n      }\n\n      .cls-81 {\n        fill: #3f5366;\n      }\n\n      .cls-82 {\n        fill: #181f27;\n      }\n\n      .cls-83 {\n        fill: #3f496b;\n      }\n\n      .cls-84 {\n        fill: #3f4f61;\n      }\n\n      .cls-85 {\n        fill: #362e2c;\n      }\n\n      .cls-86 {\n        fill: #45454c;\n      }\n\n      .cls-87 {\n        fill: #373957;\n      }\n\n      .cls-88 {\n        fill: #1c1d31;\n      }\n\n      .cls-89 {\n        fill: #0f0f1a;\n      }\n\n      .cls-90 {\n        fill: #424242;\n      }\n\n      .cls-91 {\n        fill: #414f48;\n      }\n\n      .cls-92 {\n        fill: #404366;\n      }\n\n      .cls-93 {\n        fill: #43251f;\n      }\n\n      .cls-94 {\n        fill: #405064;\n      }\n\n      .cls-95 {\n        fill: #42b0eb;\n      }\n\n      .cls-96 {\n        fill: #424469;\n      }\n\n      .cls-97 {\n        fill: #43566b;\n      }\n\n      .cls-98 {\n        fill: #23233b;\n      }\n\n      .cls-99 {\n        fill: #232323;\n      }\n\n      .cls-100 {\n        fill: #212131;\n      }\n\n      .cls-102 {\n        fill: #22232c;\n      }\n\n      .cls-103 {\n        fill: #22222c;\n      }\n\n      .cls-104 {\n        fill: #1f1f1f;\n      }\n\n      .cls-105 {\n        fill: #1e1e1e;\n      }\n\n      .cls-106 {\n        fill: #1e2429;\n      }\n\n      .cls-107 {\n        fill: #251e29;\n      }\n\n      .cls-108 {\n        fill: #121b27;\n      }\n\n      .cls-109 {\n        fill: #c4cfdf;\n      }\n\n      .cls-110 {\n        fill: #c498ad;\n      }\n\n      .cls-111 {\n        fill: #c76f6d;\n      }\n\n      .cls-112 {\n        fill: #dfbd77;\n      }\n\n      .cls-113 {\n        fill: #de814a;\n      }\n\n      .cls-114 {\n        fill: #cc5180;\n      }\n\n      .cls-115 {\n        fill: #c4d4eb;\n      }\n\n      .cls-116 {\n        fill: #cd7d4b;\n      }\n\n      .cls-117 {\n        fill: #cd8382;\n      }\n\n      .cls-118 {\n        fill: #c7ae82;\n      }\n\n      .cls-119 {\n        fill: #ae4026;\n      }\n\n      .cls-120 {\n        fill: #c6d4ed;\n      }\n\n      .cls-121 {\n        fill: #dcb35b;\n      }\n\n      .cls-122 {\n        fill: #e0e6ed;\n      }\n\n      .cls-123 {\n        fill: #dd8a89;\n      }\n\n      .cls-124 {\n        fill: #c96968;\n      }\n\n      .cls-125 {\n        fill: #dfdfdf;\n      }\n\n      .cls-126 {\n        fill: #b2dad8;\n      }\n\n      .cls-127 {\n        fill: #d66991;\n      }\n\n      .cls-128 {\n        fill: #d5dded;\n      }\n\n      .cls-129 {\n        fill: #d4aea0;\n      }\n\n      .cls-130 {\n        fill: #d6779b;\n      }\n\n      .cls-131 {\n        fill: #dd984a;\n      }\n\n      .cls-132 {\n        fill: #dd8053;\n      }\n\n      .cls-133 {\n        fill: #db7877;\n      }\n\n      .cls-134 {\n        fill: #d9e0ed;\n      }\n\n      .cls-135 {\n        fill: #be7547;\n      }\n\n      .cls-136 {\n        fill: #bebab9;\n      }\n\n      .cls-137 {\n        fill: #bd5547;\n      }\n\n      .cls-138 {\n        fill: #be8470;\n      }\n\n      .cls-139 {\n        fill: #bead93;\n      }\n\n      .cls-140 {\n        fill: #c0cbed;\n      }\n\n      .cls-141 {\n        fill: #aab9d0;\n      }\n\n      .cls-142 {\n        fill: #be7b74;\n      }\n\n      .cls-143 {\n        fill: #bdceed;\n      }\n\n      .cls-144 {\n        fill: #a6364a;\n      }\n\n      .cls-145 {\n        fill: #b23b48;\n      }\n\n      .cls-146 {\n        fill: #b22e61;\n      }\n\n      .cls-147 {\n        fill: #a9b662;\n      }\n\n      .cls-148 {\n        fill: #bfd1eb;\n      }\n\n      .cls-149 {\n        fill: #be4755;\n      }\n\n      .cls-150 {\n        fill: #cdb495;\n      }\n\n      .cls-151 {\n        fill: #a68842;\n      }\n\n      .cls-152 {\n        fill: #af4670;\n      }\n\n      .cls-153 {\n        fill: #a6776e;\n      }\n\n      .cls-154 {\n        fill: #a88480;\n      }\n\n      .cls-155 {\n        fill: #a65f6f;\n      }\n\n      .cls-156 {\n        fill: #a54940;\n      }\n\n      .cls-157 {\n        fill: #d04040;\n      }\n\n      .cls-158 {\n        fill: #8c2222;\n      }\n\n      .cls-159 {\n        fill: #9d9998;\n      }\n\n      .cls-160 {\n        fill: #b7505c;\n      }\n\n      .cls-161 {\n        fill: #9e3a47;\n      }\n\n      .cls-162 {\n        fill: #9d747b;\n      }\n\n      .cls-163 {\n        fill: #9d6871;\n      }\n\n      .cls-164 {\n        fill: #906b64;\n      }\n\n      .cls-165 {\n        fill: #c44e7c;\n      }\n\n      .cls-166 {\n        fill: #b55f5f;\n      }\n\n      .cls-167 {\n        fill: #909090;\n      }\n\n      .cls-168 {\n        fill: #b3bdd0;\n      }\n\n      .cls-169 {\n        fill: #b5416d;\n      }\n\n      .cls-170 {\n        fill: #b5484a;\n      }\n\n      .cls-171 {\n        fill: #331e19;\n      }\n\n      .cls-172 {\n        fill: #737373;\n      }\n\n      .cls-173 {\n        fill: #65809b;\n      }\n\n      .cls-174 {\n        fill: #73534e;\n      }\n\n      .cls-175 {\n        fill: #303030;\n      }\n\n      .cls-176 {\n        fill: #333c57;\n      }\n\n      .cls-177 {\n        fill: #30313e;\n      }\n\n      .cls-178 {\n        fill: #303140;\n      }\n\n      .cls-179 {\n        fill: #8d9199;\n      }\n\n      .cls-180 {\n        fill: #312024;\n      }\n\n      .cls-181 {\n        fill: #312824;\n      }\n\n      .cls-182 {\n        fill: #333743;\n      }\n\n      .cls-183 {\n        fill: #8e5f66;\n      }\n\n      .cls-184 {\n        fill: #8e554b;\n      }\n\n      .cls-185 {\n        fill: #8e9945;\n      }\n\n      .cls-186 {\n        fill: #8db6dd;\n      }\n\n      .cls-187 {\n        fill: #977149;\n      }\n\n      .cls-188 {\n        fill: #969696;\n      }\n\n      .cls-189 {\n        fill: #7c80cc;\n      }\n\n      .cls-190 {\n        fill: #9b2755;\n      }\n\n      .cls-191 {\n        fill: #995867;\n      }\n\n      .cls-192 {\n        fill: #6b5944;\n      }\n\n      .cls-193 {\n        fill: #80424f;\n      }\n\n      .cls-194 {\n        fill: #806f69;\n      }\n\n      .cls-195 {\n        fill: #7f8709;\n      }\n\n      .cls-196 {\n        fill: #804d72;\n      }\n\n      .cls-197 {\n        fill: #7d6340;\n      }\n\n      .cls-198 {\n        fill: #a1aac7;\n      }\n\n      .cls-199 {\n        fill: #8b90ec;\n      }\n\n      .cls-200 {\n        fill: #a0b8db;\n      }\n\n      .cls-201 {\n        fill: #872c3d;\n      }\n\n      .cls-202 {\n        fill: #946957;\n      }\n\n      .cls-203 {\n        fill: #946269;\n      }\n\n      .cls-204 {\n        fill: #7db3ed;\n      }\n\n      .cls-205 {\n        fill: #6a94ba;\n      }\n\n      .cls-206 {\n        fill: #6aa1d9;\n      }\n\n      .cls-207 {\n        fill: #806966;\n      }\n\n      .cls-208 {\n        fill: #752731;\n      }\n\n      .cls-209 {\n        fill: #663f3f;\n      }\n\n      .cls-210 {\n        fill: #80a0d7;\n      }\n\n      .cls-211 {\n        fill: #824e49;\n      }\n\n      .cls-212 {\n        fill: #824c57;\n      }\n\n      .cls-213 {\n        fill: #802044;\n      }\n\n      .cls-214 {\n        fill: #734949;\n      }\n\n      .cls-215 {\n        fill: #6792c2;\n      }\n\n      .cls-216 {\n        fill: #662131;\n      }\n\n      .cls-217 {\n        fill: #66212b;\n      }\n\n      .cls-218 {\n        fill: #edcfa2;\n      }\n\n      .cls-219 {\n        fill: #ed9f9e;\n      }\n\n      .cls-220 {\n        fill: #e3cdc2;\n      }\n\n      .cls-221 {\n        fill: #fff;\n      }\n\n      .cls-222 {\n        fill: #ed566a;\n      }\n\n      .cls-223 {\n        fill: #e9a85e;\n      }\n\n      .cls-224 {\n        fill: #edd7cc;\n      }\n\n      .cls-225 {\n        fill: #e9c495;\n      }\n\n      .cls-226 {\n        fill: #e9a960;\n      }\n\n      .cls-227 {\n        fill: #edb899;\n      }\n\n      .cls-228 {\n        fill: #edbb6f;\n      }\n\n      .cls-229 {\n        fill: #eda434;\n      }\n\n      .cls-230 {\n        fill: #edc6a0;\n      }\n\n      .cls-231 {\n        fill: #e76373;\n      }\n\n      .cls-232 {\n        fill: #e5cf9b;\n      }\n\n      .cls-233 {\n        fill: #eccfb1;\n      }\n\n      .cls-234 {\n        fill: #ecd6b6;\n      }\n\n      .cls-235 {\n        fill: #e89594;\n      }\n\n      .cls-236 {\n        fill: #e8948c;\n      }\n\n      .cls-237 {\n        fill: #e9e9e9;\n      }\n\n      .cls-238 {\n        fill: #028a85;\n      }\n\n      .cls-239 {\n        fill: #02a8a0;\n      }\n\n      .cls-240 {\n        fill: #029b95;\n      }\n\n      .cls-241 {\n        fill: #677107;\n      }\n\n      .cls-242 {\n        fill: #02b9b0;\n      }\n\n      .cls-243 {\n        fill: #008184;\n      }\n\n      .cls-244 {\n        fill: #009599;\n      }\n\n      .cls-245 {\n        fill: #697586;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m39.94,239.56h-1.56l2.86-.84c.83-.24.46-.45-.77-.57h.69c1.58,0,3.49-.19,4.26-.41.33-.1.39-.19.15-.26-.23-.07-.69-.11-1.33-.11-.06,0-.13,0-.2,0h-5.06s-.2-.04-.45-.04c-.01,0-.02,0-.03,0l.08-.02.32-.09.22-.06c.37-.11.27-.21-.3-.27-.36-.04-.77-.06-1.21-.07-.21-.01-.47-.02-.77-.02h-1.12c-1.18,0-2.51.11-2.98.25l-.12.03h-.47s-.02,0-.03,0h-.71c-.55,0-1.14.03-1.65.07,0,0-.01,0-.02,0-.72.06-.68.16.05.16h2.4l-.21.06h-3.35c-1.16,0-2.64.16-3.31.35-.67.19-.26.35.9.35h.27-.43s-.11.05-.11.05l-.12.04h1.2s-.77.03-.77.03h0s-7.07,1.43-7.07,1.43h-1.7l.28-.08h-1.34c-.71,0-1.51.07-1.8.15l-.31.09c-.28.08.06.15.77.15h.06s.1,0,.15,0l-13.8,4.04h1.08l13.78-4.03,3.74.03-.75.21-1.16.33-1.71.49h.58s-7.46,2.25-7.46,2.25h-.3l-.78.23h.32l-.39.12-.39.11c-1.19,0-2.54.11-3.04.25h4.87l.99-.25,1.04-.23h.55l.78-.23h-.31l7.42-1.67-2.5,1.67h-.33l-.78.23h.77l-.52.35h0c-.05,0-.1.02-.13.03l-.35.1h2.37l.35-.1s.07-.03.08-.04l1.07-.32.08-.02h.22l.78-.23h-.22l7.65-2.25h.2l.44-.12h1.2c.36,0,.74-.02,1.07-.04,1.44-.06,2.82-.19,3.47-.36h1.57c.43,0,.93-.04,1.1-.09l2.5-.73c.17-.05-.04-.09-.47-.09Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m6.44,182.28c.36-.38.86-.62,1.41-.62h.71c1.1,0,2,.95,2,2.11h-3.52c-.73,0-1.13-.93-.61-1.48,0,0,0,0,.01-.01Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "m14.38,190.52h3.52c3.01,0,5.46,2.45,5.46,5.46v14.49c0,3.01-2.45,5.46-5.46,5.46h0c-4.96,0-8.98-4.02-8.98-8.98v-10.98c0-3.01,2.45-5.46,5.46-5.46Z",
    transform: "translate(32.28 406.45) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 21.01,
    y: 204.19,
    width: 4.69,
    height: 8.28,
    rx: 2.05,
    ry: 2.05,
    transform: "translate(46.72 416.66) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "m21.35,191.12H5.99v-.28l.94-.32,15.7-.19s-.41.6-1.27.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "m3.99,187.51c0,1.76.94,3.19,2.1,3.19s2.1-1.43,2.1-3.19-.94-3.19-2.1-3.19-2.1,1.43-2.1,3.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 6.1,
    y: 184.32,
    width: 15.41,
    height: 6.39,
    transform: "translate(27.61 375.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "m19.41,187.51c0,1.76.94,3.19,2.1,3.19s2.1-1.43,2.1-3.19-.94-3.19-2.1-3.19-2.1,1.43-2.1,3.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "21.32 190.8 5.99 190.84 5.99 191.45 21.32 191.44 21.32 190.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "m21.32,191.44c1.57,0,2.85-1.68,2.85-3.73,0-.89-.27-1.73-.74-2.36-.49-.66-1.15-1.02-1.87-1.02-.65,0-1.25.33-1.7.94-.43.58-.67,1.34-.66,2.15,0,.73.22,1.43.61,1.95.41.55.96.85,1.55.85h0c1.09,0,1.98-1.15,1.97-2.56,0-.61-.18-1.18-.51-1.62-.34-.46-.81-.71-1.3-.71h0c-.92,0-1.66.96-1.66,2.13,0,1.07.69,1.94,1.53,1.94h0c.44,0,.84-.26,1.09-.67-.24.51-.66.84-1.12.84h0c-.4,0-.78-.21-1.07-.6-.31-.41-.48-.97-.48-1.56,0-.67.19-1.29.54-1.76.33-.44.76-.69,1.21-.69h0c.51,0,1,.27,1.38.77.39.52.61,1.22.61,1.97,0,1.7-1,3.09-2.23,3.09v.64Zm.18-4.82c.37,0,.68.46.68,1,0,.62-.36,1.15-.79,1.15-.49.01-.91-.6-.91-1.31,0-.82.47-1.49,1.04-1.49h0c.18,0,.35.05.5.16-.16-.09-.34-.14-.53-.14h0v.64h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "6.87 205.98 4.05 206.31 6.51 191.71 6.87 205.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "7.33 207.8 1.31 207.4 1.31 204.67 7.33 204.66 7.33 207.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "18.82 242.75 16.52 242.75 10.1 212.47 18.73 212.47 18.82 242.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "18.81 239.61 15.85 239.61 16.52 242.75 18.82 242.78 18.81 239.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "10.02 241.71 7.22 241.71 6.87 212.47 13.38 212.47 10.02 241.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m17.68,241.77c.65,0,1.18.56,1.18,1.25v.94s-2.37,0-2.37,0v-.94c0-.69.53-1.25,1.18-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m19.01,191.92l.13,13.98h2.43c-.03-1.73-.05-3.03-.05-3.2-.05-7.16-1.41-10.78-1.41-10.78h-1.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.41 207.7 6.48 195.97 5.41 207.6 6.41 207.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m6.35,217.16h12.6s.56-17.03.56-17.03l.61-8.2-4.63-1.72s-5.16.03-5.14,0l-3.84,1.51-.12,17.97-.02,3.02-.03,4.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 11.16,
    y: 194.49,
    width: 1.82,
    height: 22.67,
    transform: "translate(24.15 411.65) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "m19.66,213.03l1.06-.9s-2.97-3.96-3.48-9.75l-1.35.13c.56,6.24,3.65,10.35,3.78,10.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "m15.48,202.56l2.17-.21c-.51-5.74,1.6-10.85,1.62-10.9l-1.99-.93c-.1.23-2.36,5.72-1.79,12.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "m6.38,212.7c.26-.58,2.01-4.65,2.59-10.39l-1.08-.12c-.31,3.12-.95,5.72-1.49,7.49l-.02,3.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "m9.24,202.34c.61-6.11-.24-11.3-.28-11.52l-1.61.3c0,.05.85,5.18.26,11.04l1.62.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m15.53,187.35s2.96.85,2.63,3.23-6.12,5.86-6.12,5.86c0,0-3.5-4.34-3.5-6.24,0-1.89,2.43-3.9,6.99-2.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "12.47 194.07 10.32 190.34 15.53 190.34 12.47 194.07"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1.49,
    y: 203.92,
    width: 1.08,
    height: 40.04,
    transform: "translate(4.06 447.87) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m0,206.08v-.81c0-.75.57-1.36,1.28-1.36h1.34v2.16c0,.75-.57,1.36-1.28,1.36h-.06c-.71,0-1.28-.61-1.29-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m7.21,241.71h2.81s-.14,2.25-.14,2.25h-4.87c.04-1.25,1-2.25,2.2-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m15.53,190.34s-.68.64-2.61.64-2.61-.64-2.61-.64v-4.17h5.21v4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m18.86,213.68v-7.6c0-.84.65-1.52,1.44-1.52h0c.82,0,1.48.72,1.44,1.59l-.32,7.41-2.56.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m18.84,216.09v-2.17c0-.75.57-1.36,1.28-1.36h.06c.71,0,1.28.61,1.28,1.35v.81c0,.75-.57,1.36-1.28,1.36h-1.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "7.21 241.71 7.21 239.61 10.26 239.61 10.02 241.71 7.21 241.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m17.2,219.41h.95v-.33h-.95c-.74,0-1.34-.64-1.34-1.42v-.5h-.32v.5c0,.97.74,1.75,1.66,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m7.75,217.68v-.5h.23v.5c0,.84-.41,1.54-.95,1.71v-.35c.41-.17.72-.71.72-1.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "11.96 221.97 12.28 221.97 12.28 220.95 11.49 220.12 11.27 220.35 11.96 221.08 11.96 221.97"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m11.94,180.09h.96c2.33,0,2.07,2.65,2.07,2.65v5.14s-2.04,2.92-5.48,1.53v-5.94c0-1.37.4-3.37,2.45-3.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 9.72,
    y: 186.92,
    width: 2.19,
    height: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m12.64,179.55h0c-1.77,0-3.2,1.51-3.2,3.37v2.49h6.4v-2.49c0-1.86-1.43-3.37-3.2-3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m15.87,183.97c.37,0,.67.32.67.71v1.47c0,.39-.3.71-.67.71h-.68s0-2.17,0-2.17c0-.4.31-.72.68-.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "10.85 185.36 10.79 186.01 11.11 186.01 11.11 186.31 10.47 186.31 10.57 185.32 10.85 185.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m12.54,187.51h0s-.87,0-.87,0c-.63,0-1.14-.54-1.14-1.21h.88c.63,0,1.14.54,1.14,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m10.42,186.31h.51s0,.09,0,.09c0,.62-.48,1.12-1.06,1.12h-.42s0-.18,0-.18c0-.57.44-1.03.98-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m9.87,187.25c.05.06.19.85,1,.85s.94-.83.94-.83c0,0,1.53.36,2.09-1.13.56-1.49.57-1.79.57-1.79h.72v3.79s-.54,2.2-3.5,2.2c-1.82,0-2.29-.82-2.29-.82l.09-4.82s.02,2.05.38,2.54Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 15.09,
    y: 237.55,
    width: 3.94,
    height: 2.05,
    transform: "translate(34.11 477.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 6.87,
    y: 237.55,
    width: 3.94,
    height: 2.05,
    transform: "translate(17.68 477.16) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m14.62,179.93c.77.53,1.22,1.46,1.22,2.43v1.42h-4.94c-.37,0-.69-.26-.8-.63,0,0,0-.02,0-.02-.02-.06-.03-.11-.06-.16-.02-.06-.05-.12-.08-.18,0,0,0,0,0-.02-.03-.05-.05-.1-.09-.14-.05-.08-.11-.16-.16-.23-.03-.04-.06-.08-.1-.11-.03-.03-.06-.06-.09-.09-.01-.01-.03-.02-.04-.03-.03-.04-.07-.06-.11-.09-.06-.04-.12-.08-.18-.12.02-.1.05-.19.08-.28.64-2.07,3.05-3.31,5.36-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m11.2,179.11h1.12c1.18,0,2.14,1.01,2.14,2.25v2.42h-3.56c-.37,0-.69-.26-.8-.63-.15-.51-.48-.94-.92-1.2-.04-.02-.08-.05-.11-.06v-.53c0-1.24.95-2.25,2.13-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m13.24,183.78h-2.34c-.37,0-.69-.26-.8-.63,0,0,0-.02,0-.02-.02-.06-.04-.11-.06-.16-.02-.06-.05-.12-.08-.18,0,0,0,0,0-.02-.03-.05-.05-.1-.09-.14-.05-.08-.11-.16-.16-.23-.03-.04-.07-.08-.1-.11-.03-.03-.06-.06-.09-.09-.01-.01-.03-.02-.04-.03-.03-.03-.07-.06-.11-.09-.06-.04-.12-.08-.18-.12-.04-.02-.08-.05-.11-.06-.1-.06-.2-.1-.31-.13-.18-.06-.37-.08-.57-.08h3.04c1.11,0,2,.94,2,2.11Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m232.4,366.9s.03,0,.04-.01c.15-.05.29-.09.42-.13,0,0,.01,0,.02,0,.13-.04.24-.08.35-.12.08-.03.15-.06.21-.08.04-.02.08-.03.11-.05,0,0,0,0,.01,0,.04-.02.09-.04.12-.05,0,0,0,0,0,0,.1-.04.18-.08.25-.12h0c.2-.11.3-.19.34-.26h0s.04-.07.04-.1c0,0,0,0,0,0,0-.02,0-.03-.01-.05h0s0-.01-.01-.02c0,0,0,0,0,0,0,0-.02-.02-.02-.02,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0l1.54-.45c.67-.2.16-.36-1.13-.42l.09-.03c.06-.02.07-.03.04-.05l.5-.15c.81-.24-.13-.43-2.11-.43h-.13c-1.33,0-2.79.09-3.84.22-.51.06-.93.14-1.2.21l-1.54.45c-.45.13-.25.26.59.31.22.01.47.02.72.03l-.37.11-.16.05h0l-4.45.18h0s0,0,0,0c0,0-3.04.35-5.7,1.18-.11.04-.23.07-.34.11-2.81.94-2.63,1.15-2.63,1.15h.43,0s-.43,0-.43,0c-1.73.27-1.3.41-.88.47-1.92.75-3.06,1.44-3.71,1.95l-2.71.79h-.33c-1.31,0-2.79.12-3.31.28h4.73s2.87,0,2.87,0l.77-.27,3.04-1.03c.99-.19,2.09-.41,3.31-.65,2.03-.4,4.09-.71,5.47-1.04.74-.05,2.73-.22,2.84-.53h-1.23l-.22.07c.19-.12.27-.24.23-.37l.62-.18h-.53c.42-.18,1.76-.65,5.12-1.04l-.9.26-4.31,1.26h1.23s1.63-.21,5.24-1.15c.14-.04.28-.07.41-.11.09-.02.17-.05.25-.07.02,0,.04-.01.06-.02.06-.02.13-.04.19-.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m209.86,309.68h0c2.21,0,4.01,1.8,4.01,4.01v4.63h-4.01v-8.64h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m215.53,328.51c0,.32-.02.66-.04,1-.4,8.49-1.31,10.41-1.31,10.41h-1.23v-22.09h.91s1.85,3.14,1.67,10.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "m215.53,328.51h-2.58v-10.68h.91s.86,1.45,1.34,4.74c.1.66.18,1.39.24,2.19.08,1.1.11,2.35.08,3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m212.95,339.92v4.98s2.41-1.51,1.23-4.98h-1.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m200.87,328.86c0,.32.02.66.04,1,.4,8.49,1.31,10.41,1.31,10.41h1.23v-22.09h-.91s-1.85,3.14-1.67,10.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "m200.87,328.86h2.58v-10.68h-.91s-1.85,3.14-1.67,10.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m203.45,340.27v4.63s-2.41-1.16-1.23-4.63h1.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m202.54,336.24c0,16.28,5.26,33.09,5.26,33.09h2.84l-1.66-33.09h-6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m207.63,369.33c-1.31,0-2.36,1.12-2.36,2.49h5.55s-.17-2.49-.17-2.49h-3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "m202.54,336.24h8.97s-1.34-6.74,2.22-11.29l.14-7.13-3.47-1.1-4.03-.2-3.83,1.65v18.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m205.39,337.31h-.33v-12.66c0-4.64,2.32-7.86,2.34-7.89l.26.21s-2.27,3.16-2.27,7.68v12.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m207.85,319.56l-.71-2.33-1.68,2.18-.13-.14c-.56-.61-.27-1.7-.26-1.74l.32.1s-.2.75.07,1.24l1.82-2.36.74,2.43,1.75-1.67.22.26-2.13,2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m206.37,316.73s-.12.7,1.36.7,2.65-.7,2.65-.7v-4.54h-4.01v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m206.37,316.12v-2.84h3.63s-.64,2.56-3.63,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m211.17,307.94v2.42h-.76v3.34s-2.5,2.32-4.86,1.16c-1.03-.51-1.66-1.63-1.66-2.83v-4.09c0-.7.17-1.36.47-1.93.61-1.17,1.78-1.96,3.1-1.96h.13c1.97,0,3.58,1.74,3.58,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m211.17,307.94v2.2c-.58.19-1.28.12-1.28.12,0,0-2.43-.44-3.84-1.75-1-.92-1.48-1.79-1.7-2.5.61-1.17,1.78-1.96,3.1-1.96h.13c1.97,0,3.58,1.74,3.58,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m211.51,336.24c3.32,6.99,1.02,11.23-.24,17.93-1.73,9.17-2.72,15.16-2.72,15.16h-2.65v-33.09h5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m205.57,369.33c-1.31,0-2.36,1.12-2.36,2.49h4.73l.65-2.49h-3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m210.57,308.93h.72v2.24c0,.4-.32.72-.72.72h0c-.39,0-.71-.32-.71-.71v-1.54c0-.39.32-.71.71-.71Z",
    transform: "translate(421.14 620.82) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m205.22,311.5h-.56s-.09-.02-.13-.06c-.03-.04-.05-.09-.04-.14l.31-2.12.33.05-.28,1.92h.36v.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m206.59,313.52s-.09,0-.14,0l.03-.35c.75.08.94-.69.94-.72l.32.08c-.08.36-.42.99-1.16.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "204.05 324.54 202.54 324.54 202.54 324.19 203.72 324.19 203.72 323.04 204.05 323.04 204.05 324.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "211.41 324.54 207.72 324.54 207.72 323.04 208.05 323.04 208.05 324.19 211.07 324.19 211.07 323.04 211.41 323.04 211.41 324.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "206.06 359.96 205.73 359.96 205.73 341.13 204.29 340.41 204.43 340.09 206.06 340.91 206.06 359.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "208.2 371.49 207.87 371.42 209.65 361.96 209.98 362.03 208.2 371.49"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 206.18,
    y: 369.15,
    width: 4.1,
    height: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "m210.8,320.1c-.1-.31-.43-.54-.83-.54s-.74.23-.83.54h-.36c0,1.69,1.19,2.16,1.19,2.16,0,0,1.19-.47,1.19-2.16h-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "m215.45,324.76h-1.2v-2.19h.96c.1.66.18,1.39.24,2.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 202.37,
    y: 321.43,
    width: 0.33,
    height: 7.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 212.79,
    y: 321.43,
    width: 0.33,
    height: 4.68
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "212.84 322.7 212.02 321.83 212.26 321.59 213.07 322.45 212.84 322.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 202.67,
    y: 337.41,
    width: 8.57,
    height: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 204.29,
    y: 336.24,
    width: 1.87,
    height: 1.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 209.87,
    y: 335.55,
    width: 2.06,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 202.1,
    y: 335.83,
    width: 1.35,
    height: 2.59
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "203.21 337.15 202.3 337.15 202.3 336.8 202.88 336.8 202.88 336.15 203.21 336.15 203.21 337.15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 210.17,
    y: 337.5,
    width: 1.47,
    height: 0.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-221",
    cx: 210.9,
    cy: 336.67,
    rx: 0.21,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "207.84 332.97 207.6 332.72 209.84 330.36 210.08 330.61 207.84 332.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "207.37 334.88 207.13 334.63 208.95 332.72 209.18 332.97 207.37 334.88"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m293.95,363.15l-.39.06c-.58.02-1.12.08-1.4.14l-6.7.49-5.43-.12h0s0,0,0,0c.73-.05,1.46-.14,1.85-.26.48-.14.28-.26-.43-.28.15-.06.31-.12.46-.19l1.02-.31c.05-.02.09-.03.12-.04.02,0,.04-.02.07-.02.12,0,.23.01.34.02,0,0,.41,0,.54-.05.16-.07.24-.11.4-.18.13-.06.33-.13-.08-.16-.18-.01-.38-.02-.58-.03-.12-.23-2.01-.34-4.36-.25h0c-1.74.07-3.25.23-3.99.4-.06,0-.13,0-.19.01-.55.04-1.09.12-1.22.18-.16.07-.24.11-.4.18-.09.04.04.05.3.05-.15.02-.3.05-.45.07-.65.11-1.23.21-1.7.3h-3.15c-.06,0-.11,0-.17,0-.55,0-1.14.04-1.7.09-.58.06-1.06.13-1.33.21-.64.19-.11.34,1.17.34h.55c-.52.06-.94.13-1.19.2l-.38.11c-.86.1-1.88.23-3.1.38-.7.09-.93.19-.72.26.17.07.62.11,1.21.13l-1.08.32h-.42c-.37,0-.8.04-.95.08l-2.15.63c-.15.04.03.08.41.08h.65c0,.12.69.21,1.82.23-1.64.39-2.89.9-3.81,1.38l-1.6.36s0,0,0,0l-3.04.63h-.36s-1.04.2-1.04.2h.38s-.91.2-.91.2h0s-1.38.28-1.38.28l4.93.07c.68-.15.29-.29-.87-.31h-.13c.12-.02.58-.07,1.25-.16h.54s.09,0,.09,0h.28,0c-.14.12-.2.2-.2.2l-.35.28h4.44c.53-.16-.03-.28-1.26-.28h-.31l.74-.2h.28l.72-.21h-.2l3.52-.93c.76-.12,1.44-.22,1.97-.32,3.8-.68,5.66-1.11,6.56-1.36h.2l.43-.13h.15c.2,0,.42-.02.5-.04l1.61-.47,1.85-.54,2.48-.73,6.44.04h0c.25,0,.53-.01.81-.03,3.38-.29,5.66-.48,6.99-.58.03,0,.06,0,.09,0,.72,0,1.53-.06,1.94-.14.23-.01.45-.04.62-.06l1.73-.26-.89-.04c-.71-.04-1.8.02-2.44.11Zm-19.33-.08c.06,0,.11.01.18.02-.07.02-.13.05-.2.07l-.07.02h-.54c.21-.04.42-.07.63-.11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m260.19,308.88c.03,2.55-1.9,4.65-4.32,4.69-2.42.04-4.41-2.01-4.45-4.56-.03-2.55,1.9-4.65,4.32-4.69,2.42-.04,4.41,2.01,4.45,4.56Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m247.67,319.21h12.54v-.23l-.76-.26-12.81-.15s.34.49,1.04.65Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-60",
    cx: 260.12,
    cy: 316.27,
    rx: 1.72,
    ry: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 247.54,
    y: 313.67,
    width: 12.57,
    height: 5.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m249.26,316.27c0,1.44-.77,2.6-1.72,2.6s-1.72-1.17-1.72-2.6.77-2.6,1.72-2.6,1.72,1.17,1.72,2.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "247.7 318.95 260.21 318.98 260.21 319.48 247.7 319.47 247.7 318.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "m247.7,319.47c-1.28,0-2.33-1.37-2.32-3.05,0-.73.22-1.41.61-1.93.4-.54.94-.83,1.52-.83.53,0,1.02.27,1.39.76.35.47.54,1.09.54,1.75,0,.6-.18,1.16-.5,1.59-.34.45-.79.69-1.27.69h0c-.89,0-1.61-.94-1.61-2.09,0-.5.15-.96.42-1.32.28-.37.66-.58,1.06-.58h0c.75,0,1.36.78,1.35,1.74,0,.88-.56,1.59-1.25,1.59h0c-.36,0-.68-.21-.89-.55.2.41.54.68.92.69h0c.33,0,.63-.17.87-.49.25-.34.39-.79.39-1.27,0-.54-.15-1.05-.44-1.43-.27-.36-.62-.56-.99-.56h0c-.42,0-.82.22-1.12.63-.32.43-.5,1-.5,1.61,0,1.39.81,2.52,1.82,2.52v.52Zm-.14-3.94c-.3,0-.55.37-.56.82,0,.51.29.94.64.94.4.01.74-.49.75-1.07,0-.67-.38-1.22-.85-1.22h0c-.14,0-.28.04-.41.13.13-.07.28-.12.43-.12h0v.52h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 247.74,
    y: 317.98,
    width: 12.4,
    height: 23.22,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "m249.62,366.23l2.65.33s4.75-9.55,5.99-14.72c2.61-10.83,1.77-14.81,1.77-14.81h-6.59s-2.35,19.87-2.35,19.87h0s-1.47,9.34-1.47,9.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "m252.43,366.54c1.22.15,2.08,1.4,1.93,2.79l-5.17-.64.43-2.5,2.81.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "m254.36,366.79h2.52s1.25-29.77,1.25-29.77h-6.52c-3.69,6.73,2.74,29.77,2.74,29.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "m257.19,366.79c1.23,0,2.22,1.14,2.22,2.54h-4.44l-.61-2.54h2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "m252.85,340.72h-1v-.35h1c.78,0,1.42-.67,1.42-1.5v-.53h.34v.53c0,1.02-.79,1.85-1.76,1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "m257.81,337.02h1.32v3.33c0,.73-.59,1.32-1.32,1.32h0v-4.65h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "253.89 365.02 254.36 366.79 256.88 366.79 256.95 365.02 253.89 365.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "252.27 366.56 253.05 364.94 249.9 364.35 249.62 366.23 252.27 366.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "253.91 363.31 249.81 362.5 249.47 364.38 253.58 365.19 253.91 363.31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 253.05,
    y: 363.11,
    width: 4.18,
    height: 1.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m248.41,332.03h.5c.97,0,1.76.79,1.76,1.76v3.58c0,.97-.79,1.76-1.76,1.76h-.5c-.97,0-1.76-.79-1.76-1.76v-3.58c0-.97.79-1.76,1.76-1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "m250.23,318.26s-1.08,1.16-4.3,7.43c-.64,1.26.02,2.82,1.34,3.15l.53.13,3.84-6.85-1.4-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "m260.87,318.61v19.35c0,.21-.16.38-.36.38h-9.79c-.2,0-.36-.17-.36-.38l-.13-13.34v-6.37l.68-.23,2.19-.75.39-.13h3.78l1.56.63,1.71.7.33.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m260.87,328.81v4.9c-.49-1.52-1.15-3.99-1.45-7.05l1.15-.13c.08.8.19,1.56.31,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m260.85,326.5l-1.72.19c-.39-3.95-.35-7.45-.31-8.91l1.71.7c-.03,1.66-.02,4.7.31,8.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 259.14,
    y: 326.16,
    width: 1.49,
    height: 1.21,
    rx: 0.61,
    ry: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m254.77,326.71h-2.3c0-4.02-1.14-7.53-1.56-8.68l1.26-.43.93-.32c.51,1.43,1.67,5.13,1.67,9.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m250.35,337.52l-.02-2.14c1.52-.66,2.57-3.77,2.57-8.67h1.44c0,5.38-.91,8.99-3.98,10.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "m253.3,314.19s-2.9.83-2.58,3.17c.33,2.33,6.41,5.74,6.41,5.74,0,0,3.01-4.25,3.01-6.11,0-1.86-2.38-3.82-6.84-2.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "256.3 320.77 257.27 317.14 253.3 317.12 256.3 320.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m257.27,317.14s.11.72-1.28.72-2.49-.72-2.49-.72v-4.63h3.77v4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m257.27,316.84v-2.9h-3.41s.6,2.61,3.41,2.9Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-217",
    points: "260.87 318.61 267.67 319.84 267.43 322.57 260.87 322.23 260.87 318.61"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 252.86,
    y: 326.16,
    width: 1.56,
    height: 1.21,
    rx: 0.61,
    ry: 0.61
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "m254.42,325.94l-.81-1.44-7.66,3.3h0c.7,1.31,2.23,1.81,3.41,1.11,4.2-2.49,5.05-2.98,5.05-2.98Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-115",
    cx: 254.3,
    cy: 325.1,
    rx: 1.5,
    ry: 1.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m256.48,322.41l-.27-.57-1.81.96c-.7.37-.98,1.27-.63,2.01h0c.31.65,1.05.91,1.67.58l.13-.07c1.01-.54,1.42-1.84.91-2.91Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "m274.17,315.94l-1.56-1.51-6.51,5.76c-.24.19-.31.47-.28.78.11,1.16,1.53,2.14,2.29,1.3,4.16-4.57,6.05-6.32,6.05-6.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "m274.71,315.39c0,.87-.67,1.58-1.5,1.58s-1.5-.71-1.5-1.58.67-1.58,1.5-1.58,1.5.71,1.5,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m275.16,312.49l.74.28-.75,2.18c-.25.72-1.01,1.1-1.69.84h0c-.72-.27-1.09-1.11-.83-1.87l.08-.22c.36-1.05,1.46-1.59,2.45-1.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 250.74,
    y: 338.34,
    width: 9.62,
    height: 1.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m253.38,312.02c-.74,3.1-1.61,5.53-1.94,5.44-.34-.09-.01-2.67.73-5.77s1.61-5.53,1.94-5.44.01,2.67-.73,5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m260.22,311.8c.4,3.16.45,5.77.11,5.82s-.95-2.48-1.35-5.64c-.4-3.16-.45-5.77-.11-5.82s.95,2.48,1.35,5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m252.72,311.37c-.83,2.95-1.81,5.25-2.19,5.13-.38-.12,0-2.6.83-5.55.83-2.95,1.81-5.25,2.19-5.13.38.12,0,2.6-.83,5.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m252.97,309.96h0c.36,0,.66.3.66.68l.02,1.83h-.48c-.46.01-.84-.37-.84-.86v-.95c-.02-.38.27-.69.63-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m256.87,305.8h0c-1.82.03-3.28,1.61-3.25,3.53l.04,3.13c.03,1.92,1.52,3.46,3.34,3.43h0c1.82-.03,3.28-1.61,3.25-3.53l-.04-3.13c-.03-1.92-1.52-3.46-3.34-3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m258.71,312.67c.18,0,.36-.09.48-.25.13-.17.19-.39.16-.62l-.04-.25-.35.06.04.25c.02.12-.01.23-.08.32-.06.07-.14.11-.22.11v.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m255.03,311.33c.04,3.3-.28,5.98-.73,5.98-.44,0-.84-2.66-.88-5.96-.04-3.3.28-5.98.73-5.98.44,0,.84,2.66.88,5.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m253.68,310.59h0l-.06-4.74,4.49-.07h0c.03,2.62-1.95,4.77-4.43,4.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "257.83 314 257.87 313.67 256.7 313.54 256.66 313.87 257.83 314"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "256.84 314.16 256.95 313.29 256.63 313.24 256.52 314.12 256.84 314.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m259.8,305.98l-7.67,3.12-.25-.69c-.82-2.23.24-4.74,2.36-5.6h0c2.12-.86,4.5.25,5.31,2.49l.25.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m260.58,308.79c-2.86-1.33-6.24-.84-8.65,1.26-.42.37-.78.3-.84-.22-.08-.64-.13-.97-.21-1.61-.07-.51.18-1.28.6-1.64,2.41-2.1,5.79-2.59,8.65-1.26.49.23.54.9.61,1.41.08.64.13.97.21,1.61.07.51-.37.45-.37.45Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m259.03,373.3l-2.07-.11c.18-.03.32-.06.41-.08.34-.1.2-.2-.49-.28.79-.06,1.45-.15,1.78-.25h0c.34-.02.65-.05.79-.09l.67-.2c.13-.04.05-.07-.19-.09l.52-.15c.22-.06.31-.12.28-.18h0c.57,0,1.19-.06,1.41-.12l.22-.06h-.75c.86-.06,1.52-.16,1.6-.26h0s-1.81.05-1.81.05c.29-.06.4-.13.24-.18l-.13-.04-3.35.22c-.6.04-1.08.1-1.36.16-.81.03-1.61.08-2.3.15l-.68-.04h-.09c-.34.06-.45.12-.33.16h-.31c-.1.04-.12.07-.07.1-.07.02-.14.03-.2.05l-.5.15s-.06,0-.1,0h0c-.45,0-.96.04-1.14.1l-.67.2c-.18.05.04.1.49.1h.28-.03s0,0,0,0l-.5.15s-3.73.11-4.37.41c-.05.02-.06.05-.05.07l-2.74.1h0s-.01,0-.01,0h0c-.26.04-3.22.49-6.21,1.35-.25.07-6.19,1.74-6.19,1.74h2.84s2.84-.81,2.84-.81l-2.77.89h.22s-11.07,3.21-11.07,3.21h.03c-.06.01-.11.02-.15.03l-.4.12h2.69l.4-.12c.05-.02.09-.03.1-.05l14.52-2.96-6.75,2.84h3.18s10.87-3.08,10.87-3.08h.66s3.89-1.16,3.89-1.16h2.19c.17.02.44.04.78.04h.87c.74,0,1.57-.06,1.95-.15h5.6l3.19-.93h-9.3l1.56-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m236.79,379.58h-3.19s-.72.28-.72.28h5.44c.49-.16-.18-.28-1.53-.28Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-245",
    points: "240 337.1 236.2 336.73 236.61 320.52 240 337.1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-245",
    x: 235.68,
    y: 334.02,
    width: 4.4,
    height: 4.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 236.58,
    y: 329.5,
    width: 11.17,
    height: 8.44
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "230.93 344.09 225.24 378.49 222.63 378.49 222.73 344.09 230.93 344.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "235.81 377.31 232.63 377.31 228.81 344.09 236.2 344.09 235.81 377.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "m223.98,377.38c.74,0,1.35.64,1.35,1.42v1.06h-2.69v-1.06c0-.78.6-1.42,1.35-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "m222.41,320.75l-.25,27.99h-2.84s.24-15.08.24-15.74c.05-8.13,1.6-12.25,1.6-12.25h1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m222.16,348.74v3.91s-3.75-.24-2.14-3.91h2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "m236.61,320.52l-4.36-1.71s-5.84,0-5.84,0l-5.26,1.96.7,9.32.64,19.35h14.31s-.19-28.91-.19-28.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m226.37,315.56s-3.37.97-2.99,3.67c.38,2.7,6.95,6.66,6.95,6.66,0,0,3.97-4.93,3.97-7.08,0-2.15-2.76-4.43-7.94-3.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "226.37 318.96 229.84 323.19 232.29 318.96 226.37 318.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m239.84,336.13h.87c.81,0,1.46.69,1.46,1.54v.07c0,.85-.65,1.54-1.46,1.54h-.87c-.81,0-1.46-.69-1.46-1.54v-.07c0-.85.65-1.54,1.46-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "m238.32,379.86h-5.44l-.24-2.55h3.19c1.35,0,2.45,1.14,2.49,2.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m233.49,310.64h0v3.5h0c.45,0,.82-.39.82-.86v-1.78c0-.48-.37-.86-.82-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m232.29,318.96s-.78.73-2.96.73-2.96-.73-2.96-.73v-4.73h5.92v4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m232.29,318.23v-2.87h-4.89s.86,2.58,4.89,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m226.2,309.33v1.69h.17v4.54s2.01,1.79,4.91,1.48c1.44-.15,2.54-1.44,2.54-2.97v-4.74c0-.57-.12-1.12-.33-1.61-.19-.44-.45-.83-.76-1.17-.67-.71-1.61-1.15-2.63-1.15h-.17c-2.06,0-3.73,1.76-3.73,3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "m233.49,307.72c-.19-.44-.45-.83-.76-1.17-.67-.71-1.61-1.15-2.63-1.15h-.17c-2.06,0-3.73,1.76-3.73,3.93v1.69h.17v.88h1.25v-1.99h.45c.56,0,1.01-.48,1.01-1.07h0c0-.62.47-1.12,1.05-1.12,1.3,0,3.36,0,3.36,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m226.09,310.64h0c-.45,0-.82.39-.82.86v1.78c0,.48.37.86.82.86h.83v-2.63c0-.48-.37-.87-.83-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m231.75,313.27v-.37c.11,0,.21-.04.28-.12.07-.08.11-.19.11-.3l-.02-.63h.35s.02.62.02.62c0,.21-.07.41-.21.56-.14.15-.33.24-.53.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m232.91,314.39h-2.9s.52,1.15,1.52,1.15,1.38-1.15,1.38-1.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "m231.63,305.82l-2.21,1.73h0c-.83-1.17-.59-2.83.52-3.71l2.21-1.73h0c.83,1.17.59,2.83-.52,3.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "m233.04,306.38l-3.82,1.26h0c-.35-1.17.27-2.41,1.38-2.77l3.82-1.26h0c.35,1.17-.27,2.41-1.38,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "m230.13,306.04h4.35c0,.93-.75,1.68-1.68,1.68h-2.67v-1.68h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "m226.02,308h1.93v1.45h-.48c-.8,0-1.45-.65-1.45-1.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "m227.42,308.7l-.51-.22c-.7-.3-1.04-1.15-.75-1.89h0s1.79.77,1.79.77l-.52,1.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 227.38,
    y: 323.19,
    width: 0.56,
    height: 6.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 231.76,
    y: 323.14,
    width: 0.56,
    height: 6.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m233.09,337.72h-4.28c0,2.12-1.64,3.84-3.66,3.84h-.01v4.03h10.43v-4.03h.04c-1.39,0-2.52-1.72-2.52-3.84Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m223.25,406.55h-.01l8.16-3.46h0s0,0,0,0h.02s.04-.02.04-.02h0l2.19-.73c.15,0,.33.01.54.01h1.13l.36-.11c.55-.04,1.03-.09,1.25-.16.33-.1,0-.18-.73-.19,2.75-.85,2.86-1.37,2.86-1.37h-.04l-1.75-.12.05-.02-1.54-.09h-.02s0,0,0,0h.02s.24-.08.24-.08l.27-.08c.51-.04.93-.09,1.14-.15.14-.04.4-.12.71-.21.43,0,.92-.04,1.1-.09l.48-.14.17-.05,1.2-.35c.77-.23-.17-.41-2.1-.41h-1.5c-.37,0-.78.03-.94.08h-.22c-1.12,0-2.4.11-2.85.24l-.62.18-.58.17c-.43,0-.92.04-1.1.09l-.64.19c-.17.05.04.09.47.09-.31.09-.57.17-.71.21-.24.07-.07.12.26.17l-.46.13h-.13s.03-.03.03-.03l-1.91.06-.04.07-2.94.13s-3.25.49-6.27,1.32h0c-.21.06-.41.12-.62.17-.17.05-.47.14-.64.19,1.44,0,2.63,0,3.6-.01l-2.1.89h0s-.07.02-.07.02h.02l-8.73,3.58h0s-.03,0-.04.01l-.43.13h2.55l.43-.13c.06-.02.09-.03.09-.05l10.57-2.79-3.25,2.69h0l-.49.28h4.92c.52-.15-.12-.28-1.42-.28Zm-1.53-4.7l.68-.17-.41.17h-.28Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m216.62,349.82h.91s1.82,5.14,1.82,13.52c0,.46,0,.92-.02,1.38h-2.72l-.28-4.49.28-10.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m219.04,365.71h-.89v-3.55h.89c.93,0,1.69.8,1.69,1.78h0c0,.98-.75,1.78-1.69,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m210.92,334.51h0v5.96h-3.95v-2.01c0-2.18,1.77-3.95,3.95-3.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m214.12,339.85h0v3.36h0c.43,0,.78-.37.78-.83v-1.71c0-.46-.35-.83-.78-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m206.97,339.85h0v3.36h0c-.43,0-.78-.37-.78-.83v-1.71c0-.46.35-.83.78-.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "217.54 349.84 213.22 347.69 208.06 347.69 203.58 349.84 206.31 373.01 218.63 373.01 217.54 349.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "207.26 348.08 210.64 353.02 213.88 348.02 213.48 347.83 207.81 347.79 207.26 348.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "211.01 355.39 207.13 350.31 207.39 350.09 210.96 354.77 213.68 349.92 213.97 350.1 211.01 355.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "218.14 364.81 217.68 354.73 218.01 354.71 218.47 364.8 218.14 364.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m213.48,347.83s-.75.7-2.84.7-2.84-.7-2.84-.7v-4.54h5.69v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m213.48,347.13v-2.75h-4.7s.83,2.48,4.7,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m213.72,344.65c-3.09,3.72-6.35.05-6.35.05v-6.41c0-.85.63-1.55,1.41-1.55h3.54c.78,0,1.41.69,1.41,1.55v6.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "206.31 373.01 209.83 405.58 212.3 405.38 213.63 373.01 206.31 373.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "218.63 373.01 222.3 404.33 219.29 404.33 211.63 373.01 218.63 373.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m222.31,404.33h-3.01l.46,2.49h4.92c0-1.38-1.06-2.49-2.36-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m211.1,404.33h0c-.7,0-1.27.6-1.27,1.34v1.15h2.55v-1.15c0-.74-.57-1.34-1.27-1.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "207.8 347.83 208.79 350.88 210.64 348.53 207.8 347.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "213.48 347.83 212.49 350.88 210.64 348.53 213.48 347.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m210.62,344.66c-.43,0-.9-.08-1.34-.35l.16-.31c1.06.64,2.41.06,2.42.06l.13.32s-.64.27-1.37.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m206.31,373.01l.31,2.89s5.96.45,6.18-2.89h-6.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m213.41,373.01c.78,3.34,5.56,2.89,5.56,2.89l-.34-2.89h-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m212.8,343.91s-1.79.15-2.16-.39c-.28.6-2.16.39-2.16.39,0,0,.44-1.41,2.21-1.41s2.11,1.41,2.11,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m213.72,338.31v3.37c0,1.66-1.36,2.19-1.36,2.19,0,1.36-1.43,1.46-1.82,1.46-.39,0-1.82-.1-1.82-1.46,0,0-1.36-.53-1.36-2.19v-3.37h-.4v6.78c0,1.99,3.51,2.63,3.58,2.62.06,0,3.58-.63,3.58-2.62v-6.78h-.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "211.1 342.51 210.36 342.51 210.36 342.15 210.74 342.15 210.67 341.09 211 341.07 211.1 342.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m214.9,341.12h0c-3.14,0-5.68-2.68-5.68-5.99v-.6c0-.4.31-.72.68-.72h1.5c1.93,0,3.49,1.65,3.49,3.69v3.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "213.53 380.03 213.17 380.01 213.31 377.56 214.52 376.22 214.79 376.48 213.66 377.73 213.53 380.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m210.64,346.48h0c-.29,0-.52-.24-.52-.55v-.51c0-.3.23-.55.52-.55h0c.29,0,.52.24.52.55v.51c0,.3-.23.55-.52.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m207.14,338.8h0v-2.63h1.05v1.52c0,.61-.47,1.11-1.05,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m204.53,349.82l-.95.02s-1.79,5.11-1.79,13.49c0,.46,0,1.27.02,1.73l2.72-.35.28-4.49-.28-10.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m201.81,365.07c5.36-.16,7.13-.35,7.13-.35v-2.89l-7.13-.07v3.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 208.94,
    y: 361.83,
    width: 1.1,
    height: 2.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "m213.99,354.22l.68-.06c.6-.05,1.05-.61,1-1.24l-.34-4.34-1.84-.81.51,6.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "214.59 361.85 215.33 361.79 214.73 354.15 213.99 354.22 214.59 361.85"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m218.48,361.88l-.18,3.05c0,.07-.03.14-.06.19-.07.11-.19.18-.33.17l-6.14-.41c-.13,0-.25-.09-.3-.21-.03-.06-.04-.13-.04-.2l.18-3.05c0-.1.05-.19.11-.26.07-.07.17-.11.27-.11l6.14.41c.2.01.35.2.34.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-250"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "m213.81,362.41l-.12,2c-.01.23-.2.4-.41.38l-1.82-.12c-.03-.06-.04-.13-.04-.2l.16-2.62,1.86.13c.21.01.38.21.36.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-250"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "m218.46,362.31l-.16,2.62c0,.07-.03.14-.06.19l-.73-.05c-.21-.01-.38-.21-.36-.44l.12-2c.01-.23.2-.4.41-.38l.78.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m217.57,362.73c-.02.3-.26.53-.55.51l.07-1.08c.28.02.5.28.48.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m213.43,363.87c-.01.2.13.37.32.38l.04-.72c-.19-.01-.35.14-.36.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m215.33,364.97h0c-.92-.06-1.62-.9-1.56-1.87l.09-1.43c.06-.97.85-1.71,1.77-1.64h0c.92.06,1.62.9,1.56,1.87l-.09,1.43c-.06.97-.85,1.71-1.77,1.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-248"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m218.37,363.68l-.08,1.25c0,.07-.03.14-.06.19-.07.11-.19.18-.33.17l-2.76-.19-.11-.04-.79-.59,2.16-2.75,1.97,1.95Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m215.32,365.09h0c-.85-.06-1.49-.83-1.43-1.72l.07-1.09c.05-.89.78-1.57,1.63-1.51h0c.85.06,1.49.83,1.43,1.72l-.07,1.09c-.05.89-.78,1.57-1.63,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "m217.13,363.32c-.06.99-.87,1.74-1.8,1.67s-1.65-.91-1.59-1.9.87-1.74,1.8-1.67,1.65.91,1.59,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m216.94,363.31c-.05.88-.77,1.54-1.6,1.49-.22-.01-.42-.08-.6-.18h0c-.24-.13-.43-.32-.58-.56-.17-.27-.25-.61-.23-.96.05-.88.77-1.54,1.6-1.49.29.02.56.12.78.29.41.31.67.83.63,1.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "m216.72,363.29c-.05.75-.65,1.31-1.36,1.26-.71-.05-1.24-.69-1.2-1.44.05-.75.65-1.31,1.36-1.26.71.05,1.24.69,1.2,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m215.35,364.6c-.73-.05-1.29-.72-1.24-1.49.05-.77.68-1.36,1.41-1.31.73.05,1.29.72,1.24,1.49-.05.77-.68,1.36-1.41,1.31Zm.16-2.7c-.68-.05-1.27.5-1.32,1.22s.48,1.34,1.16,1.39c.68.05,1.27-.5,1.32-1.22s-.48-1.34-1.16-1.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m216.35,363.27c-.03.54-.47.94-.98.91s-.89-.5-.86-1.03.47-.94.98-.91.89.5.86,1.03Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-248"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m216.31,361.91l-1.57,2.71h0s0,0,0,0c0,0-.18-.11-.33-.24-.14-.13-.25-.32-.25-.32-.17-.27-.25-.61-.23-.96.05-.88.77-1.54,1.6-1.49.29.02.56.12.78.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m216.17,363.02c0,.1-.09.18-.19.17-.1,0-.17-.09-.16-.2,0-.1.09-.18.19-.17.1,0,.17.09.16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m215.84,363.49c0,.05-.05.09-.1.09s-.09-.05-.09-.1c0-.05.05-.09.1-.09s.09.05.09.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "m216.33,360.59l-1.46-.1c-.08,0-.14-.08-.13-.16h0c0-.08.07-.15.15-.14l1.46.1c.08,0,.14.08.13.16h0c0,.08-.07.15-.15.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "218.11 361.83 217.6 361.8 217.6 361.66 218.12 361.69 218.11 361.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "217.91 362.01 217.58 361.99 217.59 361.85 217.92 361.87 217.91 362.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "217.95 365.04 217.62 365.02 217.63 364.88 217.96 364.9 217.95 365.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "218.13 361.47 217.39 361.42 217.41 361.21 218.14 361.26 218.13 361.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "m213.08,361.41v.22c-.02.09-.07.16-.14.15l-1.35-.09.02-.27c0-.1.05-.2.11-.26l1.25.08c.06,0,.11.08.11.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m212.88,361.48c0,.07-.16.11-.34.1-.18-.01-.33-.08-.33-.14,0-.07.16-.11.34-.1.18.01.33.08.33.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m215.25,364.92c-.05,0-.11-.02-.16-.03l.02-.08c.05.01.1.02.16.03v.08Zm.17.01v-.08c.05,0,.11,0,.16,0v.08s-.1,0-.16,0Zm.33-.03l-.02-.08c.05-.01.1-.02.15-.04l.02.08c-.05.02-.11.03-.16.04Zm-1.12-.2s-.09-.06-.14-.09l.05-.07s.09.06.13.09l-.04.07Zm-.27-.2s-.08-.08-.12-.12l.06-.06s.07.08.11.12l-.05.06Zm2,.13l-.04-.07s.09-.06.13-.1l.05.06s-.09.07-.13.11Zm-2.22-.39s-.06-.09-.09-.14l.07-.04s.06.09.09.14l-.06.05Zm2.48.17l-.06-.06s.07-.08.1-.12l.06.05s-.07.09-.11.13Zm.38-1.27c0-.06,0-.11-.01-.17h.08s.01.1.01.16h-.08Zm-.04-.33c-.01-.05-.03-.11-.05-.16l.07-.03c.02.05.03.11.05.17l-.08.02Zm-.11-.31s-.05-.1-.08-.15l.07-.04s.06.1.08.15l-.07.04Zm-2.52-.44l-.06-.06s.08-.08.12-.12l.05.06s-.08.07-.12.11Zm2.36.15s-.07-.09-.1-.13l.06-.06s.07.09.11.13l-.06.05Zm-2.12-.37l-.04-.07s.09-.06.14-.09l.04.07s-.09.06-.13.09Zm.28-.16l-.03-.08c.05-.02.1-.04.16-.06l.02.08c-.05.02-.1.03-.15.06Zm1.37.09s-.09-.05-.14-.07l.03-.08c.05.02.1.05.15.08l-.04.07Zm-1.07-.19l-.02-.08c.05-.01.11-.02.16-.02v.08s-.1.01-.15.02Zm.78.05s-.1-.03-.15-.04l.02-.08c.05.01.11.03.16.05l-.02.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "216.37 360.08 214.93 359.98 214.94 359.81 216.38 359.9 216.37 360.08"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-249"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m213.28,364.98l-.38-.03s.14-2.07.2-3.16c.03-.51.07-.66-.11-.67l.52.03-.23,3.82Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "m209.46,353.64h0c-.93.32-1.93-.22-2.23-1.21l-1.34-4.38,1.69-.57,1.89,6.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "211.69 360.93 210.98 361.17 208.75 353.88 209.46 353.64 211.69 360.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m212.93,360.58h.54c0,1.69-1.37,3.06-3.06,3.06h-.37v-.18c0-1.59,1.29-2.89,2.89-2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m217.28,363.27h0c1.51,0,2.74,1.23,2.74,2.74v.33h-.16c-1.42,0-2.58-1.16-2.58-2.58v-.49h0Z",
    transform: "translate(437.31 729.61) rotate(-180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "204.64 359.97 204.1 355.63 204.43 355.58 204.97 359.92 204.64 359.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "205.81 365.22 205.79 364.87 208.77 364.72 208.77 364.04 209.11 364.04 209.11 365.06 205.81 365.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "209.11 361.83 208.77 361.83 208.77 361.66 205.92 361.66 205.92 361.31 209.11 361.31 209.11 361.83"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 206.31,
    y: 372.84,
    width: 12.32,
    height: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 206.57,
    y: 370.5,
    width: 11.27,
    height: 0.35
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m276.31,401.86h-1.21c0-.12-.13-.25-.34-.38h.12s-2.07-.91-2.07-.91l-3.78-.13,1.59-.47h.26c.41,0,.87-.04,1.03-.09l.32-.09.29-.08.73-.21h0l.61-.18c.7-.2-.05-.37-1.66-.37h-2.8c-1.08,0-2.34.11-2.81.25l-.16.05h-1.39c-.6,0-1.24.03-1.78.07,0,0-.01,0-.02,0-.78.07-.73.18.06.18h2.21l-.43.13h0s-.03,0-.05.01l-1.42.42c-.38.11-.14.21.52.25l-.41.12h-.03s-4.88.22-4.88.22c0,0-2.26.19-4.4.71-.73.18-1.16.3-1.42.39h0s0,0,0,0c-.07.02-.13.04-.18.06l-2.55.88h2.07s-2.7.83-2.7.83h.13l-8.89,3.19h-.01c-1.31,0-2.79.12-3.31.28h5.36l.96-.28h0l9.51-2.4-4.88,2.5c-.08.01-.15.03-.21.04l-.43.13h2.55l.43-.13s.06-.02.08-.03h.03l11.17-3.23h1.2,0,2.78l-.08.02h1.99c.24,0,.48,0,.71-.02h2.62l5.87-1.72h-.91,0Zm-4.66,0h-1.37l1.19-.1.18.1Zm-1.85,0h-1.57l.8-.22.77.22Zm-3.2-2.59s.03,0,.05,0c-.02,0-.03,0-.05,0Zm-.19,0s-.04,0-.06,0c.01,0,.03,0,.04,0,0,0,0,0,.01,0Zm-.25,0s-.05,0-.08,0c.03,0,.05,0,.08,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "250.54 373.79 250.41 405.53 247.94 405.53 242.79 373.79 250.54 373.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "237.8 373.79 239.93 404.48 242.94 404.48 244.79 373.79 237.8 373.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m248.98,378.22c-.07-.03-1.74-.68-2.13-1.86-.38-1.15-.18-2.39-.18-2.44l.33.06s-.19,1.21.16,2.27c.34,1.02,1.92,1.64,1.93,1.65l-.11.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m238.29,378.18l-.15-.25s.93-.62,1.13-1.66c.21-1.08.1-2.3.1-2.31l.28-.03c0,.05.12,1.28-.1,2.4-.23,1.17-1.22,1.82-1.26,1.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "237.2 349.75 241.35 347.84 246.46 347.84 250.93 349.06 250.54 375.65 237.79 375.65 237.2 349.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m241.35,347.97s.71,1.12,2.69,1.12,2.69-1.12,2.69-1.12v-7.23h-5.37v7.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m241.35,347.76v-3.48h4.44s0,3.48-4.44,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m239.92,404.48h3.01v2.49h-5.38c0-1.38,1.06-2.49,2.36-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m249.14,404.48h0c.7,0,1.27.6,1.27,1.34v1.15h-2.55v-1.15c0-.74.57-1.34,1.27-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "m241.58,339.38h-3.82c-.79,0-1.22-1.01-.66-1.6,0,0,0,0,.01-.01.39-.41.93-.67,1.53-.67h.77c1.2,0,2.17,1.02,2.17,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m242.02,337.31h.12v3.21h-2.17v-1.16c0-1.13.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m242.51,346.87c2.22-.23,3.48-1.85,3.48-1.85v-6.32c0-.76-.52-1.38-1.16-1.38h-2.16c-2.25,0-2.69,1.98-2.69,3.33v3.75c0,1.44,1.17,2.61,2.53,2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m245.99,336.26h0c.95,0,1.73.82,1.73,1.82v3.99h-3.08v-4.38c0-.79.61-1.43,1.35-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m246.97,340.52h.75v2.43c0,.41-.34.75-.75.75h0c-.41,0-.74-.33-.74-.74v-1.69c0-.41.33-.74.74-.74Z",
    transform: "translate(493.95 684.22) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m241.84,343.35c-.38,0-.68-.32-.68-.72v-.18h.31v.18c0,.21.17.39.37.39v.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m244.04,339.1h0c.81,0,1.46.69,1.46,1.54v2h-1.46v-3.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "243.9 382 243.18 378.09 242.01 377.15 242.21 376.87 243.49 377.89 244.23 381.94 243.9 382"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "m247.72,337.76v1.62h-5.38c-.4,0-.73-.29-.85-.69-.21-.73-.54-1.37-1.46-1.6v-.43c0-1.24.88-2.24,1.96-2.24h2.8c1.62,0,2.93,1.5,2.93,3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "m244.88,339.38h-2.53c-.4,0-.75-.28-.87-.68-.21-.72-.76-1.29-1.45-1.51-.19-.06-.4-.09-.62-.09h3.3c1.2,0,2.17,1.02,2.17,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m241.77,344.96c-.75,0-1.16-.42-1.18-.44l.23-.25-.12.12.12-.13s.34.34.95.34,1.13-.24,1.14-.24l.14.32s-.57.28-1.28.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m242.15,363.64h.64c1.37,0,2.48,1.11,2.48,2.48h0c0,1.03-.83,1.86-1.86,1.86h-1.26v-4.34h0Z",
    transform: "translate(487.42 731.62) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-227",
    x: 244.61,
    y: 360.73,
    width: 14.23,
    height: 15.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 251.73,
    y: 360.73,
    width: 8.02,
    height: 15.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 247.4,
    y: 360.73,
    width: 1.46,
    height: 1.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 247.43,
    y: 374.51,
    width: 1.46,
    height: 1.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 244.96,
    y: 363.79,
    width: 1.21,
    height: 0.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 246.48,
    y: 363.79,
    width: 0.39,
    height: 0.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 247.18,
    y: 363.79,
    width: 0.39,
    height: 0.77
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m254.51,372.14h.64c1.37,0,2.48,1.11,2.48,2.48h0c0,1.03-.83,1.86-1.86,1.86h-1.26v-4.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m251.26,355.63l-.22-5.95s5.16,6.94,6.7,11.35c.15.43.46,1.17.62,1.61l-2.63.78-4.46-7.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m258.36,362.64c-1.6,7.93-2.25,10.55-2.25,10.55l-1.6-1.05,1.11-8.95,2.74-.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "250.93 349.06 256.09 357.24 252.55 361.02 250.36 358.13 250.93 349.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "243.87 367.73 235.59 368.14 235.59 365.16 243.87 365.16 243.87 367.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "238.61 355.65 235.1 359.63 235.59 368.14 238.38 367.52 238.61 355.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "m237.2,349.75s-1.61,1.73-1.99,6.38c-.27,3.28,0,4.7,0,4.7l3.67-.31-.39-7.16-1.29-3.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-197",
    points: "250.47 358.77 248.54 356.91 248.69 356.74 250.61 358.6 250.47 358.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-197",
    points: "238.41 360.29 238.11 354.43 238.33 354.42 238.63 360.27 238.41 360.29"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m216.27,108.05l-4.55-.35s.02,0,.02,0l1.1-.38c.34-.01.67-.05.81-.09l.34-.1h.02s.12-.04.12-.04c.38-.03.71-.07.87-.12l1.05-.31c.44-.13.25-.24-.4-.31.01-.09-.34-.14-.97-.14h-6.79c-.25.08-.35.15-.31.2-.37-.05-.48-.12-.21-.2l-.3.09c-.38.11,0,.21.88.25-.33.05-.6.1-.79.15l-.95.31-.08.02h0s-.91.27-.91.27c-.07.01-.12.02-.16.03l-.21.06h.05l-.67.19s-.07.1.82.14l-5.27.32h0c-.07.01-4.28.7-7.25,1.57-2.97.87-4.69,1.54-4.69,1.54h2.52s-1.95,0-1.95,0h0s-.35,0-.35,0l-.25.07h.12c-2.01.34.98.37.98.37l1.04-.31-9.19,3h.48,0s-.64,0-.64,0c-1.41,0-3,.13-3.56.3h5.54s1.27-.3,1.27-.3h-2.25s0,0,0,0h2.25s10.71-2.45,10.71-2.45l-5.31,2.53c-.21.02-.38.05-.48.08l-.47.14h2.74s.47-.14.47-.14c.1-.03.13-.06.08-.08l12.44-3.26h.13l.69-.21h0l3.43-1.07,2.1-.47-3.23.97h0l-2.93.86h0l-.25.07h0l-1.25.37s3.43-.02,3.68-.37h.02l.25-.07h-.26s.71,0,.71,0c0,0,3.73-.83,6.19-1.54,3.63-1.06,3.01-1.57,2.96-1.61h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "183.89 81.16 192.2 81.16 190.81 112.8 188.5 112.8 183.89 81.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "178.51 81.16 186.04 81.16 182.81 111.92 179.72 111.92 178.51 81.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m179.56,111.92h3.25s-.25,2.69-.25,2.69h-5.54c0-1.48,1.14-2.68,2.55-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m189.65,111.92c.76,0,1.37.65,1.37,1.45v1.24s-2.74,0-2.74,0v-1.24c0-.8.61-1.45,1.37-1.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "180.11 85.22 180.47 85.23 180.56 111.93 180.2 111.93 180.11 85.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "184.9 87.96 184.52 85.79 183.25 84.78 183.47 84.48 184.85 85.58 185.25 87.89 184.9 87.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m196.37,69.82c0,6.49-.91,13.96-.91,13.96h-2.89s0-28.52,0-28.52h1.27s2.54,4.6,2.54,14.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m192.57,83.78v3.98s3.82-.24,2.18-3.98h-2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 192.56,
    y: 83.78,
    width: 2.45,
    height: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m175.5,69.58c0,7.86.58,13.96.58,13.96h2.56s0-28.52,0-28.52l-1.27.35s-1.88,6.3-1.88,14.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m178.65,83.54v3.98s-3.5-.24-2-3.98h2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 176.3,
    y: 83.54,
    width: 2.35,
    height: 0.67
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "177.38 55.37 182.34 51.96 187.83 51.96 193.85 55.27 191.97 71.47 192.24 83.1 185.83 83.11 182.39 81.16 180.02 83.11 177.07 83.11 177.38 55.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m188.11,52.09s-.52.91-.97,4.18c-.1.71-.19,1.52-.27,2.47-.57,6.43-1.04,24.38-1.04,24.38l-3.45-1.94-2.37,1.95s-.84-23.65,1.86-30.26h0c.14-.35.29-.65.46-.89l2.33.13h.11s3.34,0,3.34,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m188.11,52.09s-.52.91-.97,4.18l-2.05,4.11-2.3,6.29-.91-13.81h0c.14-.35.29-.65.46-.89l2.33.13h.11s3.34,0,3.34,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m185.76,53.2l-1.13,1.66s.87,1.39.77,2.27c-.1.88-.31,3.23-.31,3.23l-2.3,6.29-.4-6.18s.27-2.95.41-3.75c.15-.82,1.11-1.88,1.11-1.88l-.77-1.65h2.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 177.59,
    y: 61.99,
    width: 1.47,
    height: 0.38
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "192.56 76.03 192.38 60.56 192.74 60.56 192.77 76.03 192.56 76.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "177.04 83.11 177.01 60.56 177.37 60.56 177.4 83.11 177.04 83.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "192.42 64.67 191.18 61.22 191.52 61.09 192.75 64.54 192.42 64.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "182.51 80.55 182.27 80.27 183.71 78.85 183.71 69.37 182.63 67.25 182.95 67.07 184.07 69.27 184.07 79.01 182.51 80.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m182.36,70.07c-.36.5.18,1.07.65.69.36-.5-.18-1.07-.65-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m182.36,73.14c-.36.5.18,1.07.65.69.36-.5-.18-1.07-.65-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m182.37,76.21c-.36.5.18,1.07.65.69.36-.5-.18-1.07-.65-.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "192.63 69.7 192.5 69.35 194.11 68.66 194.25 69.01 192.63 69.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "192.72 70.3 192.67 69.92 194.85 69.61 194.9 69.98 192.72 70.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "187.11 67.35 186.8 67.16 190.23 60.68 187.7 59 190.24 56.84 188.06 52.57 188.38 52.39 190.7 56.94 188.32 58.96 190.71 60.55 187.11 67.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "179.74 66.6 178.3 59.24 179.63 58.43 178.82 57.32 181.17 53.2 181.48 53.4 179.25 57.29 180.16 58.54 178.71 59.43 180.09 66.52 179.74 66.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m178.45,74.21c0,.26.2.47.45.47.25,0,.45-.21.45-.47,0-.26-.2-.47-.45-.47-.25,0-.45.21-.45.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m178.45,71.14c0,.26.2.47.45.47.25,0,.45-.21.45-.47,0-.26-.2-.47-.45-.47-.25,0-.45.21-.45.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m188.28,83.11h-2.45s.12-4.15.12-4.15l-.04,1.57c-.04,1.41,1.03,2.58,2.37,2.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m178.67,83.11h1.35s-.04-4.15-.04-4.15l.03,1.57c.02,1.41-.58,2.58-1.34,2.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m182.01,52.53s.85,1.12,2.9,1.12,3.2-1.56,3.2-1.56l-.42-7.07h-5.57l-.12,7.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m182.12,52.3v-3.61h4.6s0,3.61-4.6,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m182.18,51.46v-3.67s4.68,0,4.68,0c0,0,0,3.67-4.68,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m185.78,39.48h-2.1c-1.95,0-3.53,1.67-3.53,3.73l.15,4.02,7.22-.25c.76,0,1.37-.65,1.37-1.44v-2.79c0-1.81-1.39-3.27-3.1-3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m180.26,51.21c3.98,1.62,6.34-1.35,6.34-1.35v-5.95s.3-3.07-2.39-3.06h-1.11c-2.37,0-2.84,2.32-2.83,3.9v6.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 180.53,
    y: 48.75,
    width: 2.54,
    height: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m186.97,40.84h0c.8,0,1.45.69,1.45,1.53v4.6h0c-1.43,0-2.59-1.22-2.59-2.73v-2.2c0-.66.51-1.2,1.14-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m187.64,45.34h0c.43,0,.78.37.78.82v1.7c0,.45-.35.82-.78.82h-.79s0-2.52,0-2.52c0-.46.35-.83.79-.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "182.01 47.92 181.27 47.92 181.39 46.77 181.72 46.81 181.64 47.57 182.01 47.57 182.01 47.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m186.13,44.34s-.04,1.6-.69,3.33c-.65,1.73-2.49,1.48-2.49,1.48,0,0-.15.96-1.09.96s-1.11-.91-1.16-.98c-.42-.57-.44-2.94-.44-2.94v5.02s.44,1.5,2.54,1.5c3.43,0,4.05-2.21,4.05-2.21v-4.73l-.73-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m181.45,41.18h.83v.8h-.83c-1.52,0-2.76-1.08-2.76-2.42v-.8c0,1.34,1.24,2.42,2.76,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m187.64,41.17v.81h-6.26c-1.19,0-2.16-1.45-2.16-3.23v-.07h6.76c.92,0,1.67,1.11,1.67,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m183.59,41.97c1.24,0,2.25,1.06,2.25,2.37h0v-2.37h-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m181.46,48.05h.93c.77,0,1.4.63,1.4,1.4h-.93c-.77,0-1.4-.63-1.4-1.4h0Z",
    transform: "translate(365.25 97.46) rotate(179.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m181.6,48.05h.32c0,.77-.63,1.4-1.4,1.4h-.32c0-.77.63-1.4,1.4-1.4Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m428,201.16c.68-.2.16-.37-1.15-.43l.09-.03c.06-.02.07-.03.04-.05l.51-.15c.83-.24-.14-.44-2.15-.44h-.14c-1.35,0-2.84.09-3.92.22-.52.06-.95.14-1.22.22l-1.57.46c-.46.14-.25.26.6.32.23.02.48.02.74.03l-.38.11-.16.05h0l-4.54.19h0s0,0,0,0c0,0-3.1.35-5.81,1.2-.12.04-.23.07-.35.11-2.86.96-2.68,1.17-2.68,1.17h.44,0s-.43,0-.43,0c-1.76.27-1.33.42-.9.48-1.96.76-3.12,1.47-3.78,1.99l-2.76.81h-.33c-1.33,0-2.84.13-3.37.28h4.83s2.93,0,2.93,0l.79-.28,3.1-1.05c1.01-.2,2.14-.42,3.38-.66,2.07-.4,4.17-.73,5.57-1.06.75-.05,2.79-.22,2.9-.54h-1.26l-.23.07c.25-.15.32-.31.17-.48,0,0,1.04-.64,5.37-1.14l-5.31,1.56h1.26s1.67-.22,5.34-1.17c.15-.04.29-.08.42-.11,3.05-.84,2.43-1.19,2.42-1.2l1.57-.46Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m401.55,144.35h0c2.26,0,4.09,1.83,4.09,4.09v4.72h-4.09v-8.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m404.7,175.18v5.07s2.46-1.54,1.26-5.07h-1.26Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m392.39,163.9c0,.33.02.67.04,1.02.41,8.66,1.33,10.61,1.33,10.61h1.26v-22.52h-.93s-1.89,3.2-1.7,10.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m395.01,175.54v4.72s-2.46-1.18-1.26-4.72h1.26Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m394.09,171.43c0,16.6,5.36,33.73,5.36,33.73h2.9l-1.7-33.73h-6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "m399.27,205.17c-1.33,0-2.41,1.14-2.41,2.54h5.65s-.17-2.54-.17-2.54h-3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m394.09,171.43h9.14s-1.36-6.87,2.27-11.51l.14-7.27-3.53-1.12-4.11-.2-3.91,1.68v18.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m402.08,151.54l-5.26,7.91s-.82-6.49,1.17-8.12l4.09.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "m399.46,154.45l-.42-2.42-1.53,2.11-.1-.15c-.42-.65-.1-1.74-.09-1.79l.25.12s-.21.75-.03,1.27l1.65-2.28.43,2.52,1.55-1.59.16.28-1.89,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m398,151.54s-.12.72,1.38.72,2.7-.72,2.7-.72v-4.63h-4.09v4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m398,150.92v-2.9h3.7s-.65,2.61-3.7,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m402.89,142.58v2.46h-.78v3.41s-2.55,2.37-4.95,1.19c-1.05-.52-1.7-1.66-1.7-2.89v-4.17c0-.72.17-1.39.48-1.96.63-1.19,1.81-2,3.16-2h.14c2.01,0,3.64,1.77,3.64,3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m402.89,142.58v2.24c-.6.19-1.3.13-1.3.13,0,0-2.48-.45-3.92-1.78-1.02-.94-1.51-1.82-1.73-2.55.63-1.19,1.81-2,3.16-2h.14c2.01,0,3.64,1.77,3.64,3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m403.23,171.43c3.39,7.13,1.04,11.45-.25,18.28-1.77,9.35-2.77,15.46-2.77,15.46h-2.7v-33.73h5.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m397.18,205.17c-1.33,0-2.41,1.14-2.41,2.54h4.82l.66-2.54h-3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m402.27,143.59h.73v2.28c0,.4-.33.73-.73.73h0c-.4,0-.73-.33-.73-.73v-1.57c0-.4.33-.73.73-.73Z",
    transform: "translate(804.55 290.2) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m396.82,146.21h-.57s-.1-.02-.13-.06-.05-.09-.04-.14l.32-2.16.34.05-.29,1.95h.37v.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m398.21,148.27s-.09,0-.14,0l.03-.36c.77.08.95-.7.96-.73l.33.08c-.08.36-.43,1.01-1.18,1.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "397.68 195.61 397.34 195.61 397.34 176.41 395.87 175.68 396.02 175.35 397.68 176.19 397.68 195.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "401.34 197.65 401.67 197.72 400.21 205.34 399.89 205.34 401.34 197.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 397.8,
    y: 204.98,
    width: 4.18,
    height: 0.36
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m407.33,163.55c0,.33-.02.67-.04,1.02-.41,8.66-1.33,10.61-1.33,10.61h-1.26v-21.53c0-.54.42-.98.93-.98h0s1.89,3.2,1.7,10.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "396.82 168.27 398.22 171.43 395.74 171.43 396.82 168.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m396.49,160.69c-.34.48.17,1.01.62.65.34-.48-.17-1.01-.62-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m396.49,163.59c-.34.48.17,1.01.62.65.34-.48-.17-1.01-.62-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m396.49,166.5c-.34.48.17,1.01.62.65.34-.48-.17-1.01-.62-.65Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m220.16,94.12s1.53-.2,4.88-1.05h.93s3.79-1.15,2.68-1.53c0,0,0,0,0,0h0s-1.32-.07-1.32-.07h0l-2.08-.12h0s.17-.05.17-.05l.39-.11c.32,0,.65-.02,1.01-.03,1.29-.06,2.41-.19,2.89-.33l1.63-.48c.11-.03.19-.06.24-.09.2,0,.39-.02.59-.02.65-.27-.66-.34-.66-.34,0,0-.37.01-.95.04-.39-.03-.87-.04-1.44-.04h-.14c-.21,0-.42,0-.63,0,.01-.12-.69-.21-1.87-.21-1.52,0-3.25.14-3.85.32-.52.15-.04.28,1.08.31-.02,0-.05.01-.07.02l-.51.15c-.14.01-.26.03-.33.05l-.59.17c-.16.05.04.09.45.09h.21l-.12.03h0l-1.82.53h-.02s-3.02.09-3.02.09h0l-1.08.03c-5.49.6-8.18,1.64-8.18,1.64h.99c-2.13.76-1.97.94-1.97.94h1.31l5.53-1.62c1.02.5-1.97,1.02-1.97,1.02h.7l-1.26.16c-1.39.18-2.43.34-3.24.5l.24-.07h-1.31c-2.14.33-1.25.51-.84.56-.93.35-1.05.68-1.76,1.1-.43.25-.83.48-1.2.69l-4.2,1.09h0l-1.15.29h8.04c.52-.16-.16-.29-1.52-.29h-.34l2.87-.84c2.96-.53,6.8-1.27,10.17-2.06.9-.07,2.38-.22,2.48-.5h-.45,0s.45,0,.45,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "m201.48,27.25c0,1.6-1.23,2.91-2.75,2.91s-2.75-1.3-2.75-2.91,1.23-2.91,2.75-2.91,2.75,1.3,2.75,2.91Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-221",
    cx: 199.76,
    cy: 28.12,
    rx: 1.49,
    ry: 1.57
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m193.47,52.01c0,.34.02.7.04,1.06.42,8.99,1.38,11.02,1.38,11.02h1.31v-23.37h-.97s-1.96,3.32-1.76,11.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m196.2,64.09v5.27s-2.55-1.59-1.31-5.27h1.31Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "m208.99,52.39c0,.34-.02.7-.04,1.06-.42,8.99-1.38,11.02-1.38,11.02h-1.31v-23.37h.97s1.96,3.32,1.76,11.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "m207.63,54.98h2.17s-.14-10.47-2.58-13.89l.41,13.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "m206.26,64.46v4.89s2.55-1.22,1.31-4.89h-1.31Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m207.22,60.2c0,17.23-5.56,35.01-5.56,35.01h-3.01l1.76-35.01h6.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "m201.84,95.22h-3.19l-.18,2.59h5.86c-.03-1.43-1.13-2.59-2.5-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "m208.15,58.73h-10.42s1.41-5.65-2.35-10.47l-.14-7.54,3.67-1.16,4.27-.21,4.05,1.74.93,5.33v12.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m197.17,40.1s2.19,2.81,5.76,2.63c3.57-.18,2.71-2.32,2.71-2.32l-2.48-1.06-4.25.21-1.75.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m203.17,39.56s.13.74-1.44.74-2.81-.74-2.81-.74v-4.81h4.24v4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m203.17,38.91v-3.01h-3.84s.68,2.71,3.84,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m198.12,30.26v2.56h.81v3.54s2.65,2.46,5.14,1.23c1.09-.54,1.76-1.73,1.76-3v-4.33c0-.74-.18-1.44-.5-2.04-.65-1.24-1.88-2.07-3.28-2.07h-.14c-2.09,0-3.78,1.84-3.78,4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "m198.12,30.26v2.33c.62.2,1.35.13,1.35.13,0,0,.11-.89,1.61-2.28,1.06-.98,2.12-1.53,4.25-2.22-.65-1.24-1.88-2.07-3.28-2.07h-.14c-2.09,0-3.78,1.84-3.78,4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m197.73,60.2c-3.51,7.4-1.08,11.88.26,18.97,1.84,9.7,2.87,16.04,2.87,16.04h2.81v-35.01h-5.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m198.78,63.79h-1.05v-.37h1.05c.82,0,1.49-.71,1.49-1.57v-.55h.35v.55c0,1.07-.83,1.94-1.84,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "m204.01,95.22h-3.19l.67,2.59h5.02c-.03-1.43-1.13-2.59-2.5-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m198.72,31.3h0c.42,0,.76.34.76.76v2.37h-.76c-.42,0-.75-.34-.75-.75v-1.63c0-.42.34-.75.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m204.39,34.02v-.37c.23,0,.41-.2.41-.44v-.13h.35v.13c0,.45-.34.81-.77.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m202.94,36.16c-.78,0-1.14-.67-1.23-1.05l.34-.09s.21.85,1,.76l.04.37c-.05,0-.1,0-.15,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m203.67,60.2h1.48v4.28c0,.82-.66,1.48-1.48,1.48h0v-5.77h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "199.48 32.34 199.78 36.55 200.39 30.57 199.48 32.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m199.02,32.48c.99-4.72,5.42-6.34,5.42-6.34,0,0,1.56.65,1.82,3.06-3.51,1.37-7.23,3.28-7.23,3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "m196.2,40.41v15.18h-3.53s-.89-9.49,2.56-14.87l.97-.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "207.22 58.73 198.43 58.73 197.73 60.2 207.22 60.2 207.22 58.73"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m267.75,60.63l-.39.06c-.58.02-1.12.08-1.4.14l-6.7.49-5.43-.12h0s0,0,0,0c.73-.05,1.46-.14,1.85-.26.48-.14.28-.26-.43-.28.15-.06.31-.12.46-.19l1.02-.31c.05-.02.09-.03.12-.04.02,0,.04-.02.06-.02.12,0,.23.01.34.02,0,0,.41,0,.54-.05.16-.07.24-.11.4-.18.13-.06.33-.13-.08-.16-.18-.01-.38-.02-.58-.03-.12-.23-2.01-.34-4.36-.25h0c-1.74.07-3.25.23-3.99.4-.06,0-.13,0-.19.01-.55.04-1.09.12-1.22.18-.16.07-.24.11-.4.18-.09.04.04.05.3.05-.15.02-.3.05-.45.07-.65.11-1.23.21-1.7.3h-3.15c-.06,0-.11,0-.17,0-.55,0-1.14.04-1.7.09-.58.06-1.06.13-1.33.21-.64.19-.11.34,1.17.34h.55c-.52.06-.94.13-1.19.2l-.38.11c-.86.1-1.88.23-3.1.38-.7.09-.93.19-.72.26.17.07.62.11,1.21.13l-1.08.32h-.42c-.37,0-.8.04-.95.08l-2.15.63c-.15.04.03.08.41.08h.65c0,.12.69.21,1.82.23-1.64.39-2.89.9-3.81,1.38l-1.6.36s0,0,0,0l-3.04.63h-.36s-1.04.2-1.04.2h.38s-.91.2-.91.2h0s-1.38.28-1.38.28l4.93.07c.68-.15.29-.29-.87-.31h-.13c.12-.02.58-.08,1.25-.16h.54s.09,0,.09,0h.28,0c-.14.12-.2.2-.2.2l-.35.28h4.44c.53-.16-.03-.28-1.26-.28h-.31l.74-.2h.28l.72-.21h-.2l3.52-.93c.76-.12,1.44-.22,1.97-.32,3.8-.68,5.66-1.11,6.56-1.36h.2l.43-.13h.15c.2,0,.42-.02.5-.04l1.61-.47,1.85-.54,2.48-.73,6.44.04h0c.25,0,.53-.01.81-.03,3.38-.29,5.66-.48,6.99-.58.03,0,.06,0,.09,0,.72,0,1.53-.06,1.94-.14.23-.01.45-.04.62-.06l1.73-.26-.89-.04c-.71-.04-1.8.02-2.44.11Zm-19.33-.08c.06,0,.11.01.18.02-.07.02-.13.05-.2.07l-.07.02h-.54c.21-.04.42-.07.63-.11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m233.99,6.37c.03,2.55-1.9,4.65-4.32,4.69-2.42.04-4.41-2.01-4.45-4.56-.03-2.55,1.9-4.65,4.32-4.69,2.42-.04,4.41,2.01,4.45,4.56Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m221.46,16.7h12.54v-.23l-.76-.26-12.81-.15s.34.49,1.04.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m235.63,13.76c0,1.44-.77,2.6-1.72,2.6s-1.72-1.17-1.72-2.6.77-2.6,1.72-2.6,1.72,1.17,1.72,2.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 221.34,
    y: 11.15,
    width: 12.57,
    height: 5.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m223.05,13.76c0,1.44-.77,2.6-1.72,2.6s-1.72-1.17-1.72-2.6.77-2.6,1.72-2.6,1.72,1.17,1.72,2.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "221.49 16.44 234 16.47 234 16.96 221.49 16.96 221.49 16.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "m221.49,16.96c-1.28,0-2.33-1.37-2.32-3.05,0-.73.22-1.41.61-1.93.4-.54.94-.83,1.52-.83.53,0,1.02.27,1.39.76.35.47.54,1.09.54,1.75,0,.6-.18,1.16-.5,1.59-.34.45-.79.69-1.27.69h0c-.89,0-1.61-.94-1.61-2.09,0-.5.15-.96.42-1.32.28-.37.66-.58,1.06-.58h0c.75,0,1.35.78,1.35,1.74,0,.88-.56,1.59-1.25,1.59h0c-.36,0-.68-.21-.89-.55.2.41.54.68.92.69h0c.32,0,.63-.17.87-.49.25-.34.39-.79.39-1.27,0-.54-.15-1.05-.44-1.43-.27-.36-.62-.56-.99-.56h0c-.42,0-.82.22-1.12.63-.32.43-.5,1-.5,1.61,0,1.39.81,2.52,1.82,2.52v.52Zm-.14-3.94c-.3,0-.55.37-.56.82,0,.51.29.94.64.94.4.01.74-.49.75-1.07,0-.67-.38-1.22-.85-1.22h0c-.14,0-.28.04-.41.13.13-.07.28-.12.43-.12h0v.52h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 221.53,
    y: 15.46,
    width: 12.4,
    height: 23.22,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "m223.41,63.72l2.65.33s4.75-9.55,5.99-14.72c2.61-10.83,1.77-14.81,1.77-14.81h-6.59s-2.35,19.87-2.35,19.87t0,0l-1.47,9.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "m226.22,64.02c1.22.15,2.08,1.4,1.93,2.79l-5.17-.64.43-2.5,2.81.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "m228.15,64.27h2.52s1.25-29.77,1.25-29.77h-6.52c-3.69,6.73,2.74,29.77,2.74,29.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "m230.98,64.27c1.23,0,2.22,1.14,2.22,2.54h-4.44l-.61-2.54h2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "m226.64,38.21h-1v-.35h1c.78,0,1.42-.67,1.42-1.5v-.53h.34v.53c0,1.02-.79,1.85-1.76,1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "m231.61,34.51h1.32v3.33c0,.73-.59,1.32-1.32,1.32h0v-4.65h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "227.68 62.5 228.15 64.27 230.67 64.27 230.75 62.5 227.68 62.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "226.07 64.04 226.85 62.43 223.69 61.84 223.41 63.72 226.07 64.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "227.71 60.8 223.6 59.98 223.27 61.86 227.37 62.67 227.71 60.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 226.85,
    y: 60.59,
    width: 4.18,
    height: 1.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m222.2,29.52h.5c.97,0,1.76.79,1.76,1.76v3.58c0,.97-.79,1.76-1.76,1.76h-.5c-.97,0-1.76-.79-1.76-1.76v-3.58c0-.97.79-1.76,1.76-1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "m224.02,15.74s-1.08,1.16-4.3,7.43c-.64,1.26.02,2.82,1.34,3.15l.53.13,3.84-6.85-1.4-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "m234.66,16.1v19.35c0,.21-.16.38-.36.38h-9.79c-.2,0-.36-.17-.36-.38l-.13-13.34v-6.37l.68-.23,2.19-.75.39-.13h3.78l1.56.63,1.71.7.33.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m234.66,26.29v4.9c-.49-1.52-1.15-3.99-1.45-7.05l1.15-.13c.08.8.19,1.56.31,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m234.64,23.98l-1.72.19c-.39-3.95-.35-7.45-.31-8.91l1.71.7c-.03,1.66-.02,4.7.31,8.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 232.93,
    y: 23.65,
    width: 1.49,
    height: 1.21,
    rx: 0.61,
    ry: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m228.56,24.19h-2.3c0-4.02-1.14-7.53-1.56-8.68l1.26-.43.93-.32c.51,1.43,1.67,5.13,1.67,9.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m224.15,35.01l-.02-2.14c1.52-.66,2.57-3.77,2.57-8.67h1.44c0,5.38-.91,8.99-3.98,10.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "m227.09,11.67s-2.9.83-2.58,3.17c.33,2.33,6.41,5.74,6.41,5.74,0,0,3.01-4.25,3.01-6.11,0-1.86-2.38-3.82-6.84-2.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "230.09 18.25 231.06 14.62 227.09 14.6 230.09 18.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m231.06,14.62s.11.72-1.28.72-2.49-.72-2.49-.72v-4.63h3.77v4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m231.06,14.33v-2.9h-3.41s.6,2.61,3.41,2.9Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-217",
    points: "234.66 16.1 241.46 17.32 241.23 20.06 234.66 19.71 234.66 16.1"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 226.65,
    y: 23.65,
    width: 1.56,
    height: 1.21,
    rx: 0.61,
    ry: 0.61
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "m228.22,23.42l-.81-1.44-7.66,3.3h0c.7,1.31,2.23,1.81,3.41,1.11,4.2-2.49,5.05-2.98,5.05-2.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "m229.6,22.59c0,.87-.67,1.58-1.5,1.58s-1.5-.71-1.5-1.58.67-1.58,1.5-1.58,1.5.71,1.5,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m230.27,19.9l-.27-.57-1.81.96c-.7.37-.98,1.27-.63,2.01h0c.31.65,1.05.91,1.67.58l.13-.07c1.01-.54,1.42-1.84.91-2.91Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "m247.97,13.42l-1.56-1.51-6.51,5.76c-.24.19-.31.47-.28.78.11,1.16,1.53,2.14,2.29,1.3,4.16-4.57,6.05-6.32,6.05-6.32Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-115",
    cx: 247,
    cy: 12.88,
    rx: 1.5,
    ry: 1.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m248.96,9.97l.74.28-.75,2.18c-.25.72-1.01,1.1-1.69.84h0c-.72-.27-1.09-1.11-.83-1.87l.08-.22c.36-1.05,1.46-1.59,2.45-1.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 224.53,
    y: 35.83,
    width: 9.62,
    height: 1.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m227.18,9.5c-.74,3.1-1.61,5.53-1.94,5.44-.34-.09-.01-2.67.73-5.77.74-3.1,1.61-5.53,1.94-5.44.34.09.01,2.67-.73,5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m234.02,9.29c.4,3.16.45,5.77.11,5.82-.34.05-.95-2.48-1.35-5.64-.4-3.16-.45-5.77-.11-5.82.34-.05.95,2.48,1.35,5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m226.51,8.85c-.83,2.95-1.81,5.25-2.19,5.13-.38-.12,0-2.6.83-5.55.83-2.95,1.81-5.25,2.19-5.13.38.12,0,2.6-.83,5.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m226.77,7.44h0c.36,0,.66.3.66.68l.02,1.83h-.48c-.46.01-.84-.37-.84-.86v-.95c-.02-.38.27-.69.63-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m230.67,3.29h0c-1.82.03-3.28,1.61-3.25,3.53l.04,3.13c.03,1.92,1.52,3.46,3.34,3.43h0c1.82-.03,3.28-1.61,3.25-3.53l-.04-3.13c-.03-1.92-1.52-3.46-3.34-3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m232.51,10.16c.18,0,.36-.09.48-.25.13-.17.19-.39.16-.62l-.04-.25-.35.06.04.25c.02.12-.01.23-.08.32-.06.07-.14.11-.22.11v.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m228.82,8.81c.04,3.3-.28,5.98-.73,5.98-.44,0-.84-2.66-.88-5.96-.04-3.3.28-5.98.73-5.98.44,0,.84,2.66.88,5.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m227.47,8.07h0l-.06-4.74,4.49-.07h0c.03,2.62-1.95,4.77-4.43,4.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "231.63 11.49 231.66 11.15 230.49 11.02 230.46 11.36 231.63 11.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "230.63 11.65 230.74 10.77 230.43 10.73 230.32 11.6 230.63 11.65"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m233.59,3.46l-7.67,3.12-.25-.69c-.82-2.23.24-4.74,2.36-5.6h0c2.12-.86,4.5.25,5.31,2.49l.25.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m234.37,6.28c-2.86-1.33-6.24-.84-8.65,1.26-.42.37-.78.3-.84-.22-.08-.64-.13-.97-.21-1.61-.07-.51.18-1.28.6-1.64,2.41-2.1,5.79-2.59,8.65-1.26.49.23.54.9.61,1.41.08.64.13.97.21,1.61.07.51-.37.45-.37.45Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m201.42,120.64l-4.46-.34h0s.7-.34.7-.34h.23c.43,0,.92-.04,1.1-.09l.47-.14c.38-.03.71-.07.87-.12l1.06-.31c.67-.2-.11-.36-1.73-.36-.87-.04-2.96-.1-4.24,0-.52.04-.83.09-.97.13-.83.07-1.52.17-1.9.28l-.29.09s0,0,0,0l-2.61.76c.5.04,1.02.07,1.53.08h0s-5.86.33-5.86.33h0s0,0,0,0l-4.86,1h-9.01l-3.2.94h5.61c-.19.08.2.15.94.15h.87c.35,0,.71-.01,1.04-.04h1.42s-3.89,1.11-3.89,1.11h1.47l-10.41,3.14h.81s0,0,0,0h-.82c-1.36,0-2.89.13-3.47.28h5.45l1.21-.28h-2.02s0,0,0,0h2.03s12.68-2.84,12.68-2.84l-5.7,2.96c-.09.01-.16.03-.22.05l-.4.12h2.7l.4-.12s.07-.02.08-.03h.03l11.18-3.3,3.24-.84h.14s-2.81.84-2.81.84h2.85s3.16-.81,5.84-1.52c.29-.08.57-.15.82-.23,2.45-.72,2.12-1.31,2.1-1.35h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "165.95 67.01 163.97 94.56 172.69 94.56 173.41 64.83 167.72 64.69 165.95 67.01"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "167.47 67.51 168.85 69.15 170.67 67.58 169.24 65.55 167.47 67.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "168.62 66.44 168.27 68.46 166.29 88.42 167.97 90.6 169.6 88.55 169.56 68.61 169.65 66.57 168.62 66.44"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "160.15 84.33 163.95 83.96 162.84 67.71 160.15 84.33"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 160.06,
    y: 81.25,
    width: 4.41,
    height: 4.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 152.38,
    y: 76.71,
    width: 11.19,
    height: 8.46
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "169.24 91.34 174.94 125.82 177.56 125.82 177.46 91.34 169.24 91.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "164.35 124.64 167.54 124.64 171.36 91.34 163.95 91.34 164.35 124.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m176.21,124.71c-.74,0-1.35.64-1.35,1.42v1.07h2.7v-1.07c0-.79-.6-1.42-1.35-1.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "165.16 124.7 165.51 124.71 165.88 97.42 165.53 97.42 165.16 124.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "173.65 99.83 176.03 124.72 176.38 124.69 174 99.8 173.65 99.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "168.9 95.1 168.69 95.4 169.93 96.39 170.31 98.52 170.66 98.45 170.26 96.18 168.9 95.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "m177.78,67.95l.25,28.05h2.85s.39-7.35.65-13.73c.03-.7.04-1.38.04-2.04,0-6.73-2.54-12.28-2.54-12.28h-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m178.03,96v3.92s3.76-.24,2.15-3.92h-2.15Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "m172.18,71.35c-.56,6.32-1.02,24.84-1.02,24.84h6.3s.88-18.9.88-18.9l.7-9.34-5.65-3.11c-.09.17-.78,1.65-1.22,6.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "167.72 64.69 170 64.82 170.12 64.82 173.36 64.82 173.12 64.69 167.72 64.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "m162.84,67.71l-.31,28.49h2.9s-.92-26.64,2.28-31.5l-4.87,3.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "m173.39,64.84s0-.02,0-.02h-.04l.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m167.71,57.17l-.12,8.46s.37.38,2.47.38c2.1,0,3.34-1.18,3.34-1.18l-.99-6.83-4.7-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m167.6,65.42c4.57,0,4.56-3.29,4.56-3.29h-4.57s0,3.29,0,3.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 163.05,
    y: 74.56,
    width: 1.45,
    height: 0.37
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m171.37,52.57h-2.08c-1.94,0-3.51,1.68-3.51,3.74v3.79s7.31,0,7.31,0c.75,0,1.36-.65,1.36-1.45v-2.8c0-1.81-1.38-3.28-3.08-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m169.75,53.94h-1.12c-2.38,0-2.85,2.33-2.85,3.15v6.91c4,2.39,6.37-1.01,6.37-1.01v-5.98s.3-3.08-2.4-3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m169.11,61.82s-.25,1.38-1.39,1.38-1.39-1.38-1.39-1.38h2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m172.53,53.94c-.63,0-1.14.54-1.14,1.21v2.21c0,1.52,1.17,2.74,2.6,2.74v-4.62c0-.85-.65-1.54-1.46-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m173.2,58.45c-.44,0-.79.37-.79.84v2.53s.79,0,.79,0c.43,0,.78-.37.78-.83v-1.71c0-.46-.35-.83-.78-.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "167.39 60.72 167.47 59.95 167.14 59.91 167.02 61.07 167.76 61.07 167.76 60.72 167.39 60.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m167.24,52.57c-1.19,1.2-.13,2.89,1.07,2.52,1.2-.37,3.64-2.36,3.64-2.36,0,0-3.52-1.37-4.7-.17Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 177.61,
    y: 73.15,
    width: 0.35,
    height: 15.22,
    transform: "translate(-.13 .28) rotate(-.09)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "176.42 73.81 177.63 77.2 177.96 77.07 176.75 73.68 176.42 73.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "177.71 81.8 177.84 82.14 179.44 81.47 179.3 81.12 177.71 81.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "177.88 82.36 177.93 82.73 180.08 82.42 180.03 82.05 177.88 82.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "173.83 88.39 173.83 87.16 173.47 87.16 173.47 88.77 177.08 88.77 177.08 88.39 173.83 88.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m160.31,83.36h-.87c-.81,0-1.46.69-1.46,1.54v.07c0,.85.66,1.54,1.46,1.54h.87c.81,0,1.46-.69,1.46-1.54v-.07c0-.85-.66-1.54-1.46-1.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "162.46 86.16 162.81 86.17 163.22 71.96 162.87 71.94 162.46 86.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "175.95 69.59 173.66 65.12 173.35 65.29 175.5 69.5 172.99 71.62 175.49 73.27 172.11 79.65 172.41 79.83 175.96 73.14 173.6 71.58 175.95 69.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "166.57 65.92 164.26 69.96 165.05 71.06 163.75 71.86 165 78.85 165.35 78.77 164.15 72.04 165.58 71.17 164.68 69.94 166.87 66.11 166.57 65.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "163.6 87.16 163.6 88.4 162.7 88.4 162.7 88.77 163.95 88.77 163.95 87.16 163.6 87.16"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m161.83,127.19h5.45l.24-2.56h-3.19c-1.36,0-2.46,1.14-2.5,2.56Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m272,78.23l-.99-.02c-.45,0-.97,0-1.43.04l-3.02-.37h.07s.17-.22.17-.22h0l.67-.86-1.16-.07-1.45-.1.15-.04.37-.11s.09,0,.14,0c.12,0,.24,0,.36-.01,2.21-.07,4.13-.23,4.76-.41.38-.11.22-.21-.33-.29l.29-.08c.27-.08.34-.15.26-.21-.17-.13-1.04-.22-2.36-.22h-.13c-1.97,0-4.23.19-5.04.43-1.79.08-3.26.22-3.8.37-.62.18.2.34,1.91.41l-.57.17-2.58.09h0l-1.11.04-5.53,1.06-5.8.56h-.15c-.99-.03-2.31.05-2.95.18l-.2.04s-.03.02.04.02l1.73.04c.92.02,2.12-.05,2.8-.16l6.04-.52,1.53-.24h0l.1-.02c-1.48.87-2.04.97-2.04.97h0c-5.06.69-6.11,1.13-9.41,2.44h1.42c-.99.55-2.22,1.22-2.23,1.22h-1.19c-1.2,0-2.6.12-3.12.28h4.76,0s.33,0,.33,0h0s4.27,0,4.27,0c.52-.15-.03-.28-1.24-.28h-.86s2.94-.54,6.14-1.22h1.41c1.5-.39,2.71-.73,3.69-1.01,2.44-.72,3.34-1.15,3.19-1.42h0,0s4.31-1.08,4.31-1.08l-.08.43,4.17.41s.13.03.31.04l2.31.04c.3,0,.69-.02.86-.06l.57-.12c.27-.06.11-.11-.36-.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "237.3 40.64 232.92 45.44 231.21 44.34 235.22 39.14 237.3 40.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m228.77,46.13h0c.25-1.32,1.46-2.18,2.72-1.91l1.54.32c.09.02.15.11.13.2h0c-.25,1.32-1.46,2.18-2.72,1.91l-1.54-.32c-.09-.02-.15-.11-.13-.2Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 242.63,
    cy: 23.17,
    rx: 5.56,
    ry: 4.04
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "254.29 45.04 248.49 41.21 249.69 39.2 255.41 43.68 254.29 45.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "247.57 29.91 250.41 39.67 248.49 41.21 246.56 35.79 247.57 29.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m242.67,47.05v33.09h1.88s1.9-8.58,2.7-17.35c.56-6.1.58-12.29-.94-15.75h-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m245.41,80.14c1.2,0,2.18,1.12,2.18,2.49h-4.92v-2.49h2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m238.57,62.99c.11.71,3.02,17.15,3.02,17.15h1.56v-33.09h-3.71c-2.37,6.2-1.84,9.89-.86,15.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m240.41,80.14c-1.2,0-2.18,1.12-2.18,2.49h4.92v-2.49h-2.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 242.99,
    y: 62.79,
    width: 0.32,
    height: 17.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 242.98,
    y: 80.14,
    width: 0.33,
    height: 2.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m238.22,69.08h9.69c.16-3.54.23-6.57.22-9.18-.03-6.52-.58-10.38-1.67-12.85h-7.16c-2.72,6.2-2.24,10.24-1.08,22.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "237.13 29.56 240.19 31.62 237.3 40.64 235.22 39.14 237.13 29.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m246.47,47.05l.13,1.56-2.56-1.56-2.75,1.8-1.98-1.8s.28-1.08-1.82-11.61l-.36-5.87,3.19-1.1,3.71-.2,3.53,1.65-1.1,17.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "244.38 28.59 242.72 31.97 240.24 28.52 244.38 28.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m244.38,28.59s.12.7-1.36.7-2.65-.7-2.65-.7v-4.54h4.01v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m244.38,27.98v-2.84h-3.63s.64,2.56,3.63,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m239.59,19.8v2.42l.79.06v3.34s2.48,2.26,4.84,1.1c1.03-.51,1.66-1.63,1.66-2.83v-4.09c0-.7-.17-1.36-.47-1.93-.61-1.17-1.78-1.96-3.1-1.96h-.13c-1.97,0-3.58,1.74-3.58,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m239.59,19.8v2.57h1.74l.38-2.13,4.7-2.37c-.61-1.17-1.78-1.96-3.1-1.96h-.13c-1.97,0-3.58,1.74-3.58,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m240.18,20.79h0c.4,0,.72.32.72.72v2.24h-.72c-.39,0-.71-.32-.71-.71v-1.54c0-.39.32-.71.71-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m245.54,24.22v-.35c.22,0,.39-.19.39-.41v-.66h.33v.66c0,.42-.32.76-.72.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m244.17,25.61c-.73,0-1.08-.64-1.16-.99l.32-.08s.2.8.94.72l.03.35s-.1,0-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m253.99,44.42h0c-.05.38.2.73.56.79l2.31.36c.36.06.7-.21.75-.59l.13-.9c.08-.59-.3-1.14-.86-1.23l-.73-.11c-1.03-.16-1.99.59-2.15,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m240.37,28.38l.99,5.77s-1.19-.63-2.18-2.01-1.07-2.92-1.07-2.92l2.26-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m244.38,28.38l-.32,5.44s1.03-.47,1.61-2.01c.58-1.54.48-2.55.48-2.55l-1.78-.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "237.3 40.64 235.22 39.14 235.68 36.85 238 38.45 237.3 40.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "250.41 39.67 248.49 41.21 247.66 38.89 249.83 37.69 250.41 39.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m244.29,59.9h3.84c-.03-6.52-.58-10.38-1.67-12.85h-6.32s.04,5.86.04,8.38c0,3.83,1.35,4.47,4.11,4.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 238.88,
    y: 35.11,
    width: 2.02,
    height: 0.67,
    transform: "translate(479.78 70.9) rotate(180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m290.13,93.28h0s-3.05-.12-3.05-.12h-.02s.32-.09.32-.09c1.98-.11,3.76-.31,4.55-.54l.39-.11.59-.17.25-.07c.81-.24.11-.49-2.68-.49-.24,0-.46,0-.68,0-.35-.1-1.16-.16-2.31-.16-2.04,0-4.34.19-5.16.43l-1.29.38c-.71.02-1.49.09-2.04.26,0,0-1.66.15-4.67.42-1.34.12-2.3.28-1.91.41h0s0,0,0,0h0s0,0,0,0h4.84s-1.79.53-1.79.53h.88l-1.92.83-3.16.69-.11.02h.04c-1.13.2-3.07.59-5.52,1.24-.76.2-1.41.41-1.96.61-2.41.87-2.97,1.63-2.97,1.63h2.31s2.19-.79,5.33-1.63h.61l-4.99,1.63h2.65s4.34-.98,7.36-1.63c.07-.01.14-.03.2-.04,3.4-.73,5.99-1.43,6.52-1.8.03-.02.06-.05.07-.07l.08-.08.6-.02.17-.09h2.12c-.08.06.25.11.82.11h1.06c.57,0,1.21-.05,1.56-.11h4.03l2.86-.84h-5.92c1.55-.65,1.93-1.12,1.93-1.12Zm-4.35.98l-.29.14h-.62l.91-.14Zm-6.42-1.56l.31-.03.07.04-1.47.43h-3.05s4.14-.43,4.14-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m263.01,98.99h.05s-2.98-.01-2.98-.01c-1.31,0-2.79.12-3.31.28h8.96l.94-.28h-2.98c-.23,0-.46,0-.69.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m257.2,81.99c.56,7.87,2.61,14.76,2.61,14.76h2.31s-.5-7.13-.24-14.76c.07-1.97.19-3.97.38-5.89h0c.06-.62.13-1.22.2-1.81.76-5.94,2.97-10.63,2.97-10.63h-6.58s-1.39,3.29-1.75,12.84c-.07,1.83-.02,3.68.11,5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m261.76,63.67l.5,12.43h0s.24,5.89.24,5.89l.59,14.76h2.65s1-8.85,1.78-14.76c.02-.13.04-.27.05-.4.88-6.64,1.09-12.95.36-16.3-.15-.67-.33-1.21-.55-1.62h-5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m257.2,81.99h10.32c.02-.13.04-.27.05-.4.88-6.64,1.09-12.95.36-16.3l-.43-1.69-8.65.06s-1.39,3.29-1.75,12.84c-.07,1.83-.02,3.68.11,5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m256.78,99.25c0-1.38,1.06-2.49,2.36-2.49h2.98l-.44,2.49h-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m257.37,29.3h7.37v18.35c0,2.03-1.65,3.69-3.69,3.69h0c-2.03,0-3.69-1.65-3.69-3.69v-18.35h0Z",
    transform: "translate(522.12 80.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m263.53,44.07h0c2.99,0,5.41-2.55,5.41-5.7v-2.59h-5.41v8.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "m261.12,43.96h-7.62c-.75.06-1.28.8-1.15,1.58l.18,1.04h7.73s.87-2.62.87-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m256.99,40.04l2.18-3.23s-3.03-1.43-2.92,2.2l.75,1.04Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "261.15 35.05 262.64 37.62 257.76 40.75 256.28 38.18 261.15 35.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "256.89 37.79 258.37 40.36 262.11 37.96 260.62 35.39 256.89 37.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "261.39 36.26 261.73 36.84 261.8 36.8 261.46 36.21 261.39 36.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "257.37 38.89 257.67 39.42 257.34 39.62 257.04 39.1 257.37 38.89"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "m253.02,42.83c2.07-2.47,3.22-3.83,3.22-3.83l.75,1.04-4.46,6.55c-.85-1.18-.44-2.65.49-3.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "258.38 65.11 259.54 65.5 260.92 63.65 263.38 65.78 268.1 63.77 267.25 58.5 268.94 53.58 269.73 45.25 266.27 44.16 262.24 43.96 257.35 43.96 259.16 58.82 258.38 65.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "266.87 60.08 267.07 59.8 264.87 58.04 264.67 58.32 266.87 60.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "267.02 59.31 267.28 59.09 265.81 57.09 265.55 57.31 267.02 59.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m261.49,53.48l5.72-4.6-1.41-1.16,1.72-.41-3.12-4.77-4.71,4.41.92.47-1.22.79,2.11,5.27Zm5.17-4.6l-5.03,4.05-1.83-4.58,1.49-.97-1.02-.52,4.06-3.8,2.63,4.02-1.92.46,1.63,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m266.25,44.16s-.97,3.92-4.69,9.04c-1.18-4.62.68-9.24.68-9.24l4.01.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "266.25 44.16 267.55 46.29 260.03 46.29 262.24 43.96 266.25 44.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m262.24,44.16s-.12.7,1.36.7,2.65-.7,2.65-.7v-4.54h-4.01v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m262.24,43.54v-2.84h3.63s-.64,2.56-3.63,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m267.01,35.38v2.42h-.76v3.34s-2.5,2.32-4.86,1.16c-1.03-.51-1.66-1.63-1.66-2.83v-4.09c0-.7.17-1.36.47-1.93.61-1.17,1.78-1.96,3.1-1.96h.13c1.97,0,3.58,1.74,3.58,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m268.94,35.13v2.2c-.75.19-1.63.12-1.63.12,0,0-1.26.44-2.18-.87l.02-1.09c0-1.65-2.26.29-2.16-2.3h-2.76c.58-1.45,1.57-2.5,4.36-2.5s4.36,2.29,4.36,4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m266.43,36.36h.72v2.24c0,.4-.32.72-.72.72h0c-.39,0-.71-.32-.71-.71v-1.54c0-.39.32-.71.71-.71Z",
    transform: "translate(532.87 75.67) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m261.31,38.92v-.35c-.34,0-.61-.29-.61-.65v-.09h-.33v.09c0,.55.42,1,.94,1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "261.12 60.99 263.45 65.78 260.92 63.65 259.54 65.5 261.12 60.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "266.25 44.16 262.89 46.88 262.24 44.24 266.25 44.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "263.37 66 267.29 64.46 267.17 64.13 263.53 65.56 261.03 60.4 259.43 65.28 258.43 64.94 258.33 65.28 259.64 65.72 261.09 61.29 263.37 66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "261.1 61.28 261.39 61.12 260.69 59.75 260.69 54.7 261.69 53.31 261.43 53.09 260.36 54.58 260.36 59.84 261.1 61.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "263.5 47.22 264.63 46.46 267.55 46.46 267.55 46.11 264.53 46.11 263.32 46.92 263.5 47.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "262.17 46.94 262.48 46.81 262.22 46.11 260.03 46.11 260.03 46.46 261.99 46.46 262.17 46.94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-52",
    cx: 261.76,
    cy: 56.13,
    rx: 0.33,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m261.47,59.06c0,.19.15.35.33.35s.33-.16.33-.35-.15-.35-.33-.35-.33.16-.33.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "m269.73,45.26s1.84,6.39,2.27,14.44l-2.39.25-1.95-12.83,2.06-1.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "268.49 53.61 268.82 53.55 268.27 49.92 267.94 49.98 268.49 53.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 266.78,
    y: 55.42,
    width: 10.78,
    height: 7.57,
    transform: "translate(544.34 118.4) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m272.15,60.46h1.42v2.21c0,.71-.55,1.29-1.23,1.29h-1.06c-.68,0-1.23-.58-1.23-1.29h0c0-1.22.94-2.21,2.09-2.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "268.47 51.39 269.08 50.22 268.79 50.05 268.18 51.21 268.47 51.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m260.4,99.25c0-1.38,1.06-2.49,2.36-2.49h2.98v2.49h-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m261.34,41.19c1.47,0,1.29-1.16,1.29-1.16h-1.29v1.16Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m363.58,155.2s.66-.24,1.22-.51c.12-.06.24-.12.35-.18.41-.23.62-.44.19-.5h0s0,0,0,0h0s-.01,0-.01,0l-3.23-.22c.11-.01.17-.02.17-.02l.28-.05h0s.43-.07.43-.07c.54,0,1.15,0,1.79-.01l1.11-.28h1.23l-.33-.23.27-.07c.08-.02.16-.04.23-.06.01,0,.02,0,.03,0h1.1c.81,0,1.73-.08,2.06-.17l.1-.03h-2.56s-.07,0-.1,0c.29-.19-.69-.34-2.45-.34h-.7c-2.26,0-4.81.21-5.71.48l-.21.06c-1.27.37-.39.47-.39.47h.08s-1.56.29-1.56.29l-5.12.24s-4.13.47-7.86,1.29h0c-.34.07-.69.14-1.03.22-2.76.6-4.62,1.17-5.06,1.31-2.76.36-.78.53-.78.53l2.43-.53h0l6.63-1.41-4.62,1.15h0l-7.35,1.67h.4l-7.44,1.79h-1.12c-1.31,0-2.79.12-3.31.28h4.92l1.4-.28h0l10.07-1.79h.95l3.78-.8-3.12.8h1.65l-6.68,1.89c-.1.02-.19.03-.25.05l-.43.13h2.55l.43-.13s.02,0,.03-.01h0s8.47-1.93,8.47-1.93h.5l3.41-.83h7.56l3.3-.96,1.88-1.25h.44Zm-3.41-.04h0s-.15.04-.15.04h.06l-.51.18h-.34s.95-.21.95-.21Zm-5.75,1.28l3.5-.78c.92.01,1.99.02,3.21.03l-1.08.76h-5.63Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "343.39 103.3 348.06 125.38 346.85 125.38 341.99 103.35 343.39 103.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m342.85,103.3l.95.02s1.79,5.11,1.79,13.49c0,.46,0,1.27-.02,1.73l-2.72-.35-.28-4.49.28-10.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m326.55,116.97c-.83,6.19-.58,12.11-.58,12.11l1.61.24,3.64-25.82-.93-.16s-2.59,5.02-3.74,13.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m326.85,115.02h3.19l.25-11.69s-2.53,4.22-3.45,11.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m327.65,128.87l-.64,4.76s-2.66-1.61-.97-5l1.61.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "330.29 103.33 334.6 101.18 339.49 101.18 343.81 103.33 341.08 126.5 328.76 126.5 330.29 103.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "334.6 101.18 335.95 104.17 339.6 101.56 334.6 101.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "341.07 126.5 337.55 159.06 335.08 158.87 335.51 126.5 341.07 126.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "328.75 126.5 326.19 157.82 328.1 157.82 335.75 126.5 328.75 126.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "341.07 126.5 339.93 141.63 333.66 141.63 334.04 134.37 333 141.63 327.12 141.63 328.75 126.5 341.07 126.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "328.74 141.65 328.41 141.61 330.13 127.68 330.46 127.73 328.74 141.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "337.67 141.64 337.34 141.61 338.43 127.69 338.76 127.72 337.67 141.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m325.07,157.82h3.01l-.46,2.49h-4.92c0-1.38,1.06-2.49,2.36-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m336.28,157.82h0c.7,0,1.27.6,1.27,1.34v1.15h-2.55v-1.15c0-.74.57-1.34,1.27-1.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "333.87 134.12 333.74 131.81 332.61 130.56 332.85 130.32 334.06 131.66 334.2 134.09 333.87 134.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m335.75,95.61l-1.15,5.58s.42.95,2.6,1.03c2.18.07,2.71-1.03,2.71-1.03l1.38-4.41-5.55-1.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "340.46 99.4 338.37 99.3 340.05 100.78 340.46 99.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m341.99,100.04c-1.94.55-4.25-.68-4.25-.68v-5.71l4.62.74-.37,5.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m333.97,94.38c-.5-3.04,2.05-4.21,3.86-4.21,2.5,0,4.53,1.76,4.53,4.21s-2.05,4.2-4.53,3.85c-2.57-.36-3.44-1.22-3.86-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m335.1,98.56s-1.22-.9-1.22-4.26c0-.73.08-.99.08-.99l2.83-3.15,3.07.14,2.14,2.16h-2.8l-.73,4.07h-1.36l-2,2.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "342.06 95.07 343.39 97.53 341.33 97.53 342.06 95.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "337.14 105 336.96 104.7 338 104.02 340.25 104.5 339.48 101.79 339.8 101.69 340.72 104.96 338.06 104.39 337.14 105"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "334.78 104.92 334.33 103.77 331.87 103.94 334.04 101.72 334.27 101.97 332.75 103.53 334.54 103.4 335.08 104.78 334.78 104.92"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 335.79,
    y: 94.56,
    width: 1.91,
    height: 3.19,
    rx: 0.95,
    ry: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m338.33,89.44h0c2.22,0,4.03,1.81,4.03,4.03v.82h-8.48v-.4c0-2.46,2-4.45,4.45-4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m342.7,92.49h2.23c0,1-.81,1.81-1.81,1.81h-2.23c0-1,.81-1.81,1.81-1.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "329.7 114.75 329.37 114.72 329.78 108.49 329.27 107.64 329.55 107.45 330.12 108.4 329.7 114.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "330.14 107.92 329.66 106.43 329.98 106.32 330.45 107.81 330.14 107.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m345.57,118.54c-5.36-.16-8.23-1.09-8.23-1.09v-1.77h8.23s0,2.86,0,2.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "341.56 102.21 334.27 114.38 336.74 126.75 338.38 126.5 335.78 115.02 342.91 102.88 341.56 102.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m333.91,114.06h.03c1.88,0,3.4,1.52,3.4,3.4h-.39c-1.68,0-3.04-1.36-3.04-3.04v-.36h0Z",
    transform: "translate(671.24 231.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m346.11,114.09h-3.57l1.27-10.76c.65.57,1.16,2.48,1.53,4.54.09.54.18,1.09.26,1.63.35,2.41.51,4.59.51,4.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "342.53 114.07 342.19 114.04 342.75 107.15 343.08 107.18 342.53 114.07"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 336.28,
    y: 125.38,
    width: 11.78,
    height: 8.72
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "341.01 98.73 339.9 98.19 340.03 97.89 341.14 98.42 341.01 98.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "m345.6,109.49h-1.52v-1.63h1.26c.09.54.18,1.09.26,1.63Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m404.4,190.18l.41-.12c.32-.09.02-.17-.68-.19.61-.14,2.45-.55,4.24-1h.51l.96-.28h-.22s.06-.02.09-.02c4.39-1.29,3.52-1.55,3.4-1.62l-4.73-.17,1.61-.47h.26c.41,0,.87-.04,1.03-.09l.61-.18c.07-.02.07-.04,0-.06l.61-.18c.1-.03.08-.06-.04-.08.22-.18-1.58-.21-1.58-.21-5.15-.06-6.75.52-6.75.52l-1.17.34c-.38.11-.14.21.52.25l-.41.12-.08.02-5.36.22h-.02c-.26.03-3.48.39-7.69,1.63-.03,0-.05.02-.08.02h-.2l-.95.28c-1.75,0-3.19,0-4.01,0l.12-.03c.36-.11-.08-.19-.99-.19h-1.88l-.8.23c-.44.13.1.24,1.21.24h1.2l6.2.07-1.16.33-.65.19-9.46,3.26h-.01c-1.31,0-2.79.12-3.31.28h4.92l1.4-.28h0l11.41-2.52h0l-4.81,2.63c-.08.01-.15.03-.2.04l-.43.13h2.55l.43-.13s.06-.02.08-.03h.03l4.71-1.39h5.9l3.96-.96h.85l.37-.11h-.22c.65-.23-.07-.43-1.7-.49Zm.66-1.23l-3.13.92-.8.23c-.13.04-.18.08-.14.11-.22.01-.44.02-.66.03l1.66-.49.63-.19,2.43-.61Zm-6.17,1.72l1.24-.36c.32-.02.64-.04.97-.05.2.05.64.08,1.26.08h1.52l.35-.1c1.4.06,2.01.23,1.44.44h-6.77Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "389.9 161.27 389.99 191.85 387.52 191.85 382.15 161.27 389.9 161.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "375.83 161.27 377.53 190.8 380.54 190.8 384.15 161.27 375.83 161.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m377.51,190.8h3.01l-.46,2.49h-4.92c0-1.38,1.06-2.49,2.36-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m388.72,190.8h0c.7,0,1.27.6,1.27,1.34v1.15h-2.55v-1.15c0-.74.57-1.34,1.27-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m393.21,147.43c0,.62.23,1.97.2,2.63-.21,6.02-1.02,12.73-1.02,12.73l-2.16-.47v-26.47h.98s2,5.23,2,11.59Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m397.16,169.93h-.44c0-2.49-1.92-4.52-4.28-4.52s-4.28,2.03-4.28,4.52h-.44c0-2.75,2.12-4.98,4.73-4.98s4.73,2.24,4.73,4.98Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "395.86 179.29 389.01 179.29 388.34 170.56 396.52 170.56 395.86 179.29"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 387.49,
    y: 169.57,
    width: 9.87,
    height: 0.99
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m390.23,162.32h0c1.95,0,3.54,1.58,3.54,3.54v.7h0c-1.95,0-3.54-1.58-3.54-3.54v-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m366.23,151.75h0c1.95,0,3.54,1.58,3.54,3.54v.7h0c-1.95,0-3.54-1.58-3.54-3.54v-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m373.96,151.01c0,.79.01,1.61.04,2.44h3.03v-17.12h-.91s-2.17,3.05-2.17,14.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 373.76,
    y: 151.23,
    width: 3.28,
    height: 2.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m378.09,153.81c-4.71-.13-9.05,0-9.05,0l.26,2.15,8.54.79.25-2.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "376.12 136.31 380.71 134.29 386.08 134.29 391.4 135.84 390.74 146.05 389.88 159.55 375.83 159.55 376.12 136.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m380.78,160.21c-.03-.09-.7-2.34-.19-12.36.44-8.59,1.55-10.09,1.6-10.15l.26.22-.13-.11.13.11s-1.1,1.56-1.53,9.95c-.51,9.91.16,12.21.17,12.23l-.32.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m380.71,134.29s.71,1.12,2.69,1.12,2.69-1.12,2.69-1.12v-7.23h-5.37v7.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m380.71,134.08v-3.48h4.44s0,3.48-4.44,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m381.87,133.19c2.22-.23,3.48-1.85,3.48-1.85l1.32-5.96c-.02-2.13-2.36-2.46-2.36-2.46-5.34-.5-4.97,4.71-4.97,4.71v3.09c0,1.44,1.17,2.61,2.53,2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m385.07,124.33h.31c.83,0,1.51.52,1.51,1.16v3.13h-3.01v-3.39c0-.5.53-.91,1.18-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m386.34,126.85h0c.41,0,.74.35.74.78v1.61c0,.43-.33.78-.74.78h-.75v-2.38c0-.44.34-.79.75-.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "381.21 129.67 380.5 129.67 380.62 128.58 380.93 128.62 380.85 129.34 381.21 129.34 381.21 129.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m384.67,129.59h-1.56v-4.89h0c.86,0,1.56.74,1.56,1.65v3.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "381.96 131.22 381.86 130.91 382.69 130.61 382.79 130.93 381.96 131.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "385.73 134.67 382.33 137.46 380.71 134.29 385.73 134.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "389.9 161.27 375.83 161.27 375.83 159.55 389.88 159.55 389.9 161.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "383.17 168.01 382.71 165.41 381.05 164.54 380.78 162.39 381.11 162.34 381.36 164.31 383.01 165.18 383.49 167.95 383.17 168.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "385.81 139.55 385.27 136.66 382.3 138.01 380.71 136.57 378.96 139.09 379.96 134.85 380.28 134.93 379.69 137.44 380.65 136.06 382.36 137.6 385.52 136.16 385.9 138.23 386.92 135.21 387.24 135.33 385.81 139.55"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 385.09,
    y: 142.14,
    width: 3.35,
    height: 1.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 380.18,
    y: 159.55,
    width: 2.63,
    height: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m393.55,150.52c0,.79-.02,1.61-.05,2.44h-3.27v-17.12h1.17c.39.7,2.15,3.05,2.15,14.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 390.23,
    y: 150.74,
    width: 3.53,
    height: 2.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 386.6,
    y: 141,
    width: 0.33,
    height: 1.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 384.7,
    y: 158.91,
    width: 0.66,
    height: 2.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 378.23,
    y: 158.98,
    width: 0.66,
    height: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m375.74,153.76c0-.07-.17-7.07.12-9.93.29-2.87.73-4.47.74-4.48l.32.1s-.44,1.59-.73,4.42c-.29,2.84-.12,9.81-.12,9.88h-.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 390.07,
    y: 144.89,
    width: 0.33,
    height: 8.39
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m398.13,180.05l-.99-.02c-.45,0-.97,0-1.43.04l-3.02-.37h.07s.17-.22.17-.22h0l.67-.86-1.16-.07-1.45-.1.15-.04.37-.11s.09,0,.14,0c.12,0,.24,0,.36-.01,2.21-.07,4.13-.23,4.76-.41.38-.11.22-.21-.33-.29l.29-.08c.27-.08.34-.15.26-.21-.17-.13-1.04-.22-2.36-.22h-.13c-1.97,0-4.23.19-5.04.43-1.79.08-3.26.22-3.8.37-.62.18.2.34,1.91.41l-.57.17-2.58.09h0l-1.11.04-5.53,1.06-5.8.56h-.15c-.99-.03-2.31.05-2.95.18l-.2.04s-.03.02.04.02l1.73.04c.92.02,2.12-.05,2.8-.16l6.04-.52,1.53-.24h0l.1-.02c-1.48.87-2.04.97-2.04.97h0c-5.06.69-6.11,1.13-9.41,2.44h1.42c-.99.55-2.22,1.22-2.23,1.22h-1.19c-1.2,0-2.6.12-3.12.28h4.76,0,4.61c.52-.15-.03-.28-1.24-.28h-.86s2.94-.54,6.14-1.22h1.41c1.5-.39,2.71-.73,3.69-1.01,2.44-.72,3.34-1.15,3.19-1.42h0,0s4.31-1.08,4.31-1.08l-.08.43,4.17.41s.13.03.31.04l2.31.04c.3,0,.69-.02.86-.06l.57-.12c.27-.06.11-.11-.36-.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "363.43 142.45 359.04 147.25 357.34 146.15 361.34 140.95 363.43 142.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m354.9,147.94h0c.25-1.32,1.46-2.18,2.72-1.91l1.54.32c.09.02.15.11.13.2h0c-.25,1.32-1.46,2.18-2.72,1.91l-1.54-.32c-.09-.02-.15-.11-.13-.2Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 368.75,
    cy: 124.99,
    rx: 5.56,
    ry: 4.04
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "380.42 146.85 374.62 143.02 375.81 141.01 381.54 145.49 380.42 146.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "373.69 131.72 376.54 141.49 374.62 143.02 372.68 137.6 373.69 131.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m368.79,148.86v33.09h1.88s1.9-8.58,2.7-17.35c.56-6.1.58-12.29-.94-15.75h-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m371.54,181.95c1.2,0,2.18,1.12,2.18,2.49h-4.92v-2.49h2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m364.7,164.8c.11.71,3.02,17.15,3.02,17.15h1.56v-33.09h-3.71c-2.37,6.2-1.84,9.89-.86,15.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m366.53,181.95c-1.2,0-2.18,1.12-2.18,2.49h4.92v-2.49h-2.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 369.12,
    y: 164.61,
    width: 0.32,
    height: 17.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 369.11,
    y: 181.95,
    width: 0.33,
    height: 2.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m364.35,170.89h9.69c.16-3.54.23-6.57.22-9.18-.03-6.52-.58-10.38-1.67-12.85h-7.16c-2.72,6.2-2.24,10.24-1.08,22.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "363.25 131.37 366.31 133.43 363.43 142.45 361.34 140.95 363.25 131.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m372.59,148.86l.13,1.56-2.56-1.56-2.75,1.8-1.98-1.8s.28-1.08-1.82-11.61l-.36-5.87,3.19-1.1,3.71-.2,3.53,1.65-1.1,17.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "370.51 130.41 368.85 133.79 366.36 130.33 370.51 130.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m370.51,130.41s.12.7-1.36.7-2.65-.7-2.65-.7v-4.54h4.01v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m370.51,129.79v-2.84h-3.63s.64,2.56,3.63,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m365.71,121.61v2.42l.79.06v3.34s2.48,2.26,4.84,1.1c1.03-.51,1.66-1.63,1.66-2.83v-4.09c0-.7-.17-1.36-.47-1.93-.61-1.17-1.78-1.96-3.1-1.96h-.13c-1.97,0-3.58,1.74-3.58,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m365.71,121.61v2.57h1.74l.38-2.13,4.7-2.37c-.61-1.17-1.78-1.96-3.1-1.96h-.13c-1.97,0-3.58,1.74-3.58,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m366.31,122.6h0c.4,0,.72.32.72.72v2.24h-.72c-.39,0-.71-.32-.71-.71v-1.54c0-.39.32-.71.71-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m371.66,126.03v-.35c.22,0,.39-.19.39-.41v-.66h.33v.66c0,.42-.32.76-.72.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m370.3,127.43c-.73,0-1.08-.64-1.16-.99l.32-.08s.2.8.94.72l.03.35s-.1,0-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m380.12,146.23h0c-.05.38.2.73.56.79l2.31.36c.36.06.7-.21.75-.59l.13-.9c.08-.59-.3-1.14-.86-1.23l-.73-.11c-1.03-.16-1.99.59-2.15,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m366.5,130.19l.99,5.77s-1.19-.63-2.18-2.01c-.99-1.38-1.08-2.92-1.08-2.92l2.26-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m370.51,130.19l-.32,5.44s1.03-.47,1.61-2.01c.58-1.54.48-2.55.48-2.55l-1.78-.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "363.43 142.45 361.34 140.95 361.8 138.66 364.13 140.26 363.43 142.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "376.54 141.49 374.62 143.02 373.79 140.7 375.96 139.5 376.54 141.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m370.42,161.71h3.84c-.03-6.52-.58-10.38-1.67-12.85h-6.32s.04,5.86.04,8.38c0,3.83,1.35,4.47,4.11,4.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 365.01,
    y: 136.92,
    width: 2.02,
    height: 0.67,
    transform: "translate(732.03 274.52) rotate(180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m135.62,175.06c.5-1.07-.09-1.26-.09-1.26h-.19s-1.61-.08-1.61-.08l-.86-.04h0l-.36-.02h-.02s.16-.05.16-.05c1.97-.06,3.9-.25,4.67-.47l2.7-.79c.55-.16-.12-.29-1.49-.29h-3.17c-2.95,0-6.3.28-7.47.62l-3.23.95h3.91-.02s0,0,0,0l-4.52.2h0s0,0,0,0l-8.46.99h0s-2.42-.38-2.42-.38h.14c.65-.06.97-.15.73-.2l-.96-.22-1.17.09c-.93.07-1.41.2-1.05.28l.74.17c.33.09.87.23,1.72.46.51.14,2.16.15,3.71.04l.43.07,3.42-.37-5.62,1.65h.36l-.07.02h0c-.84.28-1.87.72-2.7,1.35-.13.1-.21.21-.25.32l-4.31,1.42h-.31c-1.26,0-2.74.13-3.31.3h4.56l1.65-.3s.78-.13,1.98-.35c.12.17.23.29.25.32h-.15c-1.31.02-2.7.17-3.11.33l5.57-.08.56-.29h0s2.25-1.1,2.25-1.1t0,0l.91-.38c2.68-.55,5.21-1.14,6.2-1.57h0s.6,0,.6,0l3.92-1.11c.51,0,1.09.02,1.72.03,1.42.03,3.24-.09,4.07-.27h0s0,0,0,0h0Zm-4.96,0l.76-.22-.22.22h0-.54Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "m110.77,145.32l2.41,21.22s0,0,0,0l1.51,9.98-2.72.35s-4.85-10-6.13-15.52c-2.68-11.57-1.84-16.03-1.84-16.03h6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m111.8,176.85l2.89-.37.45,2.67-5.31.69c-.16-1.49.73-2.83,1.98-2.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "m109.82,177.12h-2.59s-1.14-26.41-1.14-26.41l-2.19-1.77,8.74-3.62c3.79,7.19-2.82,31.8-2.82,31.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m106.92,177.12h2.91l-.62,2.71h-4.56c0-1.5,1.02-2.71,2.28-2.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "106.49 163.51 106.06 150.94 105.31 150.11 105.56 149.85 106.41 150.79 106.41 150.86 106.85 163.5 106.49 163.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "110.89 173.54 110.55 173.47 112.49 163.77 112.83 163.85 110.89 173.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "m100.74,136.7c-1.17,1.03-2.92.87-3.9-.37-3.48-4.4-4.19-5.27-4.19-5.27l1.03-.91,7.06,6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m108.83,109.6h.85v14.19h-6.2v-8.56c0-3.11,2.39-5.64,5.34-5.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "106.09 130.15 101.38 137.38 98.46 134.59 103.54 125.66 106.09 130.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "m119.33,136.71h-4.41s-2.02-7.58-2.02-7.58l2.02-3.85s1.26,1.78,4.41,11.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "111.44 124.08 112.85 124.56 114.7 125.19 114.91 125.27 114.42 132.07 114.23 148.93 103.55 148.93 103.55 125.65 107.39 123.86 111.44 124.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "111.44 124.08 111.85 124.22 107.03 128.15 106.33 124.35 107.39 123.86 111.44 124.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "m107.39,119.13h4.02v4.95s-1.18.76-2.66.76-1.36-.76-1.36-.76v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m107.39,123.76v-3.09h3.64s-.64,2.78-3.64,3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "m108.94,111.94h.14c2.1,0,3.8,1.69,3.8,3.77v2.34h-.81v3.78s-2.91,1.71-5.41.59c-1.1-.49-1.51-1.58-1.51-2.75v-3.96c0-.68.18-1.32.5-1.87.65-1.13,1.88-1.9,3.29-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m105.68,117.84l.36.06-.04.26c-.02.12.02.24.09.33.06.07.14.12.23.12v.39c-.19,0-.38-.09-.51-.25-.14-.17-.21-.41-.17-.64l.04-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m114.47,112.21v7.16c0,2.46-1.89,4.45-4.22,4.45h-.57v-14.22h2.31c1.37,0,2.48,1.17,2.48,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m112.08,114.82h-1.05c-1.63,0-2.96-1.4-2.96-3.12h4.01v3.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-184",
    points: "108.41 120.61 107.07 120.76 107.03 120.37 108.37 120.22 108.41 120.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-184",
    points: "108.58 120.89 108.21 120.94 108.08 119.94 108.45 119.89 108.58 120.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "m119.33,136.7c-.23,1.59-1.64,2.69-3.15,2.45-5.37-.86-6.45-1.01-6.45-1.01l.2-1.4,9.4-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "m108.69,134l.9-.77,1.59,2.07c.4.53.33,1.3-.17,1.72l-1.31,1.12-1.26-1.64c-.58-.76-.47-1.88.25-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "m93.2,127.34l1.7,1.96c.43.5.4,1.27-.07,1.73l-1.24,1.2-1.35-1.56c-.63-.72-.58-1.84.1-2.51l.86-.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 103.91,
    y: 148.75,
    width: 9.73,
    height: 0.37
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 102.21,
    y: 130.72,
    width: 3.05,
    height: 2.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 103.55,
    y: 130.17,
    width: 0.35,
    height: 0.99
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m153.09,168.8h0s-2.52-.15-2.52-.15c.29-.11-.1-.22-.82-.28l1.03-.33h0l.2-.06h.25c.42,0,.89-.04,1.05-.1l.62-.2c.17-.05-.04-.1-.45-.1-.09,0-.18,0-.27,0l.5-.16h.86l.76-.24c.61-.2-.14-.35-1.68-.35h-4.63l-.25.08c-.09.03-.15.05-.2.08-.76.04-1.48.12-1.78.21l-.75.24c-.2.06-.18.12.02.16-.19.02-.36.04-.44.07l-.62.2c-.12.04-.04.07.18.09l-.17.05c-.4.13-.18.24.48.3l-.34.11s-.6.05-.97.16l-4.89.21h0s-5.12.77-8.04,1.7c-.29.09-.57.19-.84.28h1.11c-1.44.57-2.46,1.08-2.46,1.08-2.39.4-.17.54-.17.54l1.68-.54,3.39-1.08.58-.18h.01s-3.26,1.24-3.26,1.24l-.06.02h.07l-9.62,3.26h-.17c-1.25,0-2.68.13-3.17.29h5.16l.9-.29h0l10.7-2.71h.13s-7.22,2.71-7.22,2.71h0l-.9.29h5.16c.5-.16-.11-.29-1.37-.29h-.16l12.11-3.26h.22l.06-.02h0l4.59-1.27-.67.21-3.39,1.08-1.68.54s3.05-.13,3.18-.54c0,0,2.23-.52,4.33-1.08h1.11c.33-.1.64-.19.93-.28,2.92-.93,2.61-1.7,2.61-1.7h0Zm-2.95-.18l-.99-.06.4-.13c.43.05.68.11.59.19Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "m121.94,99.2c1.01,0,1.82.94,1.82,2.1v2.17c0,1.16-.82,2.1-1.82,2.1s-1.82-.94-1.82-2.1v-2.17c0-1.16.82-2.1,1.82-2.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-242",
    points: "128.79 172.79 126.06 172.79 124.36 139.96 130.92 139.96 128.79 172.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-242",
    points: "122.46 172.79 119.73 172.79 119.08 139.96 125.42 139.96 122.46 172.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m119.56,172.79h2.89v2.61h-5.16c0-1.44,1.02-2.61,2.27-2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m131.22,175.4h-5.16v-2.61h2.89c1.25,0,2.27,1.17,2.27,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m118.46,115.67v27.75h-1.5s-.94-7.27-1.12-13.58c-.02-.69-.03-1.37-.03-2.02,0-6.66,1.78-12.14,1.78-12.14h.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "m118.46,115.67v17.95h-3.55c-.03-.87-.04-1.73-.04-2.56,0-8.44,2.71-15.38,2.71-15.38h.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m118.46,143.42v4.85s-2.63-1.21-1.5-4.85h1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m134.2,127.83c0,.65-.01,1.33-.03,2.02-.19,6.31-1.12,13.58-1.12,13.58h-1.5v-27.75h.88s1.78,5.48,1.78,12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "m135.14,131.06c0,.83-.01,1.69-.04,2.56h-3.55v-17.94h.88s2.71,6.95,2.71,15.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m131.54,148.28v-4.85h1.5c1.13,3.64-1.5,4.85-1.5,4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m121.16,104.71v3.52c-.42,0-.75-.39-.75-.87v-1.79c0-.48.34-.87.75-.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-242",
    points: "127.48 113.42 132.42 115.67 130.92 143.13 119.08 143.13 117.58 115.67 122.52 113.42 127.48 113.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "124.74 120.26 122.27 113.57 127.73 113.57 124.74 120.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m127.73,113.57s-.72.74-2.73.74-2.73-.74-2.73-.74v-4.76h5.46v4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m122.27,112.83v-2.89h4.51s-.8,2.6-4.51,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m127.73,110.15s-1.86,1.8-4.52,1.49c-1.33-.15-2.34-1.45-2.34-2.99v-7.02h6.87v8.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 126.58,
    y: 102.01,
    width: 1.15,
    height: 4.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m127.98,104.71c.42,0,.75.39.75.87v1.79c0,.48-.34.87-.75.87h-.76v-2.65c0-.48.34-.88.76-.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "122.43 105.44 122.4 107.47 122.77 107.47 122.77 107.84 122.07 107.84 122.11 105.43 122.43 105.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "118.63 131.94 118.31 131.96 117.82 122.09 118.14 122.07 118.63 131.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "132.17 122.09 131.71 131.59 131.39 131.57 131.85 122.07 132.17 122.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m121.8,109.01h1.96c-1.25,1.18-1.96,0-1.96,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 119.08,
    y: 142.95,
    width: 11.83,
    height: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "m128.59,101.13v2.19h-3.35c-2.25,0-4.07-2.1-4.07-4.69v-.71h4.63c1.54,0,2.79,1.44,2.79,3.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "124.63 146.1 124.85 148.25 124.53 148.29 124.34 146.39 123.12 146.03 123.2 145.67 124.63 146.1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 119.48,
    y: 123.04,
    width: 2.79,
    height: 2.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 120.71,
    y: 122.49,
    width: 0.32,
    height: 0.99
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m122.27,112.3v1s.22,6.24.22,6.24c.04,1.19.75,2.16,1.69,2.47-.08.16-.12.34-.12.54h0c-1.15-.36-2.01-1.54-2.06-2.98l-.2-5.73c0-1.08.47-1.53.47-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m124.9,122.11l.02.56c-.3.01-.59-.03-.86-.12h0c0-.2.04-.38.12-.54.23.07.47.11.72.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "m124.88,121.53c.47-.02.86.4.88.93s-.35.99-.81,1.01c-.47.02-.86-.39-.88-.93h0c0-.2.04-.38.12-.54.14-.27.4-.46.69-.48Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "m128.73,116.83h.75c1.15-.02,2.1,1.05,2.11,2.38l.03,4.13c.01,1.44-.69,2.41-1.75,2.42v-.37c1.07-.01,1.44-1.11,1.43-2.05l-.03-4.13c0-1.12-.81-2.03-1.78-2.02h-.75c-.98.02-1.76.94-1.75,2.06l.03,4.13c0,.94.39,2.03,1.46,2.02v.37c-1.06.01-1.77-.95-1.78-2.39l-.03-4.13c-.01-1.33.92-2.42,2.07-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m128.73,116.74h.24s-.02-2.28-.02-2.28c0-.8-.54-1.58-1.22-2.08v-.61c.95.58,1.7,1.61,1.71,2.68l.02,2.28h.02c1.2-.01,2.18,1.1,2.19,2.48l.02,2.47h-.48s-.02-2.46-.02-2.46c0-1.07-.77-1.94-1.7-1.93h-.75c-.93.02-1.68.9-1.67,1.97l.02,2.47h-.48s-.02-2.46-.02-2.46c0-1.38.96-2.51,2.15-2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m128.34,125.3c.14,0,.26.13.26.3,0,.17-.11.3-.26.3-.14,0-.26-.13-.26-.3s.11-.3.26-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m129.98,125.31c.14,0,.26.13.26.3,0,.17-.11.3-.26.3-.14,0-.26-.13-.26-.3,0-.17.11-.3.26-.3Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m167.76,148.04h0s-3.05-.12-3.05-.12h-.02s.32-.09.32-.09c1.98-.11,3.76-.31,4.55-.54l.39-.11.59-.17.25-.07c.81-.24.11-.49-2.68-.49-.24,0-.46,0-.68,0-.35-.1-1.16-.16-2.31-.16-2.04,0-4.34.19-5.16.43l-1.29.38c-.71.02-1.49.09-2.04.26,0,0-1.66.15-4.67.42-1.34.12-2.3.28-1.91.41h0s0,0,0,0h0s0,0,0,0h4.84s-1.79.53-1.79.53h.88l-1.92.83-3.16.69-.11.02h.04c-1.13.2-3.07.59-5.52,1.24-.76.2-1.41.41-1.96.61-2.41.87-2.97,1.63-2.97,1.63h2.31s2.19-.79,5.33-1.63h.61l-4.99,1.63h2.65s4.34-.98,7.36-1.63c.07-.01.14-.03.2-.04,3.4-.73,5.99-1.43,6.52-1.8.03-.02.06-.05.07-.07l.08-.08.6-.02.17-.09h2.12c-.08.06.25.11.82.11h1.06c.57,0,1.21-.05,1.56-.11h4.03l2.86-.84h-5.92c1.55-.65,1.93-1.12,1.93-1.12Zm-4.35.98l-.29.14h-.62l.91-.14Zm-6.42-1.56l.31-.03.07.04-1.47.43h-3.05s4.14-.43,4.14-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m140.64,153.74h.05s-2.98-.01-2.98-.01c-1.31,0-2.79.12-3.31.28h8.96l.94-.28h-2.98c-.23,0-.46,0-.69.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m134.83,136.75c.56,7.87,2.61,14.76,2.61,14.76h2.31s-.5-7.13-.24-14.76c.07-1.97.19-3.97.38-5.89h0c.06-.62.13-1.22.2-1.81.76-5.94,2.97-10.63,2.97-10.63h-6.58s-1.39,3.29-1.75,12.84c-.07,1.83-.02,3.68.11,5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m139.39,118.42l.5,12.43h0s.24,5.9.24,5.9l.59,14.76h2.65s1-8.85,1.78-14.76c.02-.13.04-.27.05-.4.88-6.64,1.09-12.95.36-16.3-.15-.67-.33-1.21-.55-1.62h-5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m134.83,136.75h10.32c.02-.13.04-.27.05-.4.88-6.64,1.09-12.95.36-16.3l-.43-1.69-8.65.06s-1.39,3.29-1.75,12.84c-.07,1.83-.02,3.68.11,5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m134.41,154.01c0-1.38,1.06-2.49,2.36-2.49h2.98l-.44,2.49h-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m135,106.09h7.37v-18.15c0-2.15-1.65-3.89-3.69-3.89h0c-2.04,0-3.69,1.74-3.69,3.89v18.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m141.16,98.83h0c2.99,0,5.41-2.55,5.41-5.7v-2.59h-5.41v8.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "m138.74,98.71h-7.62c-.75.06-1.28.8-1.15,1.58l.18,1.04h7.73s.87-2.62.87-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m134.61,94.79l2.18-3.23s-3.03-1.43-2.92,2.2l.75,1.04Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "138.78 89.8 140.26 92.38 135.39 95.5 133.91 92.93 138.78 89.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "134.52 92.54 136 95.11 139.73 92.72 138.25 90.14 134.52 92.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "139.02 91.01 139.36 91.6 139.43 91.55 139.09 90.96 139.02 91.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "134.99 93.65 135.29 94.17 134.97 94.38 134.67 93.86 134.99 93.65"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "m130.65,97.58c2.07-2.47,3.22-3.83,3.22-3.83l.75,1.04-4.46,6.55c-.85-1.18-.44-2.65.49-3.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "136 119.86 137.16 120.25 138.54 118.41 141.01 120.54 145.73 118.53 144.88 113.25 146.57 108.34 147.36 100.01 143.89 98.91 139.86 98.71 134.98 98.71 136.79 113.58 136 119.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "144.5 114.84 144.7 114.56 142.5 112.8 142.3 113.08 144.5 114.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "144.65 114.06 144.91 113.85 143.44 111.85 143.18 112.06 144.65 114.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m139.11,108.23l5.72-4.6-1.41-1.16,1.72-.41-3.12-4.77-4.71,4.41.92.47-1.22.79,2.11,5.27Zm5.17-4.6l-5.03,4.05-1.83-4.58,1.49-.97-1.02-.52,4.06-3.8,2.63,4.02-1.92.46,1.63,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m143.88,98.91s-.97,3.92-4.69,9.04c-1.18-4.62.68-9.24.68-9.24l4.01.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "143.88 98.91 145.18 101.04 137.65 101.04 139.86 98.71 143.88 98.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m139.87,98.91s-.12.7,1.36.7,2.65-.7,2.65-.7v-4.54h-4.01v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m139.87,98.3v-2.84h3.63s-.64,2.56-3.63,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m144.64,90.14v2.42h-.76v3.34s-2.5,2.32-4.86,1.16c-1.03-.51-1.66-1.63-1.66-2.83v-4.09c0-.7.17-1.36.47-1.93.61-1.17,1.78-1.96,3.1-1.96h.13c1.97,0,3.58,1.74,3.58,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m146.57,89.89v2.2c-.75.19-1.63.12-1.63.12,0,0-1.26.44-2.18-.87l.02-1.09c0-1.65-2.26.29-2.16-2.3h-2.76c.58-1.45,1.57-2.5,4.36-2.5s4.36,2.29,4.36,4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m144.06,91.11h.72v2.24c0,.4-.32.72-.72.72h0c-.39,0-.71-.32-.71-.71v-1.54c0-.39.32-.71.71-.71Z",
    transform: "translate(288.13 185.18) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m138.93,93.68v-.35c-.34,0-.61-.29-.61-.65v-.09h-.33v.09c0,.55.42,1,.94,1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "138.75 115.74 141.08 120.54 138.54 118.41 137.16 120.25 138.75 115.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "143.88 98.91 140.51 101.63 139.87 98.99 143.88 98.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "140.99 120.75 144.92 119.22 144.8 118.89 141.16 120.32 138.66 115.15 137.06 120.04 136.05 119.7 135.95 120.03 137.27 120.47 138.72 116.05 140.99 120.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "138.72 116.04 139.02 115.87 138.32 114.51 138.32 109.45 139.32 108.06 139.05 107.85 137.99 109.34 137.99 114.6 138.72 116.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "141.13 101.97 142.25 101.22 145.18 101.22 145.18 100.87 142.16 100.87 140.95 101.68 141.13 101.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "139.8 101.7 140.11 101.57 139.85 100.87 137.65 100.87 137.65 101.22 139.62 101.22 139.8 101.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m139.06,110.89c0,.19.15.35.33.35s.33-.16.33-.35-.15-.35-.33-.35-.33.16-.33.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m139.1,113.82c0,.19.15.35.33.35s.33-.16.33-.35-.15-.35-.33-.35-.33.16-.33.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "m147.36,100.01s1.84,6.39,2.27,14.44l-2.39.25-1.95-12.83,2.06-1.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "146.12 108.36 146.45 108.31 145.89 104.67 145.57 104.73 146.12 108.36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 144.41,
    y: 110.17,
    width: 10.78,
    height: 7.57,
    transform: "translate(299.6 227.91) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m149.77,115.21h1.42v2.21c0,.71-.55,1.29-1.23,1.29h-1.06c-.68,0-1.23-.58-1.23-1.29h0c0-1.22.94-2.21,2.09-2.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "146.1 106.14 146.71 104.98 146.42 104.8 145.81 105.97 146.1 106.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m138.02,154.01c0-1.38,1.06-2.49,2.36-2.49h2.98v2.49h-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m138.97,95.95c1.47,0,1.29-1.16,1.29-1.16h-1.29v1.16Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m200.34,138.16l-.44.07c-.65.03-1.25.09-1.57.16l-7.5.55-6.07-.13h0s0,0,0,0c.82-.05,1.63-.16,2.07-.29.54-.16.31-.29-.49-.32.17-.07.34-.14.51-.21l1.14-.35c.06-.02.1-.03.14-.05.03,0,.05-.02.07-.03.13,0,.26.01.38.02,0,0,.46,0,.6-.06.18-.08.27-.12.45-.2.14-.06.37-.15-.09-.17-.21-.01-.42-.02-.65-.03-.13-.26-2.25-.38-4.88-.28h0c-1.95.08-3.64.26-4.47.45-.07,0-.14,0-.21.01-.62.05-1.22.14-1.37.2-.18.08-.27.12-.45.2-.1.04.05.06.34.05-.17.03-.34.06-.5.08-.73.12-1.38.24-1.9.34h-3.52c-.06,0-.13,0-.19,0-.61,0-1.28.04-1.91.1-.65.06-1.18.15-1.49.24-.71.21-.13.38,1.31.38h.62c-.58.06-1.05.14-1.33.22l-.42.12c-.96.11-2.11.25-3.47.42-.78.1-1.05.21-.8.29.19.08.69.13,1.35.14l-1.21.35h-.47c-.42,0-.89.04-1.06.09l-2.4.7c-.17.05.04.09.46.09h.73c0,.14.77.24,2.04.25-1.84.44-3.24,1.01-4.27,1.55l-1.79.4s0,0,0,0l-3.41.7h-.4s-1.17.22-1.17.22h.43s-1.02.22-1.02.22h0s-1.54.31-1.54.31l5.52.08c.76-.17.33-.33-.97-.35h-.15c.14-.02.64-.08,1.4-.18h.61s.11,0,.11,0h.31,0c-.15.14-.22.22-.22.22l-.4.31h4.97c.59-.17-.04-.31-1.41-.31h-.34l.83-.22h.31l.81-.24h-.22l3.94-1.04c.85-.13,1.61-.25,2.21-.36,4.26-.76,6.33-1.25,7.34-1.53h.22l.49-.14h.17c.22,0,.47-.02.56-.05l1.8-.53,2.07-.61,2.78-.81,7.2.04h0c.28,0,.59-.01.9-.04,3.78-.32,6.33-.53,7.82-.65.03,0,.07,0,.1,0,.81,0,1.71-.07,2.17-.16.26-.02.51-.04.7-.07l1.93-.3-.99-.05c-.8-.04-2.02.02-2.73.13Zm-21.63-.09c.06,0,.13.02.2.02-.08.03-.15.05-.22.08l-.08.02h-.6c.23-.04.47-.08.71-.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-171",
    cx: 157.65,
    cy: 77.51,
    rx: 4.91,
    ry: 5.18
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m148.54,89h14.03v-.26l-.85-.3-14.34-.17s.38.55,1.16.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m164.39,85.7c0,1.61-.86,2.92-1.92,2.92s-1.92-1.31-1.92-2.92.86-2.92,1.92-2.92,1.92,1.31,1.92,2.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 148.4,
    y: 82.79,
    width: 14.07,
    height: 5.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m150.32,85.7c0,1.61-.86,2.92-1.92,2.92s-1.92-1.31-1.92-2.92.86-2.92,1.92-2.92,1.92,1.31,1.92,2.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "148.57 88.7 162.57 88.74 162.57 89.29 148.57 89.29 148.57 88.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "m148.57,89.29c-1.44,0-2.6-1.53-2.6-3.41,0-.81.24-1.58.68-2.16.45-.6,1.05-.93,1.71-.93.59,0,1.14.31,1.55.86.39.53.61,1.22.61,1.96,0,.67-.2,1.3-.56,1.78-.37.5-.88.77-1.42.77h0c-1,0-1.8-1.05-1.8-2.34,0-.55.17-1.08.47-1.48.31-.42.74-.65,1.19-.65h0c.84,0,1.52.88,1.51,1.95,0,.98-.63,1.77-1.4,1.77h0c-.4,0-.76-.24-1-.61.22.46.6.77,1.03.77h0c.36,0,.71-.19.98-.55.28-.38.44-.88.44-1.42,0-.61-.17-1.18-.49-1.6-.3-.4-.69-.63-1.11-.63h0c-.47,0-.92.25-1.26.7-.36.48-.56,1.12-.56,1.8,0,1.55.91,2.82,2.04,2.83v.58Zm-.16-4.4c-.34,0-.62.42-.62.91,0,.57.33,1.05.72,1.05.45.01.83-.55.84-1.19,0-.75-.42-1.36-.95-1.36h0c-.16,0-.32.05-.46.15.15-.08.31-.13.48-.13h0v.58h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 148.62,
    y: 87.61,
    width: 13.88,
    height: 25.99,
    rx: 6.94,
    ry: 6.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "m150.72,141.62l2.97.36s5.31-10.69,6.71-16.48c2.92-12.12,1.98-16.58,1.98-16.58h-7.38s-2.63,22.23-2.63,22.23t0,0l-1.65,10.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "m153.87,141.96c1.36.17,2.33,1.57,2.16,3.13l-5.79-.72.49-2.79,3.15.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "m156.02,142.24h2.83s1.4-33.32,1.4-33.32h-7.29c-4.13,7.53,3.07,33.32,3.07,33.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "m159.19,142.24c1.37,0,2.48,1.27,2.48,2.84h-4.97l-.68-2.84h3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "m154.33,113.07h-1.12v-.4h1.12c.88,0,1.59-.75,1.59-1.68v-.59h.38v.59c0,1.14-.88,2.07-1.97,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "m159.89,108.93h1.48v3.73c0,.82-.66,1.48-1.48,1.48h0v-5.21h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "155.5 140.26 156.02 142.24 158.85 142.24 158.93 140.26 155.5 140.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "153.69 141.98 154.57 140.18 151.04 139.52 150.72 141.62 153.69 141.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "155.53 138.35 150.93 137.44 150.56 139.54 155.15 140.45 155.53 138.35"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 154.57,
    y: 138.12,
    width: 4.68,
    height: 2.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 147.39,
    y: 103.34,
    width: 4.51,
    height: 7.96,
    rx: 1.97,
    ry: 1.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "m151.4,87.92s-1.21,1.29-4.81,8.32c-.72,1.41.02,3.15,1.5,3.52l.59.15,4.29-7.67-1.57-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "m163.31,88.32v21.66c0,.23-.18.42-.4.42h-10.96c-.22,0-.4-.19-.4-.42l-.14-14.93v-7.12l.76-.26,2.45-.84.44-.15h4.23l1.74.71,1.92.79.37.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m163.31,99.73v5.48c-.55-1.71-1.29-4.47-1.63-7.89l1.28-.14c.09.9.21,1.75.34,2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m163.29,97.15l-1.92.21c-.44-4.43-.39-8.34-.34-9.98l1.92.79c-.03,1.86-.02,5.27.35,8.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 161.37,
    y: 96.78,
    width: 1.67,
    height: 1.36,
    rx: 0.68,
    ry: 0.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m156.48,97.38h-2.58c0-4.5-1.28-8.43-1.74-9.72l1.41-.48,1.04-.36c.57,1.6,1.87,5.74,1.87,10.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m151.54,109.49l-.03-2.4c1.71-.74,2.87-4.22,2.87-9.71h1.61c0,6.02-1.02,10.06-4.46,12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "m154.84,83.37s-3.25.93-2.88,3.54c.37,2.61,7.17,6.42,7.17,6.42,0,0,3.37-4.76,3.37-6.84,0-2.08-2.67-4.27-7.66-3.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "158.19 90.74 159.28 86.67 154.84 86.65 158.19 90.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m159.28,86.67s.13.8-1.43.8-2.79-.8-2.79-.8v-5.18h4.21v5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m159.28,86.34v-3.24h-3.82s.67,2.92,3.82,3.24Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-217",
    points: "163.31 88.32 170.92 89.7 170.66 92.76 163.31 92.37 163.31 88.32"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 154.35,
    y: 96.78,
    width: 1.75,
    height: 1.36,
    rx: 0.68,
    ry: 0.68
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "m156.1,96.52l-.9-1.61-8.57,3.7h0c.78,1.47,2.49,2.03,3.81,1.24,4.7-2.79,5.66-3.33,5.66-3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "m157.64,95.59c0,.98-.75,1.77-1.68,1.77s-1.68-.79-1.68-1.77.75-1.77,1.68-1.77,1.68.79,1.68,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m158.4,92.58l-.3-.64-2.03,1.08c-.78.42-1.1,1.42-.71,2.25h0c.34.72,1.18,1.01,1.87.65l.15-.08c1.13-.6,1.59-2.06,1.02-3.26Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "m178.2,85.33l-1.75-1.69-7.28,6.45c-.27.22-.34.53-.31.87.13,1.3,1.71,2.4,2.57,1.45,4.66-5.12,6.77-7.08,6.77-7.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-115",
    cx: 177.12,
    cy: 84.72,
    rx: 1.68,
    ry: 1.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m179.31,81.47l.83.32-.84,2.44c-.28.81-1.13,1.23-1.9.94h0c-.8-.31-1.22-1.24-.93-2.09l.08-.25c.4-1.17,1.63-1.78,2.75-1.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 151.98,
    y: 110.41,
    width: 10.76,
    height: 1.29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m154.94,80.94c-.83,3.46-1.8,6.19-2.18,6.09-.38-.1-.01-2.99.81-6.45.83-3.46,1.8-6.19,2.17-6.09.38.1.01,2.99-.81,6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m162.59,80.7c.45,3.54.5,6.45.12,6.51-.38.05-1.06-2.77-1.51-6.31s-.5-6.45-.12-6.51c.38-.05,1.06,2.77,1.51,6.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m154.19,80.21c-.93,3.3-2.03,5.87-2.45,5.74-.42-.13,0-2.92.93-6.22.93-3.3,2.03-5.87,2.45-5.74.42.13,0,2.92-.93,6.22Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m154.48,78.64h0c.4,0,.74.34.74.76l.03,2.05h-.54c-.51.02-.94-.42-.94-.96v-1.07c-.02-.43.3-.78.71-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m158.84,73.99h0c-2.04.03-3.67,1.8-3.64,3.95l.05,3.5c.03,2.15,1.7,3.87,3.74,3.84h0c2.04-.03,3.67-1.8,3.64-3.95l-.05-3.5c-.03-2.15-1.7-3.87-3.74-3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m160.9,81.68c.21,0,.4-.1.54-.28.15-.19.22-.44.18-.69l-.04-.28-.39.06.04.28c.02.13-.01.26-.09.36-.06.08-.15.13-.24.13v.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m156.78,80.17c.05,3.69-.32,6.69-.81,6.69-.5,0-.94-2.98-.99-6.67s.32-6.69.81-6.69c.5,0,.94,2.98.99,6.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m155.27,79.34h0l-.07-5.3,5.03-.07h0c.04,2.93-2.18,5.33-4.96,5.37Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "159.92 83.17 159.95 82.79 158.64 82.64 158.61 83.02 159.92 83.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "158.8 83.35 158.93 82.37 158.57 82.32 158.45 83.3 158.8 83.35"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m162.12,74.19l-8.59,3.49-.28-.77c-.91-2.5.27-5.31,2.64-6.27h0c2.37-.96,5.03.28,5.95,2.78l.28.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m162.99,77.33c-3.2-1.49-6.98-.94-9.68,1.41-.47.41-.87.33-.94-.24-.09-.72-.14-1.08-.24-1.8-.08-.58.21-1.43.67-1.84,2.7-2.35,6.48-2.9,9.68-1.41.55.26.61,1,.68,1.58.09.72.14,1.08.24,1.8.08.58-.41.5-.41.5Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m240.46,79.55c-.63-.59-1.23-.86-1.59-.98l4.69-1.37c.62-.18.04-.33-1.31-.37l.14-.04.09-.03s.07-.03.08-.04c.02-.05-.25-.08-.69-.08h-1.89c-.48,0-.99.02-1.46.04-.18,0-.35.02-.51.03-.73.06-1.34.14-1.65.23l-.19.06c-.97.1-1.94.26-2.59.45-1.4.07-2.67.22-3.23.38l-2.1.61s-1.48.11-6.72.76l.84-.57-1.21-.42s-2.43.21-.06.43c0,0-.31.12-1.96.7-.46.16.32.29,1.74.28h.01s0,0,0,0h0s5.61-.65,5.61-.65h0c-.11,1.09-3.03,1.51-3.04,1.51h0c-5.06.69-5.22,1.13-6.15,1.74-.12.08-.25.16-.4.24-.44.24-.85.46-1.22.65l-3.94,1.03h0l-1.09.27h2.64s0,0,0,0h4.36c.52-.15-.03-.28-1.24-.28h-.3l2.71-.79c1.75-.32,3.83-.73,5.92-1.17,1.99-.42,3.99-.88,5.72-1.35.1,0,2.61-.06,2.54-.44,0,0,1.14-.13,7.43-.84h.01s0,0,0,0h0s0,0,0,0Zm-8.09.75l3.81-1.11h.61l.13-.04.76.41-5.31.74Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m218.21,47.29v4.67s2.45-.45,1.04-3.97l-1.04-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m212.46,15.74h6.44v18.09c0,1.78-1.44,3.22-3.22,3.22h0c-1.78,0-3.22-1.44-3.22-3.22V15.74h0Z",
    transform: "translate(431.35 52.79) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m207.84,31.02h3.7v-10.06h0c-2.04,0-3.7,1.75-3.7,3.9v6.16Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m219.26,47.99l-1.04-.7,3.47-8.33,2.14,1.44c-3.88,6.4-4.58,7.59-4.58,7.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m218.28,30.77s1.43,1.32,5.55,9.64l-2.21.99-4.78-8.21,1.44-2.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m207.84,30.42s-1.27,1.18-4.89,8.33c-.36.7-.06,1.57.63,1.88l.92.41,4.78-8.21-1.44-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "m210.82,81.92h2.62s.8-2.78,1.75-7.17c.64-2.93,1.34-6.59,1.91-10.62.68-4.77,1.18-10.06,1.18-15.3h-5.93l-.72,15.64-.38,8.17h0s-.43,9.28-.43,9.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m213.59,81.92c1.2,0,2.18,1.12,2.18,2.49h-5.11s.16-2.49.16-2.49h2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m218.28,48.83h-8.26s1.52-3.75-2.11-13.64l-.07-4.78,3.19-1.09,3.71-.2,3.53,1.65v18.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "215.49 36.69 210.32 33.58 212.53 32.34 209.36 30.83 210.92 29.18 211.18 29.45 209.99 30.71 213.36 32.32 211.08 33.59 215.36 36.17 216.89 33.43 214.6 32.18 216.43 30.78 214.5 29.49 214.69 29.16 217.08 30.76 215.29 32.13 217.4 33.27 215.49 36.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "211.05 29.32 209.58 32.52 217.39 32.52 214.75 29.12 211.05 29.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "m214.75,29.12s.81,1.8.66,3.08c-.16,1.27-1.19,2.15-1.19,2.15l-3.17-5.03,3.7-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m214.75,29.32s.11.7-1.25.7-2.44-.7-2.44-.7v-4.54h3.7v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m214.75,28.71v-2.84h-3.35s.59,2.56,3.35,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m210.35,20.53v2.42h.7v3.34s2.31,2.32,4.48,1.16c.95-.51,1.53-1.63,1.53-2.83v-4.09c0-.7-.16-1.36-.43-1.93-.57-1.17-1.64-1.96-2.86-1.96h-.12c-1.82,0-3.29,1.74-3.29,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m209.82,64.58c.15.7.29,1.43.42,2.18.37,2.15.71,4.12,1.01,5.88.97,5.76,1.5,9.28,1.5,9.28h2.44v-33.09h-5.17c-2.72,6.2-1.36,10.24-.2,15.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m215.49,81.92c1.2,0,2.18,1.12,2.18,2.49h-4.36l-.6-2.49h2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m215.81,24.53v-.34c.08,0,.15-.04.2-.1.06-.08.09-.18.08-.29l-.03-.23.32-.05.03.23c.03.2-.03.41-.15.56-.11.14-.27.22-.44.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m212.21,16.51h5.19v2.47s-4.04-.34-4.04,3.9c0,2.76-1.92,3.18-2.93,3.18h-.65v-4.57c0-2.76,1.09-4.99,2.43-4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m213.06,25.4s.26,1.29,1.43,1.29,1.43-1.29,1.43-1.29h-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m210.84,16.86v.55h5.5v-2.21c0-.12-.02-.24-.06-.35-.14-.42-.52-.72-.96-.72h-1.89c-.48,0-.93.14-1.32.38-.14.09-.27.19-.4.31-.54.5-.88,1.23-.88,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m209.82,64.58l1.81-.11,3.56-.22,1.91-.12c.68-4.77,1.18-10.06,1.18-15.3h-8.26c-2.72,6.2-1.36,10.24-.2,15.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "m211.71,14.82l3.66,1.01.96-.39v-.24c0-.12-.02-.24-.06-.35l-1,.44-3.16-.78c-.14.09-.27.19-.4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "m211.05,29.32c0-.71-.54-1.28-1.21-1.28s-1.21.57-1.21,1.28h2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "m211.05,29.32c-.38-.4-1-.4-1.38,0s-.38,1.05,0,1.45l1.38-1.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "214.75 48.83 214.39 48.83 214.39 38.81 215.26 36.36 215.6 36.5 214.75 38.87 214.75 48.83"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 209.9,
    y: 35.34,
    width: 2.56,
    height: 0.77,
    transform: "translate(422.36 71.45) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m202.61,32.15l-2.63-3.76s-1.72,1.89,1.4,3.85l1.23-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m201.38,32.24l1.23-.09,1.9,8.88h0c-1.4.1-2.61-1.02-2.71-2.49-.34-5.25-.42-6.3-.42-6.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "m214.91,16.57c0,.22.17.41.39.41s.39-.18.39-.41-.17-.41-.39-.41-.39.18-.39.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 214.54,
    y: 16.42,
    width: 1.54,
    height: 0.29,
    transform: "translate(430.62 33.14) rotate(180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m310.48,111l-3.03.57c-.83-.64-1.54-.76-1.55-.76l2.1-.61c.56-.16.26-.31-.64-.38.63-.19.77-.35.47-.45l.19-.06c.31-.09.25-.17-.1-.23-.08-.01-.17-.02-.28-.03-.3-.03-.69-.04-1.18-.04h-1.89c-.44,0-.93.03-1.23.08-.08.01-.14.03-.19.04l-.09.03-.14.04c-1.58.04-3.2.19-3.82.37l-4.69,1.37c-1.17.12-3.62.39-8.27.98h-.01s0,0,0,0c0,0,0,0,0,0h0c1.46.71,1.7.84,1.7.84-2.68.38-.56.44-.46.44-1.44.46-2.58.92-3.48,1.35-.95.45-1.63.85-2.1,1.17l-2.71.79h-.3c-1.2,0-2.6.12-3.12.28h4.36s2.65,0,2.65,0l.78-.27h0l3.07-1.03c.96-.19,2.04-.41,3.23-.65.42-.08.84-.16,1.25-.24,3.24-.61,6.12-1.06,5.75-1.74h0s-.09-.42,7.26-1.51h0l1.19.65h0s0,0,0,0h0s.02,0,.02,0c1.36,0,2.98-.11,3.63-.28,2.32-.58,2.8-.7,2.8-.7,3.86-.22,2.85-.43,2.85-.43l-4.05.42Zm-21.59.92l3.58-.41-.13.04h.61l-3.81,1.11-.26-.74Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m275.14,79.65v4.67s-2.45-.45-1.04-3.97l1.04-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m280.89,69.42h-6.44v-17.91c0-1.87,1.44-3.39,3.22-3.39h0c1.78,0,3.22,1.52,3.22,3.39v17.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m285.51,63.38h-3.7v-10.06h0c2.04,0,3.7,1.75,3.7,3.9v6.16Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m274.09,80.35l1.04-.7-3.47-8.33-2.14,1.44c3.88,6.4,4.58,7.59,4.58,7.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m275.07,63.14s-1.43,1.32-5.55,9.64l2.21.99,4.78-8.21-1.44-2.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m285.51,62.78s1.27,1.18,4.89,8.33c.36.7.06,1.57-.63,1.88l-.92.41-4.78-8.21,1.44-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "m282.53,114.29h-2.62s-.8-2.78-1.75-7.17c-.64-2.93-1.34-6.59-1.91-10.62-.68-4.77-1.18-10.06-1.18-15.3h5.93l.72,15.64.38,8.17h0s.43,9.28.43,9.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m279.76,114.29c-1.2,0-2.18,1.12-2.18,2.49h5.11s-.16-2.49-.16-2.49h-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m275.07,81.2h8.26s-1.52-3.75,2.11-13.64l.07-4.78-3.19-1.1-3.71-.2-3.53,1.65v18.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "277.86 69.06 283.03 65.94 280.82 64.71 283.99 63.2 282.43 61.55 282.17 61.82 283.36 63.08 279.99 64.68 282.27 65.96 277.99 68.54 276.46 65.79 278.75 64.55 276.92 63.15 278.85 61.85 278.66 61.53 276.27 63.13 278.06 64.49 275.95 65.64 277.86 69.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "282.3 61.69 283.77 64.88 275.96 64.88 278.6 61.49 282.3 61.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "m278.6,61.49s-.81,1.8-.66,3.08c.16,1.27,1.19,2.15,1.19,2.15l3.17-5.03-3.7-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m278.6,61.69s-.11.7,1.25.7,2.44-.7,2.44-.7v-4.54h-3.7v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m278.6,61.07v-2.84h3.35s-.59,2.56-3.35,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m283,52.9v2.42h-.7v3.34s-2.31,2.32-4.48,1.16c-.95-.51-1.53-1.63-1.53-2.83v-4.09c0-.7.16-1.36.43-1.93.57-1.17,1.64-1.96,2.86-1.96h.12c1.82,0,3.29,1.74,3.29,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m283.53,96.95c-.15.7-.29,1.43-.42,2.18-.37,2.15-.71,4.12-1.01,5.88-.97,5.76-1.5,9.28-1.5,9.28h-2.44v-33.09h5.17c2.72,6.2,1.36,10.24.2,15.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m277.86,114.29c-1.2,0-2.18,1.12-2.18,2.49h4.36l.6-2.49h-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m277.54,56.9v-.34c-.08,0-.15-.04-.2-.1-.06-.08-.09-.18-.08-.29l.03-.23-.32-.05-.03.23c-.03.2.03.41.15.56.11.14.27.22.44.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m281.14,48.88h-5.19v2.47s4.04-.34,4.04,3.9c0,2.76,1.92,3.18,2.93,3.18h.65v-4.57c0-2.76-1.09-4.99-2.43-4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m280.29,57.77s-.26,1.29-1.43,1.29-1.43-1.29-1.43-1.29h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m282.51,49.23v.55h-5.5v-2.21c0-.12.02-.24.06-.35.14-.42.52-.72.96-.72h1.89c.48,0,.93.14,1.32.38.14.09.27.19.4.31.54.5.88,1.23.88,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m283.53,96.95l-1.81-.11-3.56-.22-1.91-.12c-.68-4.77-1.18-10.06-1.18-15.3h8.26c2.72,6.2,1.36,10.24.2,15.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "m281.64,47.18l-3.66,1.01-.96-.39v-.24c0-.12.02-.24.06-.35l1,.44,3.16-.78c.14.09.27.19.4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "m282.3,61.69c0-.71.54-1.28,1.21-1.28s1.21.57,1.21,1.28h-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "m282.3,61.68c.38-.4,1-.4,1.38,0s.38,1.05,0,1.45l-1.38-1.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "278.6 81.2 278.96 81.2 278.96 71.17 278.09 68.73 277.75 68.86 278.6 71.24 278.6 81.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 280.89,
    y: 67.7,
    width: 2.56,
    height: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m290.74,64.52l2.63-3.76s1.72,1.89-1.4,3.85l-1.23-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m291.97,64.61l-1.23-.09-1.9,8.88h0c1.4.1,2.61-1.02,2.71-2.49.34-5.25.42-6.3.42-6.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "m278.44,48.93c0,.22-.17.41-.39.41s-.39-.18-.39-.41.17-.41.39-.41.39.18.39.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 277.27,
    y: 48.79,
    width: 1.54,
    height: 0.29
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m325.65,134.6l-3.15-.17c.04-.05.03-.1-.08-.15.78-.04,1.47-.12,1.78-.21l.25-.07h0l.27-.08s.04-.01.05-.02c.02,0,.03,0,.05-.01l.57-.17c.33-.01.79-.05.99-.1l.14-.03c.15-.04.38-.1.23-.14-.05-.01-.14-.02-.27-.02.21-.03.38-.06.49-.09l1-.29c.31-.09.13-.17-.38-.21l.2-.06c.28-.08-.06-.15-.77-.15h-2.77l-.32.09h-1.65l-.36.11c-1.05.04-2.07.14-2.52.26h0l-1.25.37h-.33c-.08,0-.17,0-.2.02-.03,0,0,.02.09.02h.18c-.26.02-.49.05-.6.08l-.7.21c-.18.05.04.1.49.1h.28l-.22.07-.96.23c-1.02.06-1.79.16-2.34.26l-4.4.17s-4.4.48-7.15,1.29h.19c-.1.03-.2.05-.29.08-2.44.71-4.65,1.54-4.65,1.54-2.64.41-.23.55-.23.55l1.87-.55,6.17-1.6-5.26,1.68h.17l-9.86,3.47h1.03c-1.28,0-2.77.13-3.33.3h5.27l1.01-.3h0l11.04-2.85-7.67,2.85h0l-1.01.3h5.27c.56-.16-.03-.3-1.31-.3h.73l13.02-3.47h.1l6.25-1.68-4.77,1.6-1.87.55s3.35-.14,3.52-.55c0,0,3.42-.82,5.86-1.54.09-.03.18-.05.27-.08h.19c2.75-.8,1.65-1.29,1.65-1.29Zm.6-1.02l-.14.03c-.13.03-.4.05-.6.06l.74-.22h.1c.06,0,.09,0,.12,0,.08.02,0,.06-.22.11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m283.77,92.63c0,6.45.6,13.91.6,13.91h1.64l1.29-26.29h-.96s-2.58,6.07-2.58,12.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "m283.6,91.89h3.71v-11.64h-.96s-2.75,4.37-2.75,11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m286.02,106.54v4.96s-2.88-1.24-1.64-4.96h1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "m297.59,70.95h0c-1.1,0-1.99-.94-1.99-2.1v-2.65c0-1.16.89-2.1,1.99-2.1h0c1.1,0,1.99.94,1.99,2.1v2.65c0,1.16-.89,2.1-1.99,2.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "287.21 104.67 289.38 138.69 293.37 138.69 295.1 104.67 287.21 104.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "301.69 104.67 300.44 138.69 296.75 138.69 294.02 104.67 301.69 104.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "299.35 138.81 300.35 108.16 300.03 108.12 299.02 138.77 299.35 138.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "289.78 108.12 290.79 138.77 290.46 138.81 289.46 108.16 289.78 108.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m302.02,141.36c0-1.48-1.04-2.67-2.32-2.67h-2.95v2.67h5.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m288.1,141.36h5.27v-2.67h-2.95c-1.28,0-2.32,1.2-2.32,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m305.14,92.64c0,6.45-.6,13.91-.6,13.91h-1.64l-1.29-26.29h.96s2.58,6.07,2.58,12.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "m305.32,91.9h-3.71v-11.64h.96s2.75,4.37,2.75,11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m302.89,106.55v4.96s2.88-1.24,1.64-4.96h-1.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "301.69 107.29 287.21 107.29 286.35 80.25 291.92 77.96 296.99 77.96 302.57 80.26 301.69 107.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "m294.94,80.78l2.5-1.04,1.7,1.77s.32-4.29-2.33-5.34c-2.11-.83-1.87,4.61-1.87,4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "m294.93,80.78l-3.31-1.04-1.64,1.55s-.49-4.3,2.26-5.23c2.75-.93,2.69,4.72,2.69,4.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "291.47 78.11 294.94 80.78 297.44 78.11 291.47 78.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m297.44,78.11s-.78.75-2.98.75-2.98-.75-2.98-.75l.32-3.83h5.97l-.32,3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m296.76,77.17c-2.93.36-4.97-1.68-4.97-1.68v-9.61h5.41c1.43,0,2.1,1.64,2.1,2.38v5.54c0,1.73-1.09,3.2-2.54,3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "m293.62,74.59h5.7v.25c0,1.57-1.28,2.85-2.85,2.85h0c-1.57,0-2.85-1.28-2.85-2.85v-.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m298.66,74.59c0,.39-.45.7-1.01.7s-1.01-.31-1.01-.7.45-.7,1.01-.7,1.01.31,1.01.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m292.77,73.34h2.64v.2c0,1.46-1.18,2.64-2.64,2.64h0v-2.85h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 291.17,
    y: 66.64,
    width: 1.66,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 291.18,
    y: 68.44,
    width: 1.66,
    height: 2.87,
    transform: "translate(584.01 139.74) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "297.97 73.29 297.21 73.29 297.21 72.92 297.62 72.92 297.59 71.87 297.93 71.87 297.97 73.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "m294.44,62.44h2.55c.83,0,1.51.68,1.51,1.51v1.43c0,.83-.68,1.51-1.51,1.51h0c-1.41,0-2.55-1.14-2.55-2.55v-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "m292.79,63.3v1.46c0,.78.4,1.46.99,1.83.02-.03.05-.06.08-.09.19-.2.45-.33.73-.33h2.46c.07-.16.12-.35.12-.54v-1.07c0-.16-.03-.31-.08-.45-.17-.47-.61-.81-1.11-.81h-3.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "294.86 111.29 294.54 111.25 294.75 109.05 296.21 108.61 296.3 108.97 295.05 109.35 294.86 111.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "m291.18,66.71v1.82h1.23c.64,0,1.15-.56,1.15-1.24,0-.27.09-.51.23-.7.02-.03.05-.06.08-.09.19-.2.45-.33.73-.33h2.78v-2.06h-3.78c-.28,0-.55.05-.79.15-.94.35-1.62,1.32-1.62,2.45Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m295.54,72.34h.62c.45,0,.91-.37,1.09-.88l.11-.31c.14-.41.11-.84-.08-1.13-.15-.23-.39-.35-.66-.35h-1.13c-.24,0-.45.1-.61.28-.22.26-.33.69-.28,1.16l.03.31c.05.53.44.93.91.93Zm1.08-2.32c.16,0,.3.07.38.2.13.19.14.5.04.8l-.11.31c-.13.37-.46.65-.77.65h-.62c-.29,0-.54-.26-.57-.6l-.03-.31c-.04-.37.04-.7.19-.88.09-.11.21-.16.36-.16h1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m298.88,72.31h.26c.31,0,.79-.35.82-.9l.02-.31c.02-.34.02-.95-.24-1.24-.09-.11-.22-.16-.35-.16h-.83c-.16,0-.3.08-.41.22-.19.26-.25.74-.13,1.21l.07.31c.12.51.45.88.78.88Zm.52-2.32c.06,0,.1.02.14.07.13.15.19.54.16,1.01l-.02.31c-.03.38-.37.63-.54.63h-.26c-.17,0-.41-.25-.51-.65l-.07-.31c-.09-.37-.06-.76.08-.95.05-.07.11-.1.18-.1h.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m297.3,70.61s.18-.15.44-.15c.2,0,.23.08.23.08l.27-.09s-.08-.28-.5-.3c-.37-.01-.62.21-.63.22l.18.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m290.85,70.25h4.09c.08,0,.14-.07.14-.15s-.06-.15-.14-.15h-4.09c-.08,0-.14.07-.14.15s.06.15.14.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m291.51,70.09h0c-.45,0-.82.39-.82.87v1.87c0,.48.37.87.82.87h.83v-2.72c0-.48-.37-.88-.83-.88Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 294.99,
    y: 80.78,
    width: 0.3,
    height: 3.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "m296.92,73.29h.84c0,.83-.67,1.51-1.51,1.51h-.84c0-.83.67-1.51,1.51-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "m297.65,73.29h.15c.83,0,1.51.67,1.51,1.51h-.15c-.83,0-1.51-.67-1.51-1.51h0Z",
    transform: "translate(596.97 148.09) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "m295.42,74.42h-.18c-1.33,0-2.4-1.14-2.4-2.54h-.49v4.07s1.13,1.73,3.07,1.73v-3.26Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m350.02,147.61l-.43.02c-1.18-.65-3.11-.93-3.11-.93l-.58-.03h.06s-1.51-.09-1.51-.09h-.04s-2.04-.11-2.04-.11l1.71-.5h0,.03s.26,0,.26,0c.43,0,.92-.04,1.1-.09l.64-.19c.17-.05-.04-.09-.47-.09-.03,0-.07,0-.1,0l.2-.06.28-.08h.04s2.15-.01,2.15-.01l.35-.1h-.93l.56-.16c.64-.19.39-.35-.52-.45l.43-.13h-.54c-.34,0-.69,0-1.03.02l.06-.02h-.54c-.29,0-.59,0-.89.01h.05s-.54-.01-.54-.01c-1.39,0-2.93.11-3.79.26-.86.09-1.56.2-1.96.32l-.56.16h-1.11l-.35.1h1.84-.04s-.28.09-.28.09l-.22.07c-.32.01-.63.05-.76.08l-.64.19c-.13.04-.04.07.18.08h0c-.41.12-.19.23.5.28l-.54.16-.25.07-3.01.12h.01s-2.05.07-2.05.07h-.01s-.59.03-.59.03c0,0-3.84.28-9.44.93l-.28-.02-2.82.36.98.03c.98.47,2.85.76,3.41.84l-.58.17c-.27.08-.05.15.49.17l-.33.1h1.24l-.64.22-11.25,3.24h-.17c-1.31,0-2.79.12-3.31.28h5.38l.94-.28h1.33l11.79-2.85h.04s-7.19,2.85-7.19,2.85h.88l-.94.28h5.38c.52-.15-.12-.28-1.42-.28h-.17l9.66-2.78h.92l2.62-.77c.79-.01,1.64-.09,1.95-.18l.58-.17c1.12-.08,5.1-.38,9.37-.86l.65-.02s0,0-.01,0h.42s-.46-.34-.46-.34Zm-27.16.49h.45s1.77-.21,1.77-.21l-.22-.02,4.1-.44-3.7,1.31c-.13-.02-.36-.04-.66-.04h-.05l-1.67-.61Zm16.41.61h-.05c-.26,0-.54.01-.79.03l5.12-1.29,1.11.43-.34.02.27.22.59-.02-5.91.62Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m308.64,114.16h0c1.34,0,2.43,1.09,2.43,2.43v1.89h0c-1.34,0-2.43-1.09-2.43-2.43v-1.89h0Z",
    transform: "translate(619.71 232.64) rotate(-180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "323.61 117.1 323.38 150.51 319.66 150.51 316.35 117.1 323.61 117.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "311.07 117.1 310.86 150.51 315.02 150.51 317.67 117.1 311.07 117.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m308.32,153c0-1.38,1.06-2.49,2.36-2.49h3.01v2.49h-5.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m325.92,153h-5.38v-2.49h3.01c1.31,0,2.36,1.12,2.36,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m303.89,105.39l6.09,8.96-1.11,1.17s-3.67-2.92-6.79-8.23l1.8-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m301.63,107.34l4.41,1.21,5.88-8.89-2.42-3.64s-3.85,3.37-7.87,11.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "307.61 106.76 306.59 108.74 301.3 107.5 302.87 104.2 307.61 106.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m325.82,114.18h0v1.89c0,1.34-1.09,2.43-2.43,2.43h0v-1.89c0-1.34,1.09-2.43,2.43-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m330.57,105.4l-6.09,8.96,1.11,1.17s3.67-2.92,6.79-8.23l-1.8-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m332.83,107.35l-4.41,1.21-5.88-8.89,2.42-3.65s3.85,3.38,7.87,11.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "326.85 106.77 327.87 108.75 333.16 107.15 331.59 104.21 326.85 106.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m313.24,86.02h0v3.36h0c-.43,0-.78-.37-.78-.83v-1.71c0-.46.35-.83.78-.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "311.07 120.12 323.51 120.12 324.96 96.02 319.81 93.87 314.65 93.87 309.5 96.02 311.07 120.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m314.39,94.01s.75.7,2.84.7,2.84-.7,2.84-.7v-4.54h-5.69v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m314.39,93.31v-2.75h4.7s-.83,2.48-4.7,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m320.24,84.77v1.63h-.17v4.36s-1.93,1.72-4.71,1.42c-1.39-.15-2.44-1.38-2.44-2.85v-4.55c0-.55.11-1.08.31-1.55.18-.42.43-.8.73-1.12.65-.68,1.54-1.11,2.53-1.11h.16c1.97,0,3.58,1.69,3.58,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "m320.24,84.77v1.63h-.17v.84h-1.2v-2.48c0-.85-.65-1.53-1.45-1.53h-4.19c.18-.42.43-.8.73-1.12.65-.68,1.54-1.11,2.53-1.11h.16c1.98,0,3.58,1.69,3.58,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m320.34,86.02h0c.43,0,.78.37.78.83v1.71c0,.46-.35.83-.78.83h-.79v-2.52c0-.46.35-.84.79-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m314.91,88.55c-.19,0-.37-.08-.51-.23s-.2-.34-.2-.54l.02-.6h.33s-.02.61-.02.61c0,.11.03.21.11.29.07.08.17.12.27.12v.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "m317.47,82.69h1.45v2.64h0c-.8,0-1.45-.65-1.45-1.45v-1.18h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 311.09,
    y: 83.75,
    width: 11.3,
    height: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "m316.83,77.39h0c-2.56,0-4.63,2.19-4.63,4.89v1.47h9.27v-1.47c0-2.7-2.07-4.89-4.63-4.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "m315.45,83.91h-1.1v-3.65c0-1.76,1.36-3.19,3.02-3.19h.54v1.16h-.54c-1.06,0-1.92.91-1.92,2.02v3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "m314.07,83.91h-1.1v-3.65c0-1.76,1.35-3.19,3.02-3.19h.54v1.16h-.54c-1.06,0-1.92.91-1.92,2.02v3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "m316.95,83.91h-1.1v-3.65c0-1.76,1.35-3.19,3.02-3.19h.54v1.16h-.54c-1.06,0-1.92.91-1.92,2.02v3.65Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m316.01,89.93h-1.47v-.35h1.47c.23,0,.44-.09.61-.26l.07-.07.23.26-.07.07c-.22.23-.52.35-.84.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "311.23 125.02 310.75 115.19 323.81 115.19 323.37 124.41 311.23 125.02"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 311.81,
    y: 101.19,
    width: 10.17,
    height: 17.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "321.53 104.04 319.75 103.32 322.51 94.94 324.29 95.65 321.53 104.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "312.08 104.33 313.86 103.61 311.77 94.99 309.99 95.71 312.08 104.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "320.42 107 313.37 107 313.37 104.98 313.7 104.98 313.7 106.65 320.09 106.65 320.09 104.98 320.42 104.98 320.42 107"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m320.14,113.13h-6.41v-6.47h6.41v6.47Zm-6.09-.33h5.78v-5.81h-5.78v5.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 310.56,
    y: 116.35,
    width: 13.25,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 313.81,
    y: 114.83,
    width: 2.29,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 309.71,
    y: 115.49,
    width: 2.54,
    height: 3.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 313.96,
    y: 117.45,
    width: 1.89,
    height: 0.35
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "311.46 117.8 309.89 117.8 309.89 117.45 311.13 117.45 311.13 115.83 311.46 115.83 311.46 117.8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-221",
    cx: 314.95,
    cy: 116.84,
    rx: 0.21,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m310.21,117.05c0,.12-.05.22-.1.22s-.1-.1-.1-.22.05-.22.1-.22.1.1.1.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 318.47,
    y: 115.89,
    width: 6,
    height: 9.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 319.18,
    y: 116.62,
    width: 4.72,
    height: 3.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 319.69,
    y: 117.46,
    width: 0.58,
    height: 2.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 320.46,
    y: 117.82,
    width: 0.68,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 322.72,
    y: 117.82,
    width: 0.54,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 321.47,
    y: 117.27,
    width: 0.88,
    height: 2.78
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m313.33,102.9c0,.29-.22.52-.5.52s-.5-.23-.5-.52.22-.52.5-.52.5.23.5.52Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 320.92,
    cy: 102.74,
    rx: 0.5,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-246"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 312.92,
    y: 84.66,
    width: 7.32,
    height: 0.84
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m382.86,172.3l-3.55-.23.05-.02c1.76,0,3.74-.17,4.43-.37l.61-.18h-1l1.79-.52h0c.38-.11.15-.21-.5-.23.13-.11-.46-.19-1.49-.19h-2.27c-1.68,0-3.52.12-4.73.29-.93.08-1.69.19-2.09.3-.37.11-.45.21-.3.3l-.31.09h-.67l-.61.18c-.39.12-.3.22.18.29h-.04s.05.06.61.1l-4.46.21-6.56.87h0l-1.25.17-2.74-.41c.36-.06.41-.12.09-.15l-1.47-.15-1,.11c-.9.1-1.12.23-.49.3l.69.07c.13.01.35.01.56,0l3.77.71c.15-.02,1.74-.22,3.72-.48l.29.03,1.87-.26-5.85,1.88h0l-11.46,3.51h-.01c-1.34,0-2.87.13-3.4.28h5.07l1.44-.28h0l11.83-2.67-5.51,2.78c-.09.01-.16.03-.21.05l-.45.13h2.62l.45-.13s.02,0,.03-.01h0s12.27-3.66,12.27-3.66l3.7-.99,2.26.03c.19-.05.52-.15.69-.2.46-.13.86-.26,1.2-.38h.29s2.29-1.05,1.92-1.15Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m354.78,117.93h1.54c1.77,0,3.2-1.51,3.2-3.38v-1.6h-4.74v4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m352.79,118.17h-1.54c-1.77,0-3.2-1.51-3.2-3.38v-1.6h4.74v4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m355.52,108.22h3.01v5.78h-.91c-1.16,0-2.09-.99-2.09-2.21v-3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m348.72,114.44h8.58v-7.74c0-1.29-.99-2.34-2.22-2.34h-2.27c-2.26,0-4.09,1.93-4.09,4.32v5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m353.46,115.11h3.12v-7.29c0-1.22-.99-2.21-2.22-2.21h-2.27c-2.26,0-4.09,1.82-4.09,4.07h0c0,3,2.45,5.43,5.46,5.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "336.36 126.88 343.14 133.91 344.16 131.39 337.45 125.44 336.36 126.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m348.98,119.19l.8.59s-6.39,13.75-6.65,14.14l-2.05-2.13,5.26-11.63,2.64-.96Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "342.77 128.05 345.6 129.8 348.22 123.56 346.34 120.15 342.77 128.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m335.52,123.1l1.55,1.08c.77.53.98,1.62.48,2.44l-.28.45c-.25.4-.75.51-1.13.24h0c-1.25-.87-1.6-2.65-.78-3.97l.15-.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "346.34 120.15 350.78 117.94 356.1 117.94 360.71 120.15 359.82 144.43 347.14 144.43 346.34 120.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m350.51,118.07s.77,1.07,2.93,1.07,2.93-1.07,2.93-1.07v-6.94h-5.85v6.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m350.51,117.7v-2.83h4.83s-.85,2.55-4.83,2.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "359.82 144.43 360.04 177.5 357.5 177.3 352.28 144.43 359.82 144.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "347.14 144.43 347.7 176.22 350.79 176.22 354.34 144.43 347.14 144.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m347.68,176.22h3.1l-.47,2.57h-5.07c0-1.42,1.09-2.57,2.43-2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m358.73,176.22h0c.72,0,1.31.62,1.31,1.38v1.18h-2.62v-1.18c0-.76.59-1.38,1.31-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m360.71,120.15s1.84,5.26,1.84,13.88c0,.47,0,1.31-.02,1.78l-2.79-.36-.28-4.62,1.26-10.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 347.12,
    y: 124.02,
    width: 5.98,
    height: 9.5,
    rx: 1.89,
    ry: 1.89,
    transform: "translate(700.22 257.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "m347.74,125c0,.14.11.26.24.26s.24-.11.24-.26-.11-.26-.24-.26-.24.11-.24.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m350.53,131.2h.38c1.74,0,3.15,1.41,3.15,3.15h-.56c-1.64,0-2.97-1.33-2.97-2.97v-.18h0Z",
    transform: "translate(704.58 265.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "353.7 134.35 359.73 135.46 360.3 132.5 353.7 132.5 353.7 134.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m349.35,116.54c3.98,1.46,6.34-1.59,6.34-1.59v-6.67c0-.8-.55-1.45-1.23-1.45h-2.28c-2.37,0-2.84,2.09-2.84,3.52v6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "m354.85,108.96s-.04,1.85-.65,3.83c-.61,1.99-2.36,1.7-2.36,1.7,0,0-.16.85-1.06.85s-1.02-.79-1.07-.87c-.4-.66-.36-3.35-.36-3.35l-.15,6.38s.51,1.09,2.5,1.09c3.24,0,4.08-2.51,4.08-2.51v-6.1l-.93-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "m351.41,113.22h-.97c0,.88.57,1.6,1.26,1.6h.96c0-.89-.56-1.6-1.25-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "m350.32,113.22c-.59,0-1.08.61-1.08,1.37v.24s.47,0,.47,0c.65,0,1.17-.67,1.17-1.49v-.12h-.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "350.22 113.1 351.01 113.1 351.01 112.73 350.62 112.73 350.7 111.92 350.35 111.88 350.22 113.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "m359.12,148.11c-1.6,0-2.91-1.37-2.91-3.07h.36c0,1.48,1.14,2.68,2.55,2.68v.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "m347.89,148.04v-.23c.43,0,.91-1.13.91-2.76h.22c0,1.68-.5,2.99-1.13,2.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "353.07 150.16 352.3 149.34 352.3 146.25 352.52 146.25 352.52 149.25 353.23 150 353.07 150.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m354.71,110.49h3.81v-2.25c0-1.21-.76-2.19-1.69-2.19h-2.18c-.61,0-1.11.65-1.11,1.44h0c0,1.66,1.09.73,1.17,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m355.8,112.6h0c-.6,0-1.09-.51-1.09-1.15v-.96h1.09v2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m356.57,110.21h0c.43,0,.78.37.78.82v1.7c0,.45-.35.82-.78.82h-.79v-2.52c0-.46.35-.83.79-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m359.45,130.84l3.28-.27s-1.28-9.45-2.02-10.42l-1.26,10.68Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m455.19,227.96h0s-3.21-.18-3.21-.18h0l.16-.05.37-.11c.29,0,.6-.01.93-.03,1.22-.06,2.28-.18,2.73-.31l.72-.21c1.04-.07,1.95-.18,2.38-.3h0c.7-.2-.16-.37-1.91-.37-.3,0-.6,0-.9.01-.26,0-.54-.01-.85-.01h-.13c-1.97,0-4.23.19-5.04.43l-.5.15c-.12.01-.21.03-.27.05l-.09.03c-1.71.06-3.36.23-4.03.42l-1.54.45s0,0,0,0c0,0,0,0,0,0,0,0-.02,0-.04,0,0,0,0,0-.01,0-.04,0-.1.01-.17.02,0,0,0,0-.01,0-.04,0-.08.01-.12.02,0,0,0,0,0,0-.1.01-.21.03-.33.05,0,0,0,0-.01,0-.19.03-.41.06-.66.1,0,0,0,0,0,0-.42.07-.9.15-1.43.26h0c-.19.04-.38.08-.58.12,0,0,0,0,0,0-.08.02-.16.04-.24.05,0,0-.02,0-.03,0-.06.01-.13.03-.2.05-.11.03-.23.05-.34.08-.16.04-.31.08-.47.12,0,0-.02,0-.02,0-.16.04-.32.09-.48.13-.02,0-.03,0-.05.01-.06.02-.12.04-.19.05-.02,0-.04.01-.06.02-.08.02-.15.05-.23.07-.11.04-.23.07-.34.11-2.81.94-2.63,1.15-2.63,1.15h1.23l4.31-1.26.9-.26c.7.39-1.19.86-2.02,1.04h-.53l-.62.18c-.93.13-1.67.25-2.27.37l.22-.07h-1.23c-2.02.31-1.18.48-.8.53-.87.33-.99.65-1.67,1.04-.4.24-.78.46-1.13.65l-3.97,1.03-1.11.27h2.87s0,0,0,0h4.73c.52-.15-.12-.28-1.42-.28h-.33l2.71-.79c2.8-.5,6.43-1.2,9.61-1.95.85-.06,2.25-.21,2.35-.47h-.43,0s.43,0,.43,0c0,0,1.63-.21,5.24-1.15.14-.04.28-.07.41-.11,3.04-.83,2.37-1.18,2.37-1.18h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "m423.6,171.74h4.01v4.63c0,2.21-1.8,4.01-4.01,4.01h0v-8.64h0Z",
    transform: "translate(851.21 352.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m421.93,190.57c0,.32.02.66.04,1,.4,8.49,1.31,10.41,1.31,10.41h1.23v-22.09h-.91s-1.85,3.14-1.67,10.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "m421.93,190.57h2.58v-10.68h-.91s-.86,1.45-1.34,4.74c-.1.66-.18,1.39-.24,2.19-.08,1.1-.11,2.35-.08,3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m424.51,201.98v4.98s-2.41-1.51-1.23-4.98h1.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m436.59,190.92c0,.32-.02.66-.04,1-.4,8.49-1.31,10.41-1.31,10.41h-1.23v-22.09h.91s1.85,3.14,1.67,10.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "m436.59,190.92h-2.58v-10.68h.91s1.85,3.14,1.67,10.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m434.02,202.33v4.63s2.41-1.16,1.23-4.63h-1.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m434.93,198.3c0,16.28-5.26,33.09-5.26,33.09h-2.84l1.66-33.09h6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m429.84,231.39c1.31,0,2.36,1.12,2.36,2.49h-5.55s.17-2.49.17-2.49h3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "m434.93,198.3h-8.97s1.34-6.74-2.22-11.29l-.14-7.13,3.47-1.09,4.03-.2,3.83,1.65v18.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m432.08,199.37h.33v-12.66c0-4.64-2.32-7.86-2.34-7.89l-.26.21s2.27,3.16,2.27,7.68v12.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m429.62,181.62l.71-2.33,1.68,2.18.13-.14c.56-.61.27-1.7.26-1.74l-.32.1s.2.75-.07,1.24l-1.82-2.36-.74,2.43-1.75-1.67-.22.26,2.13,2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m431.09,178.79s.12.7-1.36.7-2.65-.7-2.65-.7v-4.54h4.01v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m431.09,178.18v-2.84h-3.63s.64,2.56,3.63,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "m431.75,172.81h0c-1.75,0-3.17-1.5-3.17-3.35h0c0-1.85,1.42-3.35,3.17-3.35h0c1.75,0,3.17,1.5,3.17,3.35h0c0,1.85-1.42,3.35-3.17,3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m426.29,170v2.42h.76v3.34s2.5,2.32,4.86,1.16c1.03-.51,1.66-1.63,1.66-2.83v-4.09c0-.7-.17-1.36-.47-1.93-.61-1.17-1.78-1.96-3.1-1.96h-.13c-1.97,0-3.58,1.74-3.58,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "m426.29,170v2.2c.58.19,1.28.12,1.28.12,0,0,2.43-.44,3.84-1.75,1-.92,1.48-1.79,1.7-2.5-.61-1.17-1.78-1.96-3.1-1.96h-.13c-1.97,0-3.58,1.74-3.58,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m425.96,198.3c-3.32,6.99-1.02,11.23.24,17.93,1.73,9.17,2.72,15.16,2.72,15.16h2.65v-33.09h-5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m431.89,231.39c1.31,0,2.36,1.12,2.36,2.49h-4.73l-.65-2.49h3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m426.89,170.99h0c.4,0,.72.32.72.72v2.24h-.72c-.39,0-.71-.32-.71-.71v-1.54c0-.39.32-.71.71-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m432.24,173.56h.56s.09-.02.13-.06c.03-.04.05-.09.04-.14l-.31-2.12-.33.05.28,1.92h-.36v.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m430.88,175.58s.09,0,.14,0l-.03-.35c-.75.08-.94-.69-.94-.72l-.32.08c.08.36.42.99,1.16.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "433.41 186.6 434.93 186.6 434.93 186.25 433.75 186.25 433.75 185.1 433.41 185.1 433.41 186.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "426.06 186.6 429.75 186.6 429.75 185.1 429.42 185.1 429.42 186.25 426.39 186.25 426.39 185.1 426.06 185.1 426.06 186.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "431.4 222.01 431.73 222.01 431.73 203.19 433.17 202.46 433.03 202.15 431.4 202.97 431.4 222.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "429.27 233.55 429.59 233.48 427.81 224.02 427.49 224.09 429.27 233.55"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 427.18,
    y: 231.21,
    width: 4.1,
    height: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "m426.67,182.16c.1-.31.43-.54.83-.54s.74.23.83.54h.36c0,1.69-1.19,2.16-1.19,2.16,0,0-1.19-.47-1.19-2.16h.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "m422.01,186.82h1.2v-2.19h-.96c-.1.66-.18,1.39-.24,2.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 434.76,
    y: 183.49,
    width: 0.33,
    height: 7.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 424.35,
    y: 183.49,
    width: 0.33,
    height: 4.68
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "424.63 184.75 425.44 183.89 425.21 183.64 424.39 184.51 424.63 184.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 426.23,
    y: 199.47,
    width: 8.57,
    height: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 431.31,
    y: 198.3,
    width: 1.87,
    height: 1.75,
    transform: "translate(864.49 398.36) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 425.53,
    y: 197.61,
    width: 2.06,
    height: 5,
    transform: "translate(853.13 400.23) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 434.02,
    y: 197.89,
    width: 1.35,
    height: 2.59,
    transform: "translate(869.38 398.36) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "434.25 199.21 435.17 199.21 435.17 198.86 434.59 198.86 434.59 198.21 434.25 198.21 434.25 199.21"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 425.83,
    y: 199.56,
    width: 1.47,
    height: 0.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-221",
    cx: 426.56,
    cy: 198.73,
    rx: 0.21,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "429.63 195.03 429.86 194.78 427.62 192.42 427.39 192.66 429.63 195.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "430.1 196.94 430.33 196.69 428.52 194.78 428.28 195.03 430.1 196.94"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m97.93,203.92c.63-.14,2.52-.57,4.36-1.03h.52l.99-.29h-.23s.06-.02.09-.03c4.52-1.32,3.63-1.59,3.5-1.67l-4.87-.18,1.66-.49h.26c.42,0,.9-.04,1.07-.09l.63-.18c.08-.02.07-.04,0-.06l.63-.18c.09-.03.08-.05-.01-.07h.02c.69-.21-.15-.37-1.87-.37h-3.99l-.52.15c-.21.06-.19.12.01.16-1.64.16-2.25.38-2.25.38l-1.2.35c-.39.11-.15.21.53.26l-.43.12-.08.02-5.52.23h-.02c-.28.03-3.59.41-7.92,1.67-.03,0-.06.02-.08.03h-.21l-.99.29h.57l-2.62.98-.49.14c-.31.09-.15.17.35.21l-8.33,2.88h-.01c-1.34,0-2.87.13-3.4.28h5.07l1.44-.28h0l11.75-2.6h0l-4.95,2.71c-.09.01-.16.03-.21.04l-.45.13h2.62l.45-.13s.07-.02.08-.03h.03l11.8-3.48.65-.2,2.5-.63-3.22.94-.82.24c-.46.13.1.24,1.25.24h1.56l.97-.28c.33-.1.02-.18-.7-.19Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "83.28 174.47 83.37 205.96 80.82 205.96 75.3 174.47 83.28 174.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m71.95,175.16h0v.29c0,2.12-1.72,3.84-3.84,3.84h0v-.29c0-2.12,1.72-3.84,3.84-3.84Z",
    transform: "translate(-107.19 247.26) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m70.09,166.26c.13,5.12,0,9.82,0,9.82l-2.1-.29-.77-9.27,2.88-.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "68.79 174.47 70.53 204.88 73.63 204.88 77.36 174.47 68.79 174.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m70.52,204.88h3.1l-.47,2.57h-5.07c0-1.42,1.09-2.57,2.43-2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m82.06,204.88h0c.72,0,1.31.62,1.31,1.38v1.18h-2.62v-1.18c0-.76.59-1.38,1.31-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m86.69,160.22c0,.64.23,2.03.21,2.71-.21,6.2-1.05,13.1-1.05,13.1l-2.23-.48v-27.26h1.01s2.06,5.39,2.06,11.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m83.62,175.55h0c2.01,0,3.64,1.63,3.64,3.64v.72h0c-2.01,0-3.64-1.63-3.64-3.64v-.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m66.86,163.9c0,.81.02,1.66.05,2.52h3.12v-17.63h-.94s-2.23,3.14-2.23,15.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 66.65,
    y: 164.13,
    width: 3.38,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "69.08 148.76 73.81 146.69 79.35 146.69 84.82 148.28 84.14 158.8 83.26 172.7 68.79 172.7 69.08 148.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m73.89,173.37c-.03-.09-.72-2.41-.19-12.73.45-8.85,1.6-10.39,1.65-10.45l.26.23-.13-.12.13.11s-1.13,1.61-1.57,10.24c-.52,10.21.17,12.57.17,12.6l-.32.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m73.81,146.69s.73,1.15,2.77,1.15,2.77-1.15,2.77-1.15v-7.44h-5.53v7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m73.81,146.47v-3.58h4.57s0,3.58-4.57,3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m75,145.55c2.29-.24,3.58-1.91,3.58-1.91l1.36-6.14c-.02-2.2-2.43-2.54-2.43-2.54-5.5-.52-5.12,4.85-5.12,4.85v3.18c0,1.49,1.2,2.69,2.6,2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m78.31,136.43h.32c.86,0,1.55.54,1.55,1.2v3.23h-3.1v-3.49c0-.52.55-.94,1.22-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m78.13,141.8h-1.61v-5.04h0c.89,0,1.61.76,1.61,1.7v3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m72.81,133.62h3.68c1.89,0,3.42,1.53,3.42,3.42h-3.68c-1.89,0-3.42-1.53-3.42-3.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m79.61,139.02h0c.42,0,.76.36.76.8v1.66c0,.44-.34.8-.76.8h-.77v-2.46c0-.45.35-.81.77-.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "74.32 141.93 73.6 141.93 73.72 140.81 74.04 140.85 73.96 141.59 74.32 141.59 74.32 141.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "75.1 143.52 75 143.2 75.85 142.9 75.95 143.22 75.1 143.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "78.98 147.07 75.48 149.95 73.81 146.69 78.98 147.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "83.28 174.47 68.79 174.47 68.79 172.7 83.26 172.7 83.28 174.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "76.34 181.41 75.87 178.74 74.17 177.83 73.88 175.62 74.22 175.57 74.48 177.6 76.18 178.49 76.68 181.35 76.34 181.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "79.07 152.1 78.51 149.12 75.45 150.52 73.81 149.03 72.01 151.62 73.04 147.26 73.37 147.34 72.76 149.93 73.75 148.5 75.51 150.1 78.76 148.61 79.16 150.74 80.21 147.63 80.53 147.75 79.07 152.1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 78.33,
    y: 154.77,
    width: 3.45,
    height: 1.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 73.26,
    y: 172.7,
    width: 2.71,
    height: 1.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m87.03,163.4c0,.81-.02,1.66-.05,2.52h-3.36v-17.63h1.2c.4.72,2.21,3.14,2.21,15.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 83.62,
    y: 163.63,
    width: 3.64,
    height: 2.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 79.88,
    y: 153.6,
    width: 0.34,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 77.92,
    y: 172.04,
    width: 0.68,
    height: 2.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 71.25,
    y: 172.11,
    width: 0.68,
    height: 2.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m68.69,166.74c0-.07-.17-7.28.12-10.22.3-2.95.75-4.6.76-4.62l.33.1s-.45,1.64-.75,4.55c-.29,2.92-.12,10.1-.12,10.18h-.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 83.45,
    y: 157.6,
    width: 0.34,
    height: 8.64
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m71.25,225.51l-.22-.1-2.27.14c-.52.03-.88.09-.88.14l-5.38.4-.63-.94-2.75-.19c.73-.03,1.07-.08,1.07-.08h.04c.85-.07,1.57-.17,1.93-.27l.55-.16h-.61l.28-.08c.68-.08,1.23-.17,1.56-.27h0c.36-.1.32-.2-.03-.27-.05-.15-.99-.26-2.5-.26h-2.05c-.93,0-1.96.07-2.52.17-.75.02-1.54.11-1.89.21h0l-1.61.47h-.9l-.55.16c-.63.18.13.33,1.7.34h-.02s-2.98.05-2.98.05l-.87-.47c-.15-.1-.3-.19-.42-.26l3.42-.91c.19,0,.39-.02.51-.04l.63-.11c.21-.04.32-.08.33-.11l13.69-1.14-5.88-1.14-15.64,1.3,5.19,1.01-.35.06c-.3.05-.26.11.06.13l-4.72,1.02.5.36-.53.03,1.32.81-6.38,2.05-11.46,3.29h0s-.03,0-.04,0l-.4.12h2.36l.4-.12s.08-.03.09-.04l12.16-2.51-5.8,2.41h0l-.45.26h4.56c.48-.14-.11-.26-1.32-.26h-.01l11.32-3.17h0l6.28-1.69.09.23.43-.02c.19.23.36.42.39.43l2.57-.21h0l5.62-.46c.12,0,.32,0,.51,0l1.06-.06c.97-.06,1.6-.18,1.4-.27Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "m34.3,176.16h-1.39c-1.59,0-2.88-1.36-2.88-3.04v-1.45h4.27v4.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "m36.1,176.38h1.39c1.59,0,2.88-1.36,2.88-3.04v-1.45h-4.27v4.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "m33.64,167.41h-2.71v5.21h.82c1.04,0,1.89-.89,1.89-1.99v-3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "m39.77,173.02h-7.73v-6.97c0-1.17.9-2.11,2-2.11h2.05c2.04,0,3.69,1.74,3.69,3.89v5.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "m35.49,173.62h-2.81v-6.57c0-1.1.9-1.99,2-1.99h2.05c2.04,0,3.69,1.64,3.69,3.67h0c0,2.7-2.2,4.89-4.92,4.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "50.9 184.23 44.8 190.57 43.88 188.29 49.92 182.93 50.9 184.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m39.53,177.29l-.72.53s5.76,12.39,5.99,12.74l1.85-1.92-4.74-10.48-2.38-.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "45.12 185.28 42.58 186.86 40.21 181.24 41.91 178.16 45.12 185.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m51.95,180.5l-1.4.97c-.69.48-.89,1.46-.43,2.19l.25.4c.22.36.68.46,1.01.22h0c1.13-.78,1.44-2.38.7-3.57l-.14-.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "41.91 178.16 37.91 176.17 33.12 176.17 28.96 176.71 29.76 200.04 41.19 200.04 41.91 178.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m38.15,176.29s-.69.97-2.64.97-2.64-.97-2.64-.97v-6.25h5.27v6.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m38.15,175.95v-2.55h-4.35s.77,2.3,4.35,2.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "29.76 200.04 29.56 229.84 31.85 229.66 36.55 200.04 29.76 200.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "41.18 200.04 40.69 228.69 37.9 228.69 34.7 200.04 41.18 200.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m40.7,228.69h-2.79l.42,2.31h4.56c0-1.28-.98-2.31-2.19-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m30.74,228.69h0c-.65,0-1.18.56-1.18,1.24v1.07h2.36v-1.07c0-.69-.53-1.24-1.18-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m39.19,174.91c-3.59,1.31-5.72-1.43-5.72-1.43v-6.01c0-.72.5-1.31,1.11-1.31h2.05c2.14,0,2.56,1.88,2.56,3.17v5.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 36.74,
    y: 172.64,
    width: 2.17,
    height: 1.92,
    transform: "translate(75.65 347.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "m34.24,168.08s.04,1.66.59,3.45c.55,1.79,2.12,1.54,2.12,1.54,0,0,.15.77.95.77s.92-.71.97-.79c.36-.59.32-3.01.32-3.01l.14,5.75s-.46.98-2.26.98c-2.92,0-3.67-2.26-3.67-2.26v-5.5l.84-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "m37.34,171.91h.87c0,.8-.51,1.44-1.14,1.44h-.87c0-.8.51-1.44,1.13-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "m38.32,171.91c.54,0,.97.55.97,1.23v.21s-.42,0-.42,0c-.58,0-1.06-.6-1.06-1.34v-.1h.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "38.41 171.81 37.7 171.81 37.7 171.48 38.05 171.48 37.98 170.75 38.29 170.71 38.41 171.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "m30.39,203.36c1.44,0,2.62-1.24,2.62-2.76h-.32c0,1.33-1.03,2.42-2.29,2.42v.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "m40.51,203.29v-.21c-.39,0-.82-1.02-.82-2.49h-.2c0,1.51.45,2.7,1.02,2.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "35.84 205.21 36.54 204.47 36.54 201.68 36.34 201.68 36.34 204.38 35.7 205.06 35.84 205.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "m34.37,169.46h-3.44v-2.03c0-1.09.68-1.98,1.52-1.98h1.97c.55,0,1,.58,1,1.3h0c0,1.5-.98.66-1.05,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "m33.39,171.36h0c.54,0,.98-.46.98-1.03v-.87h-.98v1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m32.69,169.2h0c-.39,0-.7.33-.7.74v1.53c0,.41.32.74.7.74h.71v-2.27c0-.41-.32-.75-.71-.75Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "26.59 160.96 26.21 170.71 23.72 170.58 25.03 160.71 26.59 160.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m30.51,177.72s-4.81-8.84-5.06-9.18l-1.73,2.04,5.38,10.14,1.41-3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "25.03 174.14 27.56 172.32 30.6 177.53 29.13 181.48 25.03 174.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m24.94,157.92l-.4,1.72c-.2.85.3,1.71,1.1,1.92l.44.11c.39.1.79-.15.89-.57h0c.32-1.38-.48-2.78-1.8-3.12l-.24-.06Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m123.26,189.17h0s0,0,0,0l-2.8-.25c1.15-.05,1.98-.13,1.98-.13l.93-.49,1.37-.4c.39-.12.35-.22-.04-.29.12-.04.11-.08-.1-.12-.57-.1-3.16-.03-4.28,0-1.69,0-3.56.17-4.23.36l-1.06.31c-.16.05-.13.09.05.12l-.48.14c-.17.05.04.09.47.09h.24l-1.58.33h0s-6.85.35-6.85.35h0c-.31.04-4.74.64-7.21,1.37-.25.07-.5.15-.73.23-2.16.71-4.57,1.53-4.57,1.53h.71c-3.02.41.67.44.67.44l1.49-.44,2.6-.74-5.36,1.71-8.1,2.35h.03c-.06.01-.11.02-.15.03l-.41.12h2.71l.41-.12c.06-.02.09-.03.1-.05l10.89-2.22h.47s.35-.11.93-.29l2.35-.48-6.81,2.86h2.04s0,0,0,0h-2.03s-.73.28-.73.28h5.49c.5-.16-.18-.28-1.54-.28h-.83,0s.81,0,.81,0l7.39-2.1h1.6l7.29-2.18h1.48c.17.02.44.04.79.04h.88c.75,0,1.59-.07,1.97-.15h5.65l3.22-.94h-9.06l1.95-1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "97.52 135.22 99.51 162.95 90.74 162.95 90.01 133.03 95.74 132.89 97.52 135.22"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "95.99 135.73 94.6 137.37 92.76 135.8 94.21 133.75 95.99 135.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "94.83 134.66 95.18 136.69 97.17 156.77 95.48 158.96 93.84 156.9 93.88 136.84 93.79 134.78 94.83 134.66"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "103.36 152.65 99.53 152.28 100.64 135.93 103.36 152.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 99,
    y: 149.55,
    width: 4.44,
    height: 4.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 99.91,
    y: 144.99,
    width: 11.26,
    height: 8.51
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "94.2 159.71 88.47 194.4 85.84 194.4 85.94 159.71 94.2 159.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "99.13 193.21 95.92 193.21 92.07 159.71 99.53 159.71 99.13 193.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m87.19,193.28c.75,0,1.36.64,1.36,1.43v1.07h-2.71v-1.07c0-.79.61-1.43,1.36-1.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "98.31 193.28 97.96 193.28 97.58 165.83 97.94 165.82 98.31 193.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "89.77 168.25 87.37 193.3 87.02 193.26 89.42 168.22 89.77 168.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "94.55 163.49 94.76 163.79 93.51 164.79 93.13 166.93 92.78 166.86 93.18 164.57 94.55 163.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m85.62,136.17l-.25,28.23h-2.87s-.39-7.4-.65-13.82c-.03-.7-.05-1.39-.04-2.06,0-6.77,2.56-12.35,2.56-12.35h1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m85.36,164.4v3.94s-3.78-.24-2.16-3.94h2.16Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m91.25,139.59c.57,6.36,1.03,34.64,1.03,34.64h-6.34s-.88-28.66-.88-28.66l-.7-9.4,5.68-3.13c.09.18.78,1.66,1.22,6.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "95.74 132.89 93.44 133.02 93.32 133.02 90.06 133.02 90.3 132.89 95.74 132.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m100.64,135.93l.31,38.31h-2.92s.93-36.45-2.29-41.35l4.9,3.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "m90.03,133.04s0-.02,0-.02h.04l-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m95.74,125.32l.12,8.52s-.37.38-2.49.38c-2.11,0-3.36-1.19-3.36-1.19l1-6.87,4.73-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m95.74,132.81c-4.73,0-4.73-3.71-4.73-3.71h4.73s0,3.71,0,3.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 98.98,
    y: 142.82,
    width: 1.46,
    height: 0.37
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m92.09,120.69h2.12c1.97,0,3.57,1.69,3.57,3.77v3.81s-7.44,0-7.44,0c-.76,0-1.38-.65-1.38-1.46v-2.82c0-1.82,1.4-3.3,3.13-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m93.69,122.07h1.12c2.4,0,2.87,2.34,2.86,3.94v6.95c-4.02,1.63-6.41-1.78-6.41-1.78v-6.01s-.3-3.1,2.42-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m90.9,122.07c.64,0,1.15.54,1.15,1.21v2.22c0,1.53-1.17,2.76-2.62,2.76v-4.65c0-.86.66-1.55,1.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m90.22,126.62c.44,0,.8.38.8.84v2.54s-.8,0-.8,0c-.44,0-.79-.37-.79-.83v-1.72c0-.46.35-.83.79-.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "96.07 129.28 95.98 128.51 96.32 128.47 96.44 129.63 95.69 129.63 95.69 129.28 96.07 129.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m96.22,120.69c1.19,1.21.13,2.91-1.07,2.54-1.21-.37-3.66-2.37-3.66-2.37,0,0,3.54-1.38,4.73-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m95.44,129.61h1.03c0,.78-.6,1.41-1.34,1.41h-1.02c0-.78.59-1.41,1.33-1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m96.59,129.61c.63,0,1.14.54,1.14,1.2v.21h-.5c-.69,0-1.24-.59-1.24-1.31v-.1h.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m91.75,125.61s.04,1.62.7,3.36c.65,1.74,2.52,1.5,2.52,1.5,0,0,.44,1.08,1.29,1.08.85,0,.93-1.02.99-1.1.42-.57.44-2.97.44-2.97l.83,5s-1.45,1.82-3.68,1.59c-3.45-.36-4.1-2.61-4.1-2.61l.28-4.4.73-1.44Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 77.95,
    y: 148.88,
    width: 15.32,
    height: 0.35,
    transform: "translate(-63.59 234.43) rotate(-89.91)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "86.98 142.06 85.76 145.48 85.43 145.35 86.65 141.93 86.98 142.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "85.68 150.11 85.55 150.45 83.95 149.77 84.08 149.42 85.68 150.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "85.51 150.67 85.46 151.05 83.3 150.73 83.35 150.36 85.51 150.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "89.59 156.74 89.59 155.5 89.94 155.5 89.94 157.12 86.31 157.12 86.31 156.74 89.59 156.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m103.19,151.68h.88c.81,0,1.47.7,1.47,1.55v.07c0,.86-.66,1.55-1.47,1.55h-.88c-.81,0-1.47-.7-1.47-1.55v-.07c0-.86.66-1.55,1.47-1.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "101.03 154.49 100.67 154.5 100.26 140.2 100.61 140.19 101.03 154.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "87.46 137.83 89.76 133.32 90.07 133.5 87.91 137.73 90.43 139.86 87.92 141.52 91.32 147.94 91.01 148.13 87.45 141.39 89.82 139.82 87.46 137.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "96.89 134.13 99.22 138.2 98.42 139.3 99.73 140.1 98.47 147.14 98.12 147.06 99.33 140.29 97.89 139.41 98.79 138.17 96.59 134.32 96.89 134.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "99.88 155.5 99.88 156.74 100.79 156.74 100.79 157.12 99.53 157.12 99.53 155.5 99.88 155.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m101.66,195.78h-5.49l-.24-2.57h3.21c1.36,0,2.47,1.15,2.52,2.57Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m124.75,207.44h-.56l-3.61,1.06-4.51,1.32-.54-.02-.57.09c-.47.07-.4.15.14.17l.58.02-5.78.95h0s-5.17.64-5.17.64l-1.78-.12,1.05-.31c.36-.05.65-.1.84-.15h.1c.32,0,.68-.03.8-.07l.08-.02c.62-.06,1.17-.13,1.57-.21,1.14,0,2.45-.1,3.19-.23.93-.16.65-.33-.62-.38-.9-.03-2.07.01-2.99.1-.43-.03-.96-.05-1.6-.05-2.21,0-4.71.21-5.59.47-.31.09-.37.17-.24.25l-.72.21c-.46.13.02.25,1.06.26l-.38.11-.06.02-3.96.19s-.81.14-1.74.33c-.39.08-.8.16-1.19.25-.47.11-.89.2-1.24.28-.22.05-.42.09-.59.13l-6.48.65h-.69c-.6-.02-1.25.02-1.43.08l-.37.11,1.69.02c.76.01,1.56-.03,1.93-.1h0s4.8-.43,4.8-.43l1.72-.15-1.74.57h7.2s.27-.3,4.14-.88c.33-.05,2.59-.37,2.73-.39,0,0,0,0,0,0,0,0,.01,0,.03,0,.12-.01.58-.07,1.83-.24.76-.1,4.96-.72,6.39-.99l4.6-.84.57-.09c.67-.1.2-.16-.59-.18l-.49-.02,4.57-1.34h13.98l3.61-1.06h-13.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m93.41,213.47h-3.27c-4.89.68-6.83,1.62-8,2.13-2.35,1.02-3.45,1.55-3.45,1.55l1.24.27,5.68-1.66-.28,1.53h0s-.04.01-.06.02l-.4.12h2.11l.41-.12c.09-.03.12-.05.11-.07.32-.17,1.3-.72,2-1.39.11-.11.01-.21-.37-.28.1-.01.19-.03.28-.04,2.74-.51,8.02-1.27,7.93-2.04h-3.93,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "m74.46,176.51l1.99-.24.93-.11-.31-2.39-.63-4.78-.39-2.98s-.32,1.29-.61,2.98c-.12.71-.24,1.49-.33,2.27-.11.96-.21,1.8-.29,2.51-.22,1.79-.36,2.74-.36,2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m70.34,182.77l-1.77-.21-.02-1.04c0-.51.5-.86,1.13-.79l2.28.27v.62c.02.74-.71,1.25-1.63,1.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "71.95 181.92 70.41 180.83 75.91 173.24 77.83 175.02 71.95 181.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m82.01,153.96c-.36,1.49.49,3.01,1.91,3.39,1.41.38,2.86-.52,3.22-2.01.36-1.49-.49-3.01-1.91-3.39-1.41-.38-2.86.52-3.22,2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m81.57,155.1c-.27,1.1.36,2.22,1.4,2.5,1.04.28,2.1-.38,2.37-1.48s-.36-2.22-1.4-2.5c-1.04-.28-2.1.38-2.37,1.48Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-76",
    cx: 80.81,
    cy: 156.61,
    rx: 4,
    ry: 4.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m83.51,157.97h.37v1.68c0,.28-.22.5-.5.5h0c-.28,0-.5-.22-.5-.5v-1.04c0-.35.28-.64.64-.64Z",
    transform: "translate(166.76 318.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "m76.06,166.02l.12,2.98.18,4.78.1,2.5.21,5.46h7.2s-.77-2.75,1.13-7.96c.16-.44,1.31-3.39,1.39-3.56l-.31-1.47.2-2.7v-.02s-.01,0-.01,0h0s-3.38-1.72-3.38-1.72h-3.5l-3.32,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m79.37,164.77s-.11.73,1.19.73c1.57,0,2.32-1.21,2.32-1.21v-4.26h-3.51v4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m79.37,164.13v-2.96h3.18s-.56,2.67-3.18,2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m80.64,154.42h0c1.42,0,2.56,1.15,2.56,2.56v3.74c0,1.33-1.08,2.42-2.42,2.42h-.15c-1.78,0-3.23-1.45-3.23-3.23v-2.27c0-1.78,1.45-3.23,3.23-3.23Z",
    transform: "translate(160.62 317.57) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m78.4,160.25c-.16,0-.31-.08-.42-.23-.12-.16-.17-.37-.14-.58l.03-.24.3.05-.03.24c-.01.11.01.22.07.3.05.07.12.1.19.1v.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "82.58 153.58 83.71 153.88 83.21 157.96 82.78 159.65 82.58 153.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m81.76,154.57h0c.59,0,1.06.48,1.06,1.06v2.33h-1.06v-3.39h0Z",
    transform: "translate(164.58 312.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "m84.71,166.14l3.37-6.49,2.36-.55c-.51,2.44-2.6,8.02-3.02,8.93-.69,1.49-.95,2.03-1.02,2.16,0,.02-.01.03-.01.03,0,0,0,0,0,0h0s-1.23-2.99-1.23-2.99l-.45-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m79.79,154.42c1.09,0,1.97.93,1.97,2.08h0v-2.08h-2.03.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "81.39 154.42 77.38 158.14 77.16 156.75 77.92 154.57 79.16 153.58 80.44 153.87 81.39 154.42"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "m76.67,181.74c-2.58,6.12-1.3,14.64-.73,19.24,1.13,9.22,1.83,13.98,1.83,13.98h2.17v-33.22h-3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m77.51,214.96h2.43v2.45h-4.36c.02-1.36.87-2.45,1.93-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "m79.3,200.58l5.59,15.63h2.06s-.92-5.78-2.83-13.05c-.5-1.91-1.69-3.52-3.57-3.68l-1.26,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m84.88,216.36c0-.76.46-1.37,1.05-1.38s1.06.6,1.06,1.36v1.07h-2.11v-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "m79.28,181.74v18.66c0,.73.56,1.31,1.24,1.31h.59c.85,0,1.6-.62,1.79-1.5,1.01-4.59,3.7-11.44.95-18.47h-4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "m83.05,185.14h.81v-.35h-.81c-.63,0-1.15-.67-1.15-1.49v-.53h-.27v.53c0,1.02.64,1.84,1.42,1.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "92.18 151.52 90.68 150.92 88.08 159.65 90.44 159.1 92.18 151.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m91.24,149.08l-1.71-.48-.26.81c-.22.65.1,1.32.71,1.49l2.2.62.27-.8c.32-.94-.33-1.4-1.21-1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "m78.14,181.74h1.14v5.47h-.04c-.61,0-1.1-.52-1.1-1.16v-4.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 76.42,
    y: 201.71,
    width: 2.17,
    height: 1.55,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(155.02 404.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 76.75,
    y: 203.72,
    width: 0.91,
    height: 0.72,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(154.4 408.17) rotate(180)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "76.18 169 75.28 178.01 76.47 176.61 76.18 169"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m414.88,226.23c.07-.04.14-.07.2-.11.06-.03.11-.07.15-.1.44-.33.35-.65-.67-.92h0s0,0,0,0l-2.39-.16c.22-.04.34-.08.27-.12.22-.03.39-.06.5-.09l.36-.11c.14,0,.29-.01.43-.02l2.12-.62.38-.11h2.02l.23-.07h-1.56l.76-.22c.93-.27-.21-.49-2.55-.49h-1.75l-.49.14c-1.66.01-3.47.17-4.12.36l-.73.21h-2.17l-.23.07h.82l-.38.11-2.28.67-.27.08c-.24.07-.12.13.25.16-.17.03-.3.05-.37.07h0s-.02,0-.02,0c-.04,0-.06.02-.06.02l-3.13.12c-2.84.27-5.12.59-6.93.92-.19.03-.37.07-.55.1-.19.04-.38.07-.56.11-.17.03-.33.07-.49.1-1.37.3-2.4.59-3.17.85-.1.04-.2.07-.29.1-.11.04-.21.08-.3.11-.09.04-.18.07-.26.1-.87.36-1.15.6-1.15.6h.99c-1.13.33-.13.44.82.48l-4.97,1.45-.35.1-.38.11-.35.1-1.79.52h0l-.92.27h5.2c.51-.15-.11-.27-1.38-.27h.26l3.01-.52.59-.1.64-.11.59-.1.98-.17.22-.04.84-.15.22-.04.44-.08.22-.04.44-.08.22-.04.44-.08.22-.04.68-.12.11-.02h0s.08-.01.08-.01l-1.82.88-.21.1-.23.11-.21.1-1.08.52h0l-.92.27h5.2c.51-.15-.11-.27-1.38-.27h.26l2.3-.52.45-.1.49-.11.45-.1.75-.17h.02l.06-.02.73-.17.17-.04.34-.08.17-.04.33-.08.17-.04.33-.08.17-.04.52-.12.17-.04,2.55-.58c1.12-.05,2.52-.18,3.49-.46h-1.15s0,0,0,0h2.13s1.36-.24,2.95-.6c.15-.03.3-.07.45-.1.15-.04.31-.07.46-.11.14-.03.28-.07.41-.1,1.02-.26,2-.55,2.66-.85.08-.03.15-.07.22-.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "m392.68,183.62v19.96l4.65.02s.54-2.18.9-5.42c.03-.3.06-.61.09-.93.03-.33.06-.66.08-1.01.02-.31.04-.62.06-.93.13-2.36.1-5.02-.25-7.7-.04-.31-.09-.62-.14-.93-.06-.34-.12-.67-.18-1.01-.06-.31-.13-.62-.2-.93-.69-2.98-1.87-5.87-3.8-8.29,0,0-1.21,2.42-1.21,7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "m392.68,184.73v2.87h5.53c-.04-.31-.09-.62-.14-.93-.06-.34-.12-.67-.18-1.01-.06-.31-.13-.62-.2-.93h-5.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "m392.68,185.66v1.01h5.39c-.06-.34-.12-.67-.18-1.01h-5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "m392.68,195.31v2.87h5.55c.03-.3.06-.61.09-.93.03-.33.06-.66.08-1.01.02-.31.04-.62.06-.93h-5.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "m392.68,196.24v1.01h5.64c.03-.33.06-.66.08-1.01h-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m392.68,203.58v4.54s3.67.47,3.67-4.52l-3.67-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "393.64 192.13 393.48 191.83 396.38 190.16 396.53 190.46 393.64 192.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "394.01 193.17 393.84 192.87 395.53 191.83 395.69 192.13 394.01 193.17"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "m381.59,165.3h9.4v5.28c0,2.29-1.86,4.16-4.16,4.16h-1.09c-2.29,0-4.16-1.86-4.16-4.16v-5.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m391.94,228.7c1.28,0,2.32,1.1,2.32,2.45h-5.2v-2.45h2.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "395 202.59 393.88 213.03 393.84 213.38 393.73 214.44 393.69 214.79 393.62 215.47 393.58 215.82 393.51 216.5 393.47 216.85 393.4 217.54 393.36 217.88 393.2 219.38 393.19 219.55 393.02 221.09 392.92 222.02 392.81 223.03 392.71 223.96 392.21 228.7 389.05 228.7 388.34 223.96 388.2 223.03 388.05 222.02 387.91 221.09 386.71 213.08 385.14 202.59 395 202.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m382.43,228.7c1.28,0,2.32,1.1,2.32,2.45h-5.2v-2.45h2.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "389.4 202.59 386.72 213.03 386.71 213.08 386.63 213.38 386.36 214.44 386.27 214.79 386.1 215.47 386.01 215.82 385.83 216.5 385.74 216.85 385.57 217.54 385.48 217.88 385.14 219.2 385.05 219.55 384.65 221.09 384.41 222.02 384.15 223.03 383.92 223.96 382.7 228.7 379.55 228.7 379.55 202.59 389.4 202.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "386.68 213.21 386.37 213.11 388.65 205.26 390.63 204.15 390.79 204.45 388.92 205.5 386.68 213.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "m396.66,199.71c-.02.34-.03.65-.05.93-.02.39-.05.73-.07,1.01-.04.6-.07.93-.07.93h-16.93v-26.14l5.05-2.11h5.07l4.23,2.11c1.49,2.26,2.26,5.92,2.63,9.82.03.31.06.62.08.93.03.34.05.67.07,1.01.02.31.04.62.05.93.2,3.99.07,7.92-.07,10.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "m389.92,173.05c2.78,1.57-.72,4.38-.72,4.38l-1.9-2.27s.81-3.13,2.62-2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m389.92,174.47c0,1.72-.72,2.96-.72,2.96l-2.45-2.4,3.17-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m389.92,174.47s-.73.69-2.79.69-2.79-.69-2.79-.69v-4.46h5.58v4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m389.92,173.78v-2.7h-4.61s.81,2.43,4.61,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m391.35,171.92c-3.94,2.08-7.02-.65-7.02-.65v-8.43h7.02v9.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 383.54,
    y: 163.19,
    width: 1.98,
    height: 4.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m384.08,165.95h0c.43,0,.78.35.78.78v2.52h-.78c-.42,0-.77-.34-.77-.77v-1.76c0-.42.34-.77.77-.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "390.14 169.11 389.4 169.11 389.4 168.77 389.76 168.77 389.48 166.89 389.8 166.83 390.14 169.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "m382.25,175.32s.14-2.88,2.61-2.72c2.98.19,4.55,5.45,4.55,5.45l-7.16-2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "m396.66,199.71c-.02.34-.03.65-.05.93-.02.39-.05.73-.07,1.01-.04.6-.07.93-.07.93h-16.93v-2.87h17.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "m396.61,200.65c-.02.39-.05.73-.07,1.01h-17v-1.01h17.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "m396.73,189.14h-17.18v-2.87h16.98c.03.31.06.62.08.93.03.34.05.67.07,1.01.02.31.04.62.05.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "m396.68,188.2h-17.13v-1.01h17.06c.03.34.05.67.07,1.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "384.65 221.09 384.41 222.02 384.15 223.03 383.92 223.96 379.55 223.96 379.55 221.09 384.65 221.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "393.02 221.09 392.92 222.02 392.81 223.03 392.71 223.96 388.34 223.96 388.2 223.03 388.05 222.02 387.91 221.09 393.02 221.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "384.41 222.02 384.15 223.03 379.55 223.03 379.55 222.02 384.41 222.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "392.92 222.02 392.81 223.03 388.2 223.03 388.05 222.02 392.92 222.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m391.05,202.59h-.33v-3.04h2.17c.14-.73.74-4.45.36-10.65-.37-6.22-1.66-8.82-1.91-9.28h-1.56l-.53-1.5.31-.12.45,1.28h1.51l.05.08c.06.1,1.59,2.53,2.01,9.53.42,6.97-.39,10.85-.4,10.88l-.03.13h-2.11v2.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "390.23 219.2 393.2 219.2 393.2 219.55 389.9 219.55 389.9 213.03 393.88 213.03 393.84 213.38 390.23 213.38 390.23 219.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "393.73 214.44 393.69 214.79 390.07 214.79 390.07 214.44 393.73 214.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "393.62 215.47 393.58 215.82 390.07 215.82 390.07 215.47 393.62 215.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "393.51 216.5 393.47 216.85 390.07 216.85 390.07 216.5 393.51 216.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "393.4 217.54 393.36 217.88 390.07 217.88 390.07 217.54 393.4 217.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "386.72 213.03 386.71 213.08 386.63 213.38 383.21 213.38 383.21 219.2 385.14 219.2 385.05 219.55 382.88 219.55 382.88 213.03 386.72 213.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "386.36 214.44 386.27 214.79 383.05 214.79 383.05 214.44 386.36 214.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "386.1 215.47 386.01 215.82 383.05 215.82 383.05 215.47 386.1 215.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "385.83 216.5 385.74 216.85 383.05 216.85 383.05 216.5 385.83 216.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "385.57 217.54 385.48 217.88 383.05 217.88 383.05 217.54 385.57 217.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m387.45,195.85h-5.45v-2.4h5.45v2.4Zm-5.16-.31h4.87v-1.78h-4.87v1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "m387.3,159.48h0c2.41,0,4.36,1.95,4.36,4.36v.85h-8.72v-.85c0-2.41,1.95-4.36,4.36-4.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "389.29 170.83 387.59 170.54 387.64 170.2 389.35 170.49 389.29 170.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "387.73 170.71 387.41 170.65 387.52 169.94 387.84 170 387.73 170.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m381.59,165.28h3.92v3.14c0,2.16-1.76,3.92-3.92,3.92h0v-7.06h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 380.77,
    y: 164.69,
    width: 12.61,
    height: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m385.83,159.52v-1.32h1.75c2.34,0,4.24,2,4.24,4.48v2.02h-3.97v-3.04c0-2.27-2.02-2.13-2.02-2.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 382.93,
    y: 163.66,
    width: 8.88,
    height: 0.34
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m380.76,203.53v4.54s-3.67.47-3.67-4.52l3.67-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "m380.76,183.62v19.96l-4.65.02s-.54-2.18-.9-5.42c-.03-.3-.06-.61-.09-.93-.03-.33-.06-.66-.08-1.01-.02-.31-.04-.62-.06-.93-.13-2.36-.1-5.02.25-7.7.04-.31.09-.62.14-.93.06-.34.12-.67.18-1.01.06-.31.13-.62.2-.93.69-2.98,1.87-5.87,3.8-8.29,0,0,1.21,2.42,1.21,7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "m380.76,184.73v2.87h-5.53c.04-.31.09-.62.14-.93.06-.34.12-.67.18-1.01.06-.31.13-.62.2-.93h5.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "m380.76,185.66v1.01h-5.39c.06-.34.12-.67.18-1.01h5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "m380.76,195.31v2.87h-5.55c-.03-.3-.06-.61-.09-.93-.03-.33-.06-.66-.08-1.01-.02-.31-.04-.62-.06-.93h5.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "m380.76,196.24v1.01h-5.64c-.03-.33-.06-.66-.08-1.01h5.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "379.8 192.13 376.91 190.46 377.06 190.16 379.96 191.83 379.8 192.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "379.43 193.17 377.75 192.13 377.91 191.83 379.6 192.87 379.43 193.17"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 380.59,
    y: 182.27,
    width: 0.33,
    height: 21.31
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "380.86 185.36 380.65 185.1 382.78 183.15 382.99 183.41 380.86 185.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "381.94 183.18 381.7 182.94 382.95 181.63 383.18 181.87 381.94 183.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "382.56 192.1 382.33 191.86 388.67 185.17 388.9 185.41 382.56 192.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "388.57 206.45 388.51 206.11 390.54 205.69 390.61 206.02 388.57 206.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m396.63,202.76h-15.87v-.34h15.57c.05-.95.28-5.9.3-11.96.02-6.67-1.14-8.77-1.15-8.79l.28-.18c.05.09,1.21,2.21,1.2,8.97-.02,6.72-.3,12.09-.31,12.14v.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "395.16 204.31 394.83 204.29 394.93 202.58 395.25 202.59 395.16 204.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m387.18,177.78s-.72-.81-1.94-1.42c-1.38-.7-2.99-.86-3.01-.86l.03-.34c.07,0,1.68.17,3.12.9,1.28.64,2.01,1.47,2.04,1.5l-.24.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "385.88 177.58 385.03 177.15 385.18 176.84 386.02 177.27 385.88 177.58"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-247"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 381.59,
    y: 165.3,
    width: 9.76,
    height: 1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m437.87,220.34h0c2.44-.77,2.56-1.23,2.56-1.23l-.65-.04,1.87-.55c.23-.07-.05-.12-.63-.12h.02s0,0,0,0l.17-.05h0l.17-.05h0l.17-.05h0l.17-.05h0l.17-.05h0l.17-.05h0l.17-.05h0l.17-.05h0l.06-.02s.03-.01.04-.02c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0-.02,0,0,0-.01,0-.02,0,0,0-.02,0-.03,0,0,0-.02,0-.03,0-.02,0-.03,0-.05,0,0,0-.02,0-.02,0-.03,0-.07,0-.11,0h0s-.02,0-.02,0c-.02,0-.04,0-.07,0-.01,0-.02,0-.03,0-.01,0-.03,0-.04,0,.11,0,.21-.02.26-.03.07-.02,0-.04-.18-.04.17,0,.36-.02.44-.04.07-.02,0-.04-.18-.04h-.42s-.16-.07-.33-.1h0s0,0,0,0c-.04,0-.08-.01-.13-.02-.01,0-.02,0-.04,0h0c-.06,0-.13-.02-.21-.02h0s-.01,0-.02,0c-.02,0-.03,0-.05,0-.01,0-.02,0-.03,0h0c-.1,0-.22-.02-.34-.02h0s-.02,0-.03,0c-.07,0-.13,0-.2-.01-.02,0-.03,0-.05,0h0s-.05,0-.07,0h0s-.01,0-.02,0c-.1,0-.2,0-.31-.01-.02,0-.03,0-.05,0h0c-.13,0-.26,0-.4,0h0s-.08,0-.11,0c-.1,0-.2,0-.3,0-.14,0-.29,0-.43,0h0s-.09,0-.14,0c-.1,0-.2,0-.3,0,0,0,0,0-.01,0h0c-.16,0-.31,0-.47.01h0s-.07,0-.1,0h0c-.13,0-.27,0-.4.02h0s-.07,0-.11,0c-.05,0-.09,0-.14,0-.09,0-.18,0-.26.01h0c-.06,0-.11,0-.17,0h0s-.05,0-.07,0c-.09,0-.18.01-.27.02,0,0-.02,0-.02,0h0c-.12,0-.24.02-.35.03h0c-.05,0-.11,0-.16.01-.14.01-.27.02-.4.04h0s-.03,0-.05,0c-.08,0-.16.02-.24.03,0,0,0,0-.01,0h0s-.09.01-.13.02h-.41c-.17,0-.36.02-.44.04-.07.02,0,.04.18.04-.17,0-.36.02-.44.04-.05.02-.02.03.06.03-.26,0-.52.03-.7.05h0s-.04,0-.06,0c0,0-.02,0-.02,0-.03,0-.05.01-.08.02l-.06.02h0l-.17.05h0l-.17.05h0l-.17.05h0l-.17.05h0l-.17.05h0l-.17.05h0l-.17.05h0l-.17.05h0-.03s0,0,0,0h0c-.58,0-1.24.06-1.48.12l-1.85.54-.96.04h-.04s-3.2.48-6.07,1.28c-.79.02-1.61.09-1.92.18-.21.06-.14.12.15.15l-.34.1h1.06c.19,0,.39,0,.59-.01l-2.63.68h-.04s-.03.02-.03.02h0,0s-2.26.51-2.26.51l-5.88,1.3h.05l-6.42,1.43h-.01c-1.22,0-2.61.12-3.1.26h4.61l1.31-.26h0l8.07-1.43h2.8l-4.66,1.53c-.09.01-.16.03-.22.04l-.41.12h2.38l.41-.12s.02,0,.03,0h0s6.87-1.56,6.87-1.56h3.9l9.28-2.64c.56,0,1.16,0,1.79,0,.18-.05.47-.13.63-.18.19-.06.37-.11.54-.16h0Zm2.13-2.17h0s-.75.22-.75.22h0l.76-.22Zm.04.21l.17-.05s0,0,0,0l-.22.06h-.02s.05-.01.07-.02Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "m418.42,165.18v-1.16h-1.03v1.16h-2.82v.02h-4.44v-1.16h-1.03v1.16h0c-.58,0-1.06.5-1.06,1.11v6.94h7.53v-.02h3.9v-6.94c0-.62-.47-1.11-1.06-1.11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 407.73,
    y: 195,
    width: 12.06,
    height: 14.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m408.05,171.61l.26,9.75-.26,4.21h-2.54c-.01-.43-.02-.87-.02-1.29,0-7.85,1.71-12.66,1.71-12.66h.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m405.78,183.17h.84v3.33h-.84c-.87,0-1.58-.75-1.58-1.66s.71-1.66,1.58-1.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "411.23 169.62 416.07 169.62 420.26 171.63 417.71 193.34 406.17 193.34 407.19 171.63 411.23 169.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "416.3 169.71 416.82 169.98 413.65 174.61 410.61 169.93 410.99 169.75 416.3 169.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "413.35 176.25 416.7 171.87 416.94 172.08 413.31 176.83 410.53 171.87 410.8 171.71 413.35 176.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "407.05 176.21 406.62 185.66 406.31 185.64 406.74 176.2 407.05 176.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "414.41 223.84 412.09 223.66 410.85 193.34 417.71 193.34 414.41 223.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "412.72 193.34 405.55 222.67 402.73 222.67 406.17 193.34 412.72 193.34"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 406.17,
    y: 193.17,
    width: 11.54,
    height: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "407.19 171.63 410.61 169.93 407.05 209.69 404.2 209.69 406.17 193.5 407.19 171.63"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m402.72,222.67h2.82l-.43,2.34h-4.61c0-1.29.99-2.34,2.21-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m413.21,222.67c.66,0,1.19.56,1.19,1.26v1.08h-2.38v-1.08c0-.69.53-1.26,1.19-1.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "415.39 172.6 413.65 170.41 416.35 169.75 415.39 172.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "411.91 172.6 410.99 169.75 413.65 170.41 411.91 172.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-207",
    points: "411.15 197.6 411.28 199.89 410.95 199.91 410.82 197.75 409.77 196.59 410.01 196.34 411.15 197.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "419.84 209.69 415.87 209.69 416.3 169.71 420.26 171.63 419.84 209.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m420.26,171.63s1.67,4.79,1.67,12.64c0,.43,0,1.19-.02,1.62l-2.54-.33-.26-4.21.26-9.75.89.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m421.92,185.9c-5.02-.15-7.71-.33-7.71-.33v-2.7l7.71-.07v3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "m408,177.61h4.91c.46,0,.84.4.84.88v8.24c0,.49-.38.88-.84.88h-4.91c-.46,0-.84-.4-.84-.88v-8.24c0-.49.38-.88.84-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m414.21,182.78v1.78h-1.52c-.93,0-1.69-.8-1.69-1.78v-1.09h2.18c.57,0,1.04.49,1.04,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m405.79,184.22h1.64v1.28c0,.88-.67,1.59-1.51,1.59h-1.06v-1.89c0-.54.41-.98.93-.98Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "419.62 178.72 419.12 182.79 418.81 182.75 419.31 178.68 419.62 178.72"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m416.35,169.75s-.7.66-2.68.66-2.68-.66-2.68-.66v-4.28h5.36v4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m411.64,167.77s.28,2.2,2.19,2.2,2.04-2.15,2.04-2.15l-4.24-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m416.64,162.66h0v3.15h0c.41,0,.73-.35.73-.77v-1.6c0-.43-.33-.77-.73-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m410.69,162.71h0v3.15h0c-.41,0-.73-.35-.73-.77v-1.6c0-.43.33-.77.73-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m415.82,168.44c-1.64,1.31-3.24.68-4.21.02-.58-.4-.92-1.09-.92-1.83v-5.36c0-.82.59-1.48,1.32-1.48h3.32c.73,0,1.32.66,1.32,1.48v5.42c0,.69-.3,1.34-.82,1.76Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m416.82,161.12c0-.74-.56-1.33-1.26-1.33h-3.44c-.69,0-1.26.6-1.26,1.33v1.85c0-.74.56-1.33,1.26-1.33h3.44c.69,0,1.26.6,1.26,1.33v-1.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m411.9,166.01h3.71v1.35c0,1.02-.83,1.85-1.85,1.85h0c-1.02,0-1.85-.83-1.85-1.85v-1.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m412.83,168.24h0c-.33,0-.6-.28-.6-.63v-1.6h1.2v1.6c0,.35-.27.63-.6.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m414.68,168.24h0c-.33,0-.6-.28-.6-.63v-1.6h1.2v1.6c0,.35-.27.63-.6.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m413.8,167.57h-.09c-.82,0-1.48-.7-1.48-1.56h3.05c0,.86-.66,1.56-1.48,1.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "414.19 165.2 413.5 165.2 413.5 164.87 413.85 164.87 413.78 163.87 414.09 163.85 414.19 165.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m417.68,160.59h-.22v-.08c0-1.46-1.54-3.22-3.8-3.22s-3.8,1.76-3.8,3.22v.08h-.04c-.41,0-.74.35-.74.78v3.83c.68,0,1.22-.58,1.22-1.29v-.54h.05c.44,0,.79-.38.79-.84v-1.84h0v1.58c0-.64.69-1.15,1.54-1.15h2.12c.78,0,1.42.43,1.53,1v.41c0,.46.36.84.8.84h.05v.54c0,.19.04.37.11.53.19.45.62.76,1.12.76v-3.83c0-.43-.33-.78-.74-.78Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m411.97,157.65v.31h-.42v-.09c.13-.08.28-.16.42-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m412.39,157.49v.03h-.09s.06-.02.09-.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 412.39,
    y: 157.52,
    width: 0.42,
    height: 0.45,
    transform: "translate(825.21 315.48) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m413.24,157.31v.21h-.42v-.14c.14-.03.28-.05.42-.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 413.24,
    y: 157.52,
    width: 0.42,
    height: 0.45,
    transform: "translate(826.91 315.48) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m414.09,157.31v.21h-.42v-.23c.14,0,.29,0,.42.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 414.09,
    y: 157.52,
    width: 0.42,
    height: 0.45,
    transform: "translate(828.6 315.48) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m414.94,157.49v.03h-.42v-.14c.15.03.29.07.42.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m415.36,157.65v.31h-.42v-.45h.09c.12.04.23.08.34.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m415.92,157.96h-.14v-.09s.09.06.14.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m411.12,158.41v.45h-.42v-.28c.05-.06.1-.11.16-.17h.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m411.55,157.96v.45h-.42v-.23c.09-.07.19-.15.29-.21h.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 411.55,
    y: 158.41,
    width: 0.42,
    height: 0.45,
    transform: "translate(823.52 317.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 411.97,
    y: 157.96,
    width: 0.42,
    height: 0.45,
    transform: "translate(824.36 316.38) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 412.39,
    y: 158.41,
    width: 0.42,
    height: 0.45,
    transform: "translate(825.21 317.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 412.82,
    y: 157.96,
    width: 0.42,
    height: 0.45,
    transform: "translate(826.06 316.38) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 413.24,
    y: 158.41,
    width: 0.42,
    height: 0.45,
    transform: "translate(826.91 317.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 413.67,
    y: 157.96,
    width: 0.42,
    height: 0.45,
    transform: "translate(827.75 316.38) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 414.09,
    y: 158.41,
    width: 0.42,
    height: 0.45,
    transform: "translate(828.6 317.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 414.51,
    y: 157.96,
    width: 0.42,
    height: 0.45,
    transform: "translate(829.45 316.38) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 414.94,
    y: 158.41,
    width: 0.42,
    height: 0.45,
    transform: "translate(830.3 317.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 415.36,
    y: 157.96,
    width: 0.42,
    height: 0.45,
    transform: "translate(831.14 316.38) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 415.78,
    y: 158.41,
    width: 0.42,
    height: 0.45,
    transform: "translate(831.99 317.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m416.47,158.41h-.26v-.23c.09.07.18.15.26.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m416.86,158.86h-.23v-.28c.08.09.16.18.23.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m410.27,159.3v.45h-.27c.05-.15.11-.3.19-.45h.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m410.7,158.86v.44h-.42v-.15c.06-.1.12-.2.19-.29h.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 410.7,
    y: 159.31,
    width: 0.42,
    height: 0.45,
    transform: "translate(821.82 319.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 411.12,
    y: 158.86,
    width: 0.42,
    height: 0.45,
    transform: "translate(822.67 318.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 411.55,
    y: 159.31,
    width: 0.42,
    height: 0.45,
    transform: "translate(823.52 319.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 411.97,
    y: 158.86,
    width: 0.42,
    height: 0.45,
    transform: "translate(824.36 318.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 412.39,
    y: 159.31,
    width: 0.42,
    height: 0.45,
    transform: "translate(825.21 319.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 412.82,
    y: 158.86,
    width: 0.42,
    height: 0.45,
    transform: "translate(826.06 318.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 413.24,
    y: 159.31,
    width: 0.42,
    height: 0.45,
    transform: "translate(826.91 319.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 413.67,
    y: 158.86,
    width: 0.42,
    height: 0.45,
    transform: "translate(827.75 318.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 414.09,
    y: 159.31,
    width: 0.42,
    height: 0.45,
    transform: "translate(828.6 319.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 414.51,
    y: 158.86,
    width: 0.42,
    height: 0.45,
    transform: "translate(829.45 318.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 414.94,
    y: 159.31,
    width: 0.42,
    height: 0.45,
    transform: "translate(830.3 319.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 415.36,
    y: 158.86,
    width: 0.42,
    height: 0.45,
    transform: "translate(831.14 318.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 415.78,
    y: 159.31,
    width: 0.42,
    height: 0.45,
    transform: "translate(831.99 319.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 416.21,
    y: 158.86,
    width: 0.42,
    height: 0.45,
    transform: "translate(832.84 318.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 416.63,
    y: 159.31,
    width: 0.42,
    height: 0.45,
    transform: "translate(833.69 319.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m417.14,159.3h-.08v-.15s.06.1.08.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m410.27,160.2v.45h-.42v-.05h.02v-.08c0-.1,0-.21.02-.31h.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 410.27,
    y: 159.75,
    width: 0.42,
    height: 0.45,
    transform: "translate(820.97 319.95) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 410.7,
    y: 160.2,
    width: 0.42,
    height: 0.45,
    transform: "translate(821.82 320.85) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 411.12,
    y: 159.75,
    width: 0.42,
    height: 0.45,
    transform: "translate(822.67 319.95) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 411.55,
    y: 160.2,
    width: 0.42,
    height: 0.45,
    transform: "translate(823.52 320.85) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 411.97,
    y: 159.75,
    width: 0.42,
    height: 0.45,
    transform: "translate(824.36 319.95) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 412.39,
    y: 160.2,
    width: 0.42,
    height: 0.45,
    transform: "translate(825.21 320.85) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 412.82,
    y: 159.75,
    width: 0.42,
    height: 0.45,
    transform: "translate(826.06 319.95) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 413.24,
    y: 160.2,
    width: 0.42,
    height: 0.45,
    transform: "translate(826.91 320.85) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 413.67,
    y: 159.75,
    width: 0.42,
    height: 0.45,
    transform: "translate(827.75 319.95) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 414.09,
    y: 160.2,
    width: 0.42,
    height: 0.45,
    transform: "translate(828.6 320.85) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 414.51,
    y: 159.75,
    width: 0.42,
    height: 0.45,
    transform: "translate(829.45 319.95) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 414.94,
    y: 160.2,
    width: 0.42,
    height: 0.45,
    transform: "translate(830.3 320.85) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 415.36,
    y: 159.75,
    width: 0.42,
    height: 0.45,
    transform: "translate(831.14 319.95) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 415.78,
    y: 160.2,
    width: 0.42,
    height: 0.45,
    transform: "translate(831.99 320.85) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 416.21,
    y: 159.75,
    width: 0.42,
    height: 0.45,
    transform: "translate(832.84 319.95) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 416.63,
    y: 160.2,
    width: 0.42,
    height: 0.45,
    transform: "translate(833.69 320.85) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m417.44,160.2h-.38v-.45h.27c.05.15.09.3.11.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m417.9,160.63v.02h-.42v-.05h.2c.08,0,.15.01.22.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m409.43,161.09v.45h-.34v-.17c0-.1.02-.19.05-.28h.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m409.85,160.65v.45h-.42v-.38s.09-.05.14-.07h.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 409.85,
    y: 161.09,
    width: 0.42,
    height: 0.45,
    transform: "translate(820.12 322.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 410.27,
    y: 160.65,
    width: 0.42,
    height: 0.45,
    transform: "translate(820.97 321.74) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 411.12,
    y: 160.65,
    width: 0.42,
    height: 0.45,
    transform: "translate(822.67 321.74) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 411.97,
    y: 160.65,
    width: 0.42,
    height: 0.45,
    transform: "translate(824.36 321.74) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 412.82,
    y: 160.65,
    width: 0.42,
    height: 0.45,
    transform: "translate(826.06 321.74) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 413.67,
    y: 160.65,
    width: 0.42,
    height: 0.45,
    transform: "translate(827.75 321.74) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 414.09,
    y: 161.09,
    width: 0.42,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 414.51,
    y: 160.65,
    width: 0.42,
    height: 0.45,
    transform: "translate(829.45 321.74) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m415.36,161.09v.1c-.13-.04-.27-.06-.42-.07v-.03h.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 415.36,
    y: 160.65,
    width: 0.42,
    height: 0.45,
    transform: "translate(831.14 321.74) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m416.21,161.09v.45h-.2c-.07-.06-.14-.12-.23-.17v-.28h.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 416.21,
    y: 160.65,
    width: 0.42,
    height: 0.45,
    transform: "translate(832.84 321.74) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 416.63,
    y: 161.09,
    width: 0.42,
    height: 0.45,
    transform: "translate(833.69 322.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 417.06,
    y: 160.65,
    width: 0.42,
    height: 0.45,
    transform: "translate(834.54 321.74) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 417.48,
    y: 161.09,
    width: 0.42,
    height: 0.45,
    transform: "translate(835.38 322.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m418.33,161v.1h-.42v-.45h.04c.16.06.3.19.38.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m418.42,161.37v.17h-.09v-.45h.04c.03.09.05.18.05.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 409.09,
    y: 161.99,
    width: 0.34,
    height: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 409.43,
    y: 161.54,
    width: 0.42,
    height: 0.45,
    transform: "translate(819.28 323.53) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 409.85,
    y: 161.99,
    width: 0.42,
    height: 0.45,
    transform: "translate(820.12 324.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 410.27,
    y: 161.54,
    width: 0.42,
    height: 0.45,
    transform: "translate(820.97 323.53) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 410.7,
    y: 161.99,
    width: 0.42,
    height: 0.45,
    transform: "translate(821.82 324.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m411.51,161.54c-.14.13-.25.28-.3.45h-.09v-.45h.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m416.63,161.54v.45h-.32c-.02-.07-.06-.15-.1-.21v-.23h.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 416.63,
    y: 161.99,
    width: 0.42,
    height: 0.45,
    transform: "translate(833.69 324.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 417.06,
    y: 161.54,
    width: 0.42,
    height: 0.45,
    transform: "translate(834.54 323.53) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 417.48,
    y: 161.99,
    width: 0.42,
    height: 0.45,
    transform: "translate(835.38 324.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 417.9,
    y: 161.54,
    width: 0.42,
    height: 0.45,
    transform: "translate(836.23 323.53) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 418.33,
    y: 161.99,
    width: 0.09,
    height: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 409.09,
    y: 162.88,
    width: 0.34,
    height: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 409.43,
    y: 162.43,
    width: 0.42,
    height: 0.45,
    transform: "translate(819.28 325.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 409.85,
    y: 162.88,
    width: 0.42,
    height: 0.45,
    transform: "translate(820.12 326.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 410.27,
    y: 162.43,
    width: 0.42,
    height: 0.45,
    transform: "translate(820.97 325.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m411.09,162.88c-.08.18-.22.33-.39.41v-.41h.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m411.16,162.44v.1c0,.09-.01.18-.04.26v-.35h.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m416.63,162.44v.44h-.21c-.05-.1-.07-.22-.07-.35v-.1h.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m417.05,162.88v.45h-.15c-.1-.03-.19-.09-.27-.15v-.29h.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 417.06,
    y: 162.43,
    width: 0.42,
    height: 0.45,
    transform: "translate(834.54 325.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 417.48,
    y: 162.88,
    width: 0.42,
    height: 0.45,
    transform: "translate(835.38 326.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 417.9,
    y: 162.43,
    width: 0.42,
    height: 0.45,
    transform: "translate(836.23 325.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 418.33,
    y: 162.88,
    width: 0.09,
    height: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 409.09,
    y: 163.77,
    width: 0.34,
    height: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 409.43,
    y: 163.33,
    width: 0.42,
    height: 0.45,
    transform: "translate(819.28 327.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 409.85,
    y: 163.78,
    width: 0.42,
    height: 0.45,
    transform: "translate(820.12 328) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m410.61,163.33c-.08.03-.16.04-.24.04h-.05v.41h-.04v-.45h.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m417.48,163.33v.45h-.29v-.41h-.05s-.06,0-.09,0v-.04h.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 417.48,
    y: 163.78,
    width: 0.42,
    height: 0.45,
    transform: "translate(835.38 328) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 417.9,
    y: 163.33,
    width: 0.42,
    height: 0.45,
    transform: "translate(836.23 327.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 418.33,
    y: 163.77,
    width: 0.09,
    height: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 409.09,
    y: 164.67,
    width: 0.34,
    height: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 409.43,
    y: 164.22,
    width: 0.42,
    height: 0.45,
    transform: "translate(819.28 328.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m410.08,164.67c-.06.1-.14.18-.23.25v-.25h.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m410.28,164.22s0,.01,0,.02v-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m417.48,164.22v.45h-.05c-.05-.07-.09-.15-.13-.23-.03-.07-.06-.14-.07-.22h.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m417.9,164.67v.41c-.16-.08-.31-.2-.42-.34v-.07h.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 417.9,
    y: 164.22,
    width: 0.42,
    height: 0.45,
    transform: "translate(836.23 328.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 418.33,
    y: 164.67,
    width: 0.09,
    height: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m409.52,165.12s-.06.02-.1.04v-.04h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m418.33,165.12v.08c-.12-.01-.24-.04-.34-.08h.34Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m417.56,159.97c.17,0,.31-.15.31-.34s-.14-.34-.31-.34h-7.77c-.17,0-.31.15-.31.34s.14.34.31.34c-.17,0-.31.15-.31.34s.14.34.31.34h7.77c.17,0,.31-.15.31-.34s-.14-.34-.31-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "m417.12,161.76c0,.18-.07.34-.18.45s-.26.19-.43.19h-.17v-.28c-.1-.56-.74-1-1.53-1h1.69c.34,0,.61.29.61.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "m410.39,161.76c0,.18.07.34.18.45s.26.19.43.19h.17v-.18c.09-.56.74-1.1,1.53-1.1h-1.69c-.34,0-.61.29-.61.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "m418.12,163.9c0,.15-.06.28-.15.38-.09.1-.22.16-.36.16h-.32c-.07-.16-.11-.34-.11-.53v-.54h.42c.28,0,.51.24.51.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "m409.38,163.9c0,.15.06.28.15.38.09.1.22.16.36.16h.32c.07-.16.11-.34.11-.53v-.54h-.42c-.28,0-.51.24-.51.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m413.76,165.2h1.05c.44,0,.81.36.81.81h-1.05c-.44,0-.81-.36-.81-.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m412.71,165.2h1.05c0,.44-.36.81-.81.81h-1.05c0-.44.36-.81.81-.81Z",
    transform: "translate(825.66 331.21) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "m410.39,161.73h0c0-.35.27-.64.6-.63h5.5c.35,0,.63.3.63.67h0l-.77.08v-.72h-5.33l-.63.61Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m110.79,217.99l4.02-1.2c-3.9.28-3.25.37-9.81.37h-.02s-4.67,0-4.67,0c-.65,0-1.3.04-1.45.08l-.99.3h0l-.52.16c-.14.04.27.08.92.08h4.67s0,0,0,0c4.87,0,5.53.03,7.33.37l.52-.16h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m102.89,217.8h-.04s.09-.02.09-.02h-2.03s-.44.13-.44.13l-2.49.11h0s-7.35.33-7.35.33l-2.34-.81-2.88-.19.54-.16c.52-.02,1.07-.04,1.65-.07l2.68-.8c.31-.09.33-.18.12-.25.88-.06,1.64-.15,2-.26.61-.18-.14-.33-1.68-.33-.89,0-1.85.05-2.62.12-.24-.01-.52-.02-.84-.02-1.42,0-3.01.13-3.68.29-.74.04-1.4.12-1.7.2l-.99.29c-.22.02-.41.04-.5.07l-.78.23c-.18.05.05.1.51.1h.31s-1.77.53-1.77.53l-6.04.25c-3.08.29-5.53.64-7.48,1-.2.04-.4.07-.59.11-.21.04-.41.08-.6.12-.18.04-.35.07-.52.11-1.47.32-2.57.64-3.37.93-.11.04-.21.08-.31.11-.11.04-.22.08-.32.12-.09.04-.19.08-.27.11-.91.39-1.2.65-1.2.65h1.08c-1.2.36-.1.48.93.52l-8.35,2.5h0l-.89.27h5.64c.4-.15-.28-.27-1.6-.27h.28s3.23-.57,3.23-.57l.63-.11.69-.12.64-.11,1.05-.19.23-.04.9-.16.24-.04.47-.08.23-.04.47-.08.23-.04.47-.08.23-.04.73-.13.11-.02h0s.09-.01.09-.01l-1.91.96-.22.11-.24.12-.22.11-1.13.57h0l-.92.28h5.65c.46-.16-.22-.28-1.57-.28h.28s2.46-.57,2.46-.57l.48-.11.52-.12.48-.11.8-.19.09-.02.78-.18.18-.04.36-.08.18-.04.36-.08.18-.04.35-.08.18-.04.55-.13.18-.04,5.42-1.26h1.61s.16-.04.45-.11c.13-.03.3-.07.48-.12.13-.03.28-.07.43-.11,1.22-.32,2.94-.79,4.33-1.27.11-.04.21-.07.32-.11.09-.03.17-.06.26-.1l.99.13,9.99-.42.24-.15.83-.04-.31.09h2.03s.67-.2.67-.2h.07c.96-.05,1.7-.16,1.65-.25l-.11-.21Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-233",
    cx: 61.29,
    cy: 149.14,
    rx: 2.79,
    ry: 2.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "m60.91,150.02c0,1.58-1.21,2.86-2.71,2.86s-2.71-1.28-2.71-2.86,1.21-2.86,2.71-2.86,2.71,1.28,2.71,2.86Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "65.86 164.75 71.7 173.14 70.33 177.77 65.07 173.55 65.86 164.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m81.39,171.26l-2.85,1.39-1.36-3.57,4.16-2.02.84,1.94c.37.86.02,1.87-.79,2.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "70.33 177.77 78.87 173.93 77.86 168.75 69.25 172.93 70.33 177.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "69.76 177.31 66.15 174.41 68.38 171.13 69.76 177.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m64.19,221.59l-3.13.03.02,2.49h5.65c-.07-1.41-1.18-2.53-2.54-2.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "67.29 193.16 66.16 204.53 66.13 204.9 66.01 206.06 65.98 206.44 65.9 207.18 65.87 207.56 65.79 208.31 65.76 208.68 65.68 209.43 65.64 209.81 65.48 211.43 65.47 211.62 65.3 213.3 65.2 214.31 65.09 215.41 64.99 216.42 64.48 221.58 61.05 221.61 60.24 216.47 60.08 215.45 59.91 214.36 59.75 213.35 58.37 204.65 56.57 193.26 67.29 193.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m53.85,221.68l-3.13.03.02,2.4h5.64c-.11-1.37-1.21-2.44-2.53-2.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "61.21 193.21 58.38 204.6 58.37 204.65 58.29 204.97 58 206.13 57.91 206.51 57.72 207.26 57.63 207.63 57.44 208.38 57.35 208.76 57.16 209.51 57.07 209.88 56.71 211.32 56.62 211.7 56.2 213.38 55.95 214.39 55.68 215.49 55.43 216.51 54.14 221.68 50.72 221.71 50.49 193.31 61.21 193.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "58.33 204.79 57.99 204.69 60.41 196.13 62.56 194.9 62.73 195.23 60.71 196.39 58.33 204.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m69.07,190.02c-.01.37-.03.71-.05,1.01-.02.42-.04.79-.06,1.1-.04.65-.07,1.01-.07,1.01l-18.41.17-.23-28.42,5.47-2.34,5.52-.05,4.62,2.25c1.63,2.44,2.51,6.42,2.95,10.65.03.34.07.68.1,1.01.03.36.06.73.09,1.1.02.34.04.68.06,1.01.25,4.33.14,8.61.02,11.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "51.8 193.31 51.64 173.26 54.4 193.29 51.8 193.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m62.33,163.1s-.9,1-3.43,1.03c-2.54.03-3.44-.95-3.44-.95l-.04-5.92,6.88-.08.04,5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m62.32,162.81l-.03-3.33-5.68.05s1.03,2.99,5.71,3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m63.75,160.96c-4.61,2.48-8.23-.69-8.23-.69l-.08-10.22,4.69-.04c1.95-.02,3.55,1.64,3.56,3.7l.06,7.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "m56.81,149.47h-.31c-1.11.01-2,.97-1.99,2.14l.03,4.09,2.32-.02-.04-6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m55.17,154.04h0c.5,0,.91.41.91.91v2.95h-.91c-.5,0-.9-.4-.9-.9v-2.06c0-.5.4-.9.9-.9Z",
    transform: "translate(-1.41 .51) rotate(-.52)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "62.3 156.96 61.43 156.97 61.43 156.56 61.85 156.56 61.85 154.9 62.23 154.83 62.3 156.96"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m51.81,194.33l.04,4.93s-3.98.55-4.03-4.88l3.99-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m51.64,172.68l.13,15.83c.03,3.36.05,5.87.05,5.87l-5.06.07s-.61-2.36-1.02-5.89c-.04-.33-.07-.67-.11-1.01-.03-.36-.07-.72-.1-1.1-.03-.33-.05-.67-.07-1.01-.16-2.56-.16-5.45.21-8.38.04-.34.09-.67.14-1.01.06-.37.12-.73.19-1.1.06-.34.13-.68.21-1.02.72-3.25,1.98-6.4,4.06-9.05,0,0,1.34,2.62,1.38,7.79Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "60.34 197.42 60.27 197.06 62.47 196.58 62.54 196.94 60.34 197.42"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "m56.44,152.59h0v-2.73h2.33v.26c0,1.36-1.04,2.46-2.33,2.46Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m78.57,254.13l1.6-.47h.26c.41,0,.87-.04,1.03-.09l.32-.09.29-.08.14-.04h0l.96-.28c.69-.2-.15-.36-1.88-.36h-1.69c-1.62,0-3.46.15-4.11.34l-.83.24s-.05.01-.07.02c-.31.01-.6.04-.73.08l-.61.18c-.12.04-.04.07.18.08l-.46.13c-.35.1-.07.19.63.22l-.36.1h-.03s-5.41.25-5.41.25h0c-.07.01-3.5.6-6.75,1.55-2.36.69-4.85,1.4-4.85,1.4h.22l-.57.17-.69.2c-.05.01-.07.03-.07.04-.51,0-1.06.06-1.28.13l-.22.06h-3.11c-.6,0-1.27.06-1.51.13l-.92.27-.2.06-2.28.67h7.52l-4.47,1.35h-.01c-1.31,0-2.79.12-3.31.28h4.92l1.4-.28h0l6.12-1.35h.76l2.28-.67.06-.02,2.19-.48-4.81,2.63c-.08.01-.15.03-.2.04l-.43.13h2.55l.43-.13s.06-.02.08-.03h.03l10.53-3.11h.06s1.44-.16,1.44-.16l-.72-.07h0s1.14.11,1.14.11l9.34-1.24s1.74-1.17.77-1.72l-4.71-.18Zm-24.22,3.71c.13-.04.45-.07.69-.07h.34c.1,0,.23.01.38.01h1.47l-.41.12h-2.69l.22-.06Zm23.93-1.89l-4.62.64,1.29-.49,3.02-.53h.08s.23.38.23.38Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m43.13,238.11h8.86c.54,0,.98.44.98.98v6.84h-12.94v-4.71c0-1.72,1.39-3.11,3.11-3.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 40.02,
    y: 235.79,
    width: 12.94,
    height: 5.24,
    rx: 2.62,
    ry: 2.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m48.78,235.79h-.52v-.58c0-.34-.21-.64-.45-.64h-2.62c-.25,0-.45.29-.45.64v.58h-.52v-.58c0-.64.44-1.16.97-1.16h2.62c.53,0,.97.52.97,1.16v.58Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 44.99,
    y: 230.13,
    width: 3.41,
    height: 1.74,
    transform: "translate(93.4 461.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m46.7,231.87h0c.94,0,1.71.77,1.71,1.71v1.11h-3.41v-1.11c0-.94.77-1.71,1.71-1.71Z",
    transform: "translate(93.4 466.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "m44.84,217.71c0,6.25-.07,12.65-.07,12.65h2.73l-.04-26.68h-1.17s-1.45,5.33-1.45,14.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m49.52,188.79h7.75v2.08c0,2.07-1.68,3.76-3.76,3.76h0c-2.2,0-3.99-1.79-3.99-3.99v-1.85h0Z",
    transform: "translate(106.78 383.42) rotate(-180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "60.08 228.64 60.17 259.22 57.69 259.22 52.32 228.64 60.08 228.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "47.33 228.64 47.7 258.17 50.71 258.17 54.32 228.64 47.33 228.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "46.29 203.68 50.89 201.53 55.99 201.53 61.57 203.21 60.91 213.42 59.39 219.51 60.08 227.5 60.08 230.45 47.33 228.64 46.29 203.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "51.48 214.51 57.83 208.55 55.43 207.49 58.19 205.91 56.04 201.57 55.74 201.73 57.75 205.76 54.66 207.53 57.21 208.66 51.59 213.94 48.86 208.02 50.78 207.4 48.7 205.92 51.73 201.06 51.45 200.87 48.24 206.02 50.02 207.28 48.39 207.8 51.48 214.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "48.31 230.53 52.93 227.97 52.75 216.31 51.65 214.07 51.35 214.23 52.42 216.4 52.6 227.76 48.15 230.22 48.31 230.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "56.25 201.65 53.18 209.65 51.59 213.81 51.37 209.89 50.89 201.67 53.05 201.65 53.15 201.65 56.25 201.65"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "52.71 205.21 51.68 203.65 53.09 201.88 54.42 203.65 52.71 205.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "53.48 202.54 53.4 204.47 53.18 209.65 51.59 213.81 51.37 209.89 52.26 204.32 52.56 202.42 53.48 202.54"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m50.89,201.66s.71,1.12,2.69,1.12,2.69-1.12,2.69-1.12v-7.23h-5.37v7.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m50.89,201.45v-3.48h4.44s0,3.48-4.44,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m47.69,258.17h3.01l-.46,2.49h-4.92c0-1.38,1.06-2.49,2.36-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m58.89,258.17h0c.7,0,1.27.6,1.27,1.34v1.15h-2.55v-1.15c0-.74.57-1.34,1.27-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m49.8,194.21h0v3.17h0c-.41,0-.74-.35-.74-.78v-1.61c0-.43.33-.78.74-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m51.35,200.58c2.65.09,4.17-1.88,4.17-1.88v-6.32c0-.76-.52-1.38-1.16-1.38h-2.16c-2.25,0-2.69,1.98-2.69,3.33v4.21c0,1.09.81,2.01,1.83,2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m50.53,198.7c.52.55,1.19.35,1.49.16l-.17-.3s-.67.42-1.15-.19l-.26.22s.06.08.1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m54.17,191.06h3.08v3.35c0,.75-.61,1.35-1.35,1.35h0c-.95,0-1.73-.77-1.73-1.73v-2.98h0Z",
    transform: "translate(111.43 386.82) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m56.51,194.21h0c.41,0,.74.35.74.78v1.61c0,.43-.33.78-.74.78h-.75v-2.38c0-.44.34-.79.75-.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "50.68 197.04 51.38 197.04 51.38 196.71 51.03 196.71 51.1 195.99 50.79 195.95 50.68 197.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m55.25,229.7l.13-.16c1.34-1.62,3.18-1.65,3.2-1.65v-.35c-.08,0-1.89.03-3.32,1.62l-2.37-3.14-.26.22,2.62,3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "m51.54,219.53c0,.26-.2.48-.45.48s-.45-.21-.45-.48.2-.48.45-.48.45.21.45.48Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-178",
    cx: 51.09,
    cy: 223.9,
    rx: 0.45,
    ry: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m53.57,192.79h0c.81,0,1.46.69,1.46,1.54v2h-1.46v-3.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "48.79 258.17 49.15 232.42 48.82 232.41 48.46 258.16 48.79 258.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "58.73 258.19 59.06 258.15 56.81 234.66 56.48 234.7 58.73 258.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "47.27 230.7 47.61 230.69 46.66 207.72 46.33 207.74 47.27 230.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "61.05 229.7 58.16 227.78 57.28 229.25 60.16 231.17 61.05 229.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m57.91,232.22l.93.62,1.09-1.82-2.66-1.77h0c-.6,1.01-.32,2.34.63,2.97Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "m58.16,227.78l4.04-9.64-1.95-4.39,1.32-10.54c2.88,5.05,5.12,15.6,5.12,15.6l-5.1,11.22-3.43-2.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "58.99 225.75 59.16 225.45 56.34 223.55 56.16 223.85 58.99 225.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "58.94 225.58 59.21 225.39 56.78 221.53 56.51 221.72 58.94 225.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "58.17 222.37 58.45 222.19 57.3 220.28 59.32 219.79 59.25 219.45 56.77 220.04 58.17 222.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "60.51 214.74 60.81 214.58 59.47 211.85 60.82 207 60.5 206.9 59.11 211.89 60.51 214.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m59.11,233.18l.11-.33s-1.59-.62-1.93-1.65c-.35-1.06-.16-2.26-.16-2.27l-.33-.06c0,.05-.2,1.3.18,2.44.39,1.18,2.06,1.83,2.13,1.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "57.06 230.38 59.85 224.16 59.55 224.01 56.76 230.23 57.06 230.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "64.79 218.64 64.84 218.29 62.45 217.9 62.4 218.25 64.79 218.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "62.5 218.12 64.89 216.96 64.75 216.64 62.36 217.8 62.5 218.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "62.26 216.96 63.55 216.3 63.4 215.98 62.11 216.64 62.26 216.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "53.26 234.95 53.59 234.89 53.21 232.74 51.93 231.73 51.73 232.01 52.91 232.94 53.26 234.95"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 46.7,
    y: 210.84,
    width: 1.93,
    height: 0.35
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "46.86 219.75 47.08 219.48 45.8 218.33 45.58 218.6 46.86 219.75"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m51.03,190.54h3.08c1.34,0,2.42,1.08,2.42,2.42h-5.5v-2.42h0Z",
    transform: "translate(107.56 383.5) rotate(-180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m107.75,260.65l-4.55-.35s.02,0,.02,0l1.1-.38c.34-.01.67-.05.81-.09l.34-.1h.02s.12-.04.12-.04c.38-.03.71-.07.87-.12l1.05-.31c.44-.13.25-.24-.4-.31.01-.09-.34-.14-.97-.14h-6.79c-.25.08-.35.15-.31.2-.37-.05-.48-.12-.21-.2l-.3.09c-.38.11,0,.21.88.25-.33.05-.6.1-.79.15l-.95.31-.08.02h0s-.91.27-.91.27c-.07.01-.12.02-.16.03l-.21.06h.05l-.67.19s-.07.1.82.14l-5.27.32h0c-.07.01-4.28.7-7.25,1.57-2.97.87-4.69,1.54-4.69,1.54h2.52s-1.95,0-1.95,0h0s-.35,0-.35,0l-.25.07h.12c-2.01.34.98.37.98.37l1.04-.31-9.19,3h.48s0,0,0,0h-.64c-1.41,0-3,.13-3.56.3h5.54s1.27-.3,1.27-.3h-2.25s0,0,0,0h2.25s10.71-2.45,10.71-2.45l-5.31,2.53c-.21.02-.38.05-.48.08l-.47.14h2.74s.47-.14.47-.14c.1-.03.13-.06.08-.08l12.44-3.26h.13l.69-.21h0l3.43-1.07,2.1-.47-3.23.97h0l-2.93.86h0l-.25.07h0l-1.25.37s3.43-.02,3.68-.37h.02l.25-.07h-.26s.71,0,.71,0c0,0,3.73-.83,6.19-1.54,3.63-1.06,3.01-1.57,2.96-1.61h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "75.37 233.76 83.68 233.76 82.3 265.4 79.98 265.4 75.37 233.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "69.99 233.76 77.52 233.76 74.29 264.53 71.2 264.52 69.99 233.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m71.04,264.53h3.25s-.25,2.69-.25,2.69h-5.54c0-1.48,1.14-2.68,2.55-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m81.13,264.52c.76,0,1.37.65,1.37,1.45v1.24s-2.74,0-2.74,0v-1.24c0-.8.61-1.45,1.37-1.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "71.6 237.83 71.95 237.83 72.04 264.54 71.68 264.54 71.6 237.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "76.38 240.56 76 238.4 74.73 237.39 74.95 237.09 76.33 238.18 76.73 240.49 76.38 240.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m87.85,222.43c0,6.49-.91,13.96-.91,13.96h-2.89s0-28.52,0-28.52h1.27s2.54,4.6,2.54,14.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m84.05,236.39v3.98s3.82-.24,2.18-3.98h-2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 84.04,
    y: 236.39,
    width: 2.45,
    height: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m66.99,222.19c0,7.86.58,13.96.58,13.96h2.56s0-28.52,0-28.52l-1.27.35s-1.88,6.3-1.88,14.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m70.13,236.15v3.98s-3.5-.24-2-3.98h2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 67.78,
    y: 236.15,
    width: 2.35,
    height: 0.67
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "68.86 207.97 73.82 204.56 79.31 204.56 85.33 207.87 83.45 224.07 83.73 235.71 77.32 235.71 73.87 233.76 71.5 235.71 68.55 235.71 68.86 207.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m79.59,204.69s-.52.91-.97,4.18c-.1.71-.19,1.52-.27,2.47-.57,6.43-1.04,24.38-1.04,24.38l-3.45-1.94-2.37,1.95s-.84-23.65,1.86-30.26h0c.14-.35.29-.65.46-.89l2.33.13h.11s3.34,0,3.34,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m79.59,204.69s-.52.91-.97,4.18l-2.05,4.11-2.3,6.29-.91-13.81h0c.14-.35.29-.65.46-.89l2.33.13h.11s3.34,0,3.34,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m77.24,205.81l-1.13,1.66s.87,1.39.77,2.27c-.1.88-.31,3.23-.31,3.23l-2.3,6.29-.4-6.18s.27-2.95.41-3.75c.15-.82,1.11-1.88,1.11-1.88l-.77-1.65h2.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 69.07,
    y: 214.59,
    width: 1.47,
    height: 0.38
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "84.04 228.63 83.87 213.16 84.22 213.16 84.25 228.63 84.04 228.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "68.52 235.71 68.5 213.16 68.85 213.16 68.88 235.71 68.52 235.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "83.9 217.27 82.67 213.83 83 213.69 84.23 217.14 83.9 217.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "73.99 233.15 73.75 232.87 75.19 231.45 75.19 221.97 74.11 219.85 74.43 219.67 75.55 221.87 75.55 231.61 73.99 233.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m73.85,222.67c-.36.5.18,1.07.65.69.36-.5-.18-1.07-.65-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m73.85,225.74c-.36.5.18,1.07.65.69.36-.5-.18-1.07-.65-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m73.85,228.82c-.36.5.18,1.07.65.69.36-.5-.18-1.07-.65-.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "84.11 222.3 83.98 221.95 85.6 221.26 85.73 221.61 84.11 222.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "84.2 222.9 84.15 222.53 86.33 222.21 86.38 222.59 84.2 222.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "78.59 219.95 78.28 219.77 81.72 213.28 79.18 211.6 81.73 209.45 79.54 205.17 79.86 204.99 82.18 209.54 79.8 211.56 82.19 213.15 78.59 219.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "71.22 219.2 69.79 211.84 71.11 211.03 70.3 209.92 72.65 205.81 72.96 206 70.73 209.9 71.64 211.14 70.19 212.03 71.57 219.13 71.22 219.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m69.93,226.81c0,.26.2.47.45.47s.45-.21.45-.47c0-.26-.2-.47-.45-.47-.25,0-.45.21-.45.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m69.93,223.75c0,.26.2.47.45.47s.45-.21.45-.47c0-.26-.2-.47-.45-.47-.25,0-.45.21-.45.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m79.76,235.71h-2.45s.12-4.15.12-4.15l-.04,1.57c-.04,1.41,1.03,2.58,2.37,2.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m70.15,235.71h1.35s-.04-4.15-.04-4.15l.03,1.57c.02,1.41-.58,2.58-1.34,2.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m73.49,205.14s.85,1.12,2.9,1.12,3.2-1.56,3.2-1.56l-.42-7.07h-5.57l-.12,7.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m73.61,204.91v-3.61h4.6s0,3.61-4.6,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m73.66,204.06v-3.67s4.68,0,4.68,0c0,0,0,3.67-4.68,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m77.27,192.08h-2.1c-1.95,0-3.53,1.67-3.53,3.73l.15,4.02,7.22-.25c.76,0,1.37-.65,1.37-1.44v-2.79c0-1.81-1.39-3.27-3.1-3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m71.74,203.81c3.98,1.62,6.34-1.35,6.34-1.35v-5.95s.3-3.07-2.39-3.06h-1.11c-2.37,0-2.84,2.32-2.83,3.9v6.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 72.01,
    y: 201.35,
    width: 2.54,
    height: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m78.45,193.44h0c.8,0,1.45.69,1.45,1.53v4.6h0c-1.43,0-2.59-1.22-2.59-2.73v-2.2c0-.66.51-1.2,1.14-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m79.12,197.94h0c.43,0,.78.37.78.82v1.7c0,.45-.35.82-.78.82h-.79s0-2.52,0-2.52c0-.46.35-.83.79-.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "73.49 200.52 72.75 200.52 72.87 199.37 73.2 199.41 73.12 200.17 73.49 200.17 73.49 200.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m77.61,196.94s-.04,1.6-.69,3.33c-.65,1.73-2.49,1.48-2.49,1.48,0,0-.15.96-1.09.96s-1.11-.91-1.16-.98c-.42-.57-.44-2.94-.44-2.94v5.02s.44,1.5,2.54,1.5c3.43,0,4.05-2.21,4.05-2.21v-4.73l-.73-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m72.93,193.78h.83v.8h-.83c-1.52,0-2.76-1.08-2.76-2.42v-.8c0,1.34,1.24,2.42,2.76,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m79.12,193.77v.81h-6.26c-1.19,0-2.16-1.45-2.16-3.23v-.07h6.76c.92,0,1.67,1.11,1.67,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m75.07,194.57c1.24,0,2.25,1.06,2.25,2.37h0v-2.37h-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m72.94,200.65h.93c.77,0,1.4.63,1.4,1.4h-.93c-.77,0-1.4-.63-1.4-1.4h0Z",
    transform: "translate(148.24 402.68) rotate(179.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m73.08,200.65h.32c0,.77-.63,1.4-1.4,1.4h-.32c0-.77.63-1.4,1.4-1.4Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m436.97,260.21l-4.55-.35s.02,0,.02,0l1.1-.38c.34-.01.67-.05.81-.09l.34-.1h.02s.12-.04.12-.04c.38-.03.71-.07.87-.12l1.05-.31c.44-.13.25-.24-.4-.31.01-.09-.34-.14-.97-.14h-6.79c-.25.08-.35.15-.31.2-.37-.05-.48-.12-.21-.2l-.3.09c-.38.11,0,.21.88.25-.33.05-.6.1-.79.15l-.95.31-.08.02h0s-.91.27-.91.27c-.07.01-.12.02-.16.03l-.21.06h.05l-.67.19s-.07.1.82.14l-5.27.32h0c-.07.01-4.28.7-7.25,1.57-2.97.87-4.69,1.54-4.69,1.54h2.52s-1.95,0-1.95,0h0s-.35,0-.35,0l-.25.07h.12c-2.01.34.98.37.98.37l1.04-.31-9.19,3h.48,0s-.64,0-.64,0c-1.41,0-3,.13-3.56.3h5.54s1.27-.3,1.27-.3h-2.25s0,0,0,0h2.25s10.71-2.45,10.71-2.45l-5.31,2.53c-.21.02-.38.05-.48.08l-.47.14h2.74s.47-.14.47-.14c.1-.03.13-.06.08-.08l12.44-3.26h.13l.69-.21h0l3.43-1.07,2.1-.47-3.23.97h0l-2.93.86h0l-.25.07h0l-1.25.37s3.43-.02,3.68-.37h.02l.25-.07h-.26s.71,0,.71,0c0,0,3.73-.83,6.19-1.54,3.63-1.06,3.01-1.57,2.96-1.61h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "404.59 233.32 412.9 233.32 411.52 264.96 409.2 264.96 404.59 233.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "399.21 233.33 406.74 233.32 403.51 264.09 400.42 264.09 399.21 233.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m400.26,264.09h3.25s-.25,2.69-.25,2.69h-5.54c0-1.48,1.14-2.68,2.55-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m410.35,264.09c.76,0,1.37.65,1.37,1.45v1.24s-2.74,0-2.74,0v-1.24c0-.8.61-1.45,1.37-1.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "400.82 237.39 401.18 237.39 401.26 264.1 400.9 264.1 400.82 237.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "405.6 240.12 405.22 237.96 403.95 236.95 404.17 236.65 405.55 237.74 405.96 240.05 405.6 240.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m417.08,221.99c0,6.49-.91,13.96-.91,13.96h-2.89s0-28.52,0-28.52h1.27s2.54,4.6,2.54,14.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m413.27,235.95v3.98s3.82-.24,2.18-3.98h-2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 413.26,
    y: 235.95,
    width: 2.45,
    height: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m396.21,221.75c0,7.86.58,13.96.58,13.96h2.56s0-28.52,0-28.52l-1.27.35s-1.88,6.3-1.88,14.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m399.35,235.71v3.98s-3.5-.24-2-3.98h2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 397,
    y: 235.71,
    width: 2.35,
    height: 0.67
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "398.09 207.53 403.04 204.12 408.54 204.12 414.55 207.43 412.67 223.63 412.95 235.27 406.54 235.27 403.09 233.32 400.72 235.27 397.77 235.27 398.09 207.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m408.82,204.25s-.52.91-.97,4.18c-.1.71-.19,1.52-.27,2.47-.57,6.43-1.04,24.38-1.04,24.38l-3.45-1.94-2.37,1.95s-.84-23.65,1.86-30.26h0c.14-.35.29-.65.46-.89l2.33.13h.11s3.34,0,3.34,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m408.82,204.25s-.52.91-.97,4.18l-2.05,4.11-2.3,6.29-.91-13.81h0c.14-.35.29-.65.46-.89l2.33.13h.11s3.34,0,3.34,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m406.46,205.37l-1.13,1.66s.87,1.39.77,2.27c-.1.88-.31,3.23-.31,3.23l-2.3,6.29-.4-6.18s.27-2.95.41-3.75c.15-.82,1.11-1.88,1.11-1.88l-.77-1.65h2.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 398.29,
    y: 214.15,
    width: 1.47,
    height: 0.38
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "413.26 228.19 413.09 212.72 413.44 212.72 413.47 228.19 413.26 228.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "397.74 235.27 397.72 212.72 398.08 212.72 398.1 235.27 397.74 235.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "413.12 216.84 411.89 213.39 412.22 213.25 413.46 216.7 413.12 216.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "403.21 232.71 402.97 232.43 404.41 231.01 404.41 221.53 403.33 219.41 403.65 219.24 404.77 221.43 404.77 231.17 403.21 232.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m403.07,222.23c-.36.5.18,1.07.65.69.36-.5-.18-1.07-.65-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m403.07,225.3c-.36.5.18,1.07.65.69.36-.5-.18-1.07-.65-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m403.07,228.38c-.36.5.18,1.07.65.69.36-.5-.18-1.07-.65-.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "413.33 221.86 413.2 221.51 414.82 220.82 414.95 221.17 413.33 221.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "413.42 222.46 413.37 222.09 415.55 221.77 415.6 222.15 413.42 222.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "407.81 219.51 407.5 219.33 410.94 212.84 408.4 211.16 410.95 209.01 408.76 204.73 409.08 204.55 411.4 209.1 409.02 211.12 411.42 212.71 407.81 219.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "400.44 218.76 399.01 211.4 400.33 210.59 399.52 209.48 401.87 205.37 402.18 205.56 399.95 209.46 400.86 210.7 399.41 211.59 400.79 218.69 400.44 218.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m399.15,226.38c0,.26.2.47.45.47.25,0,.45-.21.45-.47,0-.26-.2-.47-.45-.47-.25,0-.45.21-.45.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m399.15,223.31c0,.26.2.47.45.47.25,0,.45-.21.45-.47,0-.26-.2-.47-.45-.47-.25,0-.45.21-.45.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m408.98,235.27h-2.45s.12-4.15.12-4.15l-.04,1.57c-.04,1.41,1.03,2.58,2.37,2.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m399.37,235.27h1.35s-.04-4.15-.04-4.15l.03,1.57c.02,1.41-.58,2.58-1.34,2.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m402.71,204.7s.85,1.12,2.9,1.12,3.2-1.56,3.2-1.56l-.42-7.07h-5.57l-.12,7.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m402.83,204.47v-3.61h4.6s0,3.61-4.6,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m402.88,203.63v-3.67s4.68,0,4.68,0c0,0,0,3.67-4.68,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m406.49,191.64h-2.1c-1.95,0-3.53,1.67-3.53,3.73l.15,4.02,7.22-.25c.76,0,1.37-.65,1.37-1.44v-2.79c0-1.81-1.39-3.27-3.1-3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m400.96,203.37c3.98,1.62,6.34-1.35,6.34-1.35v-5.95s.3-3.07-2.39-3.06h-1.11c-2.37,0-2.84,2.32-2.83,3.9v6.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 401.23,
    y: 200.91,
    width: 2.54,
    height: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m407.67,193h0c.8,0,1.45.69,1.45,1.53v4.6h0c-1.43,0-2.59-1.22-2.59-2.73v-2.2c0-.66.51-1.2,1.14-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m408.35,197.5h0c.43,0,.78.37.78.82v1.7c0,.45-.35.82-.78.82h-.79s0-2.52,0-2.52c0-.46.35-.83.79-.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "402.71 200.08 401.97 200.08 402.09 198.93 402.42 198.97 402.34 199.73 402.71 199.73 402.71 200.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m406.83,196.5s-.04,1.6-.69,3.33c-.65,1.73-2.49,1.48-2.49,1.48,0,0-.15.96-1.09.96s-1.11-.91-1.16-.98c-.42-.57-.44-2.94-.44-2.94v5.02s.44,1.5,2.54,1.5c3.43,0,4.05-2.21,4.05-2.21v-4.73l-.73-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m402.15,193.34h.83v.8h-.83c-1.52,0-2.76-1.08-2.76-2.42v-.8c0,1.34,1.24,2.42,2.76,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m408.34,193.33v.81h-6.26c-1.19,0-2.16-1.45-2.16-3.23v-.07h6.76c.92,0,1.67,1.11,1.67,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m404.29,194.13c1.24,0,2.25,1.06,2.25,2.37h0v-2.37h-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m402.16,200.21h.93c.77,0,1.4.63,1.4,1.4h-.93c-.77,0-1.4-.63-1.4-1.4h0Z",
    transform: "translate(806.68 401.74) rotate(179.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m402.3,200.21h.32c0,.77-.63,1.4-1.4,1.4h-.32c0-.77.63-1.4,1.4-1.4Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m407.6,265.08h.03s-2.78-.13-2.78-.13h-.05s1.07-.31,1.07-.31l.59-.17.11-.03h.2c.39,0,.83-.04.98-.08l.56-.16c.06-.02.07-.03.04-.05l.31-.09c.09,0,.19,0,.29,0,1.66,0,3.54-.16,4.2-.35s-.15-.35-1.81-.35c-1.31,0-2.75.1-3.63.23-.29-.01-.62-.02-.98-.02h-.13c-1.33,0-2.79.09-3.84.22-.51.06-.93.14-1.2.21l-1.54.45c-.45.13-.25.26.59.31.22.01.47.02.72.03l-.37.11-.17.05-3.75.16-2.54.53h-1.64s-4.13,1.37-4.13,1.37l2.92-.02-.32.11c-2.83.38-5.65,1.07-9.77,2.44h1.4c-1.45.68-2.22,1.22-2.22,1.22h-.86c-1.2,0-2.6.12-3.12.28h4.27,0,5.09c.52-.15-.03-.28-1.24-.28h-1.19s3.4-.68,6.13-1.22h1.42c5.61-1.3,7.61-1.75,7.24-2.44h0s-.38-.14,1.81-.59l6.89-.2h0s1.36-.04,1.36-.04l-.95-1.21Zm-2.63.65l.28.39-3.5.13c.84-.15,1.9-.32,3.22-.52Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "376.78 217.39 375.27 227.14 377.95 227.63 376.78 217.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m381.68,235.46v33.09h-1.88s-1.9-8.58-2.7-17.35c-.56-6.1-.58-12.29.94-15.75h3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m378.94,268.55c-1.2,0-2.18,1.12-2.18,2.49h4.92v-2.49h-2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m385.78,251.4c-.11.71-3.02,17.15-3.02,17.15h-1.56v-33.09h3.71c2.37,6.2,1.84,9.89.86,15.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m383.94,268.55c1.2,0,2.18,1.12,2.18,2.49h-4.92v-2.49h2.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 381.04,
    y: 251.21,
    width: 0.32,
    height: 17.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 381.03,
    y: 268.55,
    width: 0.33,
    height: 2.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m386.13,257.49h-9.69c-.56-12.38-.07-18.57,1.45-22.03h7.16c2.72,6.2,2.24,10.24,1.08,22.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "387.2 217.07 384.93 218.87 389.45 228.76 392.29 228.02 387.2 217.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "m377.89,235.46l-.13,1.56,2.56-1.56,2.75,1.8,1.98-1.8s-1.81-2.65,1.82-12.55l.36-5.87-3.19-1.09-3.71-.2-3.53,1.65,1.1,18.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "381.82 225.53 384.79 221.27 383.75 219.83 385.79 219.43 384.12 216.42 383.83 216.6 385.27 219.18 383.15 219.6 384.37 221.28 381.55 225.32 381.82 225.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "380.76 225.73 381.04 225.54 378.31 221.1 380.04 219.72 378.23 218.86 380.44 216.34 380.19 216.1 377.67 218.98 379.39 219.8 377.86 221.02 380.76 225.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "382.88 217.65 381.2 225.61 379.97 217.65 382.88 217.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "384.01 215.95 384.93 219.56 381.22 218.39 378.24 219.3 380.31 215.75 384.01 215.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "380.32 216.02 381.22 218.39 382.95 216 380.32 216.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "391.06 228.36 384.58 230.22 383.91 228.24 390.32 225.82 391.06 228.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "382.05 234.24 374.96 234.57 374.43 222.24 381.53 221.9 382.05 234.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "384.58 230.22 381.77 231.02 381.18 229.27 383.91 228.24 384.58 230.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m378.92,228.63h0c.98-.86,2.43-.73,3.25.3l1.01,1.27c.06.07.05.18-.02.24h0c-.98.86-2.43.73-3.25-.3l-1.01-1.27c-.06-.07-.05-.18.02-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m379.97,216.08s-.12.7,1.36.7,2.65-.7,2.65-.7v-4.54h-4.01v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m379.97,215.46v-2.84h3.63s-.64,2.56-3.63,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m384.76,207.28v2.42l-.79.06v3.34s-2.48,2.26-4.84,1.1c-1.03-.51-1.66-1.63-1.66-2.83v-4.09c0-.7.17-1.36.47-1.93.61-1.17,1.78-1.96,3.1-1.96h.13c1.97,0,3.58,1.74,3.58,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "m384.76,207.28v2.57h-1.74l-.38-2.13-4.7-2.37c.61-1.17,1.78-1.96,3.1-1.96h.13c1.97,0,3.58,1.74,3.58,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m384.16,208.27h.72v2.24c0,.4-.32.72-.72.72h0c-.39,0-.71-.32-.71-.71v-1.54c0-.39.32-.71.71-.71Z",
    transform: "translate(768.33 419.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m378.81,211.7v-.35c-.22,0-.39-.19-.39-.41v-.66h-.33v.66c0,.42.32.76.72.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m380.18,213.1c.73,0,1.08-.64,1.16-.99l-.32-.08s-.19.8-.94.72l-.03.35s.1,0,.14,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 388.61,
    y: 226.44,
    width: 1.81,
    height: 0.23
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "389.87 227.73 389.98 227.53 388.59 226.66 388.48 226.86 389.87 227.73"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-93",
    cx: 385.06,
    cy: 204.63,
    rx: 3.01,
    ry: 3.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m110.21,313.01l6.78-1.98h-26.58l-6.86,2.01c-.86.06-1.87.17-1.35.33h-.39s-.04.11-.04.11h-.43s-1.7,1.43-1.67,1.52c.11.35.71.6,1.19.75l-1.5.58-5.35,1.79-9.79,2.84h.03c-.05,0-.09.02-.13.03l-.35.1h2.33l.35-.1s.07-.03.08-.04l12.56-2.56-5.84,2.45h2.75s9.57-2.71,9.57-2.71h1.27l8.21-2.43c1.76-.18,4.43-.49,6.66-.86.36-.06.72-.12,1.08-.19,3.29-.59,6.65-1.14,6.65-1.14h-.16s.66-.11.66-.11h-.29c2.06-.22,1.11-.34.56-.38Zm-13.02,1.34h.08s.08,0,.1,0c.06.01,0,.05-.19.1l-.12.03c-.11.03-.34.05-.51.05l.63-.18Zm10.8-1.05l-.7.12-10,1.62h.05s-4.61.09-4.61.09l.15-.05h.09c.98,0,2.1-.09,2.49-.21l.22-.06h0l.23-.07s.03-.01.04-.02c.01,0,.03,0,.04-.01l.49-.14c.28,0,.67-.04.84-.08l.12-.03c.13-.03.32-.09.2-.12-.04,0-.12-.01-.23-.02.18-.02.32-.05.42-.08l.85-.25c.26-.08.11-.14-.32-.18l.17-.05c.24-.07-.05-.13-.65-.13h-2.35l-.28.08h-1.4l-.3.09c-.89.03-1.76.12-2.13.22h0l-1.06.31h-.28c-.07,0-.14,0-.17.01-.03,0,0,.01.07.01h.15c-.22.01-.42.04-.51.07l-.6.18c-.15.04.03.08.42.08h.23l-.21.06-1.75.38h0s-4.48-.09-4.48-.09l1.13-1.63h0s.05-.12.05-.12h-.05s.13-.15.13-.15h24.55l-.95.16h-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m76.01,320.84h-2.76s-.63.24-.63.24h4.71c.43-.14-.15-.24-1.32-.24Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "73.78 269.15 75.49 292.93 67.96 292.93 67.34 267.27 72.25 267.15 73.78 269.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "70.94 290.15 66.02 319.9 63.76 319.9 63.85 290.15 70.94 290.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "75.16 318.88 72.41 318.88 69.11 290.15 75.5 290.15 75.16 318.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m64.93,318.94c.64,0,1.16.55,1.16,1.23v.92h-2.33v-.92c0-.68.52-1.23,1.16-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m57.81,251l-.91-3.24s-3.05,1.17-.86,3.79l1.78-.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "55.48 251.41 57.73 250.57 58.11 251.69 55.86 252.54 55.48 251.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m81.34,251.12l.91-3.24s3.05,1.17.86,3.79l-1.78-.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "83.66 251.53 81.38 250.66 81.07 251.7 83.28 252.66 83.66 251.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m64.8,273.92l-6.74-22.36-2.65.89s3.13,12.79,3.46,13.58c2.19,5.33,4.9,8.22,4.9,8.22l1.03-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m74.33,273.67l6.74-21.97,2.46.81s-1.5,4.94-2.77,10.29c-.14.58-.28,1.16-.44,1.7-1.57,5.57-4.96,9.5-4.96,9.5l-1.03-.32Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m68.4,272.9c.49,5.46.88,21.44.88,21.44h-5.44s-.76-16.31-.76-16.31l-1.04-11.64,5.31.9c.08.15.67,1.42,1.05,5.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "72.25 267.15 70.28 267.26 70.18 267.26 67.38 267.26 67.59 267.15 72.25 267.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m76.59,266.19l.14,28.15h-2.51s.79-22.99-1.97-27.19l4.33-.96Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "m67.36,267.28s0-.02,0-.02h.03l-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m72.19,260.82l.17,7.23s-.39.41-2.2.41-2.82-1.18-2.82-1.18l.79-5.74,4.06-.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "66.98 287.61 66.98 286.54 67.29 286.54 67.29 287.93 64.17 287.93 64.17 287.6 66.98 287.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "65.15 271.38 67.13 267.52 67.39 267.67 65.54 271.3 67.7 273.13 65.55 274.55 68.47 280.06 68.2 280.22 65.14 274.44 67.18 273.09 65.15 271.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "73.24 268.21 75.24 271.7 74.55 272.64 75.68 273.33 74.6 279.37 74.3 279.3 75.33 273.5 74.1 272.74 74.87 271.68 72.98 268.37 73.24 268.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "75.81 286.54 75.81 287.61 76.59 287.61 76.59 287.93 75.5 287.93 75.5 286.54 75.81 286.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m77.33,321.09h-4.71l-.21-2.21h2.76c1.17,0,2.12.98,2.16,2.21Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "m72.42,253.79h-2.35v1.84c0,1.07.82,1.94,1.84,1.94h.52c.6,0,1.09-.51,1.09-1.15v-1.48c0-.63-.49-1.15-1.09-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "m71.36,254.51h-2.7v1.24c0,.66.34,1.24.84,1.55.02-.03.04-.05.07-.08.16-.17.38-.28.62-.28h2.08c.06-.14.1-.3.1-.46v-.91c0-.14-.02-.26-.07-.39-.15-.4-.51-.68-.95-.68Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "m72.74,255.19c-.93,0-1.69.8-1.69,1.79v2.25c0,.99.76,1.79,1.69,1.79s1.69-.8,1.69-1.79v-2.25c0-.99-.76-1.79-1.69-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m72.4,256.7h-4.59v8.16s1.73,1.73,4.21,1.43c1.23-.15,2.16-1.39,2.16-2.86v-4.7c0-.63-.57-2.02-1.78-2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "m69.36,264.84c0,1.04.8,1.88,1.78,1.88h1.27c.98,0,1.78-.84,1.78-1.88v-.75h-4.83v.75Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 72.79,
    cy: 264.1,
    rx: 0.85,
    ry: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m68.65,265.45h1.26c.54,0,.98-.46.98-1.04v-1.38h-2.24v2.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 67.29,
    y: 257.35,
    width: 1.41,
    height: 4.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 67.29,
    y: 258.87,
    width: 1.41,
    height: 2.43
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "72.73 261.79 72.76 262.67 72.41 262.67 72.41 262.99 73.06 262.99 73.03 261.78 72.73 261.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "m68.66,255.32c-.8.3-1.37,1.12-1.37,2.08v1.55h1.04c.54,0,.98-.47.98-1.05,0-.23.07-.43.19-.59.02-.03.04-.05.07-.08.16-.17.38-.28.62-.28h2.36v-1.75h-3.21c-.24,0-.46.04-.67.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m71.91,259.91h-.96c-.21,0-.39.08-.52.24-.19.22-.28.58-.24.98l.03.26c.04.45.37.79.77.79h.53c.38,0,.77-.32.93-.75l.09-.26c.12-.35.1-.71-.07-.96-.13-.19-.33-.3-.56-.3Zm.36,1.15l-.09.26c-.11.31-.39.55-.65.55h-.53c-.25,0-.45-.22-.48-.51l-.03-.26c-.03-.31.03-.59.17-.75.08-.09.18-.14.3-.14h.96c.14,0,.25.06.32.17.11.17.12.43.03.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m74.26,259.94h-.71c-.14,0-.26.06-.34.19-.17.22-.21.63-.11,1.03l.06.26c.1.43.38.75.66.75h.22c.26,0,.67-.3.7-.77l.02-.26c.02-.29.02-.8-.2-1.05-.08-.09-.18-.14-.3-.14Zm.26,1.17l-.02.26c-.02.33-.31.53-.46.53h-.22c-.14,0-.35-.21-.43-.55l-.06-.26c-.08-.32-.05-.65.07-.81.04-.06.09-.09.15-.09h.71s.09.02.12.06c.11.13.16.46.14.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m72.86,260.34c-.31,0-.53.18-.54.19l.16.19s.15-.13.37-.13c.17,0,.2.07.2.07l.23-.07s-.07-.24-.42-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m70.49,260.16h-3.47c-.07,0-.12.06-.12.13s.05.13.12.13h3.47c.07,0,.12-.06.12-.13s-.05-.13-.12-.13Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m67.58,260.27c-.39,0-.7.33-.7.74v1.58c0,.41.31.74.7.74h.71v-2.31c0-.41-.32-.74-.71-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "m70.89,263.8v.47h1.22c.42,0,.77-.36.77-.81v-.47h-1.23c-.42,0-.76.36-.76.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "m73.56,262.99h-.77v.6c0,.38.29.68.65.68h.76v-.6c0-.37-.29-.68-.64-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "m68.7,261.8h-.41v3.45s.96,1.47,2.61,1.47v-2.77h-.15c-1.13,0-2.04-.96-2.04-2.15Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m80.58,325.81l-.99-.02c-.45,0-.97,0-1.43.04l-3.02-.37h.07s.17-.22.17-.22h0l.67-.86-1.16-.07-1.45-.1.15-.04.37-.11s.09,0,.14,0c.12,0,.24,0,.36-.01,2.21-.07,4.13-.23,4.76-.41.38-.11.22-.21-.33-.29l.29-.08c.27-.08.34-.15.26-.21-.17-.13-1.04-.22-2.36-.22h-.13c-1.97,0-4.23.19-5.04.43-1.79.08-3.26.22-3.8.37-.62.18.2.34,1.91.41l-.57.17-2.58.09h0l-1.11.04-5.53,1.06-5.8.56h-.15c-.99-.03-2.31.05-2.95.18l-.2.04s-.03.02.04.02l1.73.04c.92.02,2.12-.05,2.8-.16l6.04-.52,1.53-.24h0l.1-.02c-1.48.87-2.04.97-2.04.97h0c-5.06.69-6.11,1.13-9.41,2.44h1.42c-.99.55-2.22,1.22-2.23,1.22h-1.19c-1.2,0-2.6.12-3.12.28h4.76,0,4.61c.52-.15-.03-.28-1.24-.28h-.86s2.94-.54,6.14-1.22h1.41c1.5-.39,2.71-.73,3.69-1.01,2.44-.72,3.34-1.15,3.19-1.42h0,0s4.31-1.08,4.31-1.08l-.08.43,4.17.41s.13.03.31.04l2.31.04c.3,0,.69-.02.86-.06l.57-.12c.27-.06.11-.11-.36-.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "45.88 288.21 41.5 293.01 39.79 291.91 43.8 286.71 45.88 288.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m37.35,293.71h0c.25-1.32,1.46-2.18,2.72-1.91l1.54.32c.09.02.15.11.13.2h0c-.25,1.32-1.46,2.18-2.72,1.91l-1.54-.32c-.09-.02-.15-.11-.13-.2Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 51.21,
    cy: 270.75,
    rx: 5.56,
    ry: 4.04
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "62.87 292.62 57.07 288.79 58.26 286.77 63.99 291.25 62.87 292.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "56.15 277.49 58.99 287.25 57.07 288.79 55.14 283.37 56.15 277.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m51.25,294.62v33.09h1.88s1.9-8.58,2.7-17.35c.56-6.1.58-12.29-.94-15.75h-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m53.99,327.71c1.2,0,2.18,1.12,2.18,2.49h-4.92v-2.49h2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m47.15,310.56c.11.71,3.02,17.15,3.02,17.15h1.56v-33.09h-3.71c-2.37,6.2-1.84,9.89-.86,15.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m48.98,327.71c-1.2,0-2.18,1.12-2.18,2.49h4.92v-2.49h-2.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 51.57,
    y: 310.37,
    width: 0.32,
    height: 17.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 51.56,
    y: 327.71,
    width: 0.33,
    height: 2.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m46.8,316.65h9.69c.16-3.54.23-6.57.22-9.18-.03-6.52-.58-10.38-1.67-12.85h-7.16c-2.72,6.2-2.24,10.24-1.08,22.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "45.71 277.14 48.76 279.2 45.88 288.21 43.8 286.71 45.71 277.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m55.04,294.62l.13,1.56-2.56-1.56-2.75,1.8-1.98-1.8s.28-1.08-1.82-11.61l-.36-5.87,3.19-1.09,3.71-.2,3.53,1.65-1.1,17.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "52.96 276.17 51.3 279.55 48.81 276.09 52.96 276.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m52.96,276.17s.12.7-1.36.7-2.65-.7-2.65-.7v-4.54h4.01v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m52.96,275.55v-2.84h-3.63s.64,2.56,3.63,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m48.17,267.38v2.42l.79.06v3.34s2.48,2.26,4.84,1.1c1.03-.51,1.66-1.63,1.66-2.83v-4.09c0-.7-.17-1.36-.47-1.93-.61-1.17-1.78-1.96-3.1-1.96h-.13c-1.97,0-3.58,1.74-3.58,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m48.17,267.38v2.57h1.74l.38-2.13,4.7-2.37c-.61-1.17-1.78-1.96-3.1-1.96h-.13c-1.97,0-3.58,1.74-3.58,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m48.76,268.37h0c.4,0,.72.32.72.72v2.24h-.72c-.39,0-.71-.32-.71-.71v-1.54c0-.39.32-.71.71-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m54.11,271.79v-.35c.22,0,.39-.19.39-.41v-.66h.33v.66c0,.42-.32.76-.72.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m52.75,273.19c-.73,0-1.08-.64-1.16-.99l.32-.08s.2.8.94.72l.03.35s-.1,0-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m62.57,291.99h0c-.05.38.2.73.56.79l2.31.36c.36.06.7-.21.75-.59l.13-.9c.08-.59-.3-1.14-.86-1.23l-.73-.11c-1.03-.16-1.99.59-2.15,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m48.95,275.95l.99,5.77s-1.19-.63-2.18-2.01c-.99-1.38-1.07-2.92-1.07-2.92l2.26-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m52.96,275.95l-.32,5.44s1.03-.47,1.61-2.01c.58-1.54.48-2.55.48-2.55l-1.78-.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "45.88 288.21 43.8 286.71 44.25 284.42 46.58 286.02 45.88 288.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "58.99 287.25 57.07 288.79 56.24 286.46 58.41 285.26 58.99 287.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m52.87,307.47h3.84c-.03-6.52-.58-10.38-1.67-12.85h-6.32s.04,5.86.04,8.38c0,3.83,1.35,4.47,4.11,4.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 47.46,
    y: 282.69,
    width: 2.02,
    height: 0.67,
    transform: "translate(96.94 566.04) rotate(180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m78.19,382.57c2.39-.7,2.52-1.28,2.52-1.28h0s-2.64-.14-2.64-.14h0l-1.48-.08.25-.07.5-.15c.52-.01,1.08-.03,1.68-.06l1.06-.31c.32-.01.63-.05.76-.08l.64-.19c.13-.04.04-.07-.18-.08l.17-.05.52-.15.53-.16,2.46-.18-.65-.21h-5.17l-5.59.23,1.8.16-.14.04-.4.12-.69.2c-.07,0-.15,0-.24,0-.43,0-.92.04-1.1.09l-.65.19c-.17.05.04.09.47.09h.26l-.3.09-.48.14-1.22.36-5.66.23h0s0,0,0,0h0s0,0,0,0h0s-3.83.58-6.23,1.28c-.11.03-.22.06-.33.1h-.5l-1.3.38h.63c-1.69.59-2.94,1.17-2.94,1.17-2.49.38-.18.51-.18.51l1.75-.51,3.99-1.17h.16l-1.97.7h-.37l-1.4.41h.72l-7.76,3.16h-.09c-1.31,0-2.79.12-3.31.28h10.76c.52-.15-.12-.28-1.42-.28h-.25l13.43-3.07h.88l1.78-.52h-.43l2.73-.68h.16l-3.99,1.17-1.75.51s3.18-.13,3.31-.51c0,0,2.72-.58,5.05-1.17h.63l1.3-.38h-.5c.12-.03.23-.07.34-.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m61.04,342.19c0,.62-.01,1.27-.03,1.93-.19,6.02-1.17,12.96-1.17,12.96h-1.57v-26.47h.91s1.85,5.23,1.85,11.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "m61.04,342.19c0,.62-.01,1.27-.03,1.93h-2.73v-13.52h.91s1.85,5.23,1.85,11.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 57.78,
    y: 343.08,
    width: 3.75,
    height: 3.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m58.27,357.08v4.63s2.74-1.16,1.57-4.63h-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m41.87,342.2c0,.62.01,1.27.03,1.93.19,6.02,1.17,12.96,1.17,12.96h1.57v-26.47h-.91s-1.85,5.23-1.85,11.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "m41.87,342.2c0,.62.01,1.27.03,1.93h2.73v-13.52h-.91s-1.85,5.23-1.85,11.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 41.38,
    y: 343.08,
    width: 3.75,
    height: 3.43,
    transform: "translate(86.51 689.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m44.64,357.08v4.63s-2.74-1.16-1.57-4.63h1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m55.45,319.91h0v3.36h0c.43,0,.78-.37.78-.83v-1.71c0-.46-.35-.83-.78-.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-210",
    points: "57.62 353.77 45.29 353.77 43.73 330.6 48.87 328.46 54.04 328.46 59.18 330.6 57.62 353.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "51.46 332.13 49.99 330.76 51.46 328.72 52.92 330.76 51.46 332.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "49.64 351.2 51.46 353.35 53.27 351.2 51.95 329.63 50.96 329.63 49.64 351.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "53.5 331.97 51.46 329.09 49.41 331.97 47.21 329.6 47.45 329.35 49.38 331.44 51.46 328.51 53.53 331.44 55.46 329.35 55.7 329.6 53.5 331.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m54.3,328.59s-.75.7-2.84.7-2.84-.7-2.84-.7v-4.54h5.69v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m54.3,327.89v-2.75h-4.7s.83,2.48,4.7,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m55.76,325.99c-4.02,2.12-7.15-.66-7.15-.66v-8.59h7.15v9.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 48.61,
    y: 317.1,
    width: 1.2,
    height: 4.25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "45.29 353.77 48.61 385.09 51.46 385.09 51.46 353.77 45.29 353.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "57.62 353.77 54.3 385.09 51.46 385.09 51.46 353.77 57.62 353.77"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 48.61,
    y: 316.74,
    width: 7.15,
    height: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m48.61,318.14s1.56,1.38,7.15,1.38v-1.38h-7.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m48.65,385.09h5.77c1.38,0,2.49,1.12,2.49,2.49h-10.76c0-1.38,1.12-2.49,2.49-2.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 48.92,
    y: 384.92,
    width: 5.22,
    height: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 51.29,
    y: 359.06,
    width: 0.33,
    height: 28.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m48.35,319.91h0c-.43,0-.78.37-.78.83v1.71c0,.46.35.83.78.83h.79v-2.52c0-.46-.35-.84-.79-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m55.65,324.28h-3.76s.52-1.16,1.88-1.16,1.88,1.16,1.88,1.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "54.53 323.13 53.78 323.13 53.78 322.78 54.14 322.78 53.86 320.86 54.19 320.81 54.53 323.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m52.06,325.58c-.73,0-1.08-.64-1.16-1l.32-.08s.19.8.94.72l.03.35s-.1,0-.14,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "48.61 316.74 46.26 315.28 51.06 313.19 56.23 313.19 57.62 315.13 55.76 316.74 48.61 316.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "m54.3,314.03h-1.04c0,1.85,1.04,2.37,1.04,2.37,0,0,1.04-.52,1.04-2.37h-1.04Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 49.72,
    y: 358.88,
    width: 3.63,
    height: 0.35
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "58.44 344.13 58.1 344.11 58.6 336.7 58.94 336.72 58.44 344.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "44.49 344.13 43.99 336.72 44.32 336.7 44.82 344.11 44.49 344.13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 47.35,
    y: 352.01,
    width: 2.29,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 44.86,
    y: 352.85,
    width: 1.89,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 56.17,
    y: 352.63,
    width: 1.95,
    height: 4.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 47.5,
    y: 354.63,
    width: 1.89,
    height: 0.35
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "57.96 355.19 56.56 355.19 56.56 352.85 56.9 352.85 56.9 354.84 57.96 354.84 57.96 355.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "46.55 354.98 44.97 354.98 44.97 354.63 46.22 354.63 46.22 353.01 46.55 353.01 46.55 354.98"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 49.64,
    y: 355.19,
    width: 6.53,
    height: 0.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-221",
    cx: 48.5,
    cy: 354.02,
    rx: 0.21,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m45.29,354.23c0,.12-.05.22-.1.22s-.1-.1-.1-.22.05-.22.1-.22.1.1.1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m57.88,354.12c0,.12-.05.22-.1.22s-.1-.1-.1-.22.05-.22.1-.22.1.1.1.22Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "57.73 340.24 53.71 340.24 53.71 338.74 54.04 338.74 54.04 339.89 57.4 339.89 57.4 338.74 57.73 338.74 57.73 340.24"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 54.14,
    y: 340.06,
    width: 0.33,
    height: 1.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 56.96,
    y: 340.06,
    width: 0.33,
    height: 1.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "49.34 340.24 45.32 340.24 45.32 338.74 45.65 338.74 45.65 339.89 49.01 339.89 49.01 338.74 49.34 338.74 49.34 340.24"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 45.76,
    y: 340.06,
    width: 0.33,
    height: 1.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 48.58,
    y: 340.06,
    width: 0.33,
    height: 1.32
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 58.34,
    y: 342.9,
    width: 2.33,
    height: 0.35
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "58.45 346.63 58.23 346.37 60.56 344.14 60.78 344.4 58.45 346.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "41.69 346.16 41.51 345.87 43.62 344.38 43.81 344.68 41.69 346.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 42.38,
    y: 342.91,
    width: 2.01,
    height: 0.35
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "58.73 339.34 58.46 339.13 59.37 337.81 59.64 338.02 58.73 339.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "44.3 340.57 43.02 339.72 43.2 339.42 44.48 340.27 44.3 340.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "m56.73,334.86c-.14-.45-.6-.77-1.15-.77s-1.02.33-1.15.77h-.49c0,2.41,1.64,3.08,1.64,3.08,0,0,1.64-.67,1.64-3.08h-.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 50.29,
    y: 353.77,
    width: 2.33,
    height: 1.98
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "56.05 329.3 55.84 330.6 58.77 331.41 59.18 330.6 56.05 329.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "46.86 329.3 47.07 330.61 44.14 331.41 43.73 330.61 46.86 329.3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m95.41,375.65l-3.45-.22,1.71-.5h0l.44-.13h.26c.43,0,.92-.04,1.1-.09l.65-.19c.17-.05-.04-.09-.47-.09-.09,0-.19,0-.28,0l.69-.2.4-.12.14-.04,1.88-.11s-2.48-.55-9.39-.2l.35.31-.41.12-.12.04-.52.15s0,0,.01,0l-.17.05c-.33.01-.64.05-.77.08l-.64.19c-.13.04-.04.07.21.08l-1.11.33c.39.03.79.05,1.19.07l-.55.16-.26.08-4.76.22h-.04c-3.25.33-6.39,1.28-5.54,1.69h.29s-3.38,1.08-3.38,1.08h0l-10.72,3.25h-.01l-.07.02c-1.31,0-2.79.12-3.31.28h4.92l1.4-.28h0l11.41-2.52-4.81,2.63c-.08.01-.15.03-.2.04l-.43.13h2.55l.43-.13s.02,0,.03-.01h0s11.54-3.4,11.54-3.4l5.01-1.41c.67-.11,1.47-.25,2.4-.42,3.94-.75,2.42-.93,2.42-.93Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "59.92 324.97 64.23 322.82 69.4 322.82 73.88 324.97 73.49 349.93 60.74 349.93 59.92 324.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "64.61 335.79 61.33 329.08 63.06 328.57 61.18 327.3 64.59 322.15 64.86 322.35 61.65 327.2 63.86 328.69 61.81 329.3 64.72 335.23 70.68 329.94 67.98 328.82 71.25 327.05 69.13 323.02 69.42 322.85 71.71 327.2 68.79 328.77 71.32 329.83 64.61 335.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "64.76 349.14 63.4 348.19 63.2 336.55 64.56 335.37 64.77 335.65 63.54 336.71 63.73 348 64.95 348.85 64.76 349.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "69.65 322.91 66.4 330.94 64.72 335.1 64.48 331.18 63.98 322.95 66.26 322.94 66.38 322.94 69.65 322.91"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "65.97 326.26 64.66 324.71 66.33 322.86 67.57 325.06 65.97 326.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "66.73 323.82 66.64 325.75 66.4 330.94 64.72 335.1 64.48 331.18 65.43 325.61 65.75 323.71 66.73 323.82"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m63.97,322.96s.75.7,2.84.7,2.84-.7,2.84-.7v-4.54h-5.69v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m63.97,322.25v-2.75h4.7s-.83,2.48-4.7,2.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "73.49 349.93 73.58 380.7 71.11 380.51 65.74 349.93 73.49 349.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "60.74 349.93 61.11 379.45 64.12 379.45 67.74 349.93 60.74 349.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m61.1,379.45h3.01l-.46,2.49h-4.92c0-1.38,1.06-2.49,2.36-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m72.3,379.45h0c.7,0,1.27.6,1.27,1.34v1.15h-2.55v-1.15c0-.74.57-1.34,1.27-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m73.21,337.62l-.29-.66c-.63-1.45-2.26-2.08-3.63-1.41l-.15.07.22.5c.67,1.54,2.4,2.21,3.85,1.5h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "69.3 338.09 70.24 337.49 69.14 335.59 68.2 336.19 69.3 338.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m60.26,337.95l.16-.71c.36-1.55,1.84-2.5,3.31-2.12l.16.04-.12.54c-.38,1.64-1.95,2.65-3.51,2.25h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "60.18 337.25 68.39 336.2 69.22 338.6 60.15 340.19 60.18 337.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "62.71 337.14 63.78 337.41 64.28 335.26 63.21 334.98 62.71 337.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m62.82,313.9h0v3.36h0c-.43,0-.78-.37-.78-.83v-1.71c0-.46.35-.83.78-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m62.55,320.17c4.34,2.5,7.11-1.53,7.11-1.53v-7.92h-7.15l.04,9.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 68.46,
    y: 311.09,
    width: 1.2,
    height: 4.25,
    transform: "translate(138.12 626.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 62.51,
    y: 310.73,
    width: 7.15,
    height: 1.4,
    transform: "translate(132.17 622.86) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m69.66,312.13s-1.2,1.38-7.15,1.38v-1.38h7.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m69.92,313.9h0c.43,0,.78.37.78.83v1.71c0,.46-.35.83-.78.83h-.79v-2.52c0-.46.35-.84.79-.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "64.5 317.12 63.76 317.12 63.87 314.82 64.21 314.83 64.11 316.77 64.5 316.77 64.5 317.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m69.66,310.73l1.5-1.01s-4.34-4.93-10.08-1.83l1.43,2.85h7.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 62.51,
    y: 311.81,
    width: 5.88,
    height: 0.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "m64.72,309.12h-.47c-.06-.28-.23-.48-.44-.48s-.38.2-.44.48h-.48v.42h.48c.06.26.23.45.44.45s.37-.19.44-.45h.48v-.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 61.1,
    y: 379.28,
    width: 2.6,
    height: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m71.41,380.11l-.31-.13s.28-.7,1.21-.7,1.19.67,1.21.7l-.31.13s-.2-.48-.9-.48-.89.46-.9.48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 64.18,
    y: 318.62,
    width: 1.35,
    height: 0.35
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "61.23 352.71 61 352.45 64.84 348.78 69.97 352.13 72.7 352.13 72.7 352.48 69.87 352.48 64.87 349.21 61.23 352.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m68.88,339.59l5-14.63s2.12,1.6.75,8.4c-1.19,5.9-2.39,7.11-2.39,7.11l-3.37-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m60.84,324.94h-.91c-2.12,3-2.03,11.54.22,15.25l.69-.35,1.67-.61-.66-4.17-1.01-10.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m72.25,340.47c-6.94-1.78-8.62-2.41-8.62-2.41l.65-2.8,8.71,1.99-.74,3.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "64.85 338.45 64.52 338.36 65.21 335.47 65.53 335.55 64.85 338.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "65.62 338.7 65.3 338.61 65.98 335.72 66.31 335.8 65.62 338.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "66.38 338.91 66.06 338.82 66.74 335.92 67.06 336.01 66.38 338.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "70.03 336.75 64.24 335.43 64.31 335.09 69.81 336.35 71.45 331.55 71.77 331.67 70.03 336.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "72.34 340.68 63.59 338.23 63.67 337.89 72.16 340.27 73.21 338.01 73.51 338.17 72.34 340.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "60.73 340.27 60.67 339.92 66.7 338.76 66.76 339.1 60.73 340.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "62.09 337.02 61.01 331.8 61.33 331.73 62.41 336.95 62.09 337.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "m65.19,340.51c0,.26-.2.48-.45.48s-.45-.21-.45-.48.2-.48.45-.48.45.21.45.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "m65.31,343.02c0,.26-.2.48-.45.48s-.45-.21-.45-.48.2-.48.45-.48.45.21.45.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "m65.43,345.75c0,.26-.2.48-.45.48s-.45-.21-.45-.48.2-.48.45-.48.45.21.45.48Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "72.14 379.47 70.07 354.1 70.4 354.07 72.47 379.44 72.14 379.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "61.87 379.46 61.54 379.45 62.27 354.32 62.6 354.33 61.87 379.46"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m84.02,436.01h-.12s-.95-.88-.95-.88c0-.03-.08-.05-.19-.07,0,0,0-.01-.02-.02l-.38-.26-.95-.68c-.06-.04-.27-.07-.57-.09-.1,0-.21-.02-.33-.02l-.51-.02-2.11-.1h-.23s1.66-.5,1.66-.5h0,.03s.26,0,.26,0c.43,0,.92-.04,1.09-.09l.64-.19c.17-.05-.04-.09-.47-.09-.03,0-.07,0-.1,0l.48-.14c.06-.02.1-.03.14-.05.2-.02.37-.05.46-.08h.05s-.24-.01-.24-.01c.38-.04.62-.09.62-.14h0s-.9.02-.9.02c-.21-.07-.63-.12-1.22-.14.14-.06.07-.12-.24-.15l-1.74-.21-.41.04c-.5.05-.83.11-.94.17l-1.34-.06h-.07c-.56.1-.59.2-.14.26h-.71l-.21.06c-.21.06.03.11.55.12,0,0,0,0,0,0-.38.05-.68.11-.89.17l-.82.24-2.05.57s.14.06,1.27.09l-.36.11-1.51.06h0l-1.24.05c-.53.02-1.04.06-1.48.1-.15.01-.3.03-.44.04l-5.6.68-2.07.25s-.04,0-.06,0l-8.3.84-2.02.03c-.54,0-1.1.06-1.24.12l-.44.18,3.44-.05c.54,0,1.1-.06,1.24-.12h.04s8.63-.66,8.63-.66c.22-.01.42-.03.6-.05.21-.02.41-.03.59-.06l1.64-.2-6.7,1.99h0l-3.48,1.26h.98l-4.64,1.7h2.06s6.92-1.59,6.92-1.59h0l.18-.04.29-.07h.03l3.23-.75h0l-.93.76h.85l-.06.11h0l-.79,1.64c-.26.03-.48.06-.6.09l-.38.11h2.57l.38-.11c.08-.02.11-.05.09-.07l4-1.78h.08l2.91-1.27h.83s6.24-1.84,6.24-1.84h0l.52-.15.29.2s.09.04.18.05c0,0,.01.02.03.03l2.98.81-.99.23c-.26.06-.08.11.42.12l1.48.02,1.68-.38c.26-.06.08-.11-.42-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m45.63,440.28h5.19l1.15-.27h-3.04c-1.29,0-2.75.12-3.3.27Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m42.35,395.63c-.92-.55-1.24-1.79-.71-2.76l1.28-2.36,3.28-6.16c.52-.97,1.7-1.31,2.61-.75.69.42,1.04,1.22.95,2-.03.26-.11.52-.24.76l-3.28,6.16-1.28,2.36c-.53.97-1.7,1.31-2.61.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m46.24,392.52l-3.33-2,3.28-6.16c.52-.97,1.7-1.31,2.61-.75.69.42,1.04,1.22.95,2-.03.26-.11.52-.24.76l-3.28,6.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-236",
    points: "50.76 406.78 61.2 438.98 63.2 438.98 58.99 406.33 50.76 406.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "61.09 422.58 56.22 423.61 55.88 422.58 61.09 422.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-236",
    points: "49 437.85 51.06 437.85 54.35 406.17 46.6 406.18 49 437.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "52.66 422.48 52.55 423.47 47.84 422.48 52.66 422.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "m62.02,437.91c-.71,0-1.28.61-1.28,1.35v1.01h2.57v-1.01c0-.75-.57-1.35-1.28-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m46.03,411.07h14.53s-.07-25.3-.07-25.3c.08-1.09-.54-2.09-1.51-2.46l-.6-.22-2.45-.91-.32-.12s-5.59.04-5.56,0l-2.42,1c-1.05.43-1.74,1.5-1.73,2.69l.13,25.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "56.69 392.81 50.76 398.32 49.23 398.78 56.69 392.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "54.31 393.67 51.84 395.9 50.7 396.05 54.31 393.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "58.81 389.76 60.51 394.42 60.56 390.86 58.81 389.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "m45.63,440.28h5.19l.23-2.43h-3.04c-1.29,0-2.34,1.08-2.38,2.43Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m50.01,382.21s.74.7,2.82.7,2.82-.7,2.82-.7v-4.51h-5.65v4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m55.82,373.02v1.62h-.16v4.33s-1.92,1.7-4.68,1.41c-1.38-.15-2.42-1.38-2.42-2.83v-4.52c0-.55.11-1.07.31-1.53.18-.42.43-.8.73-1.11.64-.68,1.53-1.1,2.51-1.1h.16c1.96,0,3.55,1.68,3.55,3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m48.86,371.49c.18-.42.43-.8.73-1.11.64-.68,1.53-1.1,2.51-1.1h.16c1.96,0,3.55,1.68,3.55,3.75v1.62h-.16v.84h-1.19v-1.9h-.43c-.53,0-.97-.46-.97-1.02h0c0-.59-.45-1.07-1-1.07-1.24,0-3.21,0-3.21,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m55.91,374.27h0c.43,0,.78.37.78.82v1.7c0,.45-.35.82-.78.82h-.79v-2.51c0-.46.35-.83.79-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m49.49,375.87v.22c-.01.2.06.39.19.54.13.15.31.23.5.23v-.35c-.1,0-.2-.04-.27-.12-.07-.08-.11-.18-.1-.28v-.23s-.32,0-.32,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m48.75,377.53h2.77s-.14,1.38-1.45,1.38-1.32-1.38-1.32-1.38Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m50.63,369.68l2.11,1.65h0c.79-1.12.57-2.7-.5-3.53l-2.11-1.65h0c-.79,1.12-.57,2.7.5,3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m49.29,370.22l3.65,1.2h0c.33-1.11-.26-2.3-1.31-2.64l-3.65-1.2h0c-.33,1.11.26,2.3,1.31,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m47.92,369.89h2.54c.89,0,1.61.72,1.61,1.61h-4.15v-1.61h0Z",
    transform: "translate(99.99 741.38) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m55.53,371.76h.46v1.38h-1.84c0-.76.62-1.38,1.38-1.38Z",
    transform: "translate(110.14 744.91) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m54.65,372.43l.49-.21c.67-.29.99-1.1.72-1.81h0s-1.7.73-1.7.73l.5,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m64.11,395.63c.92-.55,1.24-1.79.71-2.76l-1.28-2.36-3.28-6.16c-.52-.97-1.7-1.31-2.61-.75-.69.42-1.04,1.22-.95,2,.03.26.11.52.24.76l3.28,6.16,1.28,2.36c.53.97,1.7,1.31,2.61.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m60.22,392.52l3.33-2-3.28-6.16c-.52-.97-1.7-1.31-2.61-.75-.69.42-1.04,1.22-.95,2,.03.26.11.52.24.76l3.28,6.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m50.04,382.06l-1.34.55s-.25,4.06,3.64,4.09c3.89.03,5.48-3.8,5.48-3.8l-2.21-.84h-5.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "53.51 414.28 52.69 422.48 46.86 422.48 46.03 411.07 52.69 411.06 53.51 414.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "52.24 411.07 55.03 422.58 61.17 422.58 59.73 411.06 52.24 411.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "m58.58,413.42h.99v-.35h-.99c-.78,0-1.41-.67-1.41-1.48v-.52h-.33v.52c0,1.01.78,1.84,1.74,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "m51.45,411.06h2.04v4.66h0c-1.13,0-2.04-.92-2.04-2.04v-2.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m67.84,403.06l1.76-.81-4.25-8.52c-.42-1.02-1.55-1.49-2.52-1.04h0c-1.07.49-1.47,1.87-.86,2.91l5.86,7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m68.48,406.06l1.41.17.35-3.31c.07-.63-.36-1.19-.95-1.26h0c-.78-.09-1.48.5-1.57,1.32l-.2,1.83c-.07.63.36,1.19.95,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m36.1,400.53l1.15,1.62,6.9-6.3c.85-.67,1.02-1.93.39-2.82h0c-.7-.98-2.06-1.09-2.88-.22l-5.55,7.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m33.47,401.87l.17,1.49,3.14-.39c.59-.07,1.02-.64.95-1.27h0c-.09-.82-.8-1.41-1.58-1.31l-1.73.22c-.59.07-1.02.64-.95,1.27Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m52.15,378.17h0s-1.03,0-1.03,0c-.75,0-1.35-.58-1.35-1.3h1.04c.74,0,1.34.58,1.34,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m49.64,376.89h.6s0,.09,0,.09c0,.66-.56,1.2-1.25,1.2h-.5s0-.19,0-.19c0-.61.52-1.11,1.15-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m48.99,377.89c.05.07.22.91,1.18.91s1.11-.89,1.11-.89c0,0,1.88.23,2.54-1.37s.7-3.09.7-3.09l.74,1.33v4.08s-.64,2.37-4.14,2.37c-2.14,0-2.7-.88-2.7-.88l.11-5.15s.01,2.17.44,2.7Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "59.73 411.06 59.9 412.46 46.03 411.07 59.73 411.06"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m95.07,400.64h0s0,0,0,0l-1.29-.12.12-.03.17-.05.17-.05.17-.05.17-.05.17-.05.17-.05.17-.05.17-.05.17-.05.17-.05.13-.04s.03,0,.04-.01c.05-.02.09-.03.12-.05,0,0,0,0,0,0,.02-.02.04-.03.04-.05,0-.02,0-.03-.03-.05-.01,0-.02-.01-.04-.02-.03-.01-.06-.02-.1-.03-.04,0-.08-.02-.13-.03-.04,0-.09-.01-.14-.02l.4-.12c.08,0,.15,0,.23,0,.15,0,.3-.01.44-.03.03,0,.06,0,.09,0,.14-.01.26-.03.36-.04.08-.01.16-.03.21-.04,0,0,0,0-.02,0l.05-.02h0s.17-.05.17-.05l.17-.05.09-.03s.05-.02.07-.02c.05-.02.07-.03.07-.05,0-.01-.02-.03-.07-.04-.01,0-.04,0-.06-.01-.06,0-.14-.02-.24-.02-.08,0-.19,0-.3,0,.05,0,.08-.01.11-.02.07-.02-.01-.04-.18-.04.16,0,.35-.02.42-.04.07-.02-.01-.04-.18-.04h-.22s0,0,0-.01c0,0,0-.02-.03-.03-.03-.02-.08-.03-.15-.04-.01,0-.02,0-.03,0-.07-.01-.15-.02-.25-.03-.05,0-.11-.01-.16-.02-.05,0-.11,0-.16-.01-.11,0-.22-.01-.35-.02-.12,0-.24-.01-.37-.01h0s0,0,0,0h-.08s0,0,0,0c-.1,0-.2,0-.31,0-.13,0-.26,0-.4,0-.13,0-.27,0-.41,0h0c-.14,0-.28,0-.42,0-.15,0-.29,0-.44,0-.13,0-.26,0-.38,0-.03,0-.05,0-.07,0-.16,0-.32,0-.47.01-.17,0-.33.01-.49.02-.09,0-.18,0-.27.01-.08,0-.16,0-.25.01-.18.01-.35.02-.5.04-.02,0-.04,0-.05,0-.17.01-.33.03-.46.04-.07,0-.14.02-.2.02-.04,0-.08.01-.11.02h-.44c-.16,0-.35.02-.42.04-.07.02.01.04.18.04-.16,0-.35.02-.42.04s.01.04.18.04h.06c-.07,0-.15,0-.23.01-.12.01-.25.03-.38.05h-.03s0,0,0,0c-.08.01-.17.03-.25.04-.08.02-.16.03-.25.05-.07.02-.15.03-.22.05-.07.02-.14.03-.21.05-.07.02-.13.03-.2.05-.07.02-.13.03-.19.05-.06.02-.13.03-.18.05-.03,0-.06.02-.09.03h0s-.09.02-.15.02c0,0,0,0,0,0-.1.02-.21.03-.33.05-.11.02-.23.03-.36.05-.04,0-.07,0-.11.01-.09.01-.18.02-.27.03-.13.02-.27.03-.41.05-.01,0-.02,0-.03,0-.09.01-.19.02-.3.03-.03,0-.07,0-.1.01-.11.01-.21.02-.31.04-.04,0-.07,0-.11.01-.13.02-.25.03-.36.05-.12.02-.22.03-.33.05,0,0,0,0,0,0-.11.02-.21.03-.3.05-.1.02-.19.03-.28.05-.09.02-.17.03-.25.05-.08.02-.16.03-.23.05h-.03l-.08.02s-.07.02-.11.02c-.07.02-.14.03-.2.05-.07.02-.13.03-.19.05-.06.02-.12.03-.17.05-.06.02-.11.03-.16.05-.05.02-.1.03-.14.05-.05.02-.09.03-.13.05h0s-.07.03-.1.04l-.69.03h0c-.27.04-4.09.56-6.23,1.18-.22.06-.43.13-.63.2-1.87.61-3.95,1.32-3.95,1.32h2.48s2.25-.64,2.25-.64l-4.64,1.48-7,2.03h.03c-.05,0-.09.02-.13.03l-.35.1h2.35l.35-.1s.08-.03.09-.04l9.41-1.92h.41s.3-.09.81-.25l2.03-.41-5.88,2.47h1.76s0,0,0,0h-1.76s-.63.25-.63.25h4.74c.43-.14-.15-.25-1.33-.25h-.71,0s.7,0,.7,0l6.39-1.81h1.38l6.3-1.88h1.28c.15.02.38.03.68.03h.76c.65,0,1.37-.06,1.7-.13h4.88l2.78-.81h-7.83l1.69-.87Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "m69.22,345.63v9.57h4.63v-6.7s0-.07,0-.11c0-.15-.02-.3-.05-.45,0,0,0-.02,0-.03-.03-.14-.07-.28-.11-.42-.05-.15-.12-.3-.2-.44-.03-.06-.07-.12-.11-.18-.06-.09-.13-.18-.2-.27-.07-.09-.15-.17-.23-.24-.08-.07-.16-.14-.24-.2-.06-.04-.12-.09-.18-.13-.13-.09-.28-.16-.42-.22-.1-.04-.2-.07-.3-.1-.04-.01-.08-.02-.13-.03-.14-.03-.28-.05-.42-.06-.04,0-.09,0-.14,0h-1.91Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m72.95,346.61v.45h.42v-.18c-.06-.09-.13-.18-.2-.27h-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m72.53,346.16v.44h.42v-.24c-.08-.07-.16-.14-.24-.2h-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m73.79,347.91v.03h0s0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m73.37,347.05v.44h.31c-.05-.15-.12-.3-.2-.44h-.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.95,
    y: 347.5,
    width: 0.42,
    height: 0.44,
    transform: "translate(146.32 695.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.53,
    y: 347.05,
    width: 0.42,
    height: 0.44,
    transform: "translate(145.47 694.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.1,
    y: 347.5,
    width: 0.42,
    height: 0.44,
    transform: "translate(144.63 695.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m73.79,348.39v.44h.06v-.33s0-.07,0-.11h-.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 73.37,
    y: 347.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(147.16 696.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.95,
    y: 348.39,
    width: 0.42,
    height: 0.44,
    transform: "translate(146.32 697.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.53,
    y: 347.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(145.47 696.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.1,
    y: 348.39,
    width: 0.42,
    height: 0.44,
    transform: "translate(144.63 697.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 73.79,
    y: 349.28,
    width: 0.06,
    height: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 73.37,
    y: 348.83,
    width: 0.42,
    height: 0.44,
    transform: "translate(147.16 698.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.95,
    y: 349.28,
    width: 0.42,
    height: 0.44,
    transform: "translate(146.32 699) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.53,
    y: 348.83,
    width: 0.42,
    height: 0.44,
    transform: "translate(145.47 698.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.1,
    y: 349.28,
    width: 0.42,
    height: 0.44,
    transform: "translate(144.63 699) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 71.26,
    y: 349.28,
    width: 0.42,
    height: 0.44,
    transform: "translate(142.94 699) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 73.79,
    y: 350.17,
    width: 0.06,
    height: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 73.37,
    y: 349.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(147.16 699.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.95,
    y: 350.17,
    width: 0.42,
    height: 0.44,
    transform: "translate(146.32 700.78) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.53,
    y: 349.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(145.47 699.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.1,
    y: 350.17,
    width: 0.42,
    height: 0.44,
    transform: "translate(144.63 700.78) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 71.68,
    y: 349.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(143.79 699.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 71.26,
    y: 350.17,
    width: 0.42,
    height: 0.44,
    transform: "translate(142.94 700.78) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 73.79,
    y: 351.06,
    width: 0.06,
    height: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 73.37,
    y: 350.61,
    width: 0.42,
    height: 0.44,
    transform: "translate(147.16 701.67) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.95,
    y: 351.06,
    width: 0.42,
    height: 0.44,
    transform: "translate(146.32 702.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.53,
    y: 350.61,
    width: 0.42,
    height: 0.44,
    transform: "translate(145.47 701.67) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.1,
    y: 351.06,
    width: 0.42,
    height: 0.44,
    transform: "translate(144.63 702.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 71.68,
    y: 350.61,
    width: 0.42,
    height: 0.44,
    transform: "translate(143.79 701.67) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 71.26,
    y: 351.06,
    width: 0.42,
    height: 0.44,
    transform: "translate(142.94 702.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 70.84,
    y: 350.61,
    width: 0.42,
    height: 0.44,
    transform: "translate(142.1 701.67) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 70.42,
    y: 351.06,
    width: 0.42,
    height: 0.44,
    transform: "translate(141.26 702.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 73.79,
    y: 351.94,
    width: 0.06,
    height: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 73.37,
    y: 351.5,
    width: 0.42,
    height: 0.44,
    transform: "translate(147.16 703.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.95,
    y: 351.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(146.32 704.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.53,
    y: 351.5,
    width: 0.42,
    height: 0.44,
    transform: "translate(145.47 703.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.1,
    y: 351.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(144.63 704.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 71.68,
    y: 351.5,
    width: 0.42,
    height: 0.44,
    transform: "translate(143.79 703.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 71.26,
    y: 351.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(142.94 704.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 70.84,
    y: 351.5,
    width: 0.42,
    height: 0.44,
    transform: "translate(142.1 703.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 70.42,
    y: 351.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(141.26 704.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 73.79,
    y: 352.83,
    width: 0.06,
    height: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 73.37,
    y: 352.39,
    width: 0.42,
    height: 0.44,
    transform: "translate(147.16 705.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.95,
    y: 352.83,
    width: 0.42,
    height: 0.44,
    transform: "translate(146.32 706.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.53,
    y: 352.39,
    width: 0.42,
    height: 0.44,
    transform: "translate(145.47 705.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.1,
    y: 352.83,
    width: 0.42,
    height: 0.44,
    transform: "translate(144.63 706.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 71.68,
    y: 352.39,
    width: 0.42,
    height: 0.44,
    transform: "translate(143.79 705.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 71.26,
    y: 352.83,
    width: 0.42,
    height: 0.44,
    transform: "translate(142.94 706.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 70.84,
    y: 352.39,
    width: 0.42,
    height: 0.44,
    transform: "translate(142.1 705.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 70.42,
    y: 352.83,
    width: 0.42,
    height: 0.44,
    transform: "translate(141.26 706.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 73.79,
    y: 353.72,
    width: 0.06,
    height: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 73.37,
    y: 353.28,
    width: 0.42,
    height: 0.44,
    transform: "translate(147.16 707) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.95,
    y: 353.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(146.32 707.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.53,
    y: 353.28,
    width: 0.42,
    height: 0.44,
    transform: "translate(145.47 707) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.1,
    y: 353.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(144.63 707.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 71.68,
    y: 353.28,
    width: 0.42,
    height: 0.44,
    transform: "translate(143.79 707) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 71.26,
    y: 353.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(142.94 707.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 70.84,
    y: 353.28,
    width: 0.42,
    height: 0.44,
    transform: "translate(142.1 707) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 70.42,
    y: 353.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(141.26 707.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 73.37,
    y: 354.17,
    width: 0.42,
    height: 0.44,
    transform: "translate(147.16 708.78) rotate(180)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m61.91,352.39c0,.15,0,.3,0,.44,0,.15,0,.3.01.44,0,.15.01.3.02.45.01.15.02.3.04.44h0c.01.16.03.31.05.45.02.16.04.31.06.45.02.16.05.31.07.44.03.18.06.33.09.44.04.21.07.33.07.33l.08-.02h0l.42-.1.43-.1.42-.1h.03s.39-.1.39-.1l.42-.1.42-.1.42-.1.23-.05.19-.04.42-.1.22-.05.2-.05.26-.06v-.14s-.03-.45-.03-.45l-.02-.44-.02-.44-.02-.45-.02-.44-.02-.44-.02-.45-.02-.44-.02-.44-.02-.45-.02-.44v-.15s0,4.16,0,4.16h-.2v-6.67h.08l-.02-.44h-.05v-.1s.03-.01.05-.02v-.14s-.16-.18-.16-.18l-.11-.13-.26-.31-.16-.2-.2-.25-.22-.26-.15-.18-.27-.32-.1-.12-.32-.39-.05-.05-.1-.12s0,.04,0,.12c0,.09-.02.24-.05.44-.02.13-.05.28-.1.44-.02.07-.04.15-.06.23h0c-.02.07-.04.14-.07.21,0,0,0,0,0,0-.05.14-.1.29-.16.44-.05.14-.12.29-.19.44-.02.04-.04.09-.06.13-.05.1-.1.2-.16.31-.07.14-.16.29-.25.44,0,.01-.01.02-.02.04-.06.1-.12.2-.18.3-.02.04-.04.07-.06.11-.06.11-.13.22-.18.33-.02.04-.04.08-.06.12-.07.15-.14.29-.2.44-.06.14-.11.29-.16.44,0,0,0,0,0,0-.05.15-.09.3-.13.45-.04.15-.08.29-.11.44-.03.15-.06.3-.09.44-.03.15-.05.3-.07.45-.01.07-.02.14-.03.21,0,.08-.02.16-.02.23-.01.15-.03.3-.03.44,0,.15-.01.3-.02.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "m62.32,355.06c0,.27.01.42.01.42v.03c0,.15.01.3.03.44,0,.1.02.19.04.29,0,0,0,.01,0,.02,0,.05.02.09.03.14.39,1.85,1.96,3.23,3.83,3.23h.15v-12.67s0,0,0,0t0,0s0,0,0,0c0,0,0,0,0,0-.06.03-.12.06-.18.09,0,0-.01,0-.01,0-.15.07-.29.15-.42.24-.1.06-.2.13-.3.2-.04.03-.08.05-.12.08-.15.11-.29.22-.42.34,0,0-.01.01-.02.02-.14.13-.28.26-.4.4-.01.02-.03.03-.04.05-.13.14-.25.29-.37.44,0,0,0,0,0,.01-.11.14-.21.29-.3.43-.04.07-.08.13-.12.2-.05.08-.1.16-.14.25-.08.15-.16.29-.23.44-.02.04-.04.09-.06.13-.05.11-.09.21-.13.32-.06.15-.12.3-.17.45-.04.13-.08.25-.12.37,0,.02-.01.05-.02.07-.04.15-.08.3-.12.44-.04.15-.07.3-.1.45-.03.15-.06.3-.08.44-.03.15-.05.3-.07.44-.01.1-.03.2-.04.29,0,.05-.01.11-.02.16-.01.16-.03.31-.04.44-.01.16-.02.31-.02.44,0,.17,0,.32,0,.45Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m66.22,347.05h.2v-.1s0,0,0,0t0,0s0,0,0,0c0,0,0,0,0,0-.06.03-.12.06-.18.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 66.2,
    y: 347.5,
    width: 0.22,
    height: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m65.78,347.3v.2h.42v-.44c-.15.07-.29.15-.42.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m65.36,347.58v.36h.42v-.44h-.3s-.08.05-.12.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 66.2,
    y: 348.39,
    width: 0.22,
    height: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 65.78,
    y: 347.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.98 696.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 65.36,
    y: 348.39,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.14 697.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 64.94,
    y: 347.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(130.29 696.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 64.51,
    y: 348.39,
    width: 0.42,
    height: 0.44,
    transform: "translate(129.45 697.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 66.2,
    y: 349.28,
    width: 0.22,
    height: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 65.78,
    y: 348.83,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.98 698.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 65.36,
    y: 349.28,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.14 699) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 64.94,
    y: 348.83,
    width: 0.42,
    height: 0.44,
    transform: "translate(130.29 698.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 64.51,
    y: 349.28,
    width: 0.42,
    height: 0.44,
    transform: "translate(129.45 699) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 64.09,
    y: 348.83,
    width: 0.42,
    height: 0.44,
    transform: "translate(128.61 698.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m63.67,349.48v.25h.42v-.45h-.3c-.04.07-.08.13-.12.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 66.2,
    y: 350.17,
    width: 0.22,
    height: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 65.78,
    y: 349.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.98 699.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 65.36,
    y: 350.17,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.14 700.78) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 64.94,
    y: 349.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(130.29 699.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 64.51,
    y: 350.17,
    width: 0.42,
    height: 0.44,
    transform: "translate(129.45 700.78) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 64.09,
    y: 349.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(128.61 699.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 63.67,
    y: 350.17,
    width: 0.42,
    height: 0.44,
    transform: "translate(127.76 700.78) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m63.31,350.17h.36v-.44h-.14c-.08.15-.16.29-.23.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m63.12,350.61h.13v-.32c-.05.11-.09.21-.13.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 66.2,
    y: 351.06,
    width: 0.22,
    height: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 65.78,
    y: 350.61,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.98 701.67) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 65.36,
    y: 351.06,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.14 702.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 64.94,
    y: 350.61,
    width: 0.42,
    height: 0.44,
    transform: "translate(130.29 701.67) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 64.51,
    y: 351.06,
    width: 0.42,
    height: 0.44,
    transform: "translate(129.45 702.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 64.09,
    y: 350.61,
    width: 0.42,
    height: 0.44,
    transform: "translate(128.61 701.67) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 63.67,
    y: 351.06,
    width: 0.42,
    height: 0.44,
    transform: "translate(127.76 702.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 63.25,
    y: 350.61,
    width: 0.42,
    height: 0.44,
    transform: "translate(126.92 701.67) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m62.83,351.43v.07h.42v-.44h-.3c-.04.13-.08.25-.12.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 66.2,
    y: 351.94,
    width: 0.22,
    height: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 65.78,
    y: 351.5,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.98 703.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 65.36,
    y: 351.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.14 704.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 64.94,
    y: 351.5,
    width: 0.42,
    height: 0.44,
    transform: "translate(130.29 703.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 64.51,
    y: 351.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(129.45 704.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 64.09,
    y: 351.5,
    width: 0.42,
    height: 0.44,
    transform: "translate(128.61 703.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 63.67,
    y: 351.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(127.76 704.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 63.25,
    y: 351.5,
    width: 0.42,
    height: 0.44,
    transform: "translate(126.92 703.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 62.83,
    y: 351.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(126.08 704.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m62.69,351.94h.14v-.44h-.02c-.04.15-.08.3-.12.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 64.94,
    y: 352.39,
    width: 0.42,
    height: 0.44,
    transform: "translate(130.29 705.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 64.51,
    y: 352.83,
    width: 0.42,
    height: 0.44,
    transform: "translate(129.45 706.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 64.09,
    y: 352.39,
    width: 0.42,
    height: 0.44,
    transform: "translate(128.61 705.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 63.67,
    y: 352.83,
    width: 0.42,
    height: 0.44,
    transform: "translate(127.76 706.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 63.25,
    y: 352.39,
    width: 0.42,
    height: 0.44,
    transform: "translate(126.92 705.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 62.83,
    y: 352.83,
    width: 0.42,
    height: 0.44,
    transform: "translate(126.08 706.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m62.5,352.83h.32v-.44h-.24c-.03.15-.06.3-.08.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 64.09,
    y: 353.28,
    width: 0.42,
    height: 0.44,
    transform: "translate(128.61 707) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 63.67,
    y: 353.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(127.76 707.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 63.25,
    y: 353.28,
    width: 0.42,
    height: 0.44,
    transform: "translate(126.92 707) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 62.83,
    y: 353.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(126.08 707.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m62.4,353.57v.16h.42v-.45h-.39c-.01.1-.03.2-.04.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 63.25,
    y: 354.17,
    width: 0.42,
    height: 0.44,
    transform: "translate(126.92 708.78) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 62.83,
    y: 354.61,
    width: 0.42,
    height: 0.44,
    transform: "translate(126.08 709.67) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 62.4,
    y: 354.17,
    width: 0.42,
    height: 0.44,
    transform: "translate(125.23 708.78) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 62.4,
    y: 355.06,
    width: 0.42,
    height: 0.44,
    transform: "translate(125.23 710.56) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "72.83 354.02 74.55 377.98 66.97 377.98 66.34 352.13 71.29 352.01 72.83 354.02"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "71.51 354.46 70.31 355.88 68.72 354.53 69.97 352.76 71.51 354.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "70.51 353.53 70.81 355.29 72.53 372.65 71.07 374.54 69.65 372.76 69.69 355.42 69.61 353.64 70.51 353.53"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "77.88 369.09 74.57 368.76 75.53 354.63 77.88 369.09"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 74.11,
    y: 366.4,
    width: 3.84,
    height: 4.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 74.9,
    y: 362.46,
    width: 9.73,
    height: 7.36
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "69.97 375.18 65.01 405.16 62.74 405.16 62.82 375.18 69.97 375.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "74.22 404.13 71.45 404.13 68.12 375.18 74.57 375.18 74.22 404.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m63.91,404.19c.65,0,1.17.55,1.17,1.24v.93h-2.35v-.93c0-.68.53-1.24,1.17-1.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "73.52 404.19 73.21 404.2 72.89 380.47 73.19 380.46 73.52 404.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "66.14 382.57 64.06 404.21 63.76 404.18 65.83 382.54 66.14 382.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "70.26 378.45 70.45 378.71 69.36 379.57 69.04 381.42 68.74 381.36 69.08 379.39 70.26 378.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m62.55,354.84l-.22,24.39h-2.48s-.34-6.39-.56-11.94c-.03-.61-.04-1.2-.04-1.78,0-5.85,2.21-10.68,2.21-10.68h1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m62.33,379.23v3.4s-3.27-.21-1.87-3.4h1.87Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m67.41,357.8c.49,5.5.89,29.94.89,29.94h-5.48s-.76-24.77-.76-24.77l-.61-8.12,4.91-2.71c.08.15.68,1.43,1.06,5.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "71.29 352.01 69.3 352.12 69.21 352.12 66.39 352.12 66.59 352.01 71.29 352.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m75.53,354.63l.27,33.1h-2.52s.8-31.5-1.98-35.73l4.24,2.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "m66.36,352.14s0-.02,0-.02h.03l-.03.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 74.09,
    y: 360.59,
    width: 1.26,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 55.92,
    y: 365.83,
    width: 13.24,
    height: 0.31,
    transform: "translate(-303.55 427.94) rotate(-89.91)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "63.73 359.94 62.67 362.89 62.38 362.77 63.44 359.82 63.73 359.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "62.6 366.89 62.49 367.19 61.1 366.6 61.22 366.3 62.6 366.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "62.45 367.38 62.41 367.7 60.55 367.43 60.59 367.11 62.45 367.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "65.98 372.62 65.98 371.55 66.29 371.55 66.29 372.94 63.15 372.94 63.15 372.62 65.98 372.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m77.73,368.25h.76c.7,0,1.27.6,1.27,1.34v.06c0,.74-.57,1.34-1.27,1.34h-.76c-.7,0-1.27-.6-1.27-1.34v-.06c0-.74.57-1.34,1.27-1.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "75.86 370.68 75.56 370.69 75.2 358.33 75.51 358.32 75.86 370.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "64.14 356.27 66.13 352.38 66.4 352.53 64.53 356.19 66.7 358.03 64.54 359.47 67.48 365.02 67.21 365.17 64.13 359.36 66.18 358 64.14 356.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "72.29 353.08 74.3 356.6 73.61 357.55 74.74 358.24 73.65 364.32 73.35 364.25 74.4 358.4 73.16 357.64 73.93 356.57 72.03 353.24 72.29 353.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "74.87 371.55 74.87 372.62 75.66 372.62 75.66 372.95 74.57 372.95 74.57 371.55 74.87 371.55"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m76.41,406.36h-4.74l-.21-2.22h2.78c1.18,0,2.14.99,2.17,2.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "m72.24,342.55v.18h.02c.09,0,.18,0,.27.03v.3h-.29v2.1h.3c.15,0,.29-.03.42-.08.13-.05.25-.13.35-.24.02-.02.05-.05.07-.07.1-.11.17-.23.22-.37.04-.11.07-.23.08-.36h0s0-.05,0-.08v-1.13l-.3-.05-.42-.08-.41-.08h0s-.29-.05-.29-.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m72.95,343.05v.44h.42v-.25c-.06-.07-.12-.14-.19-.19h-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m72.53,342.75v.3h.42v-.15c-.13-.07-.27-.12-.42-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m73.37,343.49v.44h.29c-.02-.16-.06-.31-.13-.44h-.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.95,
    y: 343.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(146.32 688.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.53,
    y: 343.49,
    width: 0.42,
    height: 0.44,
    transform: "translate(145.47 687.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m73.37,344.38v.37c.1-.11.17-.23.22-.37h-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m72.95,344.83v.24c.13-.05.25-.13.35-.24h-.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 72.53,
    y: 344.38,
    width: 0.42,
    height: 0.44,
    transform: "translate(145.47 689.21) rotate(180)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m69.92,353.42c-1.59,0-3.5-.24-3.5-1.25v-4.73h5.18v4.73c0,.61-.09,1.25-1.68,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m67.04,349.72s.42,1.29,1.97,2c1.55.71,2.59,0,2.59,0v-1.46l-4.56-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m69.55,351.11h.07c1.73,0,3.13-1.48,3.13-3.3v-6h-6.32v6c0,1.82,1.4,3.3,3.13,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m69.41,347.88c.43-.35,1.02-.29,1.02-.29,0,0,.59-.06,1.02.29.47.38.59,1.13.59,1.13,0,0-.94.14-1.4-.23-.08-.06-.15-.13-.2-.2-.06.07-.13.14-.2.2-.47.38-1.4.23-1.4.23,0,0,.12-.75.59-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m70.43,350.18l.45-.92s-.23.1-.45.1-.45-.1-.45-.1l.45.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "70.27 347.34 71.36 347.34 71.19 345.48 70.94 345.51 71.09 347.07 70.27 347.07 70.27 347.34"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m72.74,343.31h-3.11c-.89,0-1.6.76-1.6,1.69v.89c0,.93-.72,1.69-1.6,1.69h0v-4.86h6.32v.59Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m64.15,346.61c0,.2,0,.36,0,.45v.08h1.34c.1,0,.19,0,.28-.02.12-.01.23-.04.34-.06.03,0,.05-.01.08-.02.07-.02.13-.04.2-.07,0,0,0,0,0,0t0,0s0,0,0,0c0,0,0,0,0,0,.02,0,.03-.01.05-.02.05-.02.1-.05.15-.07.14-.07.28-.16.4-.26,0,0,.01-.01.02-.02.15-.13.29-.27.4-.42,0,0,.01-.02.02-.02.09-.13.18-.27.24-.42.06-.14.11-.29.14-.45.02-.1.04-.2.04-.3,0-.04,0-.08,0-.12v-.47s0-.09,0-.09c0-.12.02-.24.05-.36.04-.16.1-.31.19-.44.05-.08.11-.16.17-.22.07-.08.16-.16.25-.22.06-.04.11-.08.18-.11.13-.07.27-.13.42-.16.13-.03.26-.05.4-.05h2.71c.09,0,.18,0,.27.03.15.03.29.08.42.15.08.04.16.09.23.15.07.06.14.12.19.19.06.08.12.16.16.25.07.14.12.29.13.44,0,.03,0,.05,0,.08h0s0,.04,0,.06v-1.27c0-.07,0-.14-.01-.21-.01-.16-.04-.31-.09-.44-.05-.13-.11-.24-.2-.34-.03-.04-.06-.07-.1-.11-.09-.08-.2-.15-.32-.19-.12-.05-.26-.08-.42-.1h-.84s0,.29,0,.29v-.3h-.42s-.42.02-.42.02l-.84.02h-.42s-.42.02-.42.02h-.42s-.42.02-.42.02h-.42s-.42.02-.42.02h-.42s-.42.02-.42.02h-.42s-.42.02-.42.02h-.42s-.37.02-.37.02c-.02,0-.03,0-.05,0-.07.01-.14.06-.19.13-.08.1-.15.25-.22.44,0,.01,0,.03-.01.04-.04.12-.07.26-.1.4-.03.14-.05.29-.08.45-.02.14-.04.29-.05.44-.02.15-.03.29-.04.44-.01.15-.02.3-.03.45-.01.15-.02.3-.02.44,0,.15-.01.3-.02.44,0,.08,0,.15,0,.23h0c0,.08,0,.15,0,.22,0,.16,0,.31,0,.44,0,.16,0,.31,0,.44Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m72.95,341.52v.19h.32c-.09-.08-.2-.15-.32-.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "71.26 341.43 71.26 341.72 71.68 341.72 71.68 341.42 71.26 341.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "72.1 341.43 72.1 341.72 72.53 341.72 72.53 341.42 72.1 341.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "70.42 341.45 70.42 341.72 70.84 341.72 70.84 341.44 70.42 341.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "69.57 341.47 69.57 341.72 70 341.72 70 341.46 69.57 341.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "68.73 341.49 68.73 341.72 69.15 341.72 69.15 341.48 68.73 341.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "67.89 341.51 67.89 341.72 68.31 341.72 68.31 341.5 67.89 341.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "67.04 341.53 67.04 341.72 67.47 341.72 67.47 341.52 67.04 341.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "66.2 341.55 66.2 341.72 66.62 341.72 66.62 341.54 66.2 341.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "65.36 341.57 65.36 341.72 65.78 341.72 65.78 341.56 65.36 341.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m64.74,341.72h.19v-.13c-.07.01-.14.06-.19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m73.37,341.82v.34h.2c-.05-.13-.11-.24-.2-.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 72.95,
    y: 342.16,
    width: 0.42,
    height: 0.44,
    transform: "translate(146.32 684.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 72.53,
    y: 341.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(145.47 683.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 72.1,
    y: 342.16,
    width: 0.42,
    height: 0.44,
    transform: "translate(144.63 684.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 71.68,
    y: 341.72,
    width: 0.42,
    height: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 71.26,
    y: 342.16,
    width: 0.42,
    height: 0.44,
    transform: "translate(142.94 684.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 70.84,
    y: 341.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(142.1 683.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 70.42,
    y: 342.16,
    width: 0.42,
    height: 0.44,
    transform: "translate(141.26 684.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 70,
    y: 341.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(140.41 683.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 69.57,
    y: 342.16,
    width: 0.42,
    height: 0.44,
    transform: "translate(139.57 684.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 69.15,
    y: 341.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(138.73 683.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 68.73,
    y: 342.16,
    width: 0.42,
    height: 0.44,
    transform: "translate(137.88 684.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 68.31,
    y: 341.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(137.04 683.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 67.89,
    y: 342.16,
    width: 0.42,
    height: 0.44,
    transform: "translate(136.2 684.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 67.47,
    y: 341.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(135.35 683.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 67.04,
    y: 342.16,
    width: 0.42,
    height: 0.44,
    transform: "translate(134.51 684.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 66.62,
    y: 341.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(133.67 683.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 66.2,
    y: 342.16,
    width: 0.42,
    height: 0.44,
    transform: "translate(132.82 684.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 65.78,
    y: 341.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.98 683.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 65.36,
    y: 342.16,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.14 684.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 64.94,
    y: 341.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(130.29 683.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 64.51,
    y: 342.16,
    width: 0.42,
    height: 0.44,
    transform: "translate(129.45 684.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m73.37,342.6v.45h.3v-.24c0-.07,0-.14-.01-.21h-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m73.18,343.05c.07.06.14.12.19.19v-.19h-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m72.53,342.6v.15c.15.03.29.08.42.15v-.29h-.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 71.68,
    y: 342.6,
    width: 0.42,
    height: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 70.84,
    y: 342.6,
    width: 0.42,
    height: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 70,
    y: 342.6,
    width: 0.42,
    height: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m69.15,342.6v.17c.13-.03.26-.05.4-.05h.02v-.12h-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m68.31,342.6v.45h.25c.06-.04.11-.08.18-.11v-.33h-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m67.89,343.05v.44h.25c.05-.08.11-.16.17-.22v-.22h-.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 67.47,
    y: 342.61,
    width: 0.42,
    height: 0.44,
    transform: "translate(135.35 685.65) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 67.04,
    y: 343.05,
    width: 0.42,
    height: 0.44,
    transform: "translate(134.51 686.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 66.62,
    y: 342.61,
    width: 0.42,
    height: 0.44,
    transform: "translate(133.67 685.65) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 66.2,
    y: 343.05,
    width: 0.42,
    height: 0.44,
    transform: "translate(132.82 686.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 65.78,
    y: 342.61,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.98 685.65) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 65.36,
    y: 343.05,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.14 686.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 64.94,
    y: 342.61,
    width: 0.42,
    height: 0.44,
    transform: "translate(130.29 685.65) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 64.51,
    y: 343.05,
    width: 0.42,
    height: 0.44,
    transform: "translate(129.45 686.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m64.33,343.05h.18v-.45h-.1c-.03.14-.05.29-.08.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m73.53,343.49c.07.14.12.29.13.44h0v-.44h-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m67.89,343.94v.45h.01v-.09c0-.12.02-.24.05-.36h-.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 67.47,
    y: 343.49,
    width: 0.42,
    height: 0.44,
    transform: "translate(135.35 687.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 67.04,
    y: 343.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(134.51 688.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 66.62,
    y: 343.49,
    width: 0.42,
    height: 0.44,
    transform: "translate(133.67 687.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 66.2,
    y: 343.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(132.82 688.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 65.78,
    y: 343.49,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.98 687.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 65.36,
    y: 343.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.14 688.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 64.94,
    y: 343.49,
    width: 0.42,
    height: 0.44,
    transform: "translate(130.29 687.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 64.51,
    y: 343.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(129.45 688.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m64.24,343.94h.28v-.44h-.23c-.02.15-.03.29-.04.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m67.89,344.83v.15s0-.08,0-.12v-.03h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 67.47,
    y: 344.38,
    width: 0.42,
    height: 0.44,
    transform: "translate(135.35 689.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 67.04,
    y: 344.83,
    width: 0.42,
    height: 0.44,
    transform: "translate(134.51 690.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 66.62,
    y: 344.38,
    width: 0.42,
    height: 0.44,
    transform: "translate(133.67 689.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 66.2,
    y: 344.83,
    width: 0.42,
    height: 0.44,
    transform: "translate(132.82 690.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 65.78,
    y: 344.38,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.98 689.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 65.36,
    y: 344.83,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.14 690.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 64.94,
    y: 344.38,
    width: 0.42,
    height: 0.44,
    transform: "translate(130.29 689.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 64.51,
    y: 344.83,
    width: 0.42,
    height: 0.44,
    transform: "translate(129.45 690.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m64.18,344.83h.33v-.44h-.31c-.01.15-.02.3-.02.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m67.47,345.27v.45h.24c.06-.14.11-.29.14-.45h-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m67.04,345.72v.44h.4s.01-.02.02-.02v-.42h-.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 66.62,
    y: 345.27,
    width: 0.42,
    height: 0.44,
    transform: "translate(133.67 690.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 66.2,
    y: 345.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(132.82 691.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 65.78,
    y: 345.27,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.98 690.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 65.36,
    y: 345.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.14 691.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 64.94,
    y: 345.27,
    width: 0.42,
    height: 0.44,
    transform: "translate(130.29 690.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 64.51,
    y: 345.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(129.45 691.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m64.09,345.71h0s.42,0,.42,0v-.45h-.35c0,.08,0,.15,0,.23h0c-.02.07-.04.14-.07.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m63.93,346.16h.17v-.44h0c-.05.14-.1.29-.16.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m66.62,346.16v.44h.4s.01-.01.02-.02v-.42h-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m66.2,346.61v.45h.01c.06-.03.12-.06.18-.09,0,0,0,0,0,0t0,0s0,0,0,0c0,0,0,0,0,0,.02,0,.03-.01.05-.02.05-.02.1-.05.15-.07v-.26h-.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 65.78,
    y: 346.16,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.98 692.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 65.36,
    y: 346.61,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.14 693.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 64.94,
    y: 346.16,
    width: 0.42,
    height: 0.44,
    transform: "translate(130.29 692.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 64.51,
    y: 346.61,
    width: 0.42,
    height: 0.44,
    transform: "translate(129.45 693.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 64.09,
    y: 346.16,
    width: 0.42,
    height: 0.44,
    transform: "translate(128.61 692.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m63.67,346.74v.31h.42v-.45h-.36s-.04.09-.06.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m65.78,347.05v.24c.14-.08.28-.16.42-.24h0s-.42,0-.42,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m65.36,347.5v.08s.08-.06.12-.08h-.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 64.94,
    y: 347.05,
    width: 0.42,
    height: 0.44,
    transform: "translate(130.29 694.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m64.51,347.5v.44h.4s.01-.01.02-.02v-.42h-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m64.92,347.94h.02v-.02s-.01.01-.02.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 64.09,
    y: 347.05,
    width: 0.42,
    height: 0.44,
    transform: "translate(128.61 694.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 63.67,
    y: 347.5,
    width: 0.42,
    height: 0.44,
    transform: "translate(127.76 695.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m63.27,347.5h.4v-.44h-.16c-.07.14-.16.29-.25.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m63,347.94h.24v-.41c-.06.1-.12.2-.18.3-.02.04-.04.07-.06.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m64.09,347.94v.45h.38s.03-.03.04-.05v-.4h-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m64.47,348.39h.04v-.05s-.03.03-.04.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 63.67,
    y: 348.39,
    width: 0.42,
    height: 0.44,
    transform: "translate(127.76 697.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 63.25,
    y: 347.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(126.92 696.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 62.83,
    y: 348.39,
    width: 0.42,
    height: 0.44,
    transform: "translate(126.08 697.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m62.76,348.39h.06v-.12s-.04.08-.06.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m63.67,349.28v.2c.04-.07.08-.13.12-.2h-.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 63.25,
    y: 348.83,
    width: 0.42,
    height: 0.44,
    transform: "translate(126.92 698.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 62.83,
    y: 349.28,
    width: 0.42,
    height: 0.44,
    transform: "translate(126.08 699) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m62.4,349.27h0s.42,0,.42,0v-.44h-.26c-.06.14-.11.29-.16.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m62.27,349.72h.14v-.45h0c-.05.15-.09.3-.13.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m63.25,349.72v.44h.06c.07-.15.14-.3.23-.44h-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m62.83,350.17v.44h.29c.04-.11.09-.21.13-.32v-.13h-.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 62.4,
    y: 349.72,
    width: 0.42,
    height: 0.44,
    transform: "translate(125.23 699.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m62.07,350.61h.33v-.44h-.24c-.03.15-.06.3-.09.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m62.83,351.06v.37c.04-.13.08-.25.12-.37h-.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 62.4,
    y: 350.61,
    width: 0.42,
    height: 0.44,
    transform: "translate(125.23 701.67) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 61.98,
    y: 351.06,
    width: 0.42,
    height: 0.44,
    transform: "translate(124.38 702.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m62.4,351.5v.44h.29c.04-.15.08-.29.12-.44h-.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 61.98,
    y: 351.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(124.38 704.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m61.93,351.94h.05v-.44h-.02c-.01.15-.03.3-.03.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m62.4,352.39v.44h.1c.02-.15.05-.29.08-.44h-.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 61.98,
    y: 352.83,
    width: 0.42,
    height: 0.44,
    transform: "translate(124.38 706.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m61.91,352.39c0,.15,0,.3,0,.44h.07v-.44h-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "m62.4,353.28v.29c.01-.09.02-.19.04-.29h-.04Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 61.98,
    y: 353.72,
    width: 0.42,
    height: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m61.92,353.28c0,.15.01.3.02.45h.04v-.45h-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m65.23,340.76h6.98c0-.13-.02-.26-.05-.38-.02-.06-.04-.12-.06-.18-.03-.09-.08-.18-.13-.26-.08-.14-.18-.27-.29-.39-.02-.02-.04-.04-.06-.06-.11-.11-.23-.21-.36-.3-.07-.05-.14-.09-.22-.14-.07-.04-.14-.07-.21-.11-.13-.07-.27-.13-.42-.18-.14-.05-.28-.09-.42-.13-.03,0-.06-.02-.09-.02-.11-.03-.22-.05-.34-.07-.14-.02-.28-.04-.42-.05-.14-.01-.28-.02-.42-.02h0c-.14,0-.28,0-.41.02-.14.01-.28.03-.42.05-.12.02-.24.04-.35.07-.02,0-.05.01-.07.02-.15.04-.29.08-.42.13-.15.05-.29.11-.42.18-.08.04-.15.08-.22.12-.07.04-.13.08-.2.13-.14.1-.27.2-.38.32-.01.01-.03.02-.04.04-.12.13-.23.26-.31.4-.04.07-.08.15-.11.22-.03.07-.06.15-.08.22-.03.12-.05.25-.05.38Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m70.42,338.76v.29h.42v-.11c-.13-.07-.27-.13-.42-.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 69.57,
    y: 338.6,
    width: 0.42,
    height: 0.44,
    transform: "translate(139.57 677.65) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m69.15,338.48v.12h.42v-.07c-.14-.02-.28-.04-.42-.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 68.73,
    y: 338.6,
    width: 0.42,
    height: 0.44,
    transform: "translate(137.88 677.65) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m68.31,338.48v.12h.42v-.14h0c-.14,0-.28,0-.41.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 67.89,
    y: 338.6,
    width: 0.42,
    height: 0.44,
    transform: "translate(136.2 677.65) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m67.53,338.6h.35v-.07c-.12.02-.24.04-.35.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m67.04,338.75v.3h.42v-.43c-.15.04-.29.08-.42.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m66.4,339.05h.22v-.12c-.08.04-.15.08-.22.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m71.26,339.49v.44h.42v-.39s-.04-.04-.06-.06h-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m70.84,339.05v.44h.42v-.3c-.07-.05-.14-.09-.22-.14h-.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 70.42,
    y: 339.49,
    width: 0.42,
    height: 0.44,
    transform: "translate(141.26 679.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 70,
    y: 339.05,
    width: 0.42,
    height: 0.44,
    transform: "translate(140.41 678.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 69.57,
    y: 339.49,
    width: 0.42,
    height: 0.44,
    transform: "translate(139.57 679.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 69.15,
    y: 339.05,
    width: 0.42,
    height: 0.44,
    transform: "translate(138.73 678.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 68.73,
    y: 339.49,
    width: 0.42,
    height: 0.44,
    transform: "translate(137.88 679.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 68.31,
    y: 339.05,
    width: 0.42,
    height: 0.44,
    transform: "translate(137.04 678.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 67.89,
    y: 339.49,
    width: 0.42,
    height: 0.44,
    transform: "translate(136.2 679.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 67.47,
    y: 339.05,
    width: 0.42,
    height: 0.44,
    transform: "translate(135.35 678.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 67.04,
    y: 339.49,
    width: 0.42,
    height: 0.44,
    transform: "translate(134.51 679.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 66.62,
    y: 339.05,
    width: 0.42,
    height: 0.44,
    transform: "translate(133.67 678.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 66.2,
    y: 339.49,
    width: 0.42,
    height: 0.44,
    transform: "translate(132.82 679.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m65.82,339.49h.38v-.32c-.14.1-.27.2-.38.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m65.47,339.94h.31v-.4c-.12.13-.23.26-.31.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m72.1,340.38v.38h.11c0-.13-.02-.26-.05-.38h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m71.68,339.94v.45h.42v-.18c-.03-.09-.08-.18-.13-.26h-.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 71.26,
    y: 340.38,
    width: 0.42,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 70.84,
    y: 339.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(142.1 680.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 70.42,
    y: 340.38,
    width: 0.42,
    height: 0.44,
    transform: "translate(141.26 681.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 70,
    y: 339.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(140.41 680.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 69.57,
    y: 340.38,
    width: 0.42,
    height: 0.44,
    transform: "translate(139.57 681.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 69.15,
    y: 339.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(138.73 680.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 68.73,
    y: 340.38,
    width: 0.42,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 68.31,
    y: 339.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(137.04 680.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 67.89,
    y: 340.38,
    width: 0.42,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 67.47,
    y: 339.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(135.35 680.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 67.04,
    y: 340.38,
    width: 0.42,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 66.62,
    y: 339.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(133.67 680.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 66.2,
    y: 340.38,
    width: 0.42,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 65.78,
    y: 339.94,
    width: 0.42,
    height: 0.44,
    transform: "translate(131.98 680.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 65.36,
    y: 340.38,
    width: 0.42,
    height: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m65.28,340.38h.08v-.22c-.03.07-.06.15-.08.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m72.37,340.95c.16,0,.3-.14.3-.32s-.13-.32-.3-.32h-7.5c-.16,0-.3.14-.3.32s.13.32.3.32c-.16,0-.3.14-.3.32s.13.32.3.32h7.5c.16,0,.3-.14.3-.32s-.13-.32-.3-.32Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m114.43,409.4h0s-1.08-.06-1.08-.06l1.86-.55c.25-.07-.06-.13-.68-.13h0l.47-.14h0l1.08-.32c.17-.05-.04-.09-.47-.09h-.04,0c.17,0,.35-.02.42-.04.07-.02-.01-.04-.19-.04.18,0,.38-.02.45-.04s-.01-.04-.19-.04h-.31c-.16-.13-1.13-.24-2.89-.24s-3.49.11-4.53.24h-.31c-.18,0-.38.02-.45.04-.07.02.01.04.19.04-.18,0-.38.02-.45.04-.07.02,0,.04.16.04h0s-.23,0-.23,0h0c-.44,0-.93.04-1.1.09l-1.53.45c-.62,0-1.32.06-1.57.13l-1.92.56-1.13.04h0s-4.99.69-7.83,1.52c-.28.08-.56.17-.82.25h1.08c-1.4.5-2.39.97-2.39.97-2.32.36-.17.48-.17.48l1.63-.48,3.3-.97.56-.16h.01s-3.17,1.1-3.17,1.1l-.06.02h.06l-9.37,2.91h-.16c-1.22,0-2.6.12-3.09.26h5.03l.88-.26h0l10.42-2.42h.12s-7.03,2.42-7.03,2.42h0l-.88.26h5.03c.49-.14-.11-.26-1.33-.26h-.16l11.79-2.91h.21l.06-.02h0l4.47-1.13-.65.19-3.3.97-1.63.48s2.97-.12,3.1-.48c0,0,2.17-.46,4.22-.97h1.08c.32-.09.63-.17.9-.25,2.84-.83,2.54-1.52,2.54-1.52h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "m91.89,355.36h0v-1.23h-1.1v1.23h-2.36v-.02h-5.38v-1.23h-1.1v1.23c-.62,0-1.13.53-1.13,1.19v7.4h6.95v.02h5.24v-7.4c0-.66-.5-1.19-1.13-1.19Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "90.77 412.96 88.11 412.96 86.46 383.68 92.84 383.68 90.77 412.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "84.6 412.96 81.94 412.96 81.32 383.68 87.49 383.68 84.6 412.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m81.78,412.96h2.82v2.33h-5.03c0-1.29.99-2.33,2.21-2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m93.14,415.29h-5.03v-2.33h2.82c1.22,0,2.21,1.04,2.21,2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m80.71,362.02v24.75h-1.46s-.91-6.49-1.09-12.11c-.02-.61-.03-1.22-.03-1.8,0-5.94,1.73-10.83,1.73-10.83h.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "m80.71,362.02v16.01h-3.46c-.03-.78-.04-1.55-.04-2.29,0-7.52,2.64-13.72,2.64-13.72h.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m80.71,386.77v4.32s-2.56-1.08-1.46-4.32h1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m96.04,372.86c0,.58-.01,1.19-.03,1.8-.18,5.63-1.09,12.11-1.09,12.11h-1.46v-24.75h.85s1.73,4.89,1.73,10.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "m96.95,375.75c0,.74-.01,1.51-.04,2.29h-3.46v-16.01h.85s2.64,6.2,2.64,13.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m93.45,391.1v-4.32h1.46c1.1,3.24-1.46,4.32-1.46,4.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "89.49 360.01 94.3 362.02 92.84 386.51 81.32 386.51 79.85 362.02 84.66 360.01 89.49 360.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "86.82 366.11 84.42 360.14 89.74 360.14 86.82 366.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m89.74,360.14s-.7.66-2.66.66-2.66-.66-2.66-.66v-4.25h5.32v4.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "80.88 376.53 80.57 376.55 80.08 367.74 80.4 367.72 80.88 376.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "94.06 367.74 93.61 376.22 93.3 376.2 93.75 367.72 94.06 367.74"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 81.32,
    y: 386.35,
    width: 11.52,
    height: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "86.72 389.15 86.93 391.08 86.62 391.11 86.43 389.42 85.25 389.09 85.33 388.77 86.72 389.15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 81.7,
    y: 368.59,
    width: 2.72,
    height: 1.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 82.91,
    y: 368.1,
    width: 0.31,
    height: 0.88
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m84.42,359.01v.89s.21,5.57.21,5.57c.04,1.06.73,1.93,1.65,2.2-.08.14-.12.3-.11.48h0c-1.11-.32-1.95-1.38-2.01-2.66l-.2-5.11c0-.96.46-1.37.46-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m86.98,367.76l.02.5c-.29.01-.57-.02-.84-.1h0c0-.18.04-.34.11-.48.22.07.46.1.7.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "m86.96,367.24c.46-.02.84.35.86.83.02.48-.34.88-.79.9-.46.02-.84-.35-.86-.83h0c0-.18.04-.34.11-.48.14-.25.39-.41.68-.43Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "m90.71,363.05h.73c1.12-.02,2.04.94,2.05,2.12l.03,3.69c.01,1.28-.67,2.15-1.7,2.16v-.33c1.04,0,1.4-.99,1.39-1.83l-.03-3.69c0-1-.79-1.81-1.74-1.8h-.73c-.95.02-1.72.84-1.71,1.84l.03,3.69c0,.84.38,1.81,1.42,1.8v.33c-1.03,0-1.73-.85-1.74-2.13l-.03-3.69c0-1.18.89-2.15,2.02-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m90.71,362.97h.23s-.02-2.04-.02-2.04c0-.71-.53-1.41-1.19-1.85v-.54c.92.51,1.65,1.43,1.66,2.39l.02,2.03h.02c1.17-.01,2.12.98,2.13,2.21l.02,2.2h-.47s-.02-2.2-.02-2.2c0-.96-.75-1.73-1.66-1.72h-.73c-.91.01-1.64.8-1.63,1.75l.02,2.2h-.47s-.02-2.2-.02-2.2c0-1.23.93-2.24,2.1-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m90.33,370.6c.14,0,.26.12.26.27,0,.15-.11.27-.25.27-.14,0-.26-.12-.26-.27,0-.15.11-.27.25-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m91.93,370.61c.14,0,.26.12.26.27,0,.15-.11.27-.25.27-.14,0-.26-.12-.26-.27,0-.15.11-.27.25-.27Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m83.45,352.69h0v3.36h0c-.43,0-.78-.37-.78-.83v-1.71c0-.46.35-.83.78-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m90.59,352.69h0v3.36h0c.43,0,.78-.37.78-.83v-1.71c0-.46-.35-.83-.78-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m83.85,357.49c3.08,3.72,6.35.05,6.35.05v-6.4c0-.85-.63-1.54-1.4-1.54h-3.54c-.78,0-1.4.69-1.4,1.54v6.35Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m90.19,351.44c0-.78-.6-1.42-1.34-1.42h-3.67c-.74,0-1.34.64-1.34,1.42v1.97c0-.78.6-1.42,1.34-1.42h3.67c.74,0,1.34.64,1.34,1.42v-1.97Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m86.92,356.04h0c.9,0,1.63.73,1.63,1.63v.04h-3.25v-.04c0-.9.73-1.63,1.63-1.63Z",
    transform: "translate(173.83 713.75) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m84.76,356.75s1.79.15,2.16-.39c.28.6,2.16.39,2.16.39,0,0-.44-1.41-2.21-1.41s-2.11,1.41-2.11,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m83.85,351.15v3.36c0,1.66,1.35,2.19,1.35,2.19,0,1.36,1.43,1.46,1.82,1.46.39,0,1.82-.1,1.82-1.46,0,0,1.35-.53,1.35-2.19v-3.36h.4v6.77c0,1.99-3.51,2.62-3.57,2.62-.06,0-3.57-.63-3.57-2.62v-6.77h.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "87.2 355.35 86.46 355.35 86.56 353.91 86.89 353.93 86.82 355 87.2 355 87.2 355.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m86.92,359.32h0c.29,0,.52-.24.52-.55v-.51c0-.3-.23-.55-.52-.55h0c-.29,0-.52.24-.52.55v.51c0,.3.23.55.52.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m87.02,346.92c2.41,0,4.05,1.88,4.05,3.44v.19h-8.09v-.19c0-1.56,1.64-3.44,4.05-3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m83,349.77c-.18,0-.32-.15-.32-.34s.14-.34.32-.34h8.04c.18,0,.32.15.32.34s-.14.34-.32.34c.18,0,.32.15.32.34s-.14.34-.32.34h-8.04c-.18,0-.32-.15-.32-.34s.14-.34.32-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m91.9,355.36h0v-4.08c0-.46-.35-.83-.79-.83h-.52v3.54c0,.76.58,1.38,1.31,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m84.14,350.45v1.79c0-.06,0-.11.02-.17.11-.6.79-1.06,1.63-1.06h2.26c.91,0,1.64.55,1.64,1.23v-1.79h-5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m89.69,350.45h0c.78,0,1.41.63,1.41,1.41v1.54h-1.41v-2.96h0Z",
    transform: "translate(180.79 703.85) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m81.95,351.28v4.08c.53,0,.99-.34,1.19-.82.08-.17.11-.36.11-.56v-3.54h-.52c-.44,0-.79.37-.79.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m82.74,350.45v2.96h.57c.47,0,.85-.4.85-.89v-2.07h-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "m83.33,351.69c0,.19.07.36.19.48.12.12.28.2.46.2h.18v-.3c.11-.6.79-1.06,1.63-1.06h-1.81c-.36,0-.65.31-.65.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "m90.51,351.69c0,.19-.07.36-.19.48-.12.12-.28.2-.46.2h-.18v-.19c-.1-.6-.79-1.17-1.63-1.17h1.81c.36,0,.65.31.65.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "m82.26,353.98c0,.16.06.3.16.4.1.1.23.17.38.17h.34c.08-.17.11-.36.11-.56v-.58h-.45c-.3,0-.54.26-.54.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "m91.58,353.98c0,.16-.06.3-.16.4-.1.1-.23.17-.38.17h-.34c-.08-.17-.11-.36-.11-.56v-.58h.45c.3,0,.54.26.54.57Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m131.22,437.94s.66-.24,1.22-.51c.12-.06.24-.12.35-.18.41-.23.62-.44.19-.5h0s0,0,0,0h0s-.01,0-.01,0l-3.23-.22c.11-.01.17-.02.17-.02l.28-.05h0s.43-.07.43-.07c.54,0,1.15,0,1.79-.01l1.11-.28h1.23l-.33-.23.27-.07c.08-.02.16-.04.23-.06.01,0,.02,0,.03,0h1.1c.81,0,1.73-.08,2.06-.17l.1-.03h-2.56s-.07,0-.1,0c.29-.19-.69-.34-2.45-.34h-.7c-2.26,0-4.81.21-5.71.48l-.21.06c-1.27.37-.39.47-.39.47h.08s-1.56.29-1.56.29l-5.12.24s-4.13.47-7.86,1.29h0c-.34.07-.69.14-1.03.22-2.76.6-4.62,1.17-5.06,1.31-2.76.36-.78.53-.78.53l2.43-.53h0s6.63-1.41,6.63-1.41l-4.62,1.15h0l-7.35,1.67h.4l-7.44,1.79h-1.12c-1.31,0-2.79.12-3.31.28h4.92l1.4-.28h0l10.07-1.79h.95l3.78-.8-3.12.8h1.65l-6.68,1.89c-.1.02-.19.03-.25.05l-.43.13h2.55l.43-.13s.02,0,.03-.01h0s8.47-1.93,8.47-1.93h.5l3.41-.83h7.56l3.3-.96,1.88-1.25h.44Zm-3.41-.04h0s-.15.04-.15.04h.06l-.51.18h-.34l.95-.21Zm-5.75,1.28l3.5-.78c.92.01,1.99.02,3.21.03l-1.08.76h-5.63Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "111.03 386.04 115.71 408.12 114.49 408.12 109.64 386.09 111.03 386.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m110.5,386.04l.95.02s1.79,5.11,1.79,13.49c0,.46,0,1.27-.02,1.73l-2.72-.35-.28-4.49.28-10.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m94.2,399.71c-.83,6.19-.58,12.11-.58,12.11l1.61.24,3.64-25.82-.93-.16s-2.59,5.02-3.74,13.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m94.49,397.76h3.19l.25-11.69s-2.53,4.22-3.45,11.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m95.29,411.61l-.64,4.76s-2.66-1.61-.97-5l1.61.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "97.94 386.07 102.25 383.92 107.14 383.92 111.46 386.07 108.73 409.24 96.4 409.24 97.94 386.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "102.25 383.92 103.59 386.91 107.24 384.3 102.25 383.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "108.72 409.24 105.2 441.81 102.72 441.61 103.16 409.24 108.72 409.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "96.4 409.24 93.84 440.56 95.74 440.56 103.39 409.24 96.4 409.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "108.72 409.24 107.58 424.37 101.31 424.37 101.68 417.11 100.64 424.37 94.76 424.37 96.4 409.24 108.72 409.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "96.38 424.39 96.05 424.35 97.77 410.42 98.1 410.47 96.38 424.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "105.32 424.38 104.99 424.36 106.07 410.43 106.4 410.46 105.32 424.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m92.72,440.56h3.01l-.46,2.49h-4.92c0-1.38,1.06-2.49,2.36-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m103.92,440.56h0c.7,0,1.27.6,1.27,1.34v1.15h-2.55v-1.15c0-.74.57-1.34,1.27-1.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "101.52 416.86 101.38 414.55 100.25 413.3 100.49 413.06 101.71 414.4 101.85 416.84 101.52 416.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m103.4,378.35l-1.15,5.58s.42.95,2.6,1.03c2.18.07,2.71-1.03,2.71-1.03l1.38-4.41-5.55-1.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "108.11 382.14 106.01 382.04 107.7 383.52 108.11 382.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m109.64,382.78c-1.94.55-4.25-.68-4.25-.68v-5.71l4.62.74-.37,5.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m101.61,377.12c-.5-3.04,2.05-4.21,3.86-4.21,2.5,0,4.53,1.76,4.53,4.21s-2.05,4.2-4.53,3.85c-2.57-.36-3.44-1.22-3.86-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m102.75,381.3s-1.22-.9-1.22-4.26c0-.73.08-.99.08-.99l2.83-3.15,3.07.14,2.14,2.16h-2.8l-.73,4.07h-1.36l-2,2.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "109.71 377.82 111.03 380.27 108.98 380.27 109.71 377.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "104.78 387.74 104.61 387.44 105.64 386.76 107.89 387.24 107.12 384.54 107.44 384.43 108.37 387.7 105.71 387.14 104.78 387.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "102.42 387.66 101.97 386.51 99.51 386.68 101.69 384.46 101.92 384.72 100.4 386.27 102.19 386.15 102.73 387.52 102.42 387.66"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 103.43,
    y: 377.3,
    width: 1.91,
    height: 3.19,
    rx: 0.95,
    ry: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m105.98,372.18h0c2.22,0,4.03,1.81,4.03,4.03v.82h-8.48v-.4c0-2.46,2-4.45,4.45-4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m110.35,375.23h2.23c0,1-.81,1.81-1.81,1.81h-2.23c0-1,.81-1.81,1.81-1.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "97.35 397.49 97.02 397.46 97.43 391.23 96.92 390.38 97.2 390.19 97.77 391.14 97.35 397.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "97.78 390.66 97.31 389.17 97.62 389.06 98.1 390.55 97.78 390.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m113.21,401.29c-5.36-.16-8.23-1.09-8.23-1.09v-1.77h8.23s0,2.86,0,2.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "109.21 384.95 101.91 397.12 104.39 409.5 106.02 409.24 103.42 397.76 110.56 385.63 109.21 384.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m101.55,396.8h.03c1.88,0,3.4,1.52,3.4,3.4h-.39c-1.68,0-3.04-1.36-3.04-3.04v-.36h0Z",
    transform: "translate(206.53 796.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m113.76,396.83h-3.57l1.27-10.76c.65.57,1.16,2.48,1.53,4.54.09.54.18,1.09.26,1.63.35,2.41.51,4.59.51,4.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "110.17 396.81 109.84 396.78 110.39 389.89 110.72 389.92 110.17 396.81"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 103.93,
    y: 408.12,
    width: 11.78,
    height: 8.72
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "108.65 381.47 107.55 380.93 107.68 380.63 108.78 381.17 108.65 381.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "m113.25,392.24h-1.52v-1.63h1.26c.09.54.18,1.09.26,1.63Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m151.47,441.82h-3.17l.22-.07c.23-.07.04-.12-.42-.13.09-.01.16-.03.22-.04l.7-.21.58-.17h.23s2.39-.72,4.8-1.43c3.32-.97,3.91-1.57,3.93-1.58h0s-3.86-.24-3.86-.24h.03s.35-.11.35-.11c.46,0,.97-.02,1.53-.04l1.11-.33c.32-.01.61-.04.74-.08l.62-.18c.12-.04.04-.07-.19-.08l.77-.22c.16-.05.17-.09.05-.12.4-.04.72-.09.91-.15l.4-.12h-4.62c-.81,0-1.69.05-2.31.13-.88.02-1.78.1-2.13.2l-1.24.36-.3.09-.33.1c-.17.05.04.09.45.09h.26l-1.63.48-6.03.18c-4.88.57-11.23,1.76-11.23,1.76l.87,1.27,1.93-.11h0s-1.23.07-1.23.07l.33.17h.1s-10.91,3.16-10.91,3.16h.03c-.06.01-.1.02-.14.03l-.44.13h2.6l.44-.13c.05-.02.08-.03.09-.04l13.41-2.68-1.14.49-.06.02-2.32.68h.77l-3.19,1.38h0l-.5.28h5.02c.53-.16-.12-.28-1.45-.28h-.01l4.87-1.38h7.67l2.32-.68.2-.06.94-.27c.24-.07-.05-.13-.66-.13Zm-3.47-.07l-.22.07h-2.74l.44-.13h1.5c.15,0,.31,0,.47-.01h.34c.25,0,.35.03.22.07Zm-11.24-1.92l2.92-.39h.05s-.63.55-.63.55l-2.09.5-.25-.65Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m129.8,421.63h13.19v6.97c0,.55-.45.99-.99.99h-9.03c-1.75,0-3.17-1.42-3.17-3.17v-4.8h0Z",
    transform: "translate(272.79 851.24) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 129.8,
    y: 419.27,
    width: 13.19,
    height: 5.35,
    rx: 2.67,
    ry: 2.67,
    transform: "translate(272.79 843.89) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m134.07,419.27h.53v-.59c0-.35.21-.65.46-.65h2.68c.25,0,.46.3.46.65v.59h.53v-.59c0-.65-.44-1.19-.99-1.19h-2.68c-.55,0-.99.53-.99,1.19v.59Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 134.44,
    y: 413.49,
    width: 3.48,
    height: 1.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m134.44,415.27h3.48v1.13c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-1.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m138.08,400.84c0,6.38.07,12.89.07,12.89h-2.78l.04-27.2h1.19s1.48,5.44,1.48,14.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m129.66,373.11h0c2.02,0,3.65,1.64,3.65,3.65v.54h-3.65v-4.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "122.55 411.98 122.46 443.15 124.98 443.15 130.45 411.98 122.55 411.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "135.54 411.98 135.16 442.08 132.1 442.08 128.41 411.98 135.54 411.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "136.6 386.53 131.92 384.34 126.71 384.34 121.02 386.06 121.7 396.47 123.25 402.68 122.54 410.82 122.54 413.82 135.54 411.98 136.6 386.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "131.31 397.57 124.84 391.5 127.28 390.42 124.47 388.81 126.67 384.39 126.97 384.55 124.92 388.66 128.07 390.46 125.47 391.61 131.2 396.99 133.99 390.96 132.02 390.33 134.15 388.82 131.06 383.87 131.34 383.67 134.61 388.92 132.8 390.2 134.47 390.73 131.31 397.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "134.55 413.91 129.83 411.3 130.02 399.41 131.14 397.12 131.44 397.29 130.36 399.5 130.17 411.09 134.7 413.59 134.55 413.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "126.45 384.47 129.58 392.62 131.2 396.86 131.43 392.87 131.92 384.48 129.71 384.47 129.61 384.47 126.45 384.47"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "130.06 388.09 131.11 386.5 129.67 384.7 128.31 386.5 130.06 388.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "129.27 385.37 129.35 387.34 129.58 392.62 131.2 396.86 131.43 392.87 130.52 387.19 130.21 385.25 129.27 385.37"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m131.92,384.48s-.72,1.14-2.74,1.14-2.74-1.14-2.74-1.14v-7.37h5.48v7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m131.92,384.26v-3.55h-4.52s0,3.55,4.52,3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m135.18,442.08h-3.07l.46,2.54h5.02c0-1.4-1.08-2.54-2.41-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m123.76,442.08h0c-.72,0-1.3.61-1.3,1.37v1.17h2.6v-1.17c0-.76-.58-1.37-1.3-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m133.03,376.89h0v3.24h0c.42,0,.75-.36.75-.8v-1.64c0-.44-.34-.8-.75-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m133.32,383c-3.84,1.41-6.13-1.54-6.13-1.54v-6.45c0-.78.53-1.4,1.19-1.4h2.2c2.29,0,2.74,2.02,2.74,3.4v5.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m127.19,372.54h0c-.97,0-1.76.83-1.76,1.86v4.07h3.14v-4.47c0-.8-.62-1.46-1.38-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m126.18,376.89h0c-.42,0-.75.36-.75.8v1.64c0,.44.34.8.75.8h.76v-2.43c0-.44-.34-.8-.76-.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "132.13 379.77 131.41 379.77 131.41 379.43 131.77 379.43 131.69 378.7 132.01 378.66 132.13 379.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m127.46,413.06l-.13-.16c-1.37-1.65-3.24-1.68-3.26-1.68v-.36c.08,0,1.93.03,3.38,1.65l2.42-3.2.27.22-2.67,3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "m131.25,402.69c0,.27.21.49.46.49s.46-.22.46-.49-.21-.49-.46-.49-.46.22-.46.49Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-178",
    cx: 131.71,
    cy: 407.14,
    rx: 0.46,
    ry: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m129.38,380.68h2.85v1.17s-1.85.37-2.85-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m129.18,375.43h0c-.82,0-1.49.7-1.49,1.57v2.04h1.49v-3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m129.95,371.41h3.41c0,1.85-1.5,3.36-3.36,3.36h-3.41c0-1.85,1.5-3.36,3.36-3.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "134.05 442.08 133.68 415.83 134.02 415.83 134.39 442.08 134.05 442.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "123.92 442.1 123.59 442.06 125.88 418.12 126.21 418.15 123.92 442.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "135.6 414.08 135.26 414.06 136.22 390.66 136.56 390.67 135.6 414.08"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "121.56 413.06 124.5 411.1 125.4 412.6 122.46 414.56 121.56 413.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m124.75,415.63l-.95.63-1.11-1.86,2.71-1.81h0c.61,1.03.33,2.38-.65,3.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m124.5,411.1l-4.12-9.83,1.99-4.47-1.34-10.74c-2.93,5.15-5.22,15.9-5.22,15.9l5.2,11.44,3.5-2.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "123.66 409.03 123.48 408.73 126.36 406.8 126.54 407.1 123.66 409.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "123.71 408.86 123.43 408.66 125.9 404.73 126.19 404.93 123.71 408.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "124.5 405.59 124.21 405.4 125.38 403.45 123.32 402.95 123.39 402.61 125.92 403.22 124.5 405.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "122.1 397.81 121.8 397.64 123.17 394.87 121.79 389.91 122.12 389.81 123.54 394.9 122.1 397.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m123.54,416.6l-.12-.34s1.62-.64,1.97-1.68c.36-1.08.17-2.3.17-2.31l.33-.06c0,.05.21,1.32-.18,2.49-.4,1.2-2.1,1.87-2.17,1.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "125.63 413.76 122.77 407.41 123.08 407.25 125.93 413.6 125.63 413.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "117.74 401.78 117.69 401.43 120.13 401.04 120.18 401.39 117.74 401.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "120.08 401.26 117.65 400.07 117.79 399.75 120.22 400.93 120.08 401.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "120.32 400.07 119.01 399.4 119.16 399.07 120.47 399.75 120.32 400.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "129.49 418.41 129.16 418.35 129.54 416.16 130.85 415.12 131.05 415.41 129.85 416.36 129.49 418.41"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 134.22,
    y: 393.84,
    width: 1.97,
    height: 0.36
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "136.02 402.92 135.8 402.64 137.1 401.47 137.32 401.74 136.02 402.92"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m185.91,436.93l-.97-.06.26-.07c.65-.17-.37-.34-1.84-.36l-.2.06c1.16.02,2.09.16,1.55.3l-.17.04-2.08-.13,1.71-.5h0s0,0,0,0l.43-.13h.26c.43,0,.92-.04,1.1-.09l.27-.08.26-.08.11-.03.28-.08.3-.09s1.14-.28-.93-.32c0,0,.26.02.42.05-.12-.02-.27-.03-.43-.05,0,0,0,0,0,0,0,0-2.02-.24-4.9.05h0c-1.17.09-2.17.22-2.67.36l-2.08.61-.4.12-.47.14h1.24c-.06,0-.13.02-.19.03l-.85.14-3.93.18h-.04c-3.17.32-6.22,1.23-5.6,1.65l-10.73,3.17h.9l-3.98,1.21h-.01c-1.31,0-2.79.12-3.31.28h4.92l1.4-.28h0l5.46-1.21h3.55l-2.4,1.31c-.08.01-.15.03-.2.04l-.43.13h2.55l.43-.13s.02,0,.03-.01h0l4.56-1.34,12.22-3.5c.62-.1,1.34-.23,2.17-.39,3.94-.75,2.42-.93,2.42-.93Zm-9.07-.25l-.08.02h-.09s.16-.02.16-.02Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "163.99 411.21 164.08 441.98 161.61 441.79 156.24 411.21 163.99 411.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "151.25 411.21 151.62 440.73 154.63 440.73 158.24 411.21 151.25 411.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m151.6,440.73h3.01l-.46,2.49h-4.92c0-1.38,1.06-2.49,2.36-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m162.81,440.73h0c.7,0,1.27.6,1.27,1.34v1.15h-2.55v-1.15c0-.74.57-1.34,1.27-1.34Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "150.43 386.24 154.74 384.1 159.91 384.1 164.39 386.24 164.04 429.82 150.58 429.82 150.43 386.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "155.12 397.06 151.84 390.36 153.56 389.84 151.68 388.58 155.09 383.43 155.36 383.63 152.15 388.48 154.37 389.97 152.32 390.58 155.22 396.51 161.19 391.22 158.49 390.09 161.76 388.33 159.64 384.3 159.93 384.13 162.22 388.47 159.29 390.05 161.83 391.11 155.12 397.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "153.83 429.83 153.71 398.06 155.06 396.89 155.27 397.16 154.04 398.22 154.16 429.82 153.83 429.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "160.15 384.19 156.91 392.22 155.23 396.38 154.99 392.46 154.48 384.23 156.77 384.22 156.88 384.22 160.15 384.19"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "156.48 387.53 155.17 385.99 156.84 384.14 158.19 386.06 156.48 387.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "157.23 385.1 157.14 387.03 156.91 392.22 155.23 396.38 154.99 392.46 155.93 386.89 156.25 384.98 157.23 385.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "m154.48,384.23s.75.7,2.84.7,2.84-.7,2.84-.7v-4.54h-5.69v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m154.48,384v-2.75h4.7s-.83,2.48-4.7,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "m163.72,398.9l-.29-.66c-.63-1.45-2.26-2.08-3.63-1.41l-.15.07.22.5c.67,1.54,2.4,2.21,3.85,1.5h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-205",
    points: "159.8 399.37 160.74 398.77 159.65 396.87 158.71 397.47 159.8 399.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "m150.76,399.23l.16-.71c.36-1.55,1.84-2.5,3.31-2.12l.16.04-.12.54c-.38,1.64-1.95,2.65-3.51,2.25h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "150.69 398.53 158.89 397.48 159.73 399.88 150.65 401.47 150.69 398.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-205",
    points: "153.21 398.42 154.28 398.69 154.78 396.54 153.71 396.26 153.21 398.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "m157.11,370.94h0c-2.26,0-4.1,1.94-4.1,4.32v6.58c5.25,1.96,7.15-2.16,7.15-2.16v-3.4h1.05v-1.02c0-2.39-1.84-4.32-4.1-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m158.81,373.63h2.4v2.18c0,.71-.58,1.29-1.29,1.29h0c-.71,0-1.29-.58-1.29-1.29v-2c0-.1.08-.18.18-.18Z",
    transform: "translate(319.84 750.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "m160.42,375.17h.79v2.57c0,.44-.35.79-.79.79h0c-.43,0-.78-.35-.78-.78v-1.79c0-.43.35-.78.78-.78Z",
    transform: "translate(320.85 753.71) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m155,378.4h-.56s-.09-.02-.12-.05-.05-.08-.05-.13l.1-2.12.33.02-.09,1.94h.38v.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m159.39,400.87l5-14.63s2.12,1.6.75,8.4c-1.19,5.9-2.39,7.11-2.39,7.11l-3.37-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m151.35,386.22h-.91c-2.12,3-2.03,11.54.22,15.25l.69-.35,1.67-.61-.66-4.17-1.01-10.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m162.75,401.75c-6.94-1.78-8.62-2.41-8.62-2.41l.65-2.8,8.71,1.99-.74,3.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "160.53 398.03 154.75 396.71 154.82 396.37 160.32 397.63 161.96 392.83 162.27 392.94 160.53 398.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "162.84 401.96 154.09 399.51 154.18 399.17 162.66 401.55 163.71 399.29 164.01 399.45 162.84 401.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "151.24 401.55 151.18 401.2 157.2 400.04 157.26 400.38 151.24 401.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "152.59 398.3 151.51 393.08 151.84 393.01 152.92 398.22 152.59 398.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m154.87,378.4h0c.83,0,1.51.68,1.51,1.51v.11h-3.02v-.11c0-.83.68-1.51,1.51-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m153.01,380.78h3.66c1.74,0,1.95-1.89,1.95-3.75h1.01v3.41c0,1.46-1.12,2.65-2.51,2.65h-4.11v-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "m153.36,380.14h2.91c0,.88-.71,1.59-1.59,1.59h-.45c-.49,0-.88-.39-.88-.88v-.71h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m154.44,371.99s.6.48,1.35.23c2.01-.68,3.38-.68,3.38-.68,0,0-2.85-2.2-4.73.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m159.18,371.53s.99.46.99,1.41c0,.95-.67,1.45-.67,1.45l1.71.07s.2-2.51-2.04-2.94Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "163.86 411.98 160.58 411.98 160.58 410.39 160.91 410.39 160.91 411.62 163.86 411.62 163.86 411.98"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "m163,395.89l.02-.35c1.11.07,1.56-.95,1.61-1.85l.21-3.94c.06-1.07-.72-1.99-1.73-2.05l-.77-.05c-1.01-.06-1.89.76-1.94,1.83l-.21,3.94c-.05.89.29,1.96,1.4,2.03l-.02.35c-1.1-.07-1.79-1.03-1.71-2.4l.21-3.94c.07-1.26,1.1-2.23,2.3-2.16l.77.05c1.2.07,2.12,1.16,2.05,2.42l-.21,3.94c-.07,1.37-.86,2.25-1.96,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m163.14,387.26h-.02s.12-2.17.12-2.17c.08-1.51-1.52-3.05-3.07-3.24v.52c1.21.14,2.63,1.44,2.56,2.69l-.12,2.17-.25-.02c-1.24-.08-2.31.93-2.39,2.24l-.13,2.35.5.03.13-2.35c.06-1.02.89-1.8,1.86-1.74l.77.05c.97.06,1.71.94,1.65,1.96l-.13,2.35.5.03.13-2.35c.07-1.31-.88-2.44-2.13-2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m161.7,395.63c0,.16-.14.28-.29.27s-.26-.14-.26-.3.14-.28.29-.27.26.14.26.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m163.41,395.76c0,.16-.14.28-.29.27s-.26-.14-.26-.3.14-.28.29-.27c.15,0,.26.14.26.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m154.16,383.33l-1.89,6.19c-.4,1.31.08,2.69,1.08,3.45h0c.06-.18.15-.33.28-.44-.83-.63-1.22-1.77-.89-2.85l1.73-5.67v-.93h-.23c-.03.08-.07.16-.09.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m153.35,392.97h0c.24.18.51.33.8.43l.15-.51c-.25-.08-.47-.21-.68-.36-.13.11-.23.26-.28.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "m153.92,394.14c.46.16.96-.11,1.11-.6.15-.49-.11-1.01-.57-1.17-.3-.1-.6-.03-.83.17-.13.11-.23.26-.28.44h0c-.15.49.11,1.01.57,1.17Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m99.94,440.54l-.43.02c-1.18-.65-3.11-.93-3.11-.93l-.58-.03h.06s-1.51-.09-1.51-.09h-.04s-2.04-.11-2.04-.11l1.71-.5h0,.03s.26,0,.26,0c.43,0,.92-.04,1.1-.09l.64-.19c.17-.05-.04-.09-.47-.09-.03,0-.07,0-.1,0l.2-.06.28-.08h.04s2.15-.01,2.15-.01l.35-.1h-.93l.56-.16c.64-.19.39-.35-.52-.45l.43-.13h-.54c-.34,0-.69,0-1.03.02l.06-.02h-.54c-.29,0-.59,0-.89.01h.05s-.54-.01-.54-.01c-1.39,0-2.93.11-3.79.26-.86.09-1.56.2-1.96.32l-.56.16h-1.11l-.35.1h1.84-.04s-.28.09-.28.09l-.22.07c-.32.01-.63.05-.76.08l-.64.19c-.13.04-.04.07.18.08h0c-.41.12-.19.23.5.28l-.54.16-.25.07-3.01.12h.01s-2.05.07-2.05.07h-.01s-.59.03-.59.03c0,0-3.84.28-9.44.93l-.28-.02-2.82.36.98.03c.98.47,2.85.76,3.41.84l-.58.17c-.27.08-.05.15.49.17l-.33.1h1.24l-.64.22-11.25,3.24h-.17c-1.31,0-2.79.12-3.31.28h5.38l.94-.28h1.33l11.79-2.85h.04s-7.19,2.85-7.19,2.85h.88l-.94.28h5.38c.52-.15-.12-.28-1.42-.28h-.17l9.66-2.78h.92l2.62-.77c.79-.01,1.64-.09,1.95-.18l.58-.17c1.12-.08,5.1-.38,9.37-.86l.65-.02s0,0-.01,0h.42s-.46-.34-.46-.34Zm-27.16.49h.45s1.77-.21,1.77-.21l-.22-.02,4.1-.44-3.7,1.31c-.13-.02-.36-.04-.66-.04h-.05l-1.67-.61Zm16.41.61h-.05c-.26,0-.54.01-.79.03l5.12-1.29,1.11.43-.34.02.27.22.59-.02-5.91.62Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m58.56,407.1h0c1.34,0,2.43,1.09,2.43,2.43v1.89h0c-1.34,0-2.43-1.09-2.43-2.43v-1.89h0Z",
    transform: "translate(119.55 818.51) rotate(-180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "73.53 410.03 73.3 443.44 69.58 443.44 66.27 410.03 73.53 410.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "60.99 410.03 60.77 443.44 64.94 443.44 67.59 410.03 60.99 410.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m58.24,445.94c0-1.38,1.06-2.49,2.36-2.49h3.01v2.49h-5.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m75.84,445.94h-5.38v-2.49h3.01c1.31,0,2.36,1.12,2.36,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m53.81,398.32l6.09,8.96-1.11,1.17s-3.67-2.92-6.79-8.23l1.8-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m51.55,400.27l4.41,1.21,5.88-8.89-2.42-3.64s-3.85,3.37-7.87,11.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "57.53 399.69 56.51 401.67 51.22 400.43 52.79 397.13 57.53 399.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m75.74,407.11h0v1.89c0,1.34-1.09,2.43-2.43,2.43h0v-1.89c0-1.34,1.09-2.43,2.43-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m80.48,398.33l-6.09,8.96,1.11,1.17s3.67-2.92,6.79-8.23l-1.8-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m82.75,400.28l-4.41,1.21-5.88-8.89,2.42-3.65s3.85,3.38,7.87,11.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "76.77 399.71 77.79 401.68 83.08 400.08 81.5 397.14 76.77 399.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m63.15,378.96h0v3.36h0c-.43,0-.78-.37-.78-.83v-1.71c0-.46.35-.83.78-.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "60.99 413.06 73.43 413.06 74.88 388.95 69.73 386.81 64.56 386.81 59.42 388.95 60.99 413.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m64.31,386.94s.75.7,2.84.7,2.84-.7,2.84-.7v-4.54h-5.69v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m64.31,386.24v-2.75h4.7s-.83,2.48-4.7,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m70.16,377.7v1.63h-.17v4.36s-1.93,1.72-4.71,1.42c-1.39-.15-2.44-1.38-2.44-2.85v-4.55c0-.55.11-1.08.31-1.55.18-.42.43-.8.73-1.12.65-.68,1.54-1.11,2.53-1.11h.16c1.97,0,3.58,1.69,3.58,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "m70.16,377.7v1.63h-.17v.84h-1.2v-2.48c0-.85-.65-1.53-1.45-1.53h-4.19c.18-.42.43-.8.73-1.12.65-.68,1.54-1.11,2.53-1.11h.16c1.98,0,3.58,1.69,3.58,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m70.26,378.96h0c.43,0,.78.37.78.83v1.71c0,.46-.35.83-.78.83h-.79v-2.52c0-.46.35-.84.79-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m64.83,381.48c-.19,0-.37-.08-.51-.23-.13-.15-.2-.34-.2-.54l.02-.6h.33s-.02.61-.02.61c0,.11.03.21.11.29.07.08.17.12.27.12v.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "m67.39,375.62h1.45v2.64h0c-.8,0-1.45-.65-1.45-1.45v-1.18h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 61,
    y: 376.68,
    width: 11.3,
    height: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "m66.75,370.32h0c-2.56,0-4.63,2.19-4.63,4.89v1.47h9.27v-1.47c0-2.7-2.07-4.89-4.63-4.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "m65.37,376.84h-1.1v-3.65c0-1.76,1.36-3.19,3.02-3.19h.54v1.16h-.54c-1.06,0-1.92.91-1.92,2.02v3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "m63.99,376.84h-1.1v-3.65c0-1.76,1.36-3.19,3.02-3.19h.54v1.16h-.54c-1.06,0-1.92.91-1.92,2.02v3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "m66.87,376.84h-1.1v-3.65c0-1.76,1.36-3.19,3.02-3.19h.54v1.16h-.54c-1.06,0-1.92.91-1.92,2.02v3.65Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m65.93,382.87h-1.47v-.35h1.47c.23,0,.44-.09.61-.26l.07-.07.23.26-.07.07c-.22.23-.52.35-.84.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "61.15 417.95 60.67 408.13 73.73 408.13 73.29 417.34 61.15 417.95"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 61.73,
    y: 394.12,
    width: 10.17,
    height: 17.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "71.45 396.97 69.67 396.25 72.43 387.87 74.21 388.58 71.45 396.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "62 397.26 63.78 396.54 61.69 387.93 59.91 388.64 62 397.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "70.34 399.93 63.29 399.93 63.29 397.91 63.62 397.91 63.62 399.58 70 399.58 70 397.91 70.34 397.91 70.34 399.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m70.06,406.06h-6.41v-6.47h6.41v6.47Zm-6.09-.33h5.78v-5.81h-5.78v5.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 60.48,
    y: 409.29,
    width: 13.25,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 63.73,
    y: 407.76,
    width: 2.29,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 59.63,
    y: 408.42,
    width: 2.54,
    height: 3.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 63.88,
    y: 410.38,
    width: 1.89,
    height: 0.35
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "61.38 410.73 59.81 410.73 59.81 410.38 61.05 410.38 61.05 408.76 61.38 408.76 61.38 410.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m65.08,409.77c0,.12-.09.22-.21.22s-.21-.1-.21-.22.09-.22.21-.22.21.1.21.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m60.13,409.99c0,.12-.05.22-.1.22s-.1-.1-.1-.22.05-.22.1-.22.1.1.1.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 68.39,
    y: 408.82,
    width: 6,
    height: 9.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 69.1,
    y: 409.55,
    width: 4.72,
    height: 3.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 69.61,
    y: 410.4,
    width: 0.58,
    height: 2.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 70.38,
    y: 410.75,
    width: 0.68,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 72.63,
    y: 410.75,
    width: 0.54,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 71.39,
    y: 410.2,
    width: 0.88,
    height: 2.78
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 62.76,
    cy: 395.83,
    rx: 0.5,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m71.33,395.67c0,.29-.22.52-.5.52s-.5-.23-.5-.52.22-.52.5-.52.5.23.5.52Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-246"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 62.84,
    y: 377.6,
    width: 7.32,
    height: 0.84
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m208.26,437.35h.03s-2.78-.13-2.78-.13h-.05s1.07-.31,1.07-.31l.59-.17.11-.03h.2c.39,0,.83-.04.98-.08l.56-.16c.06-.02.07-.03.04-.05l.31-.09c.09,0,.19,0,.29,0,1.66,0,3.54-.16,4.2-.35.66-.19-.15-.35-1.81-.35-1.31,0-2.75.1-3.63.23-.29-.01-.62-.02-.98-.02h-.13c-1.33,0-2.79.09-3.84.22-.51.06-.93.14-1.2.21l-1.54.45c-.45.13-.25.26.59.31.22.01.47.02.72.03l-.37.11-.17.05-3.75.16-2.54.53h-1.64s-4.13,1.37-4.13,1.37h2.92s-.32.1-.32.1c-2.83.38-5.65,1.07-9.77,2.44h1.4c-1.45.68-2.22,1.22-2.22,1.22h-.86c-1.2,0-2.6.12-3.12.28h4.27,0s.33,0,.33,0h0s.32,0,.32,0h4.44c.52-.15-.03-.28-1.24-.28h-1.19s3.4-.68,6.13-1.22h1.42c5.61-1.3,7.61-1.75,7.24-2.44h0s-.38-.14,1.81-.59l6.89-.2h0s1.36-.04,1.36-.04l-.95-1.21Zm-2.63.65l.28.39-3.5.13c.84-.15,1.9-.32,3.22-.52Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "177.45 389.66 175.94 399.41 178.62 399.89 177.45 389.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m182.35,407.73v33.09h-1.88s-1.9-8.58-2.7-17.35c-.56-6.1-.58-12.29.94-15.75h3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m179.6,440.82c-1.2,0-2.18,1.12-2.18,2.49h4.92v-2.49h-2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m186.44,423.67c-.11.71-3.02,17.15-3.02,17.15h-1.56v-33.09h3.71c2.37,6.2,1.84,9.89.86,15.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m184.61,440.82c1.2,0,2.18,1.12,2.18,2.49h-4.92v-2.49h2.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 181.71,
    y: 423.47,
    width: 0.32,
    height: 17.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 181.7,
    y: 440.82,
    width: 0.33,
    height: 2.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m186.8,429.76h-9.69c-.56-12.38-.07-18.57,1.45-22.03h7.16c2.72,6.2,2.24,10.24,1.08,22.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "187.87 389.34 185.6 391.14 190.11 401.03 192.96 400.29 187.87 389.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "m178.55,407.73l-.13,1.56,2.56-1.56,2.75,1.8,1.98-1.8s-1.81-2.65,1.82-12.55l.36-5.87-3.19-1.1-3.71-.2-3.53,1.65,1.1,18.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "182.48 397.79 185.46 393.54 184.41 392.1 186.46 391.7 184.79 388.69 184.5 388.87 185.93 391.44 183.82 391.86 185.04 393.55 182.22 397.59 182.48 397.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "181.43 398 181.71 397.81 178.97 393.37 180.71 391.99 178.9 391.13 181.1 388.61 180.86 388.37 178.34 391.25 180.06 392.07 178.53 393.29 181.43 398"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "183.55 389.92 181.87 397.87 180.63 389.92 183.55 389.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "184.68 388.21 185.6 391.83 181.89 390.66 178.91 391.57 180.98 388.02 184.68 388.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "180.98 388.29 181.89 390.66 183.61 388.26 180.98 388.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "191.73 400.63 185.25 402.49 184.57 400.5 190.99 398.08 191.73 400.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "182.72 406.5 175.63 406.84 175.1 394.51 182.2 394.17 182.72 406.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "185.25 402.49 182.44 403.28 181.84 401.53 184.57 400.5 185.25 402.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m179.59,400.9h0c.98-.86,2.43-.73,3.25.3l1.01,1.27c.06.07.05.18-.02.24h0c-.98.86-2.43.73-3.25-.3l-1.01-1.27c-.06-.07-.05-.18.02-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m180.63,388.34s-.12.7,1.36.7,2.65-.7,2.65-.7v-4.54h-4.01v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m180.63,387.73v-2.84h3.63s-.64,2.56-3.63,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m185.43,379.55v2.42l-.79.06v3.34s-2.48,2.26-4.84,1.1c-1.03-.51-1.66-1.63-1.66-2.83v-4.09c0-.7.17-1.36.47-1.93.61-1.17,1.78-1.96,3.1-1.96h.13c1.97,0,3.58,1.74,3.58,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "m185.43,379.55v2.57h-1.74l-.38-2.13-4.7-2.37c.61-1.17,1.78-1.96,3.1-1.96h.13c1.97,0,3.58,1.74,3.58,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m184.83,380.54h.72v2.24c0,.4-.32.72-.72.72h0c-.39,0-.71-.32-.71-.71v-1.54c0-.39.32-.71.71-.71Z",
    transform: "translate(369.66 764.04) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m179.48,383.97v-.35c-.22,0-.39-.19-.39-.41v-.66h-.33v.66c0,.42.32.76.72.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m180.85,385.36c.73,0,1.08-.64,1.16-1l-.32-.08s-.19.8-.94.72l-.03.35s.1,0,.14,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 189.28,
    y: 398.7,
    width: 1.81,
    height: 0.23
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "190.54 400 190.65 399.8 189.26 398.92 189.14 399.12 190.54 400"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-93",
    cx: 185.73,
    cy: 376.89,
    rx: 3.01,
    ry: 3.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m459.06,237.53h-.01l7.11-3.02h0s0,0,0,0h.02s.03-.02.03-.02h0l1.91-.64c.13,0,.29.01.47.01h.98l.32-.09c.48-.03.89-.08,1.09-.14.29-.08,0-.15-.63-.17,2.4-.74,2.49-1.19,2.49-1.19h-.04l-1.52-.1.04-.02-1.34-.08h-.01s0,0,0,0h.02s.21-.07.21-.07l.23-.07c.44-.03.81-.08.99-.13.12-.04.35-.1.62-.18.38,0,.8-.04.95-.08l.42-.12.15-.04,1.05-.31c.67-.2-.15-.36-1.83-.36h-1.31c-.32,0-.68.03-.82.07h-.19c-.98,0-2.09.09-2.48.21l-.54.16-.51.15c-.38,0-.8.04-.95.08l-.56.16c-.15.04.03.08.41.08-.27.08-.5.15-.62.18-.21.06-.06.11.23.14l-.4.12h-.12s.02-.03.02-.03l-1.66.06-.04.06-2.56.11s-2.84.43-5.46,1.15h0c-.18.05-.36.1-.54.15-.15.04-.41.12-.55.17,1.26,0,2.29,0,3.13-.01l-1.83.78h0s-.06.02-.06.02h.02l-7.61,3.12h0s-.02,0-.04,0l-.38.11h2.22l.38-.11s.08-.03.08-.04l9.21-2.43-2.83,2.34h0l-.42.24h4.29c.45-.13-.1-.24-1.24-.24Zm-1.33-4.1l.6-.15-.35.15h-.24Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m453.27,188.09h.8s1.59,4.48,1.59,11.78c0,.4,0,.8-.02,1.2h-2.37l-.24-3.91.24-9.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m455.39,201.94h-.78v-3.1h.78c.81,0,1.47.69,1.47,1.55h0c0,.86-.66,1.55-1.47,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m448.31,174.75h0v5.2h-3.45v-1.75c0-1.9,1.54-3.45,3.45-3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m451.09,179.4h0v2.93h0c.38,0,.68-.32.68-.72v-1.49c0-.4-.31-.72-.68-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m444.86,179.4h0v2.93h0c-.38,0-.68-.32-.68-.72v-1.49c0-.4.31-.72.68-.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "454.07 188.11 450.32 186.24 445.81 186.24 441.91 188.11 444.29 208.31 455.03 208.31 454.07 188.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "445.12 186.58 448.07 190.88 450.89 186.53 450.54 186.36 445.6 186.32 445.12 186.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "448.38 192.95 445 188.53 445.23 188.33 448.35 192.41 450.72 188.18 450.97 188.34 448.38 192.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "454.6 201.16 454.2 192.37 454.49 192.36 454.89 201.15 454.6 201.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m450.54,186.36s-.65.61-2.48.61-2.48-.61-2.48-.61v-3.96h4.96v3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m450.54,185.75v-2.4h-4.09s.72,2.16,4.09,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m450.75,183.59c-2.69,3.24-5.54.04-5.54.04v-5.58c0-.74.55-1.35,1.23-1.35h3.08c.68,0,1.23.6,1.23,1.35v5.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "444.29 208.31 447.36 236.69 449.51 236.52 450.67 208.31 444.29 208.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "455.03 208.31 458.22 235.6 455.6 235.6 448.93 208.31 455.03 208.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m458.23,235.6h-2.63l.4,2.17h4.29c0-1.2-.92-2.17-2.06-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m448.47,235.6h0c-.61,0-1.11.52-1.11,1.17v1h2.22v-1c0-.65-.5-1.17-1.11-1.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "445.59 186.36 446.45 189.02 448.06 186.97 445.59 186.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "450.54 186.36 449.68 189.02 448.06 186.97 450.54 186.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m448.04,183.6c-.37,0-.78-.07-1.17-.3l.14-.27c.92.55,2.1.06,2.11.05l.11.28s-.55.24-1.2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m444.29,208.31l.27,2.52s5.19.39,5.39-2.52h-5.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m450.48,208.31c.68,2.91,4.84,2.52,4.84,2.52l-.3-2.52h-4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m449.95,182.94s-1.56.13-1.88-.34c-.24.52-1.88.34-1.88.34,0,0,.38-1.23,1.93-1.23s1.84,1.23,1.84,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m450.75,178.06v2.93c0,1.45-1.18,1.91-1.18,1.91,0,1.19-1.25,1.27-1.59,1.28-.34,0-1.59-.09-1.59-1.28,0,0-1.18-.46-1.18-1.91v-2.93h-.35v5.91c0,1.73,3.06,2.29,3.12,2.28.06,0,3.12-.55,3.12-2.28v-5.91h-.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "448.46 181.72 447.82 181.72 447.82 181.42 448.15 181.42 448.09 180.49 448.38 180.47 448.46 181.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m447.42,174.14h1.31c1.68,0,3.05,1.36,3.05,3.05v3.32h0c-2.73,0-4.95-2.22-4.95-4.95v-.82c0-.33.27-.59.59-.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "450.58 214.42 450.27 214.4 450.39 212.27 451.45 211.1 451.68 211.33 450.7 212.42 450.58 214.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m448.07,185.19h0c-.25,0-.45-.21-.45-.48v-.45c0-.26.2-.48.45-.48h0c.25,0,.45.21.45.48v.45c0,.26-.2.48-.45.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m445.02,178.5h0v-2.29h.92v1.33c0,.53-.41.97-.92.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m442.74,188.09l-.83.02s-1.56,4.46-1.56,11.76c0,.4,0,1.11.02,1.51l2.37-.31.24-3.91-.24-9.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m440.37,201.38c4.67-.14,6.21-.31,6.21-.31v-2.52l-6.21-.06v2.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 446.58,
    y: 198.56,
    width: 0.96,
    height: 1.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "m450.98,191.93l.59-.05c.52-.05.91-.53.87-1.08l-.3-3.78-1.61-.71.44,5.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "451.5 198.58 452.15 198.53 451.63 191.87 450.98 191.93 451.5 198.58"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m454.9,198.61l-.16,2.66c0,.06-.02.12-.05.17-.06.1-.17.16-.29.15l-5.35-.36c-.12,0-.22-.08-.26-.19-.02-.05-.04-.11-.03-.17l.16-2.66c0-.09.04-.17.1-.22.06-.06.15-.1.24-.09l5.35.36c.18.01.31.17.3.36Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-250"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "m450.83,199.07l-.11,1.74c-.01.2-.17.35-.36.33l-1.58-.11c-.02-.05-.04-.11-.03-.17l.14-2.29,1.62.11c.19.01.33.18.32.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-250"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "m454.88,198.98l-.14,2.29c0,.06-.02.12-.05.17l-.63-.04c-.19-.01-.33-.18-.32-.38l.11-1.74c.01-.2.17-.35.36-.33l.68.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m454.11,199.34c-.02.26-.23.46-.48.44l.06-.94c.25.02.43.24.42.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m450.5,200.34c-.01.17.11.32.28.33l.04-.62c-.16-.01-.3.12-.32.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m452.15,201.3h0c-.8-.05-1.41-.78-1.36-1.63l.08-1.25c.05-.84.74-1.49,1.54-1.43h0c.8.05,1.41.78,1.36,1.63l-.08,1.25c-.05.84-.74,1.49-1.54,1.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-248"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m454.8,200.18l-.07,1.09c0,.06-.02.12-.05.17-.06.1-.17.16-.29.15l-2.41-.16-.1-.03-.69-.51,1.88-2.4,1.72,1.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m452.15,201.4h0c-.74-.05-1.3-.72-1.25-1.5l.06-.95c.05-.78.68-1.37,1.42-1.32h0c.74.05,1.3.72,1.25,1.5l-.06.95c-.05.78-.68,1.37-1.42,1.32Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-90",
    cx: 452.24,
    cy: 199.76,
    rx: 1.48,
    ry: 1.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m453.56,199.85c-.05.76-.67,1.34-1.4,1.3-.19-.01-.37-.07-.52-.15h0c-.21-.11-.38-.28-.5-.49-.14-.24-.22-.53-.2-.83.05-.76.67-1.34,1.4-1.3.25.02.49.11.68.25.36.27.58.72.55,1.22Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "m453.36,199.84c-.04.65-.57,1.14-1.19,1.1-.62-.04-1.08-.6-1.04-1.25.04-.65.57-1.14,1.19-1.1.62.04,1.08.6,1.04,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m452.17,200.98c-.64-.04-1.12-.62-1.08-1.29.04-.67.59-1.18,1.23-1.14.64.04,1.12.62,1.08,1.29-.04.67-.59,1.18-1.23,1.14Zm.14-2.35c-.59-.04-1.11.44-1.15,1.06-.04.63.41,1.17,1.01,1.21.59.04,1.11-.44,1.15-1.06.04-.63-.41-1.17-1.01-1.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m453.04,199.82c-.03.47-.41.82-.85.79-.44-.03-.78-.43-.75-.9.03-.47.41-.82.85-.79s.78.43.75.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-248"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m453.01,198.63l-1.37,2.36h0s0,0,0,0c0,0-.16-.09-.28-.21-.12-.12-.22-.28-.22-.28-.14-.24-.22-.53-.2-.83.05-.76.67-1.34,1.4-1.3.25.02.49.11.68.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m452.89,199.6c0,.09-.08.16-.16.15s-.15-.08-.14-.17.08-.16.16-.15c.08,0,.15.08.14.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m452.6,200.01s-.04.08-.09.08c-.04,0-.08-.04-.08-.09,0-.05.04-.08.09-.08.04,0,.08.04.08.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "m453.02,197.48l-1.27-.09c-.07,0-.12-.07-.12-.14h0c0-.07.06-.13.13-.12l1.27.09c.07,0,.12.07.12.14h0c0,.07-.06.13-.13.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "454.58 198.56 454.13 198.53 454.13 198.41 454.58 198.44 454.58 198.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "454.4 198.72 454.12 198.7 454.12 198.58 454.41 198.6 454.4 198.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "454.43 201.36 454.15 201.34 454.15 201.22 454.44 201.24 454.43 201.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "454.59 198.25 453.95 198.21 453.96 198.02 454.6 198.07 454.59 198.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "m450.19,198.2v.19c-.02.08-.07.14-.12.13l-1.18-.08v-.24c.02-.09.06-.17.11-.22l1.09.07c.06,0,.1.07.09.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m450.02,198.26c0,.06-.14.1-.3.09-.16-.01-.29-.07-.28-.12,0-.06.14-.1.3-.09.16.01.29.07.28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m452.08,201.26s-.1-.01-.14-.02v-.07c.06.01.1.02.15.02v.07Zm.14,0v-.07s.09,0,.14,0v.07s-.09,0-.14,0Zm.29-.03v-.07s.08-.02.12-.03l.02.07s-.09.03-.14.04Zm-.98-.17s-.08-.05-.12-.08l.04-.06s.08.05.12.08l-.03.06Zm-.23-.18s-.07-.07-.1-.11l.05-.05s.06.07.1.1l-.05.05Zm1.74.12l-.04-.06s.07-.06.11-.09l.04.06s-.08.06-.12.09Zm-1.94-.34s-.06-.08-.08-.13l.06-.04s.05.08.08.12l-.06.04Zm2.16.14l-.05-.05s.06-.07.09-.11l.05.05s-.06.08-.1.11Zm.33-1.11s0-.1-.01-.14h.07s.01.09.01.14h-.07Zm-.04-.29s-.02-.09-.04-.14l.07-.02s.03.1.04.15l-.07.02Zm-.09-.27s-.04-.09-.07-.13l.06-.04s.05.09.07.13l-.06.03Zm-2.2-.38l-.05-.05s.07-.07.11-.1l.04.06s-.07.06-.1.1Zm2.05.13s-.06-.08-.09-.11l.05-.05s.06.08.09.12l-.06.04Zm-1.84-.32l-.04-.06s.08-.06.12-.08l.03.06s-.08.05-.12.08Zm.24-.14l-.03-.07s.09-.04.14-.05l.02.07s-.09.03-.13.05Zm1.19.08s-.08-.05-.12-.07l.03-.07s.09.04.13.07l-.03.06Zm-.93-.16v-.07s.08-.02.13-.02v.07s-.09.01-.13.02Zm.68.04s-.09-.03-.13-.04v-.07c.06.01.11.02.15.04l-.02.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "453.06 197.04 451.8 196.95 451.81 196.8 453.07 196.88 453.06 197.04"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-249"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m450.37,201.31l-.33-.02s.12-1.8.18-2.75c.03-.45.06-.57-.1-.58l.45.03-.2,3.33Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "m447.03,191.42h0c-.81.28-1.68-.19-1.95-1.05l-1.17-3.82,1.47-.5,1.64,5.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "448.98 197.77 448.36 197.99 446.41 191.63 447.03 191.42 448.98 197.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m450.06,197.47h.47c0,1.47-1.2,2.67-2.67,2.67h-.32v-.15c0-1.39,1.13-2.52,2.52-2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m453.86,199.82h0c1.32,0,2.39,1.07,2.39,2.39v.28h-.14c-1.24,0-2.25-1.01-2.25-2.25v-.42h0Z",
    transform: "translate(910.1 402.31) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "442.83 196.94 442.36 193.16 442.65 193.12 443.12 196.9 442.83 196.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "443.85 201.51 443.84 201.21 446.44 201.08 446.44 200.49 446.73 200.49 446.73 201.38 443.85 201.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "446.73 198.56 446.44 198.56 446.44 198.41 443.95 198.41 443.95 198.11 446.73 198.11 446.73 198.56"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 444.29,
    y: 208.15,
    width: 10.74,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 444.52,
    y: 206.12,
    width: 9.82,
    height: 0.31
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m255.92,442.35l-.18.06c.09-.05.16-.1.21-.14h.05s.01-.02.01-.02l1.62-.71,2.07-.54-3.77,1.34h1.29s2.9-.77,4-1.16c.38-.13.75-.31,1.08-.48h.04l6.99-2.05c.83-.24-.19-.44-2.26-.44-1.17,0-2.43.06-3.45.16-.21,0-.43,0-.67,0-2.84,0-5.33.26-6.15.5l-.25.07-.6.17-.4.12c-.81.24-.42.44.84.56l-.33.1h-.02s-3.95.12-3.95.12h0s-2.88.48-5.86,1.15h-6.03l-2.91.85h4.11c-.08.06.25.11.84.11h1.08c.58,0,1.23-.05,1.59-.11h2.16l-.43.09.44.02-.45.08c-.13.02-.26.04-.39.07-2.04.38-4.26,1.09-5.92,1.84-.03.01-.07.03-.1.04-1.48.67-3.87,1.66-3.87,1.66h2.7l6.29-1.66h.63c-2.68.86-5.94,1.66-5.94,1.66h2.36s4.74-.78,8.35-1.66c.82-.2,1.59-.41,2.22-.62.9-.29,1.55-.53,2.01-.73.76-.05,2.45-.2,2.28-.47h-1.29Zm-6.26-1.33l-.05.14h-.64l.68-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m243.03,445.82h-3.06c-.19,0-.4,0-.63,0h-3.04l-.96.28h9.13c.53-.16-.12-.28-1.45-.28Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m243.88,397.25h-7.52v-18.5c0-2.19,1.68-3.96,3.76-3.96h0c2.08,0,3.76,1.77,3.76,3.96v18.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m244.05,428.51c-.57,8.02-2.66,15.05-2.66,15.05h-2.36s.51-7.27.25-15.05c-.07-2-.19-4.04-.38-6h0c-.06-.63-.13-1.24-.21-1.84-.78-6.06-3.02-10.84-3.02-10.84h6.71s1.42,3.35,1.79,13.09c.07,1.87.02,3.76-.11,5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m239.41,409.83l-.51,12.67h0s-.24,6.01-.24,6.01l-.6,15.05h-2.7s-1.02-9.02-1.82-15.05c-.02-.14-.04-.27-.05-.4-.9-6.77-1.12-13.2-.36-16.62.15-.68.34-1.24.56-1.66h5.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "m244.41,401.63c.24,3.55-.05,10.44-.05,10.44l-1.26.09-1.4-20.77.99-.07s1.48,6.76,1.72,10.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m243.1,412.17l.29,4.35s2.38-1.27.96-4.44l-1.25.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m244.05,428.51h-10.52c-.02-.14-.04-.27-.05-.4-.9-6.77-1.12-13.2-.36-16.62l.44-1.72,8.81.07s1.42,3.35,1.79,13.09c.07,1.87.02,3.76-.11,5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m244.48,446.1c0-1.4-1.08-2.54-2.41-2.54h-3.04l.45,2.54h5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m237.6,389.85h0c-3.04,0-5.51-2.6-5.51-5.81v-2.64h5.51v8.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "239.78 381.88 239.43 382.48 239.36 382.44 239.71 381.84 239.78 381.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "242.85 411.29 241.67 411.69 240.27 409.81 237.75 411.98 232.94 409.93 233.81 404.56 232.09 399.54 231.28 391.05 234.81 389.94 238.92 389.73 242.69 391.32 242.05 404.89 242.85 411.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "234.19 406.17 233.99 405.89 236.23 404.09 236.44 404.38 234.19 406.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "234.04 405.38 233.78 405.16 235.27 403.12 235.54 403.34 234.04 405.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m239.68,399.44l-5.83-4.69,1.44-1.19-1.75-.42,3.18-4.87,4.8,4.5-.94.48,1.24.81-2.15,5.37Zm-5.27-4.69l5.13,4.13,1.86-4.67-1.52-.99,1.04-.53-4.13-3.87-2.68,4.1,1.96.47-1.66,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m234.83,389.94s.99,4,4.78,9.22c1.2-4.71-.69-9.42-.69-9.42l-4.09.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "234.83 389.94 233.5 392.11 241.17 392.11 238.92 389.73 234.83 389.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m238.92,389.94s.12.72-1.38.72-2.7-.72-2.7-.72v-4.63h4.09v4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m238.92,389.31v-2.9h-3.7s.65,2.61,3.7,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m234.05,380.99v2.46h.78v3.41s2.55,2.37,4.95,1.19c1.05-.52,1.7-1.66,1.7-2.89v-4.17c0-.72-.17-1.39-.48-1.96-.63-1.19-1.81-2-3.16-2h-.14c-2.01,0-3.64,1.77-3.64,3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m232.09,380.74v2.24c.76.19,1.66.13,1.66.13,0,0,1.28.45,2.22-.88l-.02-1.11c0-1.68,2.3.29,2.2-2.35h2.81c-.6-1.48-1.6-2.55-4.44-2.55s-4.44,2.34-4.44,4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m234.63,381.98h0c.4,0,.73.33.73.73v2.28h-.73c-.4,0-.73-.33-.73-.73v-1.57c0-.4.33-.73.73-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m239.87,384.6v-.36c.34,0,.62-.3.62-.66v-.09h.34v.09c0,.56-.43,1.02-.96,1.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "240.06 407.09 237.68 411.98 240.27 409.81 241.67 411.69 240.06 407.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "234.83 389.94 238.26 392.71 238.92 390.02 234.83 389.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "237.77 412.2 233.77 410.64 233.89 410.3 237.6 411.76 240.15 406.49 241.78 411.47 242.8 411.12 242.91 411.46 241.57 411.92 240.09 407.4 237.77 412.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "240.08 407.4 239.78 407.23 240.49 405.84 240.49 400.68 239.48 399.26 239.75 399.05 240.83 400.56 240.83 405.93 240.08 407.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "237.63 393.06 236.48 392.29 233.5 392.29 233.5 391.93 236.58 391.93 237.81 392.76 237.63 393.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "238.98 392.78 238.67 392.64 238.94 391.93 241.17 391.93 241.17 392.29 239.17 392.29 238.98 392.78"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-52",
    cx: 239.4,
    cy: 402.14,
    rx: 0.34,
    ry: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m239.7,405.13c0,.2-.15.36-.34.36s-.34-.16-.34-.36.15-.36.34-.36.34.16.34.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "m231.28,391.06s-1.88,6.51-2.32,14.72l2.43.25,1.98-13.08-2.1-1.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "232.54 399.57 232.21 399.52 232.77 395.81 233.11 395.87 232.54 399.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 223.3,
    y: 401.42,
    width: 10.99,
    height: 7.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m228.82,406.55h-1.45v2.25c0,.73.56,1.32,1.25,1.32h1.08c.69,0,1.25-.59,1.25-1.32h0c0-1.24-.96-2.25-2.14-2.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "232.57 397.3 231.94 396.12 232.24 395.94 232.86 397.13 232.57 397.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m240.8,446.1c0-1.4-1.08-2.54-2.41-2.54h-3.04v2.54h5.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m239.83,386.92c-1.5,0-1.31-1.18-1.31-1.18h1.31v1.18Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m293.98,437.9h0s-2.48-.13-2.48-.13l-.33-.02-.48-.02.19-.06.42-.12c1.25-.05,1.85-.19,2.25-.31h.02c.29-.02.56-.05.67-.08l.48-.14c.11-.03.03-.06-.18-.07l.09-.03h.8l.89-.26c.66-.19-.15-.35-1.82-.35h-.9c-.94,0-1.96.05-2.78.13l-1.03-.06h-.08c-.31.06-.39.1-.27.14h-.71c-.15.06-.08.1.15.12l-1.03.3h-.03c-.37,0-.8.04-.95.08l-.51.15c-.15.04.03.08.41.08h.27l-.1.03h0l-1.54.45h-.4s-.65.04-.65.04h-.39s-2.89.12-2.89.12l.86-.64h.24s.43-.3.43-.3h-.26s1.37-1.01,1.37-1.01h0l.31-.21h11.28l6.15-1.8h-23.31l-6.15,1.8h9.98c-.43.06-.65.15-.29.26h0s-.97.51-1.83,1.02h-.42c-.17.01-.32.03-.35.05l-.34.23s.09.03.25.02h.36c-.11.06-.22.13-.31.2-.98.68-.57,1.04-.44,1.13l-6.45,1.94h.41l-10.49,3.05h.03c-.05,0-.1.02-.13.03l-.36.11h2.41l.36-.11s.08-.03.09-.04l12.99-2.65-6.04,2.54h2.85s10.33-2.93,10.33-2.93h.36l2.91-.87h1.96c.15.02.39.03.7.03h.78c.66,0,1.41-.06,1.75-.13h5.01l2.85-.84h-8.33l1.39-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m274.29,443.52h-2.85s-.65.25-.65.25h4.87c.44-.14-.16-.25-1.37-.25Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "276.95 405.51 273.56 405.18 273.92 390.67 276.95 405.51"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 273.09,
    y: 402.75,
    width: 3.94,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-244",
    x: 273.9,
    y: 398.71,
    width: 9.99,
    height: 7.55
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "269.04 411.77 263.96 442.55 261.62 442.55 261.71 411.76 269.04 411.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "273.41 441.49 270.57 441.49 267.15 411.77 273.77 411.77 273.41 441.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m262.81,416.71h-.94v-.33h.94c.74,0,1.33-.63,1.33-1.41v-.5h.32v.5c0,.96-.74,1.74-1.65,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m272.44,414.98v-.5h-.32v.5c0,.91.66,1.65,1.51,1.73v-.33c-.67-.08-1.19-.67-1.19-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m262.82,441.55c.66,0,1.2.57,1.2,1.27v.95h-2.41v-.95c0-.7.54-1.27,1.2-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "m262.51,397.3l-3.23-14.17-2.32-10.18-1.87.45s.89,5.3,1.87,10.29c.24,1.22.49,2.42.73,3.53,1.55,7.09,3.52,10.39,3.52,10.39l1.3-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m259.27,383.13l-2.32-10.18-1.87.45s.89,5.3,1.87,10.29l2.32-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "m259.28,382.05l-2.5.61c-.37.09-.61.48-.52.88l.27,1.26c.09.39.46.64.83.55l2.5-.61-.59-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m256.95,372.95l-.75-3.41s-3.22,1-1.12,3.86l1.87-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "m274.09,414.99h-12.8s-.2-18.8-.2-18.8l-1-5.31,3.41-1.27.35-.13.57-.21.38-.14s4.31.03,5.09,0c.08,0,.13,0,.13,0l.6.24.38.15,2.91,1.14.17,24.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "265.95 390.78 261.09 396.19 261.29 414.99 274.09 414.99 273.96 396.89 270.48 390.75 265.95 390.78"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m270.71,389.69c0,.78-.71,2.29-2.62,2.29-2.42,0-4.29-1.52-4.29-2.29,0-.07.01-.13.04-.2l.57-.21.38-.14s4.31.03,5.09,0c.08,0,.13,0,.13,0l.6.24c.06.1.09.21.09.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "m271.01,389.53l-.38-.15-.6-.24s-.05,0-.13,0c.33.18.51.38.51.54,0,.62-.58,1.96-2.3,1.96-2.37,0-3.97-1.47-3.97-1.96,0-.13.1-.27.29-.41l-.57.21-.35.13s0,.05,0,.07c0,1.04,2.06,2.63,4.6,2.63,2,0,2.93-1.57,2.93-2.63,0-.06,0-.11-.02-.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m276.81,404.64h.78c.72,0,1.31.62,1.31,1.38v.06c0,.76-.58,1.38-1.31,1.38h-.78c-.72,0-1.31-.62-1.31-1.38v-.06c0-.76.58-1.38,1.31-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m275.66,443.77h-4.87l-.21-2.28h2.85c1.21,0,2.19,1.02,2.23,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m270.06,389.3s-.7.65-2.65.65-2.65-.65-2.65-.65v-4.23h5.3v4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m270.06,388.64v-2.57h-4.38s.77,2.31,4.38,2.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 264.53,
    y: 378.45,
    width: 1.61,
    height: 4.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "m268.58,376.31h0c1.92,0,3.47,1.55,3.47,3.47v2.08h-6.94v-2.08c0-1.92,1.55-3.47,3.47-3.47Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m270.97,382.04h0c.39,0,.71.32.71.71v1.26c0,.39-.32.71-.71.71h0v-2.68h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m264.62,380.6v1.48h.15v4.37s1.74,1.29,4.27,1.29c2.02,0,2.21-1.67,2.21-3v-4.13c0-.5-.1-.98-.28-1.4-.16-.38-.39-.73-.66-1.02-.59-.62-1.4-1-2.29-1h-.15c-1.79,0-3.25,1.53-3.25,3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "m270.97,379.2c-.16-.38-.39-.73-.66-1.02-.59-.62-1.4-1-2.29-1h-.15c-1.79,0-3.25,1.53-3.25,3.42v1.48h.15v.76h1.09v-1.73h.39c.49,0,.88-.42.88-.93h0c0-.54.41-.97.91-.98,1.14,0,2.93,0,2.93,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m264.53,382.02h0c.4,0,.72.32.72.72v2.05h-.72c-.39,0-.71-.32-.71-.71v-1.35c0-.39.32-.71.71-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m270.29,384.16c0,.19-.06.36-.18.49-.12.13-.28.21-.46.21v-.32c.09,0,.18-.04.24-.11.06-.07.1-.16.09-.26v-.1s.3,0,.3,0v.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "m264.02,378.22h1.68v1.26h-.42c-.7,0-1.26-.57-1.26-1.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "m265.66,378.8l-.45-.19c-.61-.26-.91-1-.66-1.65h0s1.56.67,1.56.67l-.45,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "m267.35,378.83s1.4.2,2.58,1.06c1.7,1.24,1.33,1.91,1.33,1.91l.43-1.22-.15-2-4.18.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "m268.46,378.49l1.31,1.84-2.63-1.45s.51-.82,1.31-.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "268.24 418.2 267.91 418.18 268.04 416.78 269.15 415.55 269.39 415.79 268.36 416.93 268.24 418.2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m314.95,439.54l-3.33.13c-.1-.01-.21-.02-.34-.04,0,0,1.29-.32,3.92-.92,0,0,0,0,0,0,4.97-1.23,5.11-1.69,5.11-1.69l-.35-.02.09-.03.52-.15.35-.1.81-.24,1.83-.54c1.02-.3-.27-.54-2.87-.54h0c-1.87,0-3.92.13-5.3.31h-.67c-1.16,0-2.47.11-2.93.24l-1.24.36c-.89.26-.98.5-.41.69l-.97.04h0s0,0,0,0c0,0-2.02.15-9.66,1.12h-.01s0,0,0,0c0,0,0,0,0,0h.01c1.54.74,1.79.88,1.79.88-2.79.4-.64.46-.49.46-1.51.49-2.72.97-3.66,1.42-1,.47-1.72.89-2.21,1.24l-2.85.83h-.32c-1.27,0-2.74.13-3.29.29h4.6s2.79,0,2.79,0l.82-.29h0l3.24-1.08c1.01-.21,2.15-.43,3.4-.68.44-.09.88-.17,1.31-.25.61-.12,1.21-.22,1.78-.33l8.53-.34v-.79Zm-1.62-.98l-2.63.85c.04-.08.04-.15,0-.24h0s-.06-.27,3.74-.96l-1.1.34Zm-10.94-.36l4.84-.56-4.56,1.34-.28-.78Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "m286.68,374.67h0c6.47,0,11.73,5.26,11.73,11.73v1.45c0,1.56-1.27,2.83-2.83,2.83h0c-4.91,0-8.89-3.98-8.89-8.89v-7.12h0Z",
    transform: "translate(585.09 765.35) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m287.89,404.21v4.92s-2.58-.47-1.1-4.18l1.1-.74Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m286.8,404.95l1.1-.74-3.66-8.78-2.26,1.52c4.09,6.74,4.82,8,4.82,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m287.82,386.82s-1.5,1.39-5.84,10.15l2.33,1.04,5.03-8.64-1.52-2.55Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m298.82,386.44s1.45,4.19.68,15.31c0,0-1.07.06-1.86-.04l-.57-1.42-.26-11.58,2.01-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m295.68,440.69h-2.76s-.84-2.92-1.84-7.55c-.67-3.09-1.41-6.94-2.01-11.18-.72-5.02-1.25-10.6-1.25-16.12h6.25l.76,16.47.4,8.6h0s.45,9.78.45,9.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "m292.76,440.69c-1.27,0-2.29,1.18-2.29,2.63h5.38s-.16-2.63-.16-2.63h-2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m287.82,405.84h8.7s-1.6-3.95,2.22-14.37l.07-5.03-3.36-1.15-3.91-.21-3.72,1.73v19.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "m290.54,406.33h-.34v-12.91c0-4.73,2.36-8.01,2.39-8.04l.27.22s-2.32,3.22-2.32,7.83v12.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "m293.05,388.23l-.73-2.38-1.71,2.22-.13-.14c-.57-.62-.28-1.73-.27-1.78l.33.1s-.2.77.07,1.27l1.85-2.4.76,2.48,1.79-1.7.23.27-2.18,2.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "293.04 401.9 292.8 401.65 295.09 399.24 295.33 399.49 293.04 401.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "292.56 403.85 292.32 403.6 294.17 401.65 294.41 401.9 292.56 403.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m291.54,385.29s-.12.74,1.32.74,2.57-.74,2.57-.74v-4.78h-3.89v4.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m291.54,384.97v-2.19h3.53s-.28,2.19-3.53,2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m296.74,422.42c-.15.74-.31,1.5-.45,2.3-.39,2.26-.75,4.34-1.06,6.19-1.02,6.07-1.58,9.77-1.58,9.77h-2.57v-34.85h5.45c2.86,6.53,1.43,10.78.21,16.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m290.76,440.69c-1.27,0-2.29,1.18-2.29,2.63h4.59l.63-2.63h-2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m296.74,422.42l-1.9-.12-3.75-.23-2.01-.12c-.72-5.02-1.25-10.6-1.25-16.12h8.7c2.86,6.53,1.43,10.78.21,16.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-214",
    points: "304.75 416.33 294.54 420.62 291.84 413.46 302.04 409.17 304.75 416.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m297.4,409.87l1.77,3.86s3.26-1.18-.48-3.7l-1.29-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m298.69,410.03l-1.29-.16-.33-9.58h0c1.47.18,2.61-.27,2.44,1.28-.61,5.5-.81,8.46-.81,8.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m296.46,378.84h0v2.72h-1.03v-1.7c0-.57.46-1.03,1.03-1.03Z",
    transform: "translate(591.9 760.4) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m296.12,376.59v2.59h-.68v3.58s-2.25,2.49-4.36,1.25c-.93-.54-1.49-1.75-1.49-3.03v-4.38c0-.75.15-1.46.42-2.06.55-1.25,1.59-2.1,2.79-2.1h.12c1.77,0,3.21,1.86,3.21,4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m290.8,380.87c-.16,0-.32-.08-.43-.23-.12-.16-.17-.38-.15-.6l.03-.25.31.05-.03.25c-.01.11.01.23.08.31.05.07.12.11.19.11v.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m293.48,381.8s-.25,1.38-1.39,1.38-1.39-1.38-1.39-1.38h2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "m289,376.94s5.44-.51,9.42,6.82v-6.99c0-2.69-2.11-4.87-4.71-4.87h0c-2.6,0-4.71,2.18-4.71,4.87v.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "m298.41,384.68h0v4.07h-3.31v-.76c0-1.82,1.48-3.31,3.31-3.31Z",
    transform: "translate(593.52 773.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "m293.34,393.29h0c1.85,0,3.34-1.58,3.34-3.52v-5.55h-1.06c-1.26,0-2.28,1.08-2.28,2.41v6.66Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m347.74,420.35l-2.33.68-2.45.72-1.76.44h1.13c1.79-.23,1.3-.37.92-.42l2.51-.73h9.01l2.33-.68h-9.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m341.2,422.19l-5.12,1.27-.88.22-3.49.13h0s0,0,0,0h0l.15-.04.24-.07c.2,0,.4,0,.6-.02h2.42l2-.58c.98-.29-.22-.52-2.69-.52h-1.16c-1.55,0-3.3.15-3.92.33l-2.66.78h1.68l-.53.15h0s-.02,0-.02,0l-3.68.11h0c-.1.02-2.27.38-4.69.9-.73.16-1.49.33-2.22.51h-.06l-.6.17c-.17.05.04.09.46.09h1.25c.05,0,.11,0,.16,0l-9.12,2.67h2.23c-1.3.63-2.22,1.07-2.47,1.19-.04,0-.08.02-.11.03l-.35.1h5.51c.45-.14,0-.25-1-.25h-.97s1.55-.29,5.18-1.07h2.98l12.91-3.88c.25-.05,3.15-.58,4.8-.93.31-.07.59-.13.81-.19,1.47-.36,3.51-1.1,3.51-1.1h-1.14Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 306.54,
    y: 407.16,
    width: 8.88,
    height: 10.55,
    transform: "translate(621.95 824.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m306.42,366h8.44v6.75c0,1.79-1.46,3.25-3.25,3.25h0c-2.86,0-5.19-2.32-5.19-5.19v-4.81h0Z",
    transform: "translate(621.28 742) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "m314.55,381.84l.53-7.83.77-11.5,1.17.09s.46,6.61.24,9.91c-.03.51-.09,1.08-.17,1.7-.44,3.39-1.61,8.49-1.61,8.49l-.92-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m315.85,362.51l.27-4.05s2.21,1.18.9,4.13l-1.17-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "304.79 378.44 304.81 378.61 305.55 386.34 307.15 391 306.62 396.52 306.55 397.27 314.69 397.27 314.82 391.31 315.04 379.09 311.91 377.21 308.08 377.4 307.2 377.68 304.81 378.43 304.79 378.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m313.2,397.27c1.83,6.73.39,14.6-.14,18.77-1.08,8.36-1.75,11.34-1.75,11.34h-2.06l.72-30.11h3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "m312.28,427.38h-2.31v2.22h4.15c-.02-1.23-.83-2.22-1.83-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m306.96,397.27c-1.82,5.4-1.48,10.2-.54,16.3,1.39,9.07,2.25,15.14,2.25,15.14l1.29-.08.72-31.36h-3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m313.79,397.27s.91,4.41.45,12.76h-8.49c-.74-6.95.65-12.76.65-12.76h7.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "m307.44,400.36h-.9v-.32h.9c.71,0,1.28-.61,1.28-1.35v-.48h.3v.48c0,.92-.71,1.67-1.58,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m309.61,427.44c.55,0,1,.56,1,1.24v.93h-2.01v-.93c0-.68.45-1.24,1-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "m315.81,417.71h-2.18s-.04-31.06-.04-34.88-1.68-5.62-1.68-5.62l3.04-1.21.53,5.9.34,35.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-190",
    points: "304.79 378.44 304.81 417.71 309.59 417.71 309.59 377.68 308.08 377.4 304.79 378.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "m302.64,392.14l2.26.24.7-5.79.58-4.78c.09-.58-.33-2.05-.75-2.43l-.64-.92s-.96,3.32-1.62,8.14c-.23,1.69-.43,3.57-.54,5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m302.64,391.18h1.27c.83,0,1.5.67,1.5,1.5h0c0,.49-.39.88-.88.88h-1.01c-.49,0-.88-.39-.88-.88v-1.5h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "308.1 377.4 307.07 380.08 314.21 380.08 311.91 377.21 308.1 377.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "308.1 377.4 311.29 379.98 311.9 377.47 308.1 377.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m311.9,377.4s.11.67-1.29.67-2.52-.67-2.52-.67v-4.31h3.8v4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m311.9,376.82v-2.69h-3.45s.61,2.43,3.45,2.69Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-76",
    cx: 310.34,
    cy: 370.01,
    rx: 3.8,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m307.9,371.29h0c.26,0,.48.21.48.48v1.59h-.35c-.33,0-.6-.27-.6-.6v-.99c0-.26.21-.48.48-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m311.23,367.92h.14c1.31,0,2.37,1.06,2.37,2.37v3.4c0,1.39-1.13,2.51-2.51,2.51h0c-1.74,0-3.16-1.42-3.16-3.16v-1.96c0-1.74,1.42-3.16,3.16-3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m312.63,373.46c.15,0,.3-.08.4-.21.11-.15.16-.35.14-.55l-.03-.23-.28.05.03.23c.01.11-.01.21-.07.29-.05.06-.11.1-.18.1v.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "308.59 367.65 307.51 367.93 307.95 371.29 308.39 373.41 308.59 367.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m308.48,370.54v-2.61h2.55c0,1.05-1.67,2.61-2.55,2.61Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m429.78,322.9s0-.02-.02-.03l-2.13-.78c-.11-.04-.37-.06-.71-.06-.03,0-.07,0-.11,0l-.88-.03-.7-.03,1.68-.49c.1-.02.19-.04.26-.06h0s.47,0,.47,0c.35,0,.75-.03.89-.07l.23-.07c.7-.08,1.28-.17,1.62-.27.12-.03.2-.07.25-.1.21.01.47.02.78.02,1.1,0,2.35-.1,2.78-.23.44-.13-.1-.23-1.2-.23-1,0-2.12.09-2.65.2-.45-.09-1.32-.15-2.49-.15-.92,0-1.89.04-2.79.09.06-.09-.46-.16-1.34-.16-1.1,0-2.35.1-2.78.23-.44.13.1.23,1.2.23.08,0,.17,0,.25,0-.15.03-.28.06-.39.09-.21.06-.31.12-.32.18l-.8.23c-.53.16-.15.29.84.34l-.51.15s0,0,0,0l-.13.04-1.47.06h0s-1.33.05-1.33.05c-.25.01-.49.02-.72.04-.32,0-.66.03-.95.06l-3.92.41,1.3-.33h0c.36-.02.68-.06.83-.1l.75-.21h-1.29c-.55,0-1.18.05-1.41.11l-.75.21c-.26.05-1.27.24-3.57.73-.36.08-.17.15.36.16.45.04,1.27.03,1.89-.04l1.35-.14h0l1.13-.11-1.65.48c-.32.09.07.17.87.17h.24l-.74.22h-.25c-.4,0-.87.04-1.11.08l-7.19,1.47h3.09c-1.44.62-2.28,1.17-2.77,1.59l-2.53.74h-.32c-.18,0-.35,0-.53,0-1.13.03-2.27.13-2.73.26h7.54l.36-.13.4-.14h0l2.73-.93c.92-.18,1.97-.38,3.15-.61,1.51-.29,3.04-.55,4.28-.79h3.23l2.46-1.26c.35,0,.72-.03.98-.07l1.35-.2c.38-.04,1.86-.2,5.41-.64.59-.07.66-.16.23-.2Zm-7.79.6c.66,0,1.41-.06,1.68-.14l1.45-.42.84-.24h0l1.02.35s.06.02.1.02l-4.45.62h0c-.25,0-.52.02-.75.04-.06,0-.12,0-.18,0h-.15l.74-.22h-.29Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m392.28,283.14l4.79-7.04c.46-.65,1.33-.78,1.94-.29.6.48.71,1.39.26,2.02l-4.76,6.82c-.46.66-1.41.71-1.99.16-.04-.04-.08-.08-.12-.11-.45-.42-.33-1.21-.1-1.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "395.37 283.4 396.6 279.49 396.6 281.87 395.37 283.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m412.69,282.68l-4.79-7.04c-.46-.65-1.33-.78-1.94-.29-.6.48-.71,1.39-.26,2.02l4.76,6.82c.46.66,1.41.71,1.99.16.04-.04.08-.08.12-.11.45-.42.33-1.21.1-1.57Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m396.35,262.77c0,1.16.89,2.1,1.99,2.1s1.99-.94,1.99-2.1-.89-2.1-1.99-2.1-1.99.94-1.99,2.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-47",
    cx: 402.7,
    cy: 265.68,
    rx: 4.19,
    ry: 4.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m405.79,267.01h.4v1.85c0,.3-.25.55-.55.55h0c-.3,0-.55-.25-.55-.55v-1.15c0-.39.31-.7.7-.7Z",
    transform: "translate(811.27 536.41) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m400.81,274.93s-.13.88,1.43.88,2.79-.88,2.79-.88v-5.7h-4.23v5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m400.81,273.82v-3.6h3.86s-.68,3.24-3.86,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m401.94,263.1h0c1.74,0,3.14,1.48,3.14,3.31v2.98c0,1.83-1.41,3.31-3.14,3.31h0c-1.74,0-3.14-1.48-3.14-3.31v-2.98c0-1.83,1.41-3.31,3.14-3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m399.78,270.23h2.35s-1.54,1.98-2.35,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 404.45,
    y: 264.18,
    width: 0.64,
    height: 3.79,
    transform: "translate(809.54 532.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m403.64,262.55h0c.64,0,1.17.52,1.17,1.17v2.09h-1.17v-3.26h0Z",
    transform: "translate(808.45 528.36) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m397.01,293.74c0,16.16,5.22,31.7,5.22,31.7h2.82l-1.65-31.7h-6.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m405.22,327.86h-5.5c.02-1.25.92-2.27,2.07-2.41.09-.01.18-.02.28-.02h2.99l.09,1.27.08,1.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "405.14 326.71 401.78 326.71 401.78 325.44 405.05 325.44 405.14 326.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m396.14,280.81v6.01c0,.85.65,1.53,1.45,1.53h9.47c.66,0,1.2-.57,1.2-1.27v-10.07c0-.92-.57-1.73-1.41-1.99h0l-2.03-.64-4-.2-2.41,1.04h0c-.87.37-1.49,1.18-1.66,2.15l-.6,3.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "408.26 281.02 407.19 279.49 408.26 283.24 408.26 281.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "m398.4,275.21c.18,1.12.88,2.45,3.05,2.45,2.29,0,5.13-1.51,5.4-2.64l-2.03-.64-4-.2-2.41,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m405.88,274.71s-1.16,1.88-4.51,1.79c-2.09-.06-1.82-1.78-1.82-1.78l1.27-.54,4.04.14,1.03.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m405.91,293.74c3.3,6.94,1.02,11.15-.24,17.79-1.72,9.1-2.7,13.9-2.7,13.9h-2.63v-31.7h5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m402.98,325.44l-.31,1.27-.28,1.15h-4.71c.02-1.16.8-2.13,1.83-2.37.16-.04.33-.06.51-.06h2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m402.98,325.44l-.31,1.27h-1.71c-.7,0-1.3-.52-1.44-1.21.16-.04.33-.06.51-.06h2.96Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "m394.59,304.38h15.89l-2.16-13.31c-.07-.44-.42-.77-.82-.77h-9.92c-.4,0-.75.32-.82.77l-2.16,13.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 397.83,
    y: 288.35,
    width: 9.52,
    height: 1.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m405.67,262.9c0,1.16.89,2.1,1.99,2.1s1.99-.94,1.99-2.1-.89-2.1-1.99-2.1-1.99.94-1.99,2.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "406.92 304.38 405.68 295.24 406.44 304.38 406.92 304.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "402.83 304.38 401.8 295.45 402.09 304.38 402.83 304.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "397.4 304.38 398.78 295.45 398.09 304.38 397.4 304.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "403.78 281.3 400.97 284.16 400.38 283.8 403.78 281.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "401.28 282.27 399.38 284.21 398.79 283.85 401.28 282.27"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m400.59,269.4c-.47,0-.85-.4-.85-.89h.33c0,.3.23.55.52.55v.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m410.04,290.52l-.19.52c-.47,1.24-1.81,1.85-2.98,1.36h0s.19-.52.19-.52c.47-1.24,1.81-1.85,2.98-1.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m409.97,290.63l-1.68-.67,2.71-6.4c.26-.61.9-.93,1.51-.74h0c.79.24,1.15,1.19.75,1.94-2.46,4.64-3.3,5.87-3.3,5.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m392.89,276.91v-.56c.03-1.34,1.07-2.41,2.34-2.39h0s0,.55,0,.55c-.02,1.34-1.06,2.41-2.33,2.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m392.91,276.79h1.79s-.37,6.99-.37,6.99c-.04.67-.53,1.21-1.16,1.26h0c-.81.07-1.48-.68-1.36-1.53.73-5.26,1.1-6.72,1.1-6.72Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "403.78 281.3 400.97 284.16 400.38 283.8 403.78 281.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "401.28 282.27 399.38 284.21 398.79 283.85 401.28 282.27"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m413.04,320.99h-.12s-.92-.85-.92-.85c0-.03-.07-.05-.18-.07,0,0,0-.01-.02-.02l-.37-.25-.92-.66c-.06-.04-.26-.07-.55-.09-.09,0-.2-.02-.32-.02l-.5-.02-2.04-.1h-.22s1.23-.37,1.23-.37c2.13-.12,4.06-.33,4.99-.58,1.44-.38-.03-.71-3.28-.72-3.25-.01-7.05.29-8.49.67-.81.22-.7.41.13.55l-.93.26s.14.06,1.23.08l-.35.1-1.44.06-1.23.05c-.52.02-1.01.05-1.44.1-.15.01-.29.03-.43.04l-5.42.66-2.01.24s-.04,0-.06,0l-8.03.81-1.96.03c-.52,0-1.06.06-1.2.12l-.42.18,3.33-.04c.52,0,1.06-.06,1.2-.12h.03s8.36-.64,8.36-.64c.21-.01.4-.03.58-.05.2-.02.4-.03.57-.06l1.59-.19-6.49,1.92h0l-3.37,1.22h.95l-4.49,1.65.87.26,7.82-1.8h0l.46-.11h.03l3.12-.72h0l-.9.73h.83,0s-.05.11-.05.11h0l-.77,1.59c-.26.02-.47.06-.58.09l-.37.11h2.48l.37-.11c.08-.02.11-.05.09-.07l3.87-1.72h.08l2.82-1.23h.8l6.05-1.78.5-.14.28.19s.09.04.18.05c0,0,.01.02.03.03l2.89.78-.96.22c-.26.06-.08.11.4.12l1.44.02,1.62-.37c.26-.06.08-.11-.4-.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m372.7,281.89c-.89-.54-1.2-1.73-.69-2.67l1.24-2.28,3.17-5.96c.51-.94,1.64-1.27,2.53-.73.67.4,1.01,1.18.92,1.94-.03.25-.1.5-.23.73l-3.17,5.96-1.24,2.28c-.51.94-1.64,1.26-2.53.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m376.47,278.88l-3.22-1.94,3.17-5.96c.51-.94,1.64-1.27,2.53-.73.67.4,1.01,1.18.92,1.94-.03.25-.1.5-.23.73l-3.17,5.96Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "380.85 292.69 390.95 323.86 392.89 323.86 388.81 292.25 380.85 292.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "390.84 307.99 386.13 308.99 385.8 307.99 390.84 307.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "379.14 322.77 381.13 322.77 384.32 292.1 376.82 292.1 379.14 322.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "382.68 307.89 382.58 308.85 378.02 307.89 382.68 307.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "m391.75,322.83c-.69,0-1.24.59-1.24,1.31v.98h2.48v-.98c0-.72-.56-1.31-1.24-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m376.26,296.84h14.07s-.07-24.5-.07-24.5c.08-1.05-.52-2.03-1.47-2.38l-.58-.21-2.38-.88-.31-.11s-5.41.04-5.39,0l-2.34.97c-1.01.42-1.68,1.45-1.67,2.6l.13,24.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "386.59 279.16 380.85 284.5 379.37 284.94 386.59 279.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "384.28 279.99 381.89 282.15 380.79 282.3 384.28 279.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "388.63 276.21 390.28 280.72 390.33 277.27 388.63 276.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "m375.88,325.13h5.02l.22-2.36h-2.94c-1.25,0-2.26,1.05-2.3,2.36Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m388.59,260.27c-.13,3.48-2.9,6.19-6.2,6.06-3.3-.13-5.87-3.06-5.75-6.54.13-3.48,2.9-6.19,6.2-6.06,3.3.13,5.87,3.06,5.75,6.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m380.11,268.9s.72.68,2.73.68,2.73-.68,2.73-.68v-4.37h-5.47v4.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m385.74,260v1.56h-.16v4.19s-1.86,1.65-4.53,1.37c-1.33-.14-2.34-1.33-2.34-2.74v-4.38c0-.53.11-1.03.3-1.49.17-.41.41-.77.7-1.08.62-.66,1.48-1.06,2.43-1.06h.16c1.9,0,3.44,1.62,3.44,3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m379.01,258.52c.17-.41.41-.77.7-1.08.62-.66,1.48-1.06,2.43-1.06h.16c1.9,0,3.44,1.62,3.44,3.63v1.56h-.16v.81h-1.15v-1.84h-.41c-.52,0-.94-.44-.94-.99h0c0-.58-.43-1.03-.97-1.03-1.2,0-3.1,0-3.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m385.83,261.21h0c.42,0,.75.36.75.79v1.64c0,.44-.34.79-.75.79h-.76v-2.43c0-.44.34-.8.76-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m379.61,262.76v.21c-.01.2.06.38.19.52s.3.22.49.22v-.34c-.1,0-.19-.04-.26-.12-.07-.07-.1-.17-.1-.28v-.22s-.31,0-.31,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m378.9,264.37h2.68s-.13,1.33-1.41,1.33-1.27-1.33-1.27-1.33Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m393.77,281.89c.89-.54,1.2-1.73.69-2.67l-1.24-2.28-3.17-5.96c-.51-.94-1.64-1.27-2.53-.73-.67.4-1.01,1.18-.92,1.94.03.25.1.5.23.73l3.17,5.96,1.24,2.28c.51.94,1.64,1.26,2.53.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m390,278.88l3.22-1.94-3.17-5.96c-.51-.94-1.64-1.27-2.53-.73-.67.4-1.01,1.18-.92,1.94.03.25.1.5.23.73l3.17,5.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m380.15,268.75l-1.3.54s-.24,3.93,3.52,3.96c3.76.03,5.31-3.68,5.31-3.68l-2.14-.82h-5.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "383.51 299.95 382.71 307.89 377.06 307.89 376.26 296.84 382.71 296.84 383.51 299.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "382.27 296.84 384.98 307.99 390.92 307.99 389.53 296.84 382.27 296.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "m388.41,299.12h.96v-.34h-.96c-.75,0-1.36-.64-1.36-1.44v-.51h-.32v.51c0,.98.76,1.78,1.68,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "m381.51,296.84h1.98v4.51h0c-1.09,0-1.98-.89-1.98-1.98v-2.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m397.38,289.08l1.7-.78-4.11-8.25c-.41-.99-1.5-1.44-2.44-1.01h0c-1.03.48-1.43,1.81-.83,2.82l5.68,7.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m398,291.99l1.37.16.34-3.21c.06-.61-.35-1.15-.92-1.22h0c-.75-.09-1.44.48-1.52,1.28l-.19,1.77c-.06.61.35,1.15.92,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m366.65,286.64l1.11,1.57,6.68-6.1c.82-.64.99-1.87.38-2.73h0c-.67-.95-1.99-1.05-2.79-.21l-5.38,7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m364.1,287.93l.16,1.44,3.04-.38c.58-.07.99-.62.92-1.23h0c-.09-.8-.77-1.36-1.53-1.27l-1.67.21c-.58.07-.99.62-.92,1.23Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m382.19,264.99h0s-.99,0-.99,0c-.72,0-1.31-.56-1.31-1.26h1c.72,0,1.3.56,1.3,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m379.76,263.74h.58s0,.09,0,.09c0,.64-.54,1.17-1.21,1.17h-.48s0-.19,0-.19c0-.59.5-1.07,1.11-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m379.13,264.72c.05.06.21.88,1.15.88s1.08-.86,1.08-.86c0,0,1.82.22,2.46-1.33.64-1.55.68-2.99.68-2.99l.72,1.28v3.95s-.62,2.29-4,2.29c-2.08,0-2.61-.85-2.61-.85l.11-4.98s.01,2.1.43,2.62Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "389.53 296.84 389.7 298.18 376.26 296.84 389.53 296.84"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m374.67,426.52c.63-.14,2.52-.57,4.36-1.03h.52l.99-.29h-.23s.06-.02.09-.03c4.52-1.32,3.63-1.59,3.5-1.67l-4.87-.18,1.66-.49h.26c.42,0,.9-.04,1.07-.09l.63-.18c.08-.02.07-.04,0-.06l.63-.18c.09-.03.08-.05-.01-.07h.02c.69-.21-.15-.37-1.87-.37h-3.99l-.52.15c-.21.06-.19.12.01.16-1.64.16-2.25.38-2.25.38l-1.2.35c-.39.11-.15.21.53.26l-.43.12-.08.02-5.52.23h-.02c-.28.03-3.59.41-7.92,1.67-.03,0-.06.02-.08.03h-.21l-.99.29h.57l-2.62.98-.49.14c-.31.09-.15.17.35.21l-8.33,2.88h-.01c-1.34,0-2.87.13-3.4.28h5.07l1.44-.28h0l11.75-2.6h0l-4.95,2.71c-.09.01-.16.03-.21.04l-.45.13h2.62l.45-.13s.07-.02.08-.03h.03l11.8-3.48.65-.2,2.5-.63-3.22.94-.82.24c-.46.13.1.24,1.25.24h1.56l.97-.28c.33-.1.02-.18-.7-.19Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "360.01 397.07 360.1 428.56 357.56 428.56 352.03 397.07 360.01 397.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m348.69,397.75h0v.29c0,2.12-1.72,3.84-3.84,3.84h0v-.29c0-2.12,1.72-3.84,3.84-3.84Z",
    transform: "translate(-53.05 746.58) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m346.82,388.85c.13,5.12,0,9.82,0,9.82l-2.1-.29-.77-9.27,2.88-.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "345.52 397.07 347.27 427.47 350.37 427.47 354.09 397.07 345.52 397.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m347.25,427.47h3.1l-.47,2.57h-5.07c0-1.42,1.09-2.57,2.43-2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m358.79,427.47h0c.72,0,1.31.62,1.31,1.38v1.18h-2.62v-1.18c0-.76.59-1.38,1.31-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m363.42,382.81c0,.64.23,2.03.21,2.71-.21,6.2-1.05,13.1-1.05,13.1l-2.23-.48v-27.26h1.01s2.06,5.39,2.06,11.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m360.35,398.14h0c2.01,0,3.64,1.63,3.64,3.64v.72h0c-2.01,0-3.64-1.63-3.64-3.64v-.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m343.6,386.5c0,.81.02,1.66.05,2.52h3.12v-17.63h-.94s-2.23,3.14-2.23,15.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 343.39,
    y: 386.73,
    width: 3.38,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "345.81 371.36 350.55 369.28 356.08 369.28 361.55 370.88 360.87 381.4 359.99 395.3 345.52 395.3 345.81 371.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m350.62,395.97c-.03-.09-.72-2.41-.19-12.73.45-8.85,1.6-10.39,1.65-10.45l.26.23-.13-.12.13.11s-1.13,1.61-1.57,10.24c-.52,10.21.17,12.57.17,12.6l-.33.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m350.55,369.28s.73,1.15,2.77,1.15,2.77-1.15,2.77-1.15v-7.44h-5.53v7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m350.55,369.07v-3.58h4.57s0,3.58-4.57,3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m351.74,368.15c2.29-.24,3.58-1.91,3.58-1.91l1.36-6.14c-.02-2.2-2.43-2.54-2.43-2.54-5.5-.52-5.12,4.85-5.12,4.85v3.18c0,1.49,1.2,2.69,2.6,2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m355.04,359.02h.32c.86,0,1.55.54,1.55,1.2v3.23h-3.1v-3.49c0-.52.55-.94,1.22-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m354.86,364.4h-1.61v-5.04h0c.89,0,1.61.76,1.61,1.7v3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m349.55,356.21h3.68c1.89,0,3.42,1.53,3.42,3.42h-3.68c-1.89,0-3.42-1.53-3.42-3.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m356.34,361.61h0c.42,0,.76.36.76.8v1.66c0,.44-.34.8-.76.8h-.77v-2.46c0-.45.35-.81.77-.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "351.06 364.53 350.33 364.53 350.45 363.41 350.77 363.44 350.69 364.18 351.06 364.18 351.06 364.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "351.83 366.12 351.73 365.8 352.58 365.5 352.69 365.82 351.83 366.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "355.72 369.67 352.21 372.55 350.55 369.28 355.72 369.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "360.01 397.07 345.52 397.07 345.52 395.3 359.99 395.3 360.01 397.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "353.07 404.01 352.6 401.33 350.9 400.43 350.61 398.22 350.95 398.17 351.21 400.19 352.91 401.09 353.41 403.94 353.07 404.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "355.8 374.7 355.24 371.72 352.18 373.11 350.54 371.63 348.75 374.22 349.77 369.85 350.1 369.94 349.5 372.52 350.48 371.1 352.24 372.69 355.49 371.21 355.89 373.34 356.94 370.23 357.27 370.35 355.8 374.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 355.06,
    y: 377.37,
    width: 3.45,
    height: 1.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 349.99,
    y: 395.3,
    width: 2.71,
    height: 1.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m363.76,385.99c0,.81-.02,1.66-.05,2.52h-3.36v-17.63h1.2c.4.72,2.21,3.14,2.21,15.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 360.35,
    y: 386.22,
    width: 3.64,
    height: 2.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 356.61,
    y: 376.19,
    width: 0.34,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 354.65,
    y: 394.63,
    width: 0.68,
    height: 2.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 347.99,
    y: 394.71,
    width: 0.68,
    height: 2.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m345.42,389.33c0-.07-.17-7.28.12-10.22.3-2.95.75-4.6.76-4.62l.33.1s-.45,1.64-.75,4.55c-.29,2.92-.12,10.1-.12,10.18h-.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 360.18,
    y: 380.2,
    width: 0.34,
    height: 8.64
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m355.35,414.45s0-.02-.02-.03l-2.06-.75c-.1-.04-.36-.06-.69-.06-.03,0-.07,0-.1,0h0l-.85-.03-.68-.03.44-.13c.12,0,.24-.02.35-.02.13,0,.26,0,.39,0,.13,0,.27,0,.4,0,.13,0,.22-.05.35-.06.13,0,.26,0,.39-.01.13,0,.39.04.52.03.13,0,.24-.03.36-.04.13,0,.16-.05.29-.05.13,0,.24-.02.36-.03.12,0,.16-.03.28-.04.12-.01.36,0,.48-.01.12-.01.32-.01.43-.02.11-.01.27-.02.38-.03.11-.01.03-.04.14-.06.11-.01.02-.04.12-.05.1-.01.48,0,.58-.02.1-.01-.01-.04.08-.05.09-.01.66,0,.75-.01.09-.01-.1-.04-.02-.05.08-.01.33-.02.41-.04.08-.01-.43-.04-.35-.06.07-.01.26-.02.33-.04.07-.01.4-.02.46-.04.06-.01.38-.03.44-.04.05-.01,0-.03.06-.04.05-.01-.16-.03-.12-.04.04-.01.05-.03.09-.04.04-.01.28-.03.31-.05.03-.01-.15-.02-.12-.04.02-.01-.26-.02-.24-.03.02-.01.71-.05.72-.06.01-.01.17-.03.17-.05,0-.01-.76,0-.76,0,0-.01.7-.06.68-.07-.01-.01-.05-.03-.07-.04-.02-.01-.76.02-.79,0-.02-.01.73-.07.7-.08-.03-.01-.52,0-.55,0s.36-.05.32-.07c-.04-.01-.74.03-.78.02-.05-.01.48-.07.42-.08s-.41,0-.47,0c-.06,0-.51.02-.57.01-.07,0,.47-.08.4-.09-.07,0-.53.03-.61.02-.08,0-.24,0-.32-.01-.08,0,.29-.07.2-.08-.09,0-.13-.02-.22-.03-.09,0-.22,0-.32-.01-.1,0-.23,0-.34-.01-.1,0-.58.06-.69.05-.11,0,.14-.07.03-.08-.11,0-.48.05-.59.04-.11,0-.08-.04-.2-.04-.12,0-.29,0-.41,0-.12,0-.41.05-.53.05s-.06-.06-.19-.06c-.13,0-.32.03-.45.03-.13,0-.28.02-.41.02-.13,0-.28.02-.41.03-.13,0-.17-.05-.3-.05-.13,0-.31.05-.44.06-.13,0-.25,0-.38.01-.13,0-.27-.04-.4-.03-.13,0-.28.01-.41.02-.13,0-.26.03-.39.04-.13,0-.23.03-.36.04-.13,0-.31,0-.44,0-.13,0-.24.03-.36.04-.13,0-.09.06-.22.07-.13,0-.4-.02-.52,0-.12,0-.37,0-.49,0-.12.01-.07.05-.18.06-.12.01-.2.02-.32.04-.11.01-.13.03-.24.04-.11.01-.27.02-.38.03-.11.01-.21.02-.32.04-.1.01-.48,0-.58.02-.1.01-.04.04-.13.05-.09.01-.49.01-.58.02-.09.01-.11.03-.19.05-.08.01.22.04.15.06-.08.01-.3.02-.37.04-.07.01-.2.03-.26.04-.07.01-.23.03-.29.04-.06.01.13.03.07.05-.05.01-.54.03-.59.04-.05.01.02.03-.02.04-.04.01-.24.03-.28.05-.04.01.06.03.03.04-.03.01.14.03.12.04-.02.01-.27.03-.28.05-.02.01.3.02.29.03-.01.01-.29.04-.3.05,0,.01.26.02.26.03,0,.01.3.01.31.02.01.01-.18.03-.16.05.02.01-.37.05-.35.06.02.01.75-.02.78,0,.03.01-.5.06-.46.07s.5,0,.54,0c.04.01-.11.04-.06.05s.44,0,.49,0-.19.04-.12.05.41-.01.48,0c.07,0-.01.03.06.04.07,0,.24,0,.32.01.08,0,.14.01.23.02.08,0-.35.08-.27.09.09,0,.13.02.23.03.09,0,.65-.06.75-.05.1,0-.1.06,0,.06.06,0,.26-.02.43-.03l-.26.08h0s-.13.04-.13.04l-1.42.06h0s-1.29.05-1.29.05c-.24,0-.47.02-.7.04-.31,0-.64.03-.92.06l-3.79.4,1.26-.32h0c.35-.02.66-.05.81-.1l.73-.21h-1.25c-.53,0-1.14.05-1.36.11l-.73.21c-.25.05-1.23.23-3.46.71-.35.07-.17.14.35.16.43.04,1.23.03,1.83-.04l1.31-.13h0l1.09-.1-1.6.47c-.31.09.07.16.85.16h.23l-.72.21h-.24c-.39,0-.85.03-1.08.08l-6.96,1.42h3c-1.39.6-2.21,1.14-2.68,1.54l-2.45.72h-.31c-.17,0-.34,0-.52,0-1.09.03-2.2.13-2.64.25h7.3l.35-.12.38-.14h0l2.64-.9c.89-.17,1.91-.37,3.05-.59,1.46-.29,2.94-.53,4.15-.77h3.13l2.38-1.22c.34,0,.7-.03.95-.07l1.3-.19c.37-.04,1.8-.2,5.24-.62.57-.07.64-.15.22-.19Zm-7.55.58c.64,0,1.37-.06,1.62-.14l1.41-.41.81-.24.98.34s.06.01.09.02l-4.31.6h0c-.24,0-.5.02-.72.04-.05,0-.11,0-.18,0h-.14l.72-.21h-.28Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m319.04,375.96l4.63-6.82c.44-.63,1.29-.76,1.87-.28.58.47.69,1.35.25,1.96l-4.61,6.61c-.45.64-1.37.68-1.93.16-.04-.04-.08-.07-.12-.11-.44-.41-.32-1.17-.1-1.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "322.03 376.21 323.22 372.43 323.22 374.73 322.03 376.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m338.8,375.51l-4.63-6.82c-.44-.63-1.29-.76-1.87-.28-.58.47-.69,1.35-.25,1.96l4.61,6.61c.45.64,1.37.68,1.93.16.04-.04.08-.07.12-.11.44-.41.32-1.17.1-1.52Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m321.58,359.09c0,.13.12.27.13.4,0,.13-.13.29-.12.42.01.13.16.26.17.39.02.13.23.23.25.36.02.13-.15.31-.12.44.03.13.36.17.4.29.04.12-.16.34-.12.46.04.12.32.15.36.27.05.12.34.11.4.23.05.12-.06.31,0,.43.06.11-.21.44-.14.55.07.11.69-.17.76-.06.07.11-.29.54-.22.64.08.1.47-.07.55.02.08.1.01.33.1.42.08.09.41-.08.5,0,.09.09-.03.4.06.49.09.08.37-.1.47-.02.1.08.09.27.19.35.1.07.25.04.36.1.1.07.19.13.3.19.11.06-.08.72.03.78.11.06.21.19.32.24.11.05.46-.51.57-.46.11.04.09.5.21.54.12.04.38-.48.5-.45.12.03.11.59.23.62.12.03.31-.42.44-.4.12.02.18.55.3.56.12.01.28-.49.4-.48.12,0,.23.03.35.03s.23.05.36.05c.12,0,.24.06.36.05.12-.01.21-.22.33-.24.12-.02.33.51.45.49.12-.03.16-.43.28-.46.12-.03.26.06.38.02.12-.04.19-.19.31-.24.12-.05.28.07.4.01.11-.05.27,0,.38-.05.11-.06.04-.47.14-.54.11-.06.25-.04.35-.1.1-.07.52.36.62.28.1-.07.13-.27.23-.35.1-.08,0-.41.1-.49.09-.08.17-.18.26-.27.09-.09.05-.3.13-.4.08-.09.36,0,.44-.1.08-.1.28-.1.35-.2.08-.1.2-.18.27-.29.07-.11-.12-.4-.05-.51.06-.11-.11-.36-.05-.47.06-.11.48-.02.53-.14.05-.12-.14-.35-.1-.47.05-.12.66,0,.7-.13.04-.12-.24-.37-.2-.5.04-.12.25-.2.28-.33.03-.12-.58-.4-.55-.53.02-.13.18-.21.2-.34.02-.13.32-.21.34-.34.01-.13.29-.24.3-.37,0-.13-.1-.27-.1-.4s-.26-.26-.26-.38c0-.13-.04-.25-.06-.38-.01-.13.17-.28.16-.41-.02-.13-.23-.22-.26-.35-.02-.13-.32-.17-.35-.3-.03-.13.54-.43.51-.55-.04-.12.05-.31,0-.43-.04-.12-.75.03-.8-.09-.05-.12.5-.53.44-.64-.05-.12-.14-.23-.2-.35-.06-.11-.71.14-.77.03-.07-.11.48-.65.41-.75-.07-.11-.5.05-.57-.05-.08-.1.18-.5.1-.59-.08-.1-.64.26-.72.16-.08-.09.24-.62.15-.71-.09-.09-.39.06-.48-.03-.09-.08-.44.17-.54.1-.1-.08.2-.72.1-.79-.1-.07-.45.24-.55.17-.1-.07-.25-.03-.36-.1-.11-.06.04-.65-.07-.71-.11-.06-.2-.2-.32-.25-.11-.05-.25-.08-.37-.12-.11-.04-.26-.06-.37-.1-.12-.04-.39.51-.51.47-.12-.03-.11-.66-.23-.69-.12-.03-.32.41-.45.39-.12-.02-.21-.34-.33-.36-.12-.01-.26.08-.38.08-.12,0-.25.43-.37.43s-.25-.51-.38-.5c-.12,0-.23.23-.35.24-.12.01-.22.15-.35.17-.12.02-.2.21-.32.24-.12.03-.36-.49-.47-.45-.12.03-.13.47-.24.51-.12.04-.23.05-.35.09-.12.05-.39-.33-.5-.28-.11.05-.24.1-.35.16-.11.06-.16.26-.27.32-.11.06-.12.29-.23.36-.1.07-.34-.06-.44.01-.1.07-.14.24-.24.32-.1.08.11.54.02.63-.09.08-.46-.16-.55-.07s-.38-.02-.46.07c-.08.09.11.46.03.56-.08.1-.12.22-.2.33-.08.1-.02.29-.09.4-.07.11-.22.14-.28.25-.06.11-.14.2-.2.32-.06.11-.46.04-.52.16-.05.12.09.34.04.46-.05.12-.45.1-.5.22-.04.12,0,.3-.03.42-.04.12.37.38.34.51-.03.12-.22.21-.25.33-.02.13-.1.25-.12.37-.02.13-.13.25-.14.38-.01.13.23.28.23.41,0,.13-.45.25-.45.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-107",
    cx: 329.13,
    cy: 359.05,
    rx: 4.05,
    ry: 4.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m332.12,360.34h.39v1.79c0,.29-.24.53-.53.53h0c-.29,0-.53-.24-.53-.53v-1.11c0-.37.3-.68.68-.68Z",
    transform: "translate(663.95 723) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m327.3,368.01s-.12.85,1.39.85,2.71-.85,2.71-.85v-5.52h-4.09v5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m327.3,366.94v-3.48h3.74s-.66,3.14-3.74,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m328.4,356.56h0c1.68,0,3.04,1.44,3.04,3.21v2.88c0,1.77-1.36,3.21-3.04,3.21h0c-1.68,0-3.04-1.44-3.04-3.21v-2.88c0-1.77,1.36-3.21,3.04-3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m326.3,363.46h2.28s-1.49,1.92-2.28,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 330.82,
    y: 357.6,
    width: 0.62,
    height: 3.67,
    transform: "translate(662.26 718.87) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m330.04,356.03h0c.62,0,1.13.51,1.13,1.13v2.02h-1.13v-3.15h0Z",
    transform: "translate(661.21 715.2) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m329.53,354.31s-.03.09-.05.11c-.03.02-.09-.03-.12-.01-.02.02-.02.11-.04.13-.02.02,0,.14-.01.17-.02.03-.1-.04-.12,0-.02.03.05.2.04.23-.02.03-.11-.04-.13,0-.02.04.05.17.03.21-.01.04.06.18.05.22-.01.04-.08,0-.09.05,0,.04-.14-.05-.15,0,0,.04.2.32.2.36,0,.05-.19-.08-.19-.03,0,.05.13.22.13.27,0,.05-.07.04-.07.1s.12.19.12.25c0,.05-.09.03-.09.09,0,.06.11.17.12.23,0,.06-.04.08-.03.14,0,.06.05.13.07.19.01.06.02.11.03.17.01.06-.17.04-.16.11.01.06.01.12.03.18.02.06.22.17.24.23.02.06-.08.11-.06.17.02.06.2.13.22.19.02.06-.1.13-.07.19.02.06.17.1.19.17.03.06-.07.15-.05.21.03.06.17.08.2.14.03.06.05.12.08.18s.05.12.08.18c.03.06.05.12.08.18.03.06.1.08.13.13.03.06-.03.22,0,.28.04.06.13.03.17.08.04.05.05.14.09.19.04.05.09.07.13.12.04.05.06.15.09.2.04.05.07.14.11.18.04.05.11-.04.15,0,.04.05.07.12.11.16.04.04.05.3.09.34.04.04.09.03.13.07.04.04.09-.04.13,0s.08.06.12.1c.04.03.08-.01.12.02s.09.18.13.21c.04.03.09.12.13.15s.09.08.13.1c.04.02.06-.1.1-.08.04.02.05-.1.09-.08.04.02.12.23.16.24.04.01.04-.11.08-.1.04,0,.16.32.2.33.04,0,.02-.16.06-.16.04,0,.1.1.14.1.03,0-.06-.33-.02-.33.03,0,.09.07.12.06.03,0,.12.13.15.13.03,0,.12.11.15.1.03-.01.03-.08.06-.1s0-.16.02-.17c.03-.02.04-.05.07-.07.02-.02.1.05.13.03.02-.02,0-.14.01-.17.02-.03-.04-.18-.02-.21.02-.03.22.22.24.18.02-.03.08-.01.09-.05.02-.04-.19-.36-.18-.4.01-.04.23.18.25.14.01-.04.01-.1.02-.14,0-.04-.2-.33-.2-.38,0-.04.26.16.26.11,0-.05-.13-.24-.13-.29,0-.05.15.03.15-.02,0-.05-.21-.28-.21-.34,0-.05.19.05.19,0,0-.05-.11-.19-.11-.24,0-.06-.15-.2-.15-.25,0-.06.2.01.19-.04,0-.06-.16-.19-.17-.25-.01-.06-.05-.13-.07-.19-.01-.06.15-.06.13-.12-.01-.06,0-.12-.02-.18-.02-.06-.05-.13-.06-.2-.02-.06-.05-.13-.07-.2-.02-.06-.2-.13-.23-.2-.02-.06.11-.13.09-.19-.02-.06-.17-.11-.19-.17-.03-.06.02-.14,0-.2-.03-.06-.08-.12-.11-.18-.03-.06-.15-.07-.18-.13-.03-.06.05-.18.01-.24-.03-.06-.11-.09-.14-.15-.03-.06-.09-.09-.12-.15-.03-.06-.09-.07-.13-.13-.04-.06.02-.23-.02-.29-.04-.05-.13,0-.17-.06-.04-.05-.07-.11-.11-.16-.04-.05-.03-.23-.06-.28-.04-.05-.08-.11-.12-.15-.04-.05-.09-.05-.13-.09-.04-.05-.09-.03-.13-.07-.04-.04-.07-.17-.11-.21-.04-.04-.09-.04-.13-.08-.04-.04-.09.12-.13.08s-.08-.24-.12-.28c-.04-.03-.09-.19-.13-.22s-.07.11-.11.08c-.04-.03-.08-.03-.12-.06-.04-.02-.07.02-.11,0-.04-.02-.08-.09-.12-.11-.04-.02-.08-.04-.12-.06-.04-.02-.12-.22-.16-.23-.04-.01-.05.08-.09.07-.04,0-.13-.21-.17-.22-.04,0-.06.04-.1.03-.04,0,0,.23-.03.23-.03,0-.1-.09-.13-.08-.03,0-.08-.02-.11-.02-.03,0-.09-.04-.12-.03-.03,0,0,.15-.03.16-.03.01-.16-.19-.19-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m324.3,359.63s.07.01.09.03c.02.02-.01.08,0,.1.02.02.08,0,.1.01.02.02.1-.02.12,0,.02.01-.01.09.01.1.02.01.14-.07.16-.06.03,0-.02.1.01.1.03,0,.12-.06.15-.05.03,0,.13-.07.16-.07.03,0,.02.07.05.07.03,0-.02.12.01.12.03,0,.21-.21.24-.21.04,0-.04.16,0,.16.04,0,.15-.14.18-.14.04,0,.04.05.08.04.04,0,.13-.12.17-.13.04,0,.04.07.08.06.04-.01.11-.11.15-.13.04-.01.06.02.1,0,.04-.01.09-.06.13-.08.04-.02.08-.03.12-.05.04-.02.05.14.1.12.04-.02.09-.02.13-.05.04-.02.09-.2.14-.22.04-.02.09.05.13.03.04-.02.07-.18.11-.2.04-.03.1.06.15.04.04-.03.06-.15.1-.18.04-.03.12.04.16.01.04-.03.04-.15.08-.18.04-.03.08-.05.12-.09s.08-.05.12-.09c.04-.03.09-.05.13-.09.04-.03.04-.09.08-.12.04-.04.17,0,.2-.04.04-.04,0-.11.04-.15.04-.04.09-.06.13-.1.03-.04.04-.08.07-.12.03-.04.1-.06.13-.1.03-.04.09-.07.12-.11.03-.04-.04-.08-.01-.12.03-.04.08-.07.11-.11.03-.04.21-.08.24-.12.02-.04.01-.08.04-.12.02-.04-.04-.07-.02-.1.02-.04.04-.07.06-.11.02-.04-.02-.06,0-.1.02-.04.12-.09.14-.13s.08-.09.09-.13c.01-.04.05-.08.06-.12.01-.04-.08-.03-.07-.07,0-.03-.08-.03-.07-.06,0-.03.16-.13.16-.16,0-.03-.09-.02-.09-.05,0-.03.22-.17.22-.21,0-.03-.12,0-.12-.03,0-.03.06-.1.06-.13,0-.03-.24.09-.24.06,0-.03.04-.08.03-.11,0-.03.08-.12.07-.14-.01-.02.07-.12.06-.14-.01-.02-.06-.02-.08-.04-.01-.02-.11.03-.13,0-.02-.02-.04-.03-.06-.05-.02-.02.03-.09,0-.11-.02-.02-.1.03-.12.01-.02-.01-.13.06-.15.05-.02-.01.13-.21.11-.22-.03,0-.02-.06-.05-.07-.03,0-.24.2-.27.2-.03,0,.1-.21.07-.22-.03,0-.07,0-.11,0-.03,0-.22.21-.25.21-.03,0,.09-.23.05-.23-.04,0-.16.14-.2.14-.04,0,0-.13-.04-.12-.04,0-.18.21-.22.22-.04,0,0-.16-.03-.15-.04,0-.12.11-.16.12s-.13.14-.17.16c-.04.01-.02-.17-.06-.15-.04.01-.12.15-.16.17-.04.02-.09.06-.13.08-.04.02-.06-.11-.1-.09-.04.02-.09.02-.13.04-.04.02-.09.05-.14.08-.04.02-.09.06-.14.08-.04.02-.07.18-.12.21-.04.03-.11-.08-.15-.05-.04.03-.06.15-.1.18-.04.03-.11,0-.15.03-.04.03-.08.08-.12.11-.04.03-.03.13-.07.17-.04.03-.14-.01-.18.02-.04.03-.05.1-.09.13-.04.03-.06.08-.09.12-.04.04-.04.09-.08.12-.04.04-.17.02-.21.05-.04.04.01.11-.02.15-.03.04-.07.07-.11.11-.03.04-.17.05-.2.09-.03.04-.07.08-.1.12-.03.04-.02.08-.05.12-.03.04,0,.08-.03.12-.03.04-.12.08-.14.12-.02.04-.02.08-.04.11-.02.04.1.06.08.09-.02.04-.17.09-.19.13-.02.04-.13.1-.14.13-.02.04.09.04.07.08s-.01.07-.03.1.03.05.01.09c-.01.04-.06.08-.07.12,0,.03-.02.07-.03.1,0,.03-.15.13-.15.16,0,.03.07.03.07.06,0,.03-.14.14-.14.17,0,.03.04.05.04.07,0,.03.17-.04.17,0,0,.03-.05.09-.04.12,0,.03,0,.07,0,.09,0,.03-.02.07,0,.1.01.02.11-.02.12,0,.01.02-.12.16-.1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m323.62,386.22c0,15.65,5.05,30.69,5.05,30.69h2.73l-1.6-30.69h-6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m331.57,419.26h-5.33c.02-1.21.89-2.2,2-2.33.09-.01.18-.02.27-.02h2.9l.08,1.23.08,1.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "331.49 418.14 328.24 418.14 328.24 416.91 331.41 416.91 331.49 418.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m322.78,373.7v5.82c0,.82.63,1.48,1.41,1.48h9.17c.64,0,1.16-.55,1.16-1.23v-9.75c0-.89-.55-1.67-1.36-1.93h0l-1.97-.62-3.87-.19-2.34,1h0c-.84.36-1.44,1.15-1.61,2.09l-.58,3.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "334.51 373.91 333.48 372.43 334.51 376.05 334.51 373.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "m324.97,368.28c.17,1.09.86,2.37,2.96,2.37,2.22,0,4.96-1.46,5.22-2.56l-1.97-.62-3.87-.19-2.34,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m332.21,367.8s-1.12,1.82-4.37,1.73c-2.02-.06-1.77-1.72-1.77-1.72l1.23-.53,3.91.14,1,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m332.24,386.22c3.19,6.72.98,10.79-.23,17.23-1.67,8.81-2.61,13.46-2.61,13.46h-2.55v-30.69h5.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m329.4,416.91l-.3,1.23-.27,1.12h-4.56c.02-1.12.77-2.06,1.78-2.29.16-.04.32-.06.49-.06h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m329.4,416.91l-.3,1.23h-1.66c-.68,0-1.25-.5-1.4-1.18.16-.04.32-.06.49-.06h2.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "m321.28,396.52h15.39l-2.09-12.88c-.07-.43-.41-.74-.8-.74h-9.61c-.39,0-.73.31-.8.74l-2.09,12.88Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 324.41,
    y: 381,
    width: 9.22,
    height: 1.89
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "333.21 396.52 332.02 387.67 332.75 396.52 333.21 396.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "329.26 396.52 328.26 387.88 328.54 396.52 329.26 396.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "324 396.52 325.33 387.88 324.66 396.52 324 396.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "330.18 374.18 327.45 376.95 326.88 376.6 330.18 374.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "327.76 375.12 325.91 376.99 325.34 376.64 327.76 375.12"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m327.09,362.66c-.45,0-.82-.39-.82-.87h.32c0,.29.23.53.5.53v.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m336.23,383.11l-.19.5c-.45,1.2-1.75,1.79-2.89,1.31h0s.19-.5.19-.5c.45-1.2,1.75-1.79,2.89-1.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m336.17,383.21l-1.62-.65,2.62-6.2c.25-.59.88-.9,1.46-.72h0c.76.23,1.12,1.15.73,1.88-2.38,4.5-3.19,5.68-3.19,5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m319.63,369.93v-.54c.03-1.3,1.04-2.33,2.27-2.31h0s0,.54,0,.54c-.02,1.3-1.03,2.33-2.26,2.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m319.65,369.81h1.74s-.36,6.77-.36,6.77c-.03.65-.52,1.17-1.13,1.22h0c-.79.07-1.43-.66-1.32-1.48.71-5.1,1.07-6.5,1.07-6.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "330.18 374.18 327.45 376.95 326.88 376.6 330.18 374.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "327.76 375.12 325.91 376.99 325.34 376.64 327.76 375.12"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m356.64,439.09l-.99-.02c-.45,0-.97,0-1.43.04l-3.02-.37h.07s.17-.22.17-.22h0l.67-.86-1.16-.07-1.45-.1.15-.04.37-.11s.09,0,.14,0c.12,0,.24,0,.36-.01,2.21-.07,4.13-.23,4.76-.41.38-.11.22-.21-.33-.29l.29-.08c.27-.08.34-.15.26-.21-.17-.13-1.04-.22-2.36-.22h-.13c-1.97,0-4.23.19-5.04.43-1.79.08-3.26.22-3.8.37-.62.18.2.34,1.91.41l-.57.17-2.58.09h0l-1.11.04-5.53,1.06-5.8.56h-.15c-.99-.03-2.31.05-2.95.18l-.2.04s-.03.02.04.02l1.73.04c.92.02,2.12-.05,2.8-.16l6.04-.52,1.53-.24h0l.1-.02c-1.48.87-2.04.97-2.04.97h0c-5.06.69-6.11,1.13-9.41,2.44h1.42c-.99.55-2.22,1.22-2.23,1.22h-1.19c-1.2,0-2.6.12-3.12.28h4.76,0s.33,0,.33,0h0s4.27,0,4.27,0c.52-.15-.03-.28-1.24-.28h-.86s2.94-.54,6.14-1.22h1.41c1.5-.39,2.71-.73,3.69-1.01,2.44-.72,3.34-1.15,3.19-1.42h0,0s4.31-1.08,4.31-1.08l-.08.43,4.17.41s.13.03.31.04l2.31.04c.3,0,.69-.02.86-.06l.57-.12c.27-.06.11-.11-.36-.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "321.95 401.49 317.56 406.29 315.86 405.19 319.86 399.99 321.95 401.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m313.41,406.98h0c.25-1.32,1.46-2.18,2.72-1.91l1.54.32c.09.02.15.11.13.2h0c-.25,1.32-1.46,2.18-2.72,1.91l-1.54-.32c-.09-.02-.15-.11-.13-.2Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 327.27,
    cy: 384.02,
    rx: 5.56,
    ry: 4.04
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "338.94 405.89 333.13 402.06 334.33 400.05 340.06 404.53 338.94 405.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "332.21 390.76 335.05 400.53 333.13 402.06 331.2 396.64 332.21 390.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m327.31,407.9v33.09h1.88s1.9-8.58,2.7-17.35c.56-6.1.58-12.29-.94-15.75h-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m330.06,440.99c1.2,0,2.18,1.12,2.18,2.49h-4.92v-2.49h2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m323.22,423.84c.11.71,3.02,17.15,3.02,17.15h1.56v-33.09h-3.71c-2.37,6.2-1.84,9.89-.86,15.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m325.05,440.99c-1.2,0-2.18,1.12-2.18,2.49h4.92v-2.49h-2.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 327.63,
    y: 423.65,
    width: 0.32,
    height: 17.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 327.63,
    y: 440.99,
    width: 0.33,
    height: 2.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m322.87,429.93h9.69c.16-3.54.23-6.57.22-9.18-.03-6.52-.58-10.38-1.67-12.85h-7.16c-2.72,6.2-2.24,10.24-1.08,22.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "321.77 390.41 324.83 392.47 321.95 401.49 319.86 399.99 321.77 390.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m331.11,407.9l.13,1.56-2.56-1.56-2.75,1.8-1.98-1.8s.28-1.08-1.82-11.61l-.36-5.87,3.19-1.1,3.71-.2,3.53,1.65-1.1,17.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "329.03 389.45 327.37 392.82 324.88 389.37 329.03 389.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m329.03,389.45s.12.7-1.36.7-2.65-.7-2.65-.7v-4.54h4.01v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m329.03,388.83v-2.84h-3.63s.64,2.56,3.63,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m324.23,380.65v2.42l.79.06v3.34s2.48,2.26,4.84,1.1c1.03-.51,1.66-1.63,1.66-2.83v-4.09c0-.7-.17-1.36-.47-1.93-.61-1.17-1.78-1.96-3.1-1.96h-.13c-1.97,0-3.58,1.74-3.58,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m324.23,380.65v2.57h1.74l.38-2.13,4.7-2.37c-.61-1.17-1.78-1.96-3.1-1.96h-.13c-1.97,0-3.58,1.74-3.58,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m324.83,381.64h0c.4,0,.72.32.72.72v2.24h-.72c-.39,0-.71-.32-.71-.71v-1.54c0-.39.32-.71.71-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m330.18,385.07v-.35c.22,0,.39-.19.39-.41v-.66h.33v.66c0,.42-.32.76-.72.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m328.81,386.46c-.73,0-1.08-.64-1.16-.99l.32-.08s.2.8.94.72l.03.35s-.1,0-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m338.63,405.27h0c-.05.38.2.73.56.79l2.31.36c.36.06.7-.21.75-.59l.13-.9c.08-.59-.3-1.14-.86-1.23l-.73-.11c-1.03-.16-1.99.59-2.15,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m325.02,389.23l.99,5.77s-1.19-.63-2.18-2.01c-.99-1.38-1.08-2.92-1.08-2.92l2.26-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m329.03,389.23l-.32,5.44s1.03-.47,1.61-2.01c.58-1.54.48-2.55.48-2.55l-1.78-.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "321.95 401.49 319.86 399.99 320.32 397.7 322.65 399.3 321.95 401.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "335.05 400.53 333.13 402.06 332.31 399.74 334.48 398.54 335.05 400.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m328.94,420.75h3.84c-.03-6.52-.58-10.38-1.67-12.85h-6.32s.04,5.86.04,8.38c0,3.83,1.35,4.47,4.11,4.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 323.52,
    y: 395.96,
    width: 2.02,
    height: 0.67,
    transform: "translate(649.07 792.6) rotate(180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m413.03,371.6h-2.83c-.36,0-.78.03-.92.08l-2.27.66c-.36,0-.77.03-1.03.07l-1.36.21-1.89.09.09-.04c.2-.08.02-.14-.4-.17-.04-.04-.18-.07-.4-.09-.09,0-.19-.02-.31-.02h-.05s-.67-.04-.67-.04h0s-.67-.04-.67-.04h0l-.53-.12h-.11s0,0,0,0c0,0,0,0,0,0l.38-.11c2.23-.02,3.17-.23,3.76-.4l1.32-.39h.97l1.08-.32c.81-.24-.18-.43-2.21-.43h-1.09c-1.15,0-2.38.06-3.38.16l-1.25-.07h-.1c-.37.07-.48.13-.34.17h-.8l-.05.02c-.19.06-.1.1.18.13l-1.24.36h-.04c-.45,0-.97.04-1.15.1l-.62.18c-.18.05.04.1.5.1h.33l-.39.11h0l-1.21.35-.18-.02-1.3.16h0l-1.22.05h0l-.58.02c-1.03.04-1.98.14-2.38.25l-2.83.8-2.67.83-2.54.38c-.22.01-.42.04-.51.06l-.6.18-1.45.42c-.12.04.03.07.34.07h1.48l-13.78,3.01h.03c-.05.01-.1.02-.14.03l-.37.11h2.49l.37-.11s.08-.03.09-.04l15.73-2.53-6,2.42h2.95s12.06-3.15,12.06-3.15h.38s0,0,0,0l2.56-.74-.72.65c-.46,0-.99.04-1.25.1l-1.95.4,1.51.03c.5.01,1.16-.03,1.46-.09l1.43-.29c.11-.02.16-.05.14-.07l2.87-1.01c.77-.08,1.24-.2,1.15-.29-.04-.05-.22-.09-.5-.11.1-.02.17-.04.23-.06l1.36-.58,2.84-.2h.07c.41.02,1.03,0,1.39-.06l1.46-.22h2.08c.36,0,.78-.03.92-.08l2.67-.78c.14-.04-.03-.08-.4-.08Zm-31.05,3.03h-.74l1.42-.21-.69.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m381.28,378.26h-2.95s-.67.26-.67.26h5.04c.46-.14-.16-.26-1.42-.26Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 385.92,
    y: 315.99,
    width: 3.85,
    height: 8.45,
    rx: 1.72,
    ry: 1.72,
    transform: "translate(775.69 640.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 386.21,
    y: 315.99,
    width: 3.85,
    height: 8.45,
    rx: 1.72,
    ry: 1.72,
    transform: "translate(776.28 640.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m386.92,318.41h0c.14,0,.25-.12.25-.27v-1.19c0-.15-.11-.27-.25-.27h0c-.14,0-.25.12-.25.27v1.19c0,.15.11.27.25.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "367.67 344.17 367.2 343.99 374.06 324.94 374.53 325.13 367.67 344.17"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m382.21,336.29h0c1.02-.1,1.77-1.06,1.67-2.14l-1.02-8.46c-.1-1.08-1.01-1.87-2.03-1.77h0c-1.02.1-1.77,1.06-1.67,2.14l1.03,8.46c.1,1.08,1.01,1.87,2.03,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m384.75,335.72c.62,1.29.13,2.87-1.1,3.53-1.23.65-2.72.14-3.35-1.16-.62-1.29-.13-2.87,1.1-3.53,1.23-.65,2.72-.14,3.35,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m383.72,347.38l1.45.25-.61-9.8c-.08-.93-.86-1.61-1.74-1.52h0c-.97.09-1.63,1.07-1.41,2.07l2.3,8.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m383.31,351.49l-1.26-.23.53-3.24c.13-.78.83-1.3,1.56-1.16h0c.7.13,1.17.83,1.05,1.56l-.31,1.9c-.13.78-.83,1.3-1.56,1.16Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "380.38 376.15 377.43 376.15 374.24 345.39 381.76 345.39 380.38 376.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "377.72 345.98 368.06 377.25 365.64 377.25 369.73 345.54 377.72 345.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m366.88,376.22c.69,0,1.25.59,1.25,1.31v.98h-2.49v-.99c0-.73.56-1.31,1.25-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m382.13,325.19l-.08,22.44h-13.25s-.33-15.1-.33-15.1l.09-7.23c.01-1.01.62-1.91,1.53-2.25l2.6-.97s5.43.03,5.4,0l2.63,1.03.06.02c.14.05.27.12.39.21.59.4.95,1.08.95,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m381.18,323.35l-8.2,22.77-.47-.19,8.21-22.81.06.02c.14.05.27.12.39.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "370.6 322.87 376.93 328.68 379.94 322.81 379 322.44 376.78 327.04 371.64 322.4 370.6 322.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "378.71 323.04 376.78 327.04 372.08 322.81 376.3 323.91 378.71 323.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m382.7,378.52h-5.04l-.22-2.36h2.95c1.25,0,2.27,1.05,2.31,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m378.13,322.11s.25,1.81-1.77,1.81-3.71-1.81-3.71-1.81v-4.17h5.48v4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "m375.17,352.63h1.05c.61,0,1.1-.52,1.1-1.17v-3.83h-2.15v5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "371.55 322.58 374.78 325.88 376.3 323.91 372.39 320.94 371.55 322.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "379.15 322.5 377.97 325.58 376.3 323.91 378.21 321.41 379.15 322.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "382.04 347.63 382.05 345.32 368.74 345.39 368.79 347.63 382.04 347.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m378.14,321.49v-3.64h-4.64s0,3.64,4.64,3.64Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m379.07,331.79h0c.54-.92.27-2.13-.61-2.7l-6.38-4.58c-.88-.57-2.02-.28-2.56.64h0c-.54.92-.27,2.13.61,2.7l6.38,4.58c.88.57,2.02.28,2.56-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m378.02,328.03c1.35.26,2.25,1.63,2,3.05s-1.54,2.37-2.9,2.11c-1.35-.26-2.25-1.63-2-3.06.25-1.43,1.54-2.37,2.9-2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m384.65,325.12l1.2,1.5-6.42,5.52c-.78.7-1.95.59-2.62-.23h0c-.73-.91-.52-2.29.44-2.92l7.39-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m386.43,322.79l1.3.49-1.04,3.05c-.2.58-.8.87-1.35.67h0c-.72-.27-1.09-1.11-.83-1.86l.57-1.68c.2-.58.8-.87,1.35-.67Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m368.82,343.35h3.56c.95,0,1.72.77,1.72,1.72v3.51c0,.82-.66,1.48-1.48,1.48h-4.05c-.82,0-1.48-.66-1.48-1.48v-3.51c0-.95.77-1.72,1.72-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m368.44,343.35h4.32c.74,0,1.34.6,1.34,1.34h0c0,1.08-.88,1.96-1.96,1.96h-3.08c-1.08,0-1.96-.88-1.96-1.96h0c0-.74.6-1.34,1.34-1.34Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 372.36,
    y: 309.22,
    width: 1.96,
    height: 5.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m377.28,306.62h0c2.33,0,4.21,1.89,4.21,4.21v2.52h-8.43v-2.52c0-2.33,1.89-4.21,4.21-4.21Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m372.47,311.83v1.79h.18v5.3s2.11,1.57,5.19,1.57c2.46,0,2.69-2.03,2.69-3.65v-5.02c0-.61-.12-1.18-.35-1.7-.2-.46-.47-.88-.81-1.24-.71-.75-1.7-1.22-2.79-1.22h-.18c-2.18,0-3.94,1.86-3.94,4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m380.18,310.12c-.2-.46-.47-.88-.81-1.24-.71-.75-1.7-1.22-2.79-1.22h-.18c-2.18,0-3.94,1.86-3.94,4.16v1.79h.18v.93h1.32v-2.11h.47c.59,0,1.07-.51,1.07-1.13h0c0-.66.5-1.18,1.11-1.18,1.38,0,3.56,0,3.56,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "m372.36,313.55h0c.48,0,.87.39.87.87v2.49h-.87c-.48,0-.86-.39-.86-.86v-1.64c0-.48.39-.86.86-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m379.36,316.15c0,.23-.07.44-.22.6-.15.16-.35.25-.56.25v-.39c.11,0,.22-.05.3-.13s.12-.2.11-.32v-.12s.37,0,.37,0v.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m379.57,317.69h-3.07s.55,1.21,1.61,1.21,1.46-1.21,1.46-1.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m371.74,308.93h2.04v1.54h-.5c-.85,0-1.54-.69-1.54-1.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m373.74,309.64l-.54-.23c-.74-.32-1.1-1.22-.8-2h0s1.89.82,1.89.82l-.55,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m375.78,309.67s1.7.25,3.13,1.29c2.06,1.51,1.61,2.32,1.61,2.32l.52-1.48-.19-2.43-5.08.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m377.13,309.26l1.6,2.24-3.19-1.76s.62-.99,1.6-.47Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m410,415.94l.96-.04.06-.28-.5.02c.08-.79-3.66-1.3-3.78-1.32,0,0,0,0,0,0-1.15-.05-2.28-.1-3.4-.16l-.67-.23.64-.19.48-.14.13-.04h.26c.43,0,.92-.04,1.1-.09l.48-.14c.17-.05-.04-.09-.47-.09-.09,0-.19,0-.28,0l.52-.15.73-.21.14-.04.7-.21c2.08-.06,3.69-.17,4.1-.29.64-.19-1.84-.34-5.54-.34s-7.21.15-7.85.34c-.41.12.47.23,2.14.29l-.7.21-.87.25-1.74.51c-.86.04-1.36.09-1.36.09h1.06l-.28.08-.33.1s.38.09.62.15l-1.37.13c-1.58.06-3.15.11-4.73.17,0,0,0,0,0,0-.27.02-7.44.52-12.77,1.32l-.37-.02-1.83.28.71.04c-.29.49.88.8,1.77.97-2.58.38.85.52.85.52l-6.94,2.03h4.39c-.34.28-.73.58-1.23.91h-.27c-1.41,0-2.78.12-3.05.27h5.29,0,5.47c.75-.15.2-.27-1.21-.27h-.1c1.74-.33,3.39-.63,4.99-.91h4.39l7.48-2.19,1.07-.31h0s-1.61.47-1.61.47c0,0,4.32-.13,4.37-.52,2.01-.16,5.34-.48,8.37-.97Zm-29.85.21l5.14-.65c-1.3.34-2.53.69-3.62,1.02h-.01l-.85.25-.65-.62Zm20.17.37c1.16-.33,2.31-.68,3.34-1.02l.7.65-4.88.62.85-.25h-.01Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m394.02,377.94c-2.13,7.04-6.52,10.22-6.52,10.22l-1.83-1.27,4.94-9.99,3.41,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "m393.56,375.75c.26.73.51,1.5.74,2.28l-5.25,2.08-7.42-14.92,3.55-1.57s5.73,4.71,8.38,12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m386.27,391.58v-5.13h2.41c1.81,3.85-2.41,5.13-2.41,5.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "393.9 375.35 387.96 377.73 389.05 380.11 394.79 377.84 393.9 375.35"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "m367.83,390.14h18.2c.46-7.8.29-18.8-.85-26.53-1.9-.67-3.8-1.37-5.67-2.11h-5.17c-1.87.75-3.77,1.45-5.67,2.11-1.14,7.73-1.31,18.73-.85,26.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m382.68,386.82s.57-3.46.3-11.11c-.24-6.75-.79-9.71-.79-9.74v-.08s-5.36-3.31-5.36-3.31l-.17.3,5.21,3.23c.09.5.56,3.49.77,9.61.27,7.6-.29,11-.29,11.03l.33.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "m386.04,390.14c-1.45,10.59-3.88,17.59-6.03,28.03h-3.07c0-10.47,0-17.57,0-28.03h9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "m367.83,390.14c1.45,10.59,3.88,17.59,6.03,28.03h3.07c0-10.47,0-17.57,0-28.03h-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "m371.48,420.63h10.76c.24-1.35-.72-2.45-2.13-2.45h-6.5c-1.41,0-2.37,1.1-2.12,2.45h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 376.77,
    y: 395.48,
    width: 0.33,
    height: 25.15
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m359.85,377.95c2.13,7.04,6.52,10.22,6.52,10.22l1.83-1.27-4.94-9.99-3.41,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "m360.31,375.76c-.26.73-.51,1.5-.74,2.28l5.25,2.08,7.42-14.92-3.55-1.57s-5.73,4.71-8.38,12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m367.6,391.58v-5.13h-2.41c-1.81,3.85,2.41,5.13,2.41,5.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m374.09,361.64s.75.7,2.84.7,2.84-.7,2.84-.7v-4.54h-5.69v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m374.09,361.44v-2.75h4.7s-.83,2.48-4.7,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "m376.2,362.31l-2.15-1.79-1.27,1.64s1.71,2.29,3.42.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m372.63,359.56c4.52,1.61,7.15-1.18,7.15-1.18v-8.14h-7.15v9.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m377.31,357.95h-5.74s.88-1.23,2.92-1.19c2.04.04,2.82,1.19,2.82,1.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 378.58,
    y: 350.59,
    width: 1.2,
    height: 4.25,
    transform: "translate(758.36 705.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 372.63,
    y: 345.78,
    width: 7.15,
    height: 6.75,
    transform: "translate(752.4 698.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m380.04,353.85h0c.43,0,.78.37.78.83v1.26c0,.46-.35.83-.78.83h-.79v-2.08c0-.46.35-.84.79-.84Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-234",
    cx: 376.2,
    cy: 345.78,
    rx: 6.69,
    ry: 3.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m376.74,359.93s-2.65,1.41-2.65,1.39-1.46-1.76-1.46-1.76l1.37-.95,2.75,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "m379.78,360.06l-3.58,2.25s1,.94,2.2.94,2.89-1,2.89-1l-1.52-2.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "372.99 356.67 374.36 356.49 374.31 356.14 373.5 356.25 373.82 355.37 373.51 355.24 372.99 356.67"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 375.79,
    y: 395.3,
    width: 2.28,
    height: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 367.6,
    y: 390.14,
    width: 18.68,
    height: 19.8,
    transform: "translate(753.87 800.09) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 367.6,
    y: 383.43,
    width: 18.68,
    height: 6.71,
    transform: "translate(753.87 773.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "369.01 408.23 384.86 408.23 384.86 390.23 384.53 390.23 384.53 407.88 369.34 407.88 369.34 390.14 369.01 390.14 369.01 408.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "359.97 375.35 365.91 377.73 364.82 380.12 359.08 377.84 359.97 375.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "m376.2,362.31l.73,5.19s1.12-1.38,1.19-2.6c.07-1.21-1.92-2.6-1.92-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "m376.2,362.31l-.73,5.19s-1.12-1.38-1.19-2.6c-.07-1.21,1.92-2.6,1.92-2.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 380.57,
    cy: 367.94,
    rx: 0.53,
    ry: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m380.04,372.14c0,.31.24.56.53.56s.53-.25.53-.56-.24-.56-.53-.56-.53.25-.53.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m380.04,376.33c0,.31.24.56.53.56s.53-.25.53-.56-.24-.56-.53-.56-.53.25-.53.56Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 380.57,
    cy: 380.53,
    rx: 0.53,
    ry: 0.56
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m371.85,367.94c0,.31.24.56.53.56s.53-.25.53-.56-.24-.56-.53-.56-.53.25-.53.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m371.85,372.14c0,.31.24.56.53.56s.53-.25.53-.56-.24-.56-.53-.56-.53.25-.53.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m371.85,376.33c0,.31.24.56.53.56s.53-.25.53-.56-.24-.56-.53-.56-.53.25-.53.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m371.85,380.53c0,.31.24.56.53.56s.53-.25.53-.56-.24-.56-.53-.56-.53.25-.53.56Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "367.92 373.63 368.17 369.47 367.84 369.45 367.59 373.61 367.92 373.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "367.7 372.02 367.97 371.81 366.3 369.36 366.03 369.56 367.7 372.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "385.93 373.51 386.26 373.49 386.01 369.33 385.68 369.35 385.93 373.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "386.15 371.89 387.82 369.44 387.55 369.23 385.88 371.69 386.15 371.89"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "375.94 360.36 379.25 358.99 379.25 354.69 378.58 354.85 378.58 358.29 375.24 359.27 375.94 360.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "373.38 359.31 372.63 358.69 372.63 359.56 373.38 359.31"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m412.94,435.71c.25-.15-.16-.26-.73-.34-.55-.08-1.24-.12-1.64-.14l.12-.04.44-.13c.76-.02,1.53-.06,2.2-.12-.32.19-.41.32-.17.31.34,0,1.22-.27,1.99-.6l.37-.11c.53-.07.95-.15,1.22-.23.91-.28-.28-.5-2.66-.49-2.38,0-5.05.23-5.96.51,0,0-.01,0-.02,0-.4.06-.82.13-1.25.2-1.9.32-3.19.59-2.86.6.17,0,.75-.06,1.54-.17-.78.16-1.19.27-1.01.27.28,0,1.88-.23,3.63-.54h.17c-.62.2-1.01.37-1.09.46l-.23.07c-.27,0-.65.02-1.09.05-.35.02-.74.05-1.14.08,0,0,0,0-.01,0-4.66.26-9.28.92-10.2,1.06-.49.04-.72.11-.5.16,1.31.27,2.48.48,3.1.6-.45.07-.85.13-1.21.2-2.67.51-6.83,1.23-8.39,1.73,0,0,0,0,0,0h0s.71.28,2.54.34c.03,0,.08,0,.11,0l-.82.18s0,0,0,0l-4.98,1.03h0s-1.38.28-1.38.28l4.93.07c.68-.15.29-.29-.87-.31h-.87c.38-.06,1.61-.2,3.18-.4-.31.26-.45.42-.45.42l-.39.28h4.44c.53-.16-.03-.28-1.26-.28h-.86s4.65-1.22,4.65-1.22c.14-.02.27-.04.4-.06,1.95,0,3.66-.08,4.92-.17l7.55-2.21h0l1.08-.32,1.67.62,1.12-.07s.34-.16-.64-.69c0,0,1.24-.52,1.28-.88Zm-16.56.78l4.98-.59s-.41.21-.93.45c-.59.27-1.34.57-1.81.62-.13.01-.26.03-.38.04l-1.86-.53Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m378.83,399.73l1.34,2.01,6.67-11.9-.8-.21c-4.55,2.28-7.2,10.09-7.2,10.09Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m396.62,401.18c2.78,4.79,3.01,6.27,3.01,6.27l-.87.66-3.83-5.65,1.69-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m401.13,411.6l-2.37-3.5.87-.65c2.48,1.82,1.51,4.15,1.51,4.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m396.62,401.18l-1.69,1.28-2.37-12.04h0c.57.08,1.1.38,1.42.88,1.85,2.85,2.64,9.89,2.64,9.89Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "m381.08,423.78s1.67,2.54,3.71,3.1c2.04.57,7.61-4.28,7.61-4.28l-9.9-.58-1.42,1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m383.24,437.89l1.82.33s5.43-9.55,6.68-14.72c2.61-10.83.25-14.35.25-14.35h-4.94s-2.35,19.41-2.35,19.41t0,0l-1.47,9.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m386.05,438.19c1.22.15,2.08,1.4,1.93,2.79l-5.17-.64.43-2.49,2.81.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m388.01,438.45h1.94l1.25-29.31h-5.96c-3.68,6.73,2.78,29.31,2.78,29.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m390.81,438.45c1.23,0,2.22,1.14,2.22,2.54h-4.44l-.57-2.54h2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "m394.98,394.67v10.72h0v19.97c-.99.86-2.5,1.65-4.61,1.51-4.41-.29-6.24-4.65-8.18-3.93-.38.14-.75.44-1.11.84-.16-4.55,1.55-11.03,2.48-15.64.25-1.23.67-2.42,1.33-3.47.3-.47.01-3.19-.31-5.63-.29-2.14-.61-4.08-.61-4.08-.11-2.58.67-4.12,1.54-5.04.29-.31.59-.54.87-.72.71-.46,1.3-.56,1.3-.56h2.79s1.31.41,2.52,1.45c1.11.95,2.13,2.42,1.99,4.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "390.85 388.9 390.58 390.28 387.3 388.9 387.3 384.77 390.85 384.77 390.85 388.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m388.31,386.34h2.54v2.13h-.52c-1.12,0-2.02-.95-2.02-2.13h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m393.9,380.51c.03,2.5-1.86,4.55-4.23,4.58-2.37.03-4.31-1.96-4.35-4.46-.03-2.5,1.86-4.55,4.23-4.58,2.37-.03,4.31,1.96,4.35,4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m386.75,383.57c-.72,3.03-1.57,5.41-1.9,5.32-.33-.09-.01-2.61.71-5.64.72-3.03,1.57-5.41,1.9-5.32s.01,2.61-.71,5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m393.44,383.36c.39,3.09.44,5.64.1,5.69-.34.05-.93-2.42-1.32-5.52s-.44-5.64-.1-5.69.93,2.42,1.32,5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m386.1,382.93c-.82,2.88-1.77,5.13-2.14,5.01-.37-.12,0-2.55.81-5.43.82-2.88,1.77-5.13,2.14-5.01.37.12,0,2.55-.81,5.43Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m386.35,381.56h0c.35,0,.64.29.65.67l.02,1.79h-.47c-.45.01-.82-.37-.82-.84v-.93c-.02-.37.27-.68.62-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m390.17,377.49h0c-1.78.03-3.21,1.57-3.18,3.45l.04,3.06c.02,1.88,1.49,3.38,3.27,3.36h0c1.78-.03,3.21-1.57,3.18-3.45l-.04-3.06c-.02-1.88-1.49-3.38-3.27-3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m392.36,385.06h-2.33s1.52,1.96,2.33,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m391.7,384.27c.44,0,.8-.38.8-.84h-.31c0,.28-.22.52-.49.52v.33Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m388.36,382.9c.04,3.22-.28,5.84-.71,5.85-.43,0-.82-2.6-.86-5.83-.04-3.22.28-5.84.71-5.85.43,0,.82,2.6.86,5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m387.04,382.17h0l-.06-4.63,4.39-.06h0c.03,2.56-1.91,4.66-4.33,4.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "391.48 378.14 391.35 378.78 390.6 378.61 390.72 377.97 391.48 378.14"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m378.95,400.92c3.28,3.56,5.9,6.16,5.9,6.16l.82-.72-5.23-6.82c-.35-.46-.98-.52-1.41-.15h0c-.44.39-.48,1.1-.08,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m385.86,406.03l-1.79-.6h0c-.08,1.22,1.21,2.79,2.37,2.87l1.38.1h0c.08-1.22-.8-2.28-1.96-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m392.99,390.1c-.4.38-1.12.64-2.39.56-1.96-.13-3.34-.82-4.22-1.45.71-.46,1.3-.56,1.3-.56h2.79s1.31.41,2.52,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m385.66,394.75c-.04,1.85-.6,3.34-1.08,4.29-.29-2.14-.61-4.08-.61-4.08-.11-2.58.67-4.12,1.54-5.04.09,1.13.2,2.88.15,4.82Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m388.28,440.62l-2.87.1c-.39.01-.73.05-.95.08l-4.93.16-.04-.38.57-.02v-.35c.54-.23.42-.43-.22-.52-.05,0-.1-.01-.16-.02-.14-.02-.3-.03-.48-.05-.65-.06-1.27-.07-1.27-.07l-.44-.02h0s.48-.14.48-.14c1.55-.04,3.09-.19,3.7-.37l.82-.24c.33-.05.6-.11.8-.17.78-.23.23-.42-1.21-.5-.44-.02-.96-.04-1.56-.04-.24,0-.47,0-.71,0-.02,0-.16,0-.17-.01,0,0-.15,0-.16-.01,0,0,.19-.02.18-.03-.01,0-.16,0-.18,0-.01,0,.27-.03.26-.04-.02,0-.21,0-.23,0-.02,0,.05-.02.02-.02-.02,0-.36.02-.39.01-.03,0,.02-.01-.01-.02-.03,0,.07-.02.04-.03-.03,0,.05-.02.01-.02-.04,0-.12,0-.16,0-.04,0-.18,0-.22,0-.04,0-.09,0-.14,0-.04,0-.01-.02-.06-.02-.05,0-.16,0-.21,0-.05,0-.19.01-.24,0-.05,0,.1-.04.05-.04-.05,0-.07-.01-.12-.01-.05,0-.3.04-.36.04-.06,0,.05-.04,0-.04-.06,0-.13,0-.19,0-.06,0-.26.04-.31.04-.06,0,.01-.04-.05-.04-.06,0-.19.03-.25.03-.06,0-.07-.02-.13-.02-.06,0-.19.04-.26.04-.06,0-.08-.03-.14-.03-.06,0-.15.02-.21.02-.06,0-.13.03-.2.03-.06,0-.13-.03-.19-.03-.06,0-.12.03-.18.03-.06,0-.12.01-.18.01-.06,0-.17-.02-.23-.02-.06,0-.14,0-.21,0-.06,0-.13,0-.19.01-.06,0-.13.01-.19.02-.06,0-.02.03-.08.04-.06,0-.24-.01-.3,0-.06,0-.02.03-.07.03-.06,0-.19,0-.24,0-.05,0-.08.01-.14.02-.05,0,.02.02-.03.03-.05,0-.26,0-.3,0-.05,0-.03.02-.08.02-.05,0-.05.02-.09.02-.05,0-.02.02-.06.02-.04,0-.29,0-.33,0-.04,0,.08.02.05.03-.04,0-.08.01-.12.02-.04,0-.26,0-.29.02-.03,0-.07.01-.1.02-.03,0,0,.01-.02.02-.03,0,.03.01.01.02-.02,0-.16.01-.18.02-.02,0,.01.01,0,.02-.02,0,.21,0,.19.02-.01,0-.24.02-.25.02-.01,0-.16.02-.17.02,0,0,.18,0,.17.01s.02.01.01.02c0,0,.08,0,.08.02,0,0-.05.01-.04.02,0,0,0,.01.01.02,0,0-.18.02-.17.03.01,0,.14,0,.15.01.01,0-.16.02-.14.03.02,0,.09,0,.11.01.02,0,.27,0,.29,0,.02,0-.03.02,0,.02.03,0,.03.01.06.02.03,0,.02.01.05.02.03,0,.18,0,.21,0,.04,0-.11.03-.07.03.04,0,.13,0,.17,0,.04,0,.03.01.06.02-.14,0-.24.01-.24.01,0,0-.12.08.28.12-.53.04-.84.12-.84.12,0,0,.66.03,1.28,0,.11,0,.22-.02.31-.03.08.1.48.18,1.13.23l-1.62.47h0,0s-.63.02-.93.04h0c-.41.02-.81.05-1.19.08-.38.02-.76.05-1.05.09l-1.95.27c-.1,0-.14-.02-.14-.02l-4.99.65.39.03-1.57.22c-.54.04-.92.11-.83.17.39.28.49.62.51.81-.25.03-.42.07-.43.1l-.04.18s.04.03.12.05c-.93.2-1.46.39-1.83.58-.52.27-.73.54-1.27.86-.06.03-.11.07-.16.1-.29.17-.51.32-.69.44l-2.71.69h0l-1.12.28h7.79c.5-.15-.15-.28-1.47-.28h.14l.19-.06c.12-.03,0-.06-.24-.07l1.75-.51c.88-.14,1.85-.31,2.87-.5,1.55-.28,3.27-.6,4.96-.96,1.55-.33,3.08-.68,4.41-1.05h0s.4-.12.4-.12h1.07s.53-.16,1.23-.36c.26.03.72.04,1.25,0l6.74-.29c.2.01.48.02.81,0l1.74-.06c.63-.02,1.15-.09,1.18-.16l.06-.16Zm-23.66.34h0l.76-.11.28.02.28-.03-2.57.79.18-.52,1.06-.15Zm-1.17.87s-.09,0-.14,0l.07-.19h1.47c-.51.07-.97.13-1.4.19Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m363.06,409.54l2.61-1.08-4.39-11.3c-.29-.75-1.1-1.11-1.81-.82h0c-.73.3-1.08,1.18-.79,1.94l4.38,11.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "363.8 403.66 362.84 405.39 362.52 404.14 363.8 403.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m364.45,409.99l6.87-3.12-.47-1.63-7.4,2.42c-.49.19-.81.69-.79,1.23h0c.02.95.99,1.54,1.79,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m372.71,403.98l-2.32.87c-.66.25-1,1.01-.77,1.7h0c.23.69.96,1.06,1.62.81l1.13-.42c.66-.25,1-1.01.77-1.7l-.42-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "m360.44,405.08l3.85-1.62-2.21-5.86c-.42-1.12-1.63-1.67-2.69-1.22h0c-1.06.45-1.58,1.72-1.16,2.84l2.21,5.86Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m350.29,385.8c.05.03.14.02.19.05.05.03.08.13.13.16.05.03.14,0,.19.02.05.02.15-.04.2-.02.06.02.08.14.14.16.06.02.16-.11.21-.1.06.02.09.16.15.17.06.01.14-.1.2-.09.06,0,.13-.12.19-.11.06,0,.11.11.17.11.06,0,.12.2.18.2.06,0,.11-.34.17-.34.06,0,.14.26.2.26.06,0,.09-.22.15-.23.06,0,.13.08.19.07.06-.01.07-.2.13-.21.06-.02.15.12.21.1.06-.02.06-.19.11-.21.06-.02.13.03.18,0,.05-.02.08-.1.13-.13.05-.03.1-.05.15-.08.05-.03.26.22.31.19.05-.03.13-.04.17-.08.05-.04-.08-.33-.03-.37.05-.04.22.09.26.05.04-.04-.09-.29-.05-.33.04-.04.26.1.3.06.04-.05-.08-.24-.05-.29.04-.05.26.06.3.01.04-.05-.12-.24-.08-.29.03-.05.07-.09.1-.14.03-.05.08-.09.11-.14.03-.06.08-.09.11-.14.03-.06-.03-.15,0-.2.02-.06.28-.01.3-.07.02-.06-.13-.18-.11-.24.02-.06.09-.1.11-.16.01-.06-.03-.13-.01-.19.01-.06.1-.11.11-.17,0-.06.07-.12.08-.18,0-.06-.17-.14-.17-.2,0-.06.05-.12.05-.18,0-.06.27-.14.27-.2,0-.06-.07-.13-.08-.19,0-.06-.16-.11-.17-.17,0-.06-.03-.12-.04-.18-.01-.06-.11-.1-.12-.16-.01-.06.09-.16.08-.22-.02-.06.03-.15.01-.2-.02-.06-.02-.13-.04-.19-.02-.06-.18-.05-.21-.11-.03-.06-.17-.04-.2-.1-.03-.05.11-.21.08-.26-.03-.05-.17-.03-.21-.08-.03-.05.17-.29.13-.34-.04-.05-.21,0-.24-.04-.04-.05-.01-.16-.06-.21-.04-.05-.3.15-.35.11-.04-.04-.03-.13-.08-.17-.04-.04,0-.19-.05-.23-.05-.04-.02-.19-.07-.22-.05-.04-.13-.03-.18-.06-.05-.03-.17.05-.22.02-.05-.03-.11-.05-.16-.07-.05-.03-.07-.15-.12-.17-.05-.02-.14.04-.2.02-.06-.02-.15.1-.21.08-.06-.02-.03-.35-.09-.36-.06-.02-.11-.1-.17-.11-.06-.01-.18.33-.24.32-.06,0-.08-.35-.14-.36-.06,0-.13,0-.19,0-.06,0-.13.34-.18.34-.06,0-.13-.37-.19-.37-.06,0-.11.23-.16.24-.06,0-.15-.2-.21-.19-.06,0-.06.34-.12.35-.06.01-.18-.26-.24-.25-.06.02-.08.18-.13.2-.06.02-.04.24-.1.26-.06.02-.23-.27-.28-.25-.05.02-.02.25-.07.28-.05.03-.08.1-.13.13-.05.03-.24-.18-.29-.15-.05.03-.13.04-.18.07-.05.04-.1.09-.14.13-.05.04-.09.1-.13.14-.04.04.1.3.05.34-.04.04-.29-.12-.33-.08-.04.05.08.24.04.29-.04.05-.19,0-.22.05-.04.05-.03.13-.07.18-.03.05.1.22.07.27-.03.05-.26-.02-.29.04-.03.06.03.16,0,.22-.03.06,0,.14-.02.19-.02.06.03.14.01.2-.02.06-.28.03-.3.09-.02.06.15.18.14.24-.01.06-.04.11-.05.17-.01.06-.23.09-.24.15,0,.06-.02.13-.03.19,0,.06.06.14.06.2,0,.06.08.13.08.19,0,.06-.11.13-.11.19,0,.06.06.12.06.19,0,.06.24.09.25.15,0,.06-.18.16-.17.22.01.06-.1.16-.09.22.01.06.21.07.22.13.02.06.06.11.08.17.02.06.11.08.13.14.02.06,0,.13.03.19.03.06.04.11.07.17.03.05-.1.21-.07.26.03.05.15.05.19.1.03.05-.08.22-.04.27.04.05.12.07.16.12.04.05.24-.06.28-.02.04.05.02.15.07.19.04.04.07.11.11.15.04.04.06.12.11.16.05.04.17-.03.22,0,.05.04-.01.26.04.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m360.85,385.77c0,2.68-2.06,4.85-4.6,4.85s-4.6-2.17-4.6-4.85c0-2.04,1.19-3.79,2.89-4.51h0s0,0,0,0c.53-.22,1.11-.35,1.71-.35s1.16.12,1.68.34c1.71.71,2.92,2.46,2.92,4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m353.42,386.95h.11c.29,0,.52.25.52.55v1.96h-.49c-.37,0-.66-.31-.66-.7v-1.26c0-.3.23-.55.52-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m358.18,394.8s.12.86-1.4.86-2.73-.86-2.73-.86v-5.57h4.13v5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m358.18,394.05v-3.48h-3.74s.66,3.14,3.74,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m357.34,382.88h0c-1.81,0-3.28,1.55-3.28,3.46v3.11c0,1.91,1.47,3.46,3.28,3.46h0c1.81,0,3.28-1.55,3.28-3.46v-3.11c0-1.91-1.47-3.46-3.28-3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m356.99,390.11s.23,1.25,1.26,1.25,1.26-1.25,1.26-1.25h-2.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 354.05,
    y: 384,
    width: 0.68,
    height: 3.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m354.9,385.7h-.56v-3.4h1.22v2.7c0,.38-.3.7-.66.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m362.1,413.17h-9.35s1.45-4.54-.78-9.28c-.6-1.28-.96-2.67-.98-4.1v-.77c-.06-2.19,1.29-4.13,3.27-4.76h0l3.91-.19,1.78.76c1.21.52,2.08,1.65,2.32,3l.47,2.71-.64,12.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m349.58,408.58l-2.59-1.14,4.61-11.2c.31-.74,1.12-1.09,1.83-.78h0c.72.32,1.06,1.2.75,1.96l-4.59,11.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m355.77,400.62l-1.72-6.29s-.56.19-.78.38l1.04,6.93,1.46-1.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m358.45,389.55c.45,0,.82-.39.82-.87h-.32c0,.29-.23.53-.5.53v.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m353.56,442.67h2.91s.89-2.12,1.95-5.76c.38-1.31.79-2.82,1.18-4.5.59-2.54,1.21-5.46,1.69-8.67.48-3.26.82-6.82.82-10.58h-6.84l-1.11,19.25-.23,4.02h0s-.36,6.23-.36,6.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "m354.31,441.53h2.13v.08c0,.59-.48,1.06-1.06,1.06h0c-.59,0-1.06-.48-1.06-1.06v-.08h0Z",
    transform: "translate(710.75 884.19) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "m356.65,442.67h-3.09l-.17,2.51h5.68c-.03-1.39-1.1-2.51-2.42-2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m351.25,423.75c.39,2.42,1.12,4.88,1.67,7.79.06.3.11.59.17.87.3,1.56.58,2.89.83,4.02,1.15,5.15,1.78,6.23,1.78,6.23h2.72v-29.5h-5.66c-1.96,4.12-2.04,7.31-1.51,10.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m358.76,442.67h-3.09l.65,2.51h4.86c-.03-1.39-1.1-2.51-2.42-2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m351.25,423.75h7.17v-10.58h-5.66c-1.96,4.12-2.04,7.31-1.51,10.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "m355.03,413.17h1.83v1.95h-3.78c0-1.07.87-1.95,1.95-1.95Z",
    transform: "translate(709.95 828.3) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "m358.42,413.17v10.58h2.86c.48-3.26.82-6.82.82-10.58h-3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m358.53,419.91h-.11v-6.74h1.63v5.14c0,.88-.68,1.6-1.52,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "m357.37,441.53h.92c.33,0,.61.29.61.64v.5h-2.13v-.5c0-.35.27-.64.61-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "m363.17,413.17v-11.54c0-2.68-.94-5.12-2.07-6.06-1.18-.98-2.39-1.28-2.39-1.28,0,0-.36,1.99-2.58,3.7-2.4,1.84-5.1,1.48-5.1,1.48l.24,13.7h11.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "352.71 402.89 351.26 405.73 353.66 403.38 352.71 402.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "m354.64,399.15s-.71.27-2.36.06c-1.46-.18-1.88-.64-1.88-.64l-2.78,5.86,3.35,1.86,3.67-7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m347.06,408.27c1.93,3.61,3.73,8.52,3.73,8.52l1.53-.52-3.08-9.09c-.19-.51-.66-.84-1.18-.81h0c-.9.04-1.44,1.08-1,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "m353.56,418.2l-.86-2.43c-.25-.69-.97-1.04-1.63-.78h0c-.65.26-.99,1.03-.74,1.72l.42,1.18c.25.69.97,1.04,1.63.78l1.19-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "m357.93,381.25c-1.1.21-3.14.82-4.08,2.61-1.48,2.81-1.3,3.92-1.29,3.99-.04-.08-.84-1.71.17-4.24.5-1.25,1.75-2.3,1.8-2.34h0s0,0,0,0c.53-.22,1.11-.35,1.71-.35s1.16.12,1.68.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "m350.65,388.24s.76.27,1.25-.08c.49-.35.53-1.2.53-1.2,0,0-.76-.27-1.25.08-.49.35-.53,1.2-.53,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "m350.4,386.09s.18.82.73,1.07c.54.25,1.24-.16,1.24-.16,0,0-.18-.82-.73-1.07-.54-.25-1.24.16-1.24.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "362.09 414.22 352.76 413.17 362.1 413.17 362.09 414.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "348.12 404.7 350.61 406.09 350.21 407.05 348.12 404.7"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m419.33,378.07l4.1-1.1h.26c3.72-.41,7.1-1.37,6.1-1.71h-.04l-3.32-.22.08-.02c1.68-.02,2.42-.11,2.42-.11l2.11-.65h0s.08-.02.08-.02l1.21-.32c.16-.05.25-.09.27-.13,1.31-.05,2.36-.38,1.31-.5-1.02.09-3.68.07-5.19.09-.89.01-1.63.07-2.19.14-1.38.06-2.67.19-3.21.35l-1.11.32c-.17.05-.14.09.06.13l-.14.04h0l-.35.1c-.18.05.04.1.49.1h.03l-1.66.49-5.08.23s-2.78.18-4,.95c-.29.18-.44.32-.51.43l-4.7,1.43-11.94,3.47h0s-.03,0-.04.01l-.44.13h2.6l.44-.13c.05-.02.08-.03.09-.04l13.41-2.68-5.94,2.57h0l-.5.28h5.02c.53-.16-.12-.28-1.45-.28l.07-.02h-.01l11.68-3.31h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "407.83 323.59 403.43 321.4 398.16 321.4 393.6 323.59 394 349.04 406.99 349.04 407.83 323.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "403.05 334.62 406.39 327.79 404.63 327.26 406.55 325.97 403.07 320.72 402.8 320.93 406.07 325.87 403.81 327.38 405.9 328.01 402.94 334.06 396.86 328.66 399.61 327.51 396.28 325.71 398.44 321.61 398.14 321.44 395.81 325.86 398.79 327.47 396.2 328.55 403.05 334.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "402.89 348.23 404.28 347.27 404.48 335.4 403.1 334.2 402.89 334.48 404.14 335.56 403.95 347.07 402.71 347.94 402.89 348.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "397.92 321.49 401.22 329.68 402.93 333.92 403.18 329.92 403.7 321.54 401.36 321.52 401.25 321.52 397.92 321.49"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-205",
    points: "401.66 324.9 403 323.33 401.29 321.44 400.03 323.69 401.66 324.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-205",
    points: "400.89 322.42 400.98 324.39 401.22 329.68 402.93 333.92 403.18 329.92 402.22 324.25 401.89 322.31 400.89 322.42"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m403.7,321.54s-.76.72-2.9.72-2.9-.72-2.9-.72v-4.63h5.8v4.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "394 349.04 393.91 380.41 396.43 380.21 401.9 349.04 394 349.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "406.99 349.04 406.61 379.13 403.55 379.13 399.86 349.04 406.99 349.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m406.63,379.13h-3.07l.46,2.54h5.02c0-1.4-1.08-2.54-2.41-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m395.21,379.13h0c-.72,0-1.3.61-1.3,1.37v1.17h2.6v-1.17c0-.76-.58-1.37-1.3-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m394.28,336.49l.3-.68c.65-1.48,2.3-2.12,3.7-1.44l.16.08-.22.51c-.68,1.57-2.44,2.25-3.93,1.53h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "398.27 336.97 397.31 336.35 398.43 334.42 399.39 335.04 398.27 336.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m407.49,336.83l-.17-.72c-.37-1.58-1.87-2.55-3.37-2.16l-.17.04.13.55c.39,1.68,1.99,2.7,3.58,2.29h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "407.56 336.11 399.2 335.04 398.35 337.49 407.6 339.11 407.56 336.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "404.99 336 403.9 336.28 403.39 334.08 404.48 333.8 404.99 336"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 403.98,
    y: 378.96,
    width: 2.65,
    height: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m396.12,379.8l.31-.14s-.28-.71-1.23-.71-1.22.68-1.23.71l.31.13s.21-.49.91-.49.91.47.92.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "406.5 351.87 406.72 351.61 402.82 347.86 397.59 351.28 394.8 351.28 394.8 351.63 397.68 351.63 402.78 348.31 406.5 351.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m398.7,338.5l-5.1-14.91s-2.17,1.63-.77,8.56c1.21,6.01,2.43,7.25,2.43,7.25l3.43-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m406.89,323.57h.93c2.16,3.06,2.07,11.76-.22,15.54l-.71-.36-1.7-.63.67-4.25,1.03-10.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m395.26,339.4c7.08-1.81,8.79-2.46,8.79-2.46l-.66-2.86-8.88,2.03.76,3.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "397.53 335.61 403.42 334.26 403.35 333.91 397.74 335.19 396.07 330.3 395.75 330.42 397.53 335.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "395.17 339.61 404.09 337.11 404.01 336.77 395.35 339.19 394.28 336.89 393.98 337.05 395.17 339.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "407 339.19 407.06 338.84 400.92 337.65 400.86 338 407 339.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "405.62 335.88 406.72 330.56 406.39 330.48 405.29 335.8 405.62 335.88"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-100",
    cx: 402.92,
    cy: 340.32,
    rx: 0.46,
    ry: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m402.34,344.06c0,.27.21.49.46.49s.46-.22.46-.49-.21-.49-.46-.49-.46.22-.46.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "395.37 379.15 397.48 353.29 397.14 353.26 395.04 379.12 395.37 379.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "405.84 379.14 406.18 379.13 405.44 353.52 405.1 353.53 405.84 379.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m403.68,320.95v-3.8h-4.85s0,3.8,4.85,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m403.62,320.06v-3.87s-4.93,0-4.93,0c0,0,0,3.87,4.93,3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m399.82,307.44h2.21c2.05,0,3.72,1.76,3.72,3.92l-.15,4.23-7.6-.26c-.8,0-1.44-.68-1.44-1.52v-2.93c0-1.9,1.46-3.44,3.26-3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m405.64,320.23c-4.19,1.7-6.67-1.86-6.67-1.86v-6.26s-.32-3.23,2.52-3.23h1.17c2.5,0,2.99,2.44,2.98,4.11v7.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 402.68,
    y: 317.2,
    width: 2.67,
    height: 1.84,
    transform: "translate(808.04 636.25) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m398.58,308.88h0c-.84,0-1.53.72-1.53,1.61v4.84h0c1.51,0,2.73-1.29,2.73-2.88v-2.31c0-.7-.54-1.26-1.2-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m397.87,313.61h0c.46,0,.83.37.83.83v2.69h-.83c-.45,0-.82-.37-.82-.82v-1.88c0-.45.37-.82.82-.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "403.57 316.33 404.35 316.33 404.22 315.12 403.88 315.16 403.96 315.96 403.57 315.96 403.57 316.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m398.03,309.14s5.73-.62,7,1.06c1.69.39,1.81-3.31.14-4.57-.7.84-3.45.62-4.88.84-1.88.28-2.26,2.68-2.26,2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m401.93,317.94h1.06c.77,0,1.39-.66,1.39-1.47h-1.07c-.76,0-1.38.65-1.38,1.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m403.89,316.47h.34c.81,0,1.47.66,1.47,1.47h-.34c-.81,0-1.47-.66-1.47-1.47h0Z",
    transform: "translate(809.52 634.5) rotate(-179.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m399.46,312.56s.04,1.69.73,3.5c.68,1.82,2.62,1.56,2.62,1.56,0,0,.15,1.01,1.15,1.01s1.17-.95,1.22-1.03c.44-.6.46-3.1.46-3.1l.11,5.87s-.57,1-2.79,1c-3.61,0-4.56-2.33-4.56-2.33l.29-4.98.77-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m400.74,308.36h0v3.55h-1.31v-2.23c0-.72.59-1.31,1.31-1.31Z",
    transform: "translate(800.18 620.27) rotate(180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m240.83,437.07l-4.55-.35s.02,0,.02,0l1.1-.38c.34-.01.67-.05.81-.09l.34-.1h.02s.12-.04.12-.04c.38-.03.71-.07.87-.12l1.05-.31c.44-.13.25-.24-.4-.31.01-.09-.34-.14-.97-.14h-6.79c-.25.08-.35.15-.31.2-.37-.05-.48-.12-.21-.2l-.3.09c-.38.11,0,.21.88.25-.33.05-.6.1-.79.15l-.95.31-.08.02h0s-.91.27-.91.27c-.07.01-.12.02-.16.03l-.21.06h.05l-.67.19s-.07.1.82.14l-5.27.32h0c-.07.01-4.28.7-7.25,1.57-2.97.87-4.69,1.54-4.69,1.54h2.52s-1.95,0-1.95,0h0s-.35,0-.35,0l-.25.07h.12c-2.01.34.98.37.98.37l1.04-.31-9.19,3h.48s0,0,0,0h-.64c-1.41,0-3,.13-3.56.3h5.54s1.27-.3,1.27-.3h-2.25s0,0,0,0h2.25s10.71-2.45,10.71-2.45l-5.31,2.53c-.21.02-.38.05-.48.08l-.47.14h2.74s.47-.14.47-.14c.1-.03.13-.06.08-.08l12.44-3.26h.13s.69-.21.69-.21h0l3.43-1.07,2.1-.47-3.23.97h0l-2.93.86h0l-.25.07h0l-1.25.37s3.43-.02,3.68-.37h.02l.25-.07h-.26s.71,0,.71,0c0,0,3.73-.83,6.19-1.54,3.63-1.06,3.01-1.57,2.96-1.61h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "208.45 410.18 216.76 410.18 215.38 441.82 213.07 441.82 208.45 410.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "203.07 410.18 210.61 410.18 207.37 440.94 204.29 440.94 203.07 410.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m204.12,440.94h3.25s-.25,2.69-.25,2.69h-5.54c0-1.48,1.14-2.68,2.55-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m214.21,440.94c.76,0,1.37.65,1.37,1.45v1.24s-2.74,0-2.74,0v-1.24c0-.8.61-1.45,1.37-1.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "204.68 414.24 205.04 414.25 205.12 440.95 204.76 440.95 204.68 414.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "209.46 416.97 209.08 414.81 207.82 413.8 208.03 413.5 209.41 414.6 209.82 416.9 209.46 416.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m220.94,398.84c0,6.49-.91,13.96-.91,13.96h-2.89s0-28.52,0-28.52h1.27s2.54,4.6,2.54,14.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m217.13,412.8v3.98s3.82-.24,2.18-3.98h-2.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 217.13,
    y: 412.8,
    width: 2.45,
    height: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m200.07,398.6c0,7.86.58,13.96.58,13.96h2.56s0-28.52,0-28.52l-1.27.35s-1.88,6.3-1.88,14.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m203.22,412.56v3.98s-3.5-.24-2-3.98h2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 200.86,
    y: 412.56,
    width: 2.35,
    height: 0.67
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "201.95 384.39 206.9 380.97 212.4 380.97 218.41 384.29 216.53 400.49 216.81 412.12 210.4 412.12 206.95 410.18 204.58 412.12 201.63 412.12 201.95 384.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m212.68,381.1s-.52.91-.97,4.18c-.1.71-.19,1.52-.27,2.47-.57,6.43-1.04,24.38-1.04,24.38l-3.45-1.94-2.37,1.95s-.84-23.65,1.86-30.26h0c.14-.35.29-.65.46-.89l2.33.13h.11s3.34,0,3.34,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m212.68,381.1s-.52.91-.97,4.18l-2.05,4.11-2.3,6.29-.91-13.81h0c.14-.35.29-.65.46-.89l2.33.13h.11s3.34,0,3.34,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m210.32,382.22l-1.13,1.66s.87,1.39.77,2.27c-.1.88-.31,3.23-.31,3.23l-2.3,6.29-.4-6.18s.27-2.95.41-3.75c.15-.82,1.11-1.88,1.11-1.88l-.77-1.65h2.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 202.15,
    y: 391.01,
    width: 1.47,
    height: 0.38
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "217.13 405.05 216.95 389.57 217.31 389.57 217.33 405.05 217.13 405.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "201.6 412.12 201.58 389.57 201.94 389.57 201.96 412.12 201.6 412.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "216.98 393.69 215.75 390.24 216.08 390.11 217.32 393.55 216.98 393.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "207.08 409.56 206.83 409.29 208.27 407.86 208.27 398.38 207.2 396.27 207.51 396.09 208.63 398.29 208.63 408.03 207.08 409.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m206.93,399.09c-.36.5.18,1.07.65.69.36-.5-.18-1.07-.65-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m206.93,402.16c-.36.5.18,1.07.65.69.36-.5-.18-1.07-.65-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m206.93,405.23c-.36.5.18,1.07.65.69.36-.5-.18-1.07-.65-.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "217.2 398.72 217.06 398.37 218.68 397.68 218.81 398.03 217.2 398.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "217.28 399.31 217.24 398.94 219.41 398.63 219.46 399 217.28 399.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "211.68 396.36 211.36 396.18 214.8 389.69 212.26 388.01 214.81 385.86 212.63 381.58 212.94 381.41 215.27 385.96 212.88 387.98 215.28 389.56 211.68 396.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "204.31 395.62 202.87 388.26 204.19 387.45 203.38 386.33 205.73 382.22 206.04 382.41 203.82 386.31 204.72 387.56 203.27 388.45 204.66 395.54 204.31 395.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m203.01,403.23c0,.26.2.47.45.47s.45-.21.45-.47c0-.26-.2-.47-.45-.47s-.45.21-.45.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m203.01,400.16c0,.26.2.47.45.47s.45-.21.45-.47c0-.26-.2-.47-.45-.47s-.45.21-.45.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m212.85,412.12h-2.45s.12-4.15.12-4.15l-.04,1.57c-.04,1.41,1.03,2.58,2.37,2.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m203.24,412.12h1.35s-.04-4.15-.04-4.15l.03,1.57c.02,1.41-.58,2.58-1.34,2.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m206.57,381.55s.85,1.12,2.9,1.12,3.2-1.56,3.2-1.56l-.42-7.07h-5.57l-.12,7.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m206.69,381.32v-3.61h4.6s0,3.61-4.6,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m206.74,380.48v-3.67s4.68,0,4.68,0c0,0,0,3.67-4.68,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m210.35,368.49h-2.1c-1.95,0-3.53,1.67-3.53,3.73l.15,4.02,7.22-.25c.76,0,1.37-.65,1.37-1.44v-2.79c0-1.81-1.39-3.27-3.1-3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m204.82,380.22c3.98,1.62,6.34-1.35,6.34-1.35v-5.95s.3-3.07-2.39-3.06h-1.11c-2.37,0-2.84,2.32-2.83,3.9v6.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 205.09,
    y: 377.76,
    width: 2.54,
    height: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m211.53,369.86h0c.8,0,1.45.69,1.45,1.53v4.6h0c-1.43,0-2.59-1.22-2.59-2.73v-2.2c0-.66.51-1.2,1.14-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "m212.21,374.35h0c.43,0,.78.37.78.82v1.7c0,.45-.35.82-.78.82h-.79s0-2.52,0-2.52c0-.46.35-.83.79-.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "206.57 376.93 205.83 376.93 205.95 375.79 206.28 375.82 206.2 376.58 206.57 376.58 206.57 376.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m210.69,373.35s-.04,1.6-.69,3.33c-.65,1.73-2.49,1.48-2.49,1.48,0,0-.15.96-1.09.96s-1.11-.91-1.16-.98c-.42-.57-.44-2.94-.44-2.94v5.02s.44,1.5,2.54,1.5c3.43,0,4.05-2.21,4.05-2.21v-4.73l-.73-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m206.02,370.2h.83v.8h-.83c-1.52,0-2.76-1.08-2.76-2.42v-.8c0,1.34,1.24,2.42,2.76,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m212.2,370.19v.81h-6.26c-1.19,0-2.16-1.45-2.16-3.23v-.07h6.76c.92,0,1.67,1.11,1.67,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m208.15,370.99c1.24,0,2.25,1.06,2.25,2.37h0v-2.37h-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m206.02,377.06h.93c.77,0,1.4.63,1.4,1.4h-.93c-.77,0-1.4-.63-1.4-1.4h0Z",
    transform: "translate(414.44 755.49) rotate(179.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m206.16,377.06h.32c0,.77-.63,1.4-1.4,1.4h-.32c0-.77.63-1.4,1.4-1.4Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m436.25,435.19h0s-2.52-.15-2.52-.15c.29-.11-.1-.22-.82-.28l1.03-.33h0l.2-.06h.25c.42,0,.89-.04,1.05-.1l.62-.2c.17-.05-.04-.1-.45-.1-.09,0-.18,0-.27,0l.5-.16h.86l.76-.24c.61-.2-.14-.35-1.68-.35h-4.63l-.25.08c-.09.03-.15.05-.2.08-.76.04-1.48.12-1.78.21l-.75.24c-.2.06-.18.12.02.16-.19.02-.36.04-.44.07l-.62.2c-.12.04-.04.07.18.09l-.17.05c-.4.13-.18.24.48.3l-.34.11s-.6.05-.97.16l-4.89.21h0s-5.12.77-8.04,1.7c-.29.09-.57.19-.84.28h1.11c-1.44.57-2.46,1.08-2.46,1.08-2.39.4-.17.54-.17.54l1.68-.54,3.39-1.08.58-.18h.01s-3.26,1.24-3.26,1.24l-.06.02h.07l-9.62,3.26h-.17c-1.25,0-2.68.13-3.17.29h5.16l.9-.29h0l10.7-2.71h.13s-7.22,2.71-7.22,2.71h0l-.9.29h5.16c.5-.16-.11-.29-1.37-.29h-.16l12.11-3.26h.22l.06-.02h0l4.59-1.27-.67.21-3.39,1.08-1.68.54s3.05-.13,3.18-.54c0,0,2.23-.52,4.33-1.08h1.11c.33-.1.64-.19.93-.28,2.92-.93,2.61-1.7,2.61-1.7h0Zm-2.95-.18l-.99-.06.4-.13c.43.05.68.11.59.19Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "m405.1,365.6c1.01,0,1.82.94,1.82,2.1v2.17c0,1.16-.82,2.1-1.82,2.1s-1.82-.94-1.82-2.1v-2.17c0-1.16.82-2.1,1.82-2.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-242",
    points: "411.95 439.18 409.22 439.18 407.52 406.36 414.08 406.36 411.95 439.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-242",
    points: "405.62 439.18 402.89 439.18 402.24 406.36 408.58 406.36 405.62 439.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m402.72,439.18h2.89v2.61h-5.16c0-1.44,1.02-2.61,2.27-2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m414.38,441.8h-5.16v-2.61h2.89c1.25,0,2.27,1.17,2.27,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m401.62,382.07v27.75h-1.5s-.94-7.27-1.12-13.58c-.02-.69-.03-1.37-.03-2.02,0-6.66,1.78-12.14,1.78-12.14h.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "m401.62,382.07v17.95h-3.55c-.03-.87-.04-1.73-.04-2.56,0-8.44,2.71-15.38,2.71-15.38h.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m401.62,409.82v4.85s-2.63-1.21-1.5-4.85h1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m417.36,394.22c0,.65-.01,1.33-.03,2.02-.19,6.31-1.12,13.58-1.12,13.58h-1.5v-27.75h.88s1.78,5.48,1.78,12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "m418.3,397.46c0,.83-.01,1.69-.04,2.56h-3.55v-17.95h.88s2.71,6.95,2.71,15.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m414.7,414.68v-4.85h1.5c1.13,3.64-1.5,4.85-1.5,4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m404.32,371.1v3.52c-.42,0-.75-.39-.75-.87v-1.79c0-.48.34-.87.75-.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-242",
    points: "410.64 379.82 415.58 382.07 414.08 409.53 402.24 409.53 400.74 382.07 405.68 379.82 410.64 379.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "407.9 386.65 405.43 379.96 410.89 379.96 407.9 386.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m410.89,379.96s-.72.74-2.73.74-2.73-.74-2.73-.74v-4.76h5.46v4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m405.43,379.23v-2.89h4.51s-.8,2.6-4.51,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m410.89,376.54s-1.86,1.8-4.52,1.49c-1.33-.15-2.34-1.45-2.34-2.99v-7.02h6.87v8.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 409.74,
    y: 368.4,
    width: 1.15,
    height: 4.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "m411.14,371.1c.42,0,.75.39.75.87v1.79c0,.48-.34.87-.75.87h-.76v-2.65c0-.48.34-.88.76-.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "405.59 371.84 405.56 373.87 405.93 373.87 405.93 374.24 405.23 374.24 405.27 371.83 405.59 371.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "401.79 398.33 401.47 398.36 400.98 388.48 401.29 388.46 401.79 398.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "415.33 388.48 414.87 397.99 414.55 397.97 415.01 388.46 415.33 388.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "m404.96,375.41h1.96c-1.25,1.18-1.96,0-1.96,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 402.24,
    y: 409.34,
    width: 11.83,
    height: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "m411.75,367.53v2.19h-3.35c-2.25,0-4.07-2.1-4.07-4.69v-.71h4.63c1.54,0,2.79,1.44,2.79,3.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "407.79 412.49 408 414.65 407.69 414.69 407.5 412.78 406.28 412.42 406.36 412.07 407.79 412.49"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 402.64,
    y: 389.43,
    width: 2.79,
    height: 2.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 403.87,
    y: 388.88,
    width: 0.32,
    height: 0.99
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m405.43,378.69v1s.22,6.24.22,6.24c.04,1.19.75,2.16,1.69,2.47-.08.16-.12.34-.12.54h0c-1.15-.36-2.01-1.54-2.06-2.98l-.2-5.73c0-1.08.47-1.53.47-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m408.06,388.5l.02.56c-.3.01-.59-.03-.86-.12h0c0-.2.04-.38.12-.54.23.07.47.11.72.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "m408.04,387.93c.47-.02.86.4.88.93s-.35.99-.81,1.01c-.47.02-.86-.39-.88-.93h0c0-.2.04-.38.12-.54.14-.27.4-.46.69-.48Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "m411.89,383.23h.75c1.15-.02,2.1,1.05,2.11,2.38l.03,4.13c.01,1.44-.69,2.41-1.75,2.42v-.37c1.07-.01,1.44-1.11,1.43-2.05l-.03-4.13c0-1.12-.81-2.03-1.78-2.02h-.75c-.98.02-1.76.94-1.75,2.06l.03,4.13c0,.94.39,2.03,1.46,2.02v.37c-1.06.01-1.77-.95-1.78-2.39l-.03-4.13c-.01-1.33.92-2.42,2.07-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m411.89,383.14h.24s-.02-2.28-.02-2.28c0-.8-.54-1.58-1.22-2.08v-.61c.95.58,1.7,1.61,1.71,2.68l.02,2.28h.02c1.2-.01,2.18,1.1,2.19,2.48l.02,2.47h-.48s-.02-2.46-.02-2.46c0-1.07-.77-1.94-1.7-1.93h-.75c-.93.02-1.68.9-1.67,1.97l.02,2.47h-.48s-.02-2.46-.02-2.46c0-1.38.96-2.51,2.15-2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m411.5,391.69c.14,0,.26.13.26.3,0,.17-.11.3-.26.3-.14,0-.26-.13-.26-.3,0-.17.11-.3.26-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m413.14,391.7c.14,0,.26.13.26.3s-.11.3-.26.3c-.14,0-.26-.13-.26-.3s.11-.3.26-.3Z"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVermittlungHaus);
export default __webpack_public_path__ + "static/media/vermittlung-haus.5e5eb4dc35bf1a9eaee307c5200f9c12.svg";
export { ForwardRef as ReactComponent };